/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		153: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "javascripts/" + ({}[chunkId]||chunkId) + "-" + "d07a2eed5a1912ce9525" + ".min.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://assets.animatron.com/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "NaY7");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+G96":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/video-improve-steps_434e922beb0d0c4958c42c135b8cd366.css";

/***/ }),

/***/ "+K6/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/special-upgrade_0838e38048c599a797e001a6ac31fbe7.css";

/***/ }),

/***/ "+goU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/comments_617675bfb2cd10445614323cb480cfa3.css";

/***/ }),

/***/ "+hc0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var module_1 = __webpack_require__("hfrq");
var underscore_extensions_1 = __webpack_require__("R0iF");
var TabsCtrl = (function () {
    /*@ngInject*/
    TabsCtrl.$inject = ["$rootScope", "$scope", "$location", "$state", "$timeout", "$element", "$q"];
    function TabsCtrl($rootScope, $scope, $location, $state, $timeout, $element, $q) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$location = $location;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$element = $element;
        this.$q = $q;
        if (_.isUndefined(this.firstRun))
            this.firstRun = true;
        if (_.isUndefined(this.isMobileMode))
            this.isMobileMode = true;
        this.path = this.$state.current.name;
        this.configureTabs();
        if (!this.defaultTab && this.tabs && this.tabs.length > 0) {
            this.defaultTab = this.tabs[0];
        }
        this.changeTab = this.changeTab || angular.noop;
        this.reloadOnChange = this.reloadOnChange || false;
        if (this.firstRun) {
            this.defaultTab && this.onTabChange(this.defaultTab);
        }
        else {
            this.currentTab = this.defaultTab;
        }
        if (!this.disableBorder) {
            underscore_extensions_1.Utils.scopedEvent('resize', this.$scope, _.throttle(function () { return _this.setCss(true); }, 500));
        }
        var destroy = $rootScope.$on('user:login', this.configureTabs.bind(this));
        $scope.$on('$destroy', function () { return destroy(); });
    }
    TabsCtrl.prototype.$onChanges = function (onChangesObj) {
        this.setCss(true);
    };
    TabsCtrl.prototype.activateTab = function (tab) {
        this.onTabChange(tab);
    };
    TabsCtrl.prototype.isActive = function (tab) {
        return tab === this.currentTab;
    };
    TabsCtrl.prototype.getTabsProperties = function (cached) {
        if (cached === void 0) { cached = true; }
        return cached && this.tabsProperties || this.computeTabsProperties();
    };
    TabsCtrl.prototype.getCurrent = function (cached) {
        var _this = this;
        if (cached === void 0) { cached = true; }
        return this.getTabsProperties(cached)
            .then(function (w) { return w[_this.tabs.indexOf(_this.currentTab)]; });
    };
    TabsCtrl.prototype.computeTabsProperties = function () {
        var _this = this;
        this.tabsProperties = this.$q(function (resolve) { return _this.$timeout(function () {
            resolve(_.map(_this.$element[0].querySelectorAll(".tab"), function (s) { return ({ width: s.offsetWidth, x: s.offsetLeft }); }));
        }); });
        return this.tabsProperties;
    };
    TabsCtrl.prototype.setCss = function (force) {
        var _this = this;
        if (force === void 0) { force = false; }
        this.cssSet = true;
        this.getCurrent(!force).then(function (tabProps) {
            if (!tabProps)
                return; //if tab is hidden
            var hr = _this.$element[0].querySelector(".hr");
            if (!hr)
                return;
            var marginProp = "translateX(" + tabProps.x + "px)";
            ['mozTransform', 'webkitTransform', 'transform'].map(function (prop) { return hr.style[prop] = marginProp; });
            hr.style.width = tabProps.width + 'px';
            if (!_this.transitionSet && !_this.reloadOnChange) {
                _this.transitionSet = true;
                _this.$timeout(function () { return underscore_extensions_1.Utils.rAF(function () {
                    return hr.style.transition = 'transform .3s, width .3s ease-in-out';
                }); });
            }
        });
    };
    TabsCtrl.prototype.onTabChange = function (currentTab) {
        if (_.contains(this.tabs, currentTab) && (!this.isActive(currentTab) || !this.cssSet)) {
            this.enableAnimation = !!this.currentTab;
            this.currentTab = currentTab;
            this.changeTab({ currentTab: currentTab });
            if (!this.disableBorder) {
                this.setCss();
            }
        }
    };
    TabsCtrl.prototype.configureTabs = function () {
        var _this = this;
        if (this.config && this.tabs) {
            this.tabs = this.tabs.filter(function (t) { return _this.config[t] !== true; });
        }
    };
    return TabsCtrl;
}());
var TabsSubPathCtrl = (function (_super) {
    TabsSubPathCtrl.$inject = ["$rootScope", "$scope", "$location", "$state", "$timeout", "$element", "$q"];
    tslib_1.__extends(TabsSubPathCtrl, _super);
    /*@ngInject*/
    function TabsSubPathCtrl($rootScope, $scope, $location, $state, $timeout, $element, $q) {
        var _this = _super.call(this, $rootScope, $scope, $location, $state, $timeout, $element, $q) || this;
        _this.$rootScope = $rootScope;
        _this.$scope = $scope;
        _this.$location = $location;
        _this.$state = $state;
        _this.$timeout = $timeout;
        _this.$element = $element;
        _this.$q = $q;
        _this.parent = $state.$current.parent.self.name || $state.current.name;
        var childStates = $state.get().map(function (s) { return s.name; }).filter(function (s) { return s.startsWith(_this.parent) && s.indexOf('.') > 0; });
        _this.tabs = childStates.map(function (s) { return _this.stripParent(s); });
        _this.configureTabs();
        _this.defaultTab = _this.defaultTab || _this.tabs[0];
        var hash = $location.hash();
        if (_.contains(_this.tabs, hash)) {
            $location.path(_this.addParent(hash, '/'));
            $location.hash('').replace();
        }
        else if (!_.contains(_this.tabs, _this.stripParent($state.current.name))) {
            $state.go(_this.addParent(_this.defaultTab), $state.params);
        }
        _this.$scope.$watch(function () { return _this.stripParent($state.current.name); }, _this.onTabChange.bind(_this));
        return _this;
    }
    TabsSubPathCtrl.prototype.$postLink = function () {
        var _this = this;
        this.$timeout(function () {
            _.each(_this.$element[0].querySelectorAll('a'), function (el) {
                el.href = _this.$state.href(_this.addParent(el.id), _this.$state.params);
            });
        });
    };
    TabsSubPathCtrl.prototype.activateTab = function (tab) {
        this.$state.go(this.addParent(tab), this.$state.params, { reload: this.reloadOnChange });
    };
    TabsSubPathCtrl.prototype.onTabChange = function (currentTab) {
        if (this.parent && this.tabs.indexOf(this.stripParent(this.$state.current.name)) !== -1) {
            this.$rootScope.setTitle(this.$state.current.name + '.title');
            _super.prototype.onTabChange.call(this, currentTab);
        }
    };
    TabsSubPathCtrl.prototype.stripParent = function (tab) {
        return tab.substring(this.parent.length + 1, tab.length);
    };
    TabsSubPathCtrl.prototype.addParent = function (tab, separator) {
        if (separator === void 0) { separator = '.'; }
        return this.parent + separator + tab;
    };
    return TabsSubPathCtrl;
}(TabsCtrl));
var directivesMap = { 'tabs': TabsCtrl, 'tabsSubPath': TabsSubPathCtrl };
Object.keys(directivesMap).forEach(function (name) {
    module_1.default.component(name, {
        controller: directivesMap[name],
        controllerAs: 'Tabs',
        bindings: {
            changeTab: '&',
            defaultTab: '@',
            tabs: '=?',
            reloadOnChange: '=?',
            currentTab: '=?',
            disableBorder: '=?',
            firstRun: '=?',
            config: '<?',
            labels: '<?',
            isMobileMode: '<?'
        },
        transclude: true,
        templateUrl: __webpack_require__("GOYa")
    });
});


/***/ }),

/***/ "+kS6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/20.svg";

/***/ }),

/***/ "+lAx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/es_9fa3b7a66e7a9a11282f2835f9e86da5.json";

/***/ }),

/***/ "+m0I":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/m-wave-landing_b4cbadfd08b34e17775b9422f742694d.css";

/***/ }),

/***/ "+sRS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var underscore_extensions_1 = __webpack_require__("R0iF");
exports.setWrapper = (function () {
    var headerShown = false;
    var enableFooter = function () {
        if (!headerShown) {
            try {
                document.querySelector('footer').style.display = 'block';
                headerShown = true;
            }
            catch (e) {
                setTimeout(function () { return enableFooter(); }, 100);
            }
        }
    };
    return function (wrapper) { return ({
        setWrapper: /*@ngInject*/ ["$rootScope", "$state", function ($rootScope, $state) {
            var event = $rootScope.$on('$stateChangeSuccess', function () {
                var product = underscore_extensions_1.Utils.getProduct();
                $rootScope.wrapperClass = wrapper + " wrapper-" + product;
                enableFooter();
                event();
            });
        }]
    }); };
})();
function setTitle(title) {
    return {
        setTitle: /*@ngInject*/ ["$rootScope", function ($rootScope) {
            var event = $rootScope.$on('$stateChangeSuccess', function () {
                $rootScope.setTitle(title);
                event();
            });
        }]
    };
}
exports.setTitle = setTitle;
var prevVisitPageName = '';
exports.createTrackVisit = function (analyticSvc, $rootScope) { return function (name, params) {
    if (params === void 0) { params = {}; }
    if (prevVisitPageName === name)
        return;
    analyticSvc.visitPage(name, params);
    prevVisitPageName = name;
    var clear = $rootScope.$on('$stateChangeStart', function () {
        prevVisitPageName = '';
        clear();
    });
}; };
function trackVisit(name, params) {
    if (params === void 0) { params = {}; }
    return {
        trackVisit: /*@ngInject*/ ["analyticSvc", "$rootScope", function (analyticSvc, $rootScope) {
            var visitPage = exports.createTrackVisit(analyticSvc, $rootScope);
            visitPage(name, params);
        }]
    };
}
exports.trackVisit = trackVisit;
function onEnterTrackVisit(name, params) {
    if (params === void 0) { params = {}; }
    return {
        onEnter /*@ngInject*/: ["analyticSvc", "$rootScope", function (analyticSvc, $rootScope) {
            var visitPage = exports.createTrackVisit(analyticSvc, $rootScope);
            visitPage(name, params);
        }]
    };
}
exports.onEnterTrackVisit = onEnterTrackVisit;
// if mod is function, execute it, if array execute all functions inside
exports.loadModule = function (mod) { return (function () {
    var applyOr = function (f, or) { return _.isFunction(f) ? f() : or; };
    return {
        loadModule: /*@ngInject*/ ["$ocLazyLoad", function ($ocLazyLoad) {
            var applied = applyOr(mod, _.isArray(mod) ? mod.map(function (m) { return applyOr(m, m); }) : mod);
            if (applied && applied.then) {
                return applied.then(function (modules) { return $ocLazyLoad.load(_.flatten([modules])
                    .map(function (m) { return Object.assign({}, m, { files: m.files.filter(function (f) { return !_.isEmpty(f); }) }); })); });
            }
            else {
                return $ocLazyLoad.load(applied);
            }
        }]
    };
})(); };
exports.redirect = function (condition, callback) {
    return new Promise(function (resolve) { return (_.isFunction(condition) ? condition() : condition) ? callback() : resolve(); });
};
exports.redirectResolve = function (condition, path) {
    if (path === void 0) { path = '/landing'; }
    return ({
        redirect: ['$location', function ($location) {
                return exports.redirect(condition, function () { return $location.path(path); });
            }
        ]
    });
};
exports.redirectForLogin = function (path) { return ({
    redirect: /*@ngInject*/ ["$location", function ($location) {
        return exports.redirect(options.user.anonymous, function () {
            var redirectUrl = "/" + underscore_extensions_1.Utils.getStateByProduct() + "login?redirectUrl=" + (path || location.href);
            $location.path(redirectUrl);
        });
    }]
}); };
exports.nullToEmptyString = function (str) { return str ? str : ''; };
function stateStudioRedirect($stateProvider, config, stateName) {
    config = Object.assign({}, config);
    var url = typeof config.url === 'string' && config.url;
    var isStudioState = /^studio-/.test(stateName) || /^\/studio\//.test(url);
    if (isStudioState) {
        var newStateName = stateName.replace('studio-', '').replace('studio/', '');
        var newUrl = url.replace('studio/', '');
        $stateProvider.state(newStateName, {
            url: newUrl,
            params: config.params,
            resolve: {
                redirect: /*@ngInject*/ ["$location", function ($location) {
                    var path = "/studio" + $location.url();
                    var hasParentState = /\./g.test(stateName);
                    !hasParentState && underscore_extensions_1.Utils.redirect(path, $location, true);
                }]
            }
        });
    }
    return config;
}
exports.stateStudioRedirect = stateStudioRedirect;
function extendState($stateProvider) {
    var state = $stateProvider.state.bind($stateProvider);
    $stateProvider.state = function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        var config = params.pop();
        var stateName = params.length !== 0 && params[0];
        params.push(stateStudioRedirect($stateProvider, config, stateName));
        return state.apply(void 0, params);
    };
}
exports.extendState = extendState;


/***/ }),

/***/ "/78k":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/delete-account_f527ed6d5bc82c385a7035597f54d203.css";

/***/ }),

/***/ "/Rep":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/_fonts_24e4cdcccfcdaf84ac4e796f9618d86c.css";

/***/ }),

/***/ "/pFW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var underscore_extensions_1 = __webpack_require__("R0iF");
var CommentsCtrl = (function () {
    CommentsCtrl.$inject = ["HttpSvc", "AuthenticationSvc", "$timeout", "$filter"];
    function CommentsCtrl(HttpSvc, AuthenticationSvc, //used in the template
        $timeout, $filter) {
        this.HttpSvc = HttpSvc;
        this.AuthenticationSvc = AuthenticationSvc;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.MaxLength = 500;
    }
    CommentsCtrl.prototype.$onInit = function () {
        var _this = this;
        this.ProjectPageCtrl.projectPromise.then(function (p) {
            _this.project = p;
            _this.project.comments.sort(function (a, b) { return a.created_at - b.created_at; });
        });
    };
    CommentsCtrl.prototype.update = function (comment, newText) {
        var _this = this;
        if (newText.length > this.MaxLength)
            return;
        this.updating = true;
        this.HttpSvc('comments', comment.comment_id).securePut(newText)
            .finally(function () { return _this.updating = false; });
        comment.text = newText;
        comment.edit = false;
    };
    CommentsCtrl.prototype.post = function (post) {
        var _this = this;
        if (this.sending)
            return;
        this.sending = true;
        post.text = this.$filter('stripTags')(post.text);
        this.Form.$setValidity('flood', true);
        this.Form.$setValidity('empty', post.text.length > 0);
        this.Form.$setValidity('maxlength', post.text.length <= this.MaxLength);
        this.$timeout(function () {
            if (_this.Form.$valid) {
                _this.HttpSvc('comments')
                    .securePost({ projectId: _this.project.id, text: post.text })
                    .then(function (r) { return r.data; }).then(function (response) {
                    if (underscore_extensions_1.Utils.isApiError(response)) {
                        _this.Form.$setValidity('flood', response.message !== 'Too many comments');
                        console.error("Cannot add comment", response);
                    }
                    else if (+response !== 0 && !_.isNaN(+response)) {
                        _this.project.comments.push({ comment_id: response, user: options.user, text: post.text });
                        post.text = '';
                    }
                })
                    .finally(function () { return _this.sending = false; });
            }
            else {
                _this.sending = false;
            }
        });
    };
    CommentsCtrl.prototype.delete = function (id) {
        var _this = this;
        this.deleting = true;
        this.HttpSvc('comments', id).secureDelete().then(function () {
            return _this.project.comments = _this.project.comments.filter(function (c) { return c.comment_id !== id; });
        }).finally(function () { return _this.deleting = false; });
    };
    CommentsCtrl.prototype.canDelete = function (comment) {
        return options.user.staff ||
            this.myComment(comment) ||
            this.project.owner.username === options.user.username;
    };
    CommentsCtrl.prototype.canEdit = function (comment) {
        return this.myComment(comment) && this.isMyLast(comment);
    };
    CommentsCtrl.prototype.enterEditMode = function (comment) {
        this.project.comments.map(function (c) { return c.edit = false; });
        comment.edit = true;
    };
    CommentsCtrl.prototype.isMyLast = function (comment) {
        var _this = this;
        var last = _.last(this.project.comments.filter(function (c) { return !c.deleted && !_this.myComment(c); }));
        return (last && last.comment_id || 0) < comment.comment_id;
    };
    CommentsCtrl.prototype.myComment = function (comment) {
        return comment.user.username === options.user.username;
    };
    return CommentsCtrl;
}());
module_1.default.component('comments', {
    controller: CommentsCtrl,
    require: { ProjectPageCtrl: '^projectPage' },
    templateUrl: __webpack_require__("wTNS")
});


/***/ }),

/***/ "/r0m":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/wave-landing-smmw_8a4fbcf4c62acc3c3758558068b3567e.css";

/***/ }),

/***/ "03GZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/participate-steps_61bcf94abd74e1acd6ab43b8f35d3600.css";

/***/ }),

/***/ "07M5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/thumbnail-picker_516cd78a8c3e7fccbc3eb4d9fb57c06e.css";

/***/ }),

/***/ "0MDI":
/***/ (function(module, exports, __webpack_require__) {

var path = 'https://assets.animatron.com/html/user-page.html';
var html = "<news class=\"fix-margin\"></news> <div class=\"projects-header clearfix\" ng-hide=\"UserCtrl.userNotFound\"> <static-include src=\"" + __webpack_require__("Ldjh") + "\"></static-include> <div class=\"search-box user-project-page\"> <span class=\"search-title\" ng-if=\"!sameUser || (sameUser && !$root.options.enableContests)\"> {{::$root.t('search.' + (sameUser ? 'your' : 'user') + '.projects')}} </span> <tabs change-tab=\"UserCtrl.onTabChange(currentTab)\" current-tab=\"UserCtrl.currentTab\" default-tab=\"{{UserCtrl.$stateParams.page || 'your'}}\" tabs=\"UserCtrl.tabs\" ng-if=\"sameUser && $root.options.enableContests\"> </tabs> <search ng-hide=\"true\" username=\"{{animatron.projectsAuthor.username}}\"></search> </div> </div> <static-include src=\"" + __webpack_require__("b6Iv") + "\"></static-include> <div> <join-contests-page ng-if=\"UserCtrl.currentTab === 'join'\"></join-contests-page> <my-contests-page ng-if=\"UserCtrl.currentTab === 'contest'\"></my-contests-page> <initiate-contest ng-if=\"UserCtrl.currentTab === 'init'\"></initiate-contest> </div> <div ng-if=\"!animatron.busy && animatron.loaded\" class=\"icon-status-msg-box\"> <div class=\"not-found-msg icon-status-msg icon-no-projects\" ng-if=\"animatron.count === 0 && !UserCtrl.userNotFound\"> <span ng-if=\"sameUser\">{{::$root.t('project.you.empty')}}</span> <span ng-if=\"!sameUser\">{{::animatron.projectsAuthor.displayName.split(' ')[0]}} {{::$root.t('projects.user.empty')}}</span> <br> <a ng-href=\"{{::$root.options.editorDomain}}#new=1\" ng-if=\"sameUser\" class=\"button button-blue hide-on-mobile\">{{::$root.t('projects.create')}}</a> </div> <div class=\"not-found-msg icon-status-msg icon-followers\" ng-if=\"::UserCtrl.userNotFound\"> <span>{{::$root.t('projects.user.notfound')}}</span> </div> </div> ";
var angular = window.angular;
var injector = angular.element(document).injector();
if (injector) {
injector.get('$templateCache').put(path, html);
} else {
angular.module('templates').run(['$templateCache', function(c) { c.put(path, html) }]);
}
module.exports = path;

/***/ }),

/***/ "0eTi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/19.png";

/***/ }),

/***/ "0nYI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/mobile_917f0e4a4623aafe6e33f8359c9e2fe9.css";

/***/ }),

/***/ "0ts5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

HttpSvcFactory.$inject = ["$http"];
Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("jYQ6");
var Strings_1 = __webpack_require__("fxc3");
var HttpSvc = (function () {
    function HttpSvc($http) {
        var path = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            path[_i - 1] = arguments[_i];
        }
        this.$http = $http;
        this.headers = {};
        this.methods = ['get', 'post', 'put', 'delete'];
        this.methodsWithData = ['post', 'put'];
        this.path = path.join('/');
        this.url = options.apiDomain + '/' + this.path;
        this.createRegularMethods();
        this.createSecureMethods();
    }
    HttpSvc.prototype.setApiUrl = function (url) {
        this.url = url + '/' + this.path;
        return this;
    };
    HttpSvc.prototype.chain = function (path) {
        return new HttpSvc(this.$http, this.path, path);
    };
    HttpSvc.prototype.withData = function (m) {
        return _.contains(this.methodsWithData, m);
    };
    HttpSvc.prototype.setHeaders = function (method, headers, params) {
        var _a = params[0], data = _a === void 0 ? {} : _a, _b = params[1], config = _b === void 0 ? {} : _b;
        if (!this.withData(method)) {
            config = data;
        }
        config.headers = _.extend(config.headers || {}, headers);
        return this.withData(method) ? [data, config] : [config];
    };
    HttpSvc.prototype.createRegularMethods = function () {
        var _this = this;
        _.each(this.methods, function (method) {
            _this[method] = function () {
                var params = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    params[_i] = arguments[_i];
                }
                params = _this.setHeaders(method, _this.headers, params);
                return _this.request(method, params);
            };
        });
    };
    HttpSvc.prototype.createSecureMethods = function () {
        var _this = this;
        _.each(this.methods, function (method) {
            var newMethod = 'secure' + Strings_1.Strings.capitalize(method);
            _this[newMethod] = function () {
                var params = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    params[_i] = arguments[_i];
                }
                if (Strings_1.Strings.isBlank(options.headers['Animatron-Security-Token'])) {
                    if (console.trace)
                        console.trace();
                    throw new Error('Empty cookie');
                }
                params = _this.setHeaders(method, options.headers, params);
                return _this[method].apply(_this, params);
            };
        });
    };
    HttpSvc.prototype.request = function (methodName, params, retry) {
        var _this = this;
        if (retry === void 0) { retry = true; }
        return (_a = this.$http)[methodName].apply(_a, [this.url].concat(params)).catch(function (reason) {
            return reason.status === -1 && retry ?
                _this.request(methodName, params, false) : Promise.reject(reason);
        });
        var _a;
    };
    return HttpSvc;
}());
exports.HttpSvc = HttpSvc;
function HttpSvcFactory($http) {
    return function () {
        var url = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            url[_i] = arguments[_i];
        }
        return new (HttpSvc.bind.apply(HttpSvc, [void 0, $http].concat(url)))();
    };
}
module_1.default.service('HttpSvc', HttpSvcFactory);


/***/ }),

/***/ "0wzA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/modal_00989dd4b47de8bc5c22825dcd8d5ebc.css";

/***/ }),

/***/ "0zt+":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./banner-video-preview_x2.jpg": "rJ0m",
	"./card-maker.png": "h+vD",
	"./creativity.png": "HN/J",
	"./light-presentation-image.png": "KV5y",
	"./pattern-light-landing-bottom.svg": "nNID",
	"./video-maker.png": "SXt6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0zt+";

/***/ }),

/***/ "15vf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/wave-projects_3204ee28fab49cea7a0f267536301b3a.css";

/***/ }),

/***/ "1S0N":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./education.html": "gsWG",
	"./week1.html": "CM5t",
	"./week2.html": "DHQn",
	"./week3.html": "6cC1",
	"./week4.html": "Wmao",
	"./week5.html": "ovcP",
	"./week6.html": "Oquy",
	"./week7.html": "XKv6",
	"./week8.html": "eWSb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1S0N";

/***/ }),

/***/ "1aEF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/studio-header_fcc27ea6f7101e4ec0a54ca6d124cbb4.html";

/***/ }),

/***/ "1uG8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/studio-responsiveness_0d63adb360b437e94760fa672954909d.css";

/***/ }),

/***/ "23em":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/top-layout_9b95e61e5c017537657e059804636bd9.html";

/***/ }),

/***/ "28+3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * To add new page, create new json object with the same structure as the ones below.
 * Most values should be key references to i18n files. So translations should also be written in app/assets/i18n/m_*.properties files
 * It is essential that all properties are present and have correct names.
 * Images are stored in app/assets/images/landing/medium folder, but here should only be filename.
 */

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ([
    {
        url: 'studio/presentation-maker',
        title: 'medium.presentation.title',
        description: 'medium.presentation.description',
        preview: 'medium-presentation1.jpg',
        topVideoListSection: {
            title: 'medium.presentation.h1',
            description: 'medium.presentation.h2',
            list: [
                'medium.top-list1',
                'medium.top-list2',
                'medium.top-list3',
                'medium.top-list4',
                'medium.top-list5'
            ],
            modalVideo: {
                preview: 'presentation_preview.jpg',
                youtubeId: 'JwuaE4hNKro',
                alt: 'medium.presentation.alt1'
            }
        },
        barListSection: {
            title: 'medium.make-presentation-title',
            btnUrl: 'https://editor.animatron.com',
            list: [
                {
                    title: 'medium.make-presentation-title1',
                    content: 'medium.make-presentation-content1'
                },
                {
                    title: 'medium.make-presentation-title2',
                    content: 'medium.make-presentation-content2'
                },
                {
                    title: 'medium.make-presentation-title3',
                    content: 'medium.make-presentation-content3'
                },
                {
                    title: 'medium.make-presentation-title4',
                    content: 'medium.make-presentation-content4'
                }
            ],
            btn: 'medium.make-presentation-button'
        },
        verticalListSection: {
            title: 'medium.animated-presentation-title',
            description: 'medium.animated-presentation-description',
            list: [
                {
                    title: 'medium.animated-presentation-title1',
                    content: 'medium.animated-presentation-content1',
                    icon: 'animated-presentation/img1.svg',
                    alt: 'medium.animated-presentation-title1'
                },
                {
                    title: 'medium.animated-presentation-title2',
                    content: 'medium.animated-presentation-content2',
                    icon: 'animated-presentation/img2.svg'
                },
                {
                    title: 'medium.animated-presentation-title3',
                    content: 'medium.animated-presentation-content3',
                    icon: 'animated-presentation/img3.svg'
                },
                {
                    title: 'medium.animated-presentation-title4',
                    content: 'medium.animated-presentation-content4',
                    icon: 'animated-presentation/img4.svg'
                }
            ],
            btn: 'medium.animated-presentation-button',
            btnUrl: 'https://editor.animatron.com'
        },
        relatedLandings: {}
    },
    {
        url: 'studio/whiteboard-animation-software',
        title: 'medium.whiteboard.title',
        description: 'medium.whiteboard.description',
        preview: 'whiteboard/medium-whiteboard-image.jpg',
        topVideoListSection: {
            title: 'medium.whiteboard.h1',
            description: 'medium.whiteboard.h2',
            list: [
                'medium.whiteboard-list1',
                'medium.whiteboard-list2',
                'medium.whiteboard-list3',
                'medium.whiteboard-list4',
                'medium.whiteboard-list5'
            ],
            modalVideo: {
                preview: 'whiteboard/medium-whiteboard-image.jpg',
                youtubeId: 'NU-0qpoD7Yk',
                alt: 'medium.whiteboard.description'
            }
        },
        barListSection: {
            title: 'medium.make-whiteboard-title',
            list: [
                {
                    title: 'medium.make-whiteboard-title1',
                    content: 'medium.make-whiteboard-content1'
                },
                {
                    title: 'medium.make-whiteboard-title2',
                    content: 'medium.make-whiteboard-content2'
                },
                {
                    title: 'medium.make-whiteboard-title3',
                    content: 'medium.make-whiteboard-content3'
                },
                {
                    title: 'medium.make-whiteboard-title4',
                    content: 'medium.make-whiteboard-content4'
                }
            ],
            btnUrl: 'https://editor.animatron.com',
            btn: 'medium.make-whiteboard-button'
        },
        verticalListSection: {
            title: 'medium.whiteboard-video-title',
            description: 'medium.whiteboard-video-description',
            list: [
                {
                    title: 'medium.whiteboard-video-title1',
                    content: 'medium.whiteboard-video-content1',
                    icon: 'whiteboard/icon1.svg'
                },
                {
                    title: 'medium.whiteboard-video-title2',
                    content: 'medium.whiteboard-video-content2',
                    icon: 'whiteboard/icon2.svg'
                },
                {
                    title: 'medium.whiteboard-video-title3',
                    content: 'medium.whiteboard-video-content3',
                    icon: 'whiteboard/icon3.svg'
                },
                {
                    title: 'medium.whiteboard-video-title4',
                    content: 'medium.whiteboard-video-content4',
                    icon: 'whiteboard/icon4.svg'
                }
            ],
            btnUrl: 'https://editor.animatron.com',
            btn: 'medium.whiteboard-video-button'
        },
        relatedLandings: {}
    },
    {
        url: 'studio/lite-mode',
        title: 'medium.litemode.title',
        description: 'medium.litemode.description',
        preview: 'litemode/1.png',
        topVideoListSection: {
            title: 'medium.litemode.h1',
            description: 'medium.litemode.h2',
            list: [
                'medium.litemode-list1',
                'medium.litemode-list2',
                'medium.litemode-list3',
                'medium.litemode-list4',
                'medium.litemode-list5'
            ],
            modalVideo: {
                preview: 'litemode/1.png',
                youtubeId: 'StEBsxh0I6s',
                alt: 'medium.litemode-alt1'
            }
        },
        barListSection: {
            title: 'medium.why-litemode-title',
            list: [
                {
                    title: 'medium.why-litemode-title1',
                    content: 'medium.why-litemode-content1'
                },
                {
                    title: 'medium.why-litemode-title2',
                    content: 'medium.why-litemode-content2'
                },
                {
                    title: 'medium.why-litemode-title3',
                    content: 'medium.why-litemode-content3'
                },
                {
                    title: 'medium.why-litemode-title4',
                    content: 'medium.why-litemode-content4'
                }
            ],
            btnUrl: 'https://editor.animatron.com',
            btn: 'medium.why-litemode-button'
        },
        verticalListSection: {
            title: 'medium.more-litemode-title',
            description: 'medium.more-litemode-description',
            list: [
                {
                    title: 'medium.more-litemode-title1',
                    content: 'medium.more-litemode-content1',
                    imageUrl: 'litemode/img1.gif',
                    alt: 'medium.litemode-alt2'
                },
                {
                    title: 'medium.more-litemode-title2',
                    content: 'medium.more-litemode-content2',
                    imageUrl: 'litemode/img2.gif',
                    alt: 'medium.litemode-alt3'
                },
                {
                    title: 'medium.more-litemode-title3',
                    content: 'medium.more-litemode-content3',
                    imageUrl: 'litemode/img3.gif',
                    alt: 'medium.litemode-alt4'
                },
                {
                    title: 'medium.more-litemode-title4',
                    content: 'medium.more-litemode-content4',
                    imageUrl: 'litemode/img4.gif',
                    alt: 'medium.litemode-alt5'
                }
            ],
            btnUrl: 'http://www.animatron.com/blog/whats-new-in-animatron-lite-mode-whiteboard-animation-and-more/',
            btn: 'medium.more-litemode-button'
        },
        videoSamples: {
            title: 'medium.litemode-samples.title',
            description: 'medium.litemode-samples.description',
            list: [
                'NU-0qpoD7Yk',
                '13mGg5gmPL4',
                'TxyPmfybDlw'
            ]
        },
        relatedLandings: {}
    },
    {
        url: 'studio/animation-for-agencies',
        title: 'medium.agencies.title',
        description: 'medium.agencies.description',
        preview: 'agencies/1.png',
        topVideoListSection: {
            title: 'medium.agencies.h1',
            description: 'medium.agencies.h2',
            list: [
                'medium.agencies-list1',
                'medium.agencies-list2',
                'medium.agencies-list3',
                'medium.agencies-list4',
                'medium.agencies-list5'
            ],
            modalVideo: {
                preview: 'agencies/1.png',
                youtubeId: 'StEBsxh0I6s',
                alt: 'medium.agencies-alt1'
            }
        },
        textSections: {
            order: 1,
            bgColor: true,
            list: [
                {
                    title: 'medium.agencies.text-section-1.title',
                    content: 'medium.agencies.text-section-1.content',
                    btnUrl: 'https://editor.animatron.com'
                }
            ]
        },
        barListSection: {
            order: 3,
            bgColor: true,
            title: 'medium.agencies-title',
            btnUrl: 'https://editor.animatron.com',
            list: [
                {
                    title: 'medium.agencies-title1',
                    content: 'medium.agencies-content1'
                },
                {
                    title: 'medium.agencies-title2',
                    content: 'medium.agencies-content2'
                },
                {
                    title: 'medium.agencies-title3',
                    content: 'medium.agencies-content3'
                },
                {
                    title: 'medium.agencies-title4',
                    content: 'medium.agencies-content4'
                }
            ],
            btn: 'medium.agencies-button'
        },
        verticalListSection: {
            order: 4,
            title: 'medium.why-agencies-title',
            btnUrl: 'https://editor.animatron.com',
            description: 'medium.why-agencies-description',
            list: [
                {
                    title: 'medium.why-agencies-title1',
                    content: 'medium.why-agencies-content1',
                    icon: 'agencies/AGENCIES_1.svg'
                },
                {
                    title: 'medium.why-agencies-title2',
                    content: 'medium.why-agencies-content2',
                    icon: 'agencies/AGENCIES_2.svg'
                },
                {
                    title: 'medium.why-agencies-title3',
                    content: 'medium.why-agencies-content3',
                    icon: 'agencies/AGENCIES_3.svg'
                },
                {
                    title: 'medium.why-agencies-title4',
                    content: 'medium.why-agencies-content4',
                    icon: 'agencies/AGENCIES_4.svg'
                }
            ],
            btn: 'medium.why-agencies-button'
        },
        videoSamples: {
            order: 2,
            title: 'medium.agencies-samples.title',
            description: 'medium.agencies-samples.description',
            list: [
                '4ZNaLnVaGj8',
                'NU-0qpoD7Yk',
                'UjmaE78NyB4',
                'h0iARjYhbHY',
                'LhyXWD-Ua-w',
                '8Rq75fMP8v8'
            ]
        },
        relatedLandings: {
            order: 5,
            bgColor: true
        }
    },
    {
        url: 'studio/animation-for-designers',
        title: 'medium.designers.title',
        description: 'medium.designers.description',
        preview: 'designers/1.png',
        topVideoListSection: {
            title: 'medium.designers.h1',
            description: 'medium.designers.h2',
            list: [
                'medium.designers-list1',
                'medium.designers-list2',
                'medium.designers-list3',
                'medium.designers-list4',
                'medium.designers-list5'
            ],
            modalVideo: {
                preview: 'designers/1.png',
                youtubeId: 'C7QXCTcQvCA',
                alt: 'medium.designers-alt1'
            }
        },
        textSections: {
            order: 1,
            list: [
                {
                    title: 'medium.designers.text-section-1.title',
                    content: 'medium.designers.text-section-1.content'
                }
            ]
        },
        barListSection: {
            order: 3,
            bgColor: true,
            title: 'medium.designers-title',
            btnUrl: 'https://editor.animatron.com',
            list: [
                {
                    title: 'medium.designers-title1',
                    content: 'medium.designers-content1'
                },
                {
                    title: 'medium.designers-title2',
                    content: 'medium.designers-content2'
                },
                {
                    title: 'medium.designers-title3',
                    content: 'medium.designers-content3'
                },
                {
                    title: 'medium.designers-title4',
                    content: 'medium.designers-content4'
                }
            ],
            btn: 'medium.designers-button'
        },
        videoSamples: {
            order: 2,
            description: 'medium.designers-samples.description',
            list: [
                '5lmn5G2SM1Q',
                'nL8KXi-Ebpg',
                'Hsb8Hnxnyyw'
            ]
        },
        verticalListSection: {
            order: 4,
            title: 'medium.why-designers-title',
            btnUrl: 'https://editor.animatron.com',
            description: 'medium.why-designers-description',
            list: [
                {
                    title: 'medium.why-designers-title1',
                    content: 'medium.why-designers-content1',
                    icon: 'wave/wave-heart.svg'
                },
                {
                    title: 'medium.why-designers-title2',
                    content: 'medium.why-designers-content2',
                    icon: 'wave/wave-heart.svg'
                },
                {
                    title: 'medium.why-designers-title3',
                    content: 'medium.why-designers-content3',
                    icon: 'wave/wave-heart.svg'
                },
                {
                    title: 'medium.why-designers-title4',
                    content: 'medium.why-designers-content4',
                    icon: 'wave/wave-heart.svg'
                }
            ],
            btn: 'medium.why-designers-button'
        },
        relatedLandings: {
            order: 5,
            bgColor: true
        }
    },
    {
        url: 'studio/stock-footage',
        title: 'medium.stock.title',
        description: 'medium.stock.description',
        preview: 'stock/preview.png',
        bgVideoSection: {
            title: 'medium.stock.h1',
            videoUrl: 'stock/videostock_720p',
            btnUrl: 'https://www.animatron.com/',
            btn: 'medium.stock.button'
        },
        textSections: {
            order: 1,
            list: [
                {
                    title: 'medium.stock.header-content.title',
                    content: 'medium.stock.header-content.content'
                }
            ]
        },
        verticalListSection: {
            order: 3,
            title: 'medium.stock.vertical-list.title',
            bgColor: true,
            list: [
                {
                    title: 'medium.why-stock-title1',
                    content: 'medium.stock.vertical-list.content-1',
                    icon: 'wave/wave-heart.svg'
                },
                {
                    title: 'medium.why-stock-title2',
                    content: 'medium.stock.vertical-list.content-2',
                    icon: 'wave/wave-heart.svg'
                },
                {
                    title: 'medium.why-stock-title3',
                    content: 'medium.stock.vertical-list.content-3',
                    icon: 'wave/wave-heart.svg'
                },
                {
                    title: 'medium.why-stock-title4',
                    content: 'medium.stock.vertical-list.content-4',
                    icon: 'wave/wave-heart.svg'
                }
            ],
            btnUrl: 'https://www.animatron.com/',
            btn: 'medium.stock.vertical-list.btn'
        },
        videoSamples: {
            order: 2,
            title: 'medium.stock-samples.title',
            description: 'medium.stock-samples.description',
            list: [
                '5lmn5G2SM1Q',
                'Vm_W4CX72rw',
                'Hsb8Hnxnyyw'
            ]
        },
        relatedLandings: {
            order: 4
        }
    },
    {
        url: 'wave/social-video-maker',
        title: 'wv.social.video.title',
        description: 'wv.social.video.description',
        preview: 'wave/preview.png',
        bgVideoSection: {
            title: 'wv.social.video.h1',
            videoUrl: 'wave/social',
            btnUrl: '/wave/signup',
            editorRedirect: true,
            btn: 'medium.social.video.btn-try-now'
        },
        textSections: {
            order: 1,
            list: [
                {
                    title: 'medium.social.video.header-content.title',
                    content: 'medium.social.video.header-content.content'
                }
            ]
        },
        horizontalListSection: {
            order: 2,
            bgColor: true,
            title: 'medium.social.video.horizontal-list.title',
            list: [
                {
                    content: 'medium.social.video.horizontal-list.content1'
                },
                {
                    content: 'medium.social.video.horizontal-list.content2'
                },
                {
                    content: 'medium.social.video.horizontal-list.content3'
                }
            ]
        },
        verticalListSection: {
            order: 4,
            title: 'medium.social.video.vertical-list.title',
            list: [
                {
                    content: 'medium.social.video.vertical-list.content-1',
                    icon: 'wave/wave-heart.svg'
                },
                {
                    content: 'medium.social.video.vertical-list.content-2',
                    icon: 'wave/wave-heart.svg'
                },
                {
                    content: 'medium.social.video.vertical-list.content-3',
                    icon: 'wave/wave-heart.svg'
                }
            ],
            btnUrl: '/wave/signup',
            editorRedirect: true,
            btn: 'medium.wave.vertical-list.btn'
        },
        videoSlider: {
            order: 3,
            title: 'medium.wave.video-slider.title',
            description: 'medium.wave.video-slider.description',
            list: [
                {
                    preview: 'wave/swimsuit_square.png',
                    url: 'wave/swimsuit_square'
                },
                {
                    preview: 'wave/swimsuit_mobile.png',
                    url: 'wave/swimsuit_mobile'
                },
                {
                    preview: 'wave/swimsuit_desktop.png',
                    url: 'wave/swimsuit_desktop'
                }
            ],
            editorRedirect: true,
            btn: 'medium.wave.video-slider.btn',
            btnUrl: '/wave/signup'
        }
    },
    {
        url: 'wave/small-business-video',
        title: 'wv.business.video.title',
        description: 'wv.business.video.description',
        preview: 'wave/business_preview.png',
        bgVideoSection: {
            title: 'wv.business.video.h1',
            videoUrl: 'wave/small_business',
            btnUrl: '/wave/signup',
            editorRedirect: true,
            btn: 'medium.social.video.btn-try-now'
        },
        textSections: {
            order: 1,
            list: [
                {
                    title: 'medium.business.video.header-content.title',
                    content: 'medium.business.video.header-content.content'
                }
            ]
        },
        horizontalListSection: {
            order: 4,
            title: 'medium.business.video.horizontal-list.title',
            list: [
                {
                    content: 'medium.business.video.horizontal-list.content1'
                },
                {
                    content: 'medium.business.video.horizontal-list.content2'
                },
                {
                    content: 'medium.business.video.horizontal-list.content3'
                }
            ]
        },
        verticalListSection: {
            order: 3,
            bgColor: true,
            title: 'medium.business.video.vertical-list.title',
            list: [
                {
                    content: 'medium.business.video.vertical-list.content-1',
                    icon: 'wave/wave-heart.svg'
                },
                {
                    content: 'medium.business.video.vertical-list.content-2',
                    icon: 'wave/wave-heart.svg'
                },
                {
                    content: 'medium.business.video.vertical-list.content-3',
                    icon: 'wave/wave-heart.svg'
                },
                {
                    content: 'medium.business.video.vertical-list.content-4',
                    icon: 'wave/wave-heart.svg'
                }
            ],
            btnUrl: '/wave/signup',
            editorRedirect: true,
            btn: 'medium.wave.vertical-list.btn'
        },
        videoSamples: {
            order: 2,
            title: 'medium.business-samples.title',
            description: 'medium.business-samples.description',
            list: [
                '8Rq75fMP8v8',
                'Vm_W4CX72rw',
                'LhyXWD-Ua-w'
            ],
            editorRedirect: true,
            btn: 'medium.wave.video-slider.btn',
            btnUrl: '/wave/signup'
        }
    },
    {
        url: 'wave/blog-video',
        title: 'wv.blog.video.title',
        description: 'wv.blog.video.description',
        preview: 'wave/blog.png',
        bgVideoSection: {
            title: 'wv.blog.video.h1',
            videoUrl: 'wave/blog',
            btnUrl: '/wave/signup',
            editorRedirect: true,
            btn: 'medium.social.video.btn-try-now'
        },
        textSections: {
            order: 1,
            list: [
                {
                    title: 'medium.blog.header-content.title',
                    content: 'medium.blog.header-content.content'
                }
            ]
        },
        horizontalListSection: {
            order: 3,
            bgColor: true,
            title: 'medium.blog.horizontal-list.title',
            list: [
                {
                    content: 'medium.blog.horizontal-list.content1'
                },
                {
                    content: 'medium.blog.horizontal-list.content2'
                },
                {
                    content: 'medium.blog.horizontal-list.content3'
                }
            ]
        },
        verticalListSection: {
            order: 4,
            title: 'medium.blog.vertical-list.title',
            list: [
                {
                    content: 'medium.blog.vertical-list.content-1',
                    icon: 'wave/wave-heart.svg'
                },
                {
                    content: 'medium.social.video.vertical-list.content-2',
                    icon: 'wave/wave-heart.svg'
                },
                {
                    content: 'medium.social.video.vertical-list.content-3',
                    icon: 'wave/wave-heart.svg'
                }
            ],
            btnUrl: '/wave/signup',
            editorRedirect: true,
            btn: 'medium.wave.vertical-list.btn'
        },
        videoSlider: {
            order: 2,
            title: 'medium.blog.video-slider.title',
            description: 'medium.blog.video-slider.description',
            list: [
                {
                    preview: 'wave/skiing_square.png',
                    alt: 'medium.blog-video.alt1',
                    url: 'wave/skiing_square'
                },
                {
                    preview: 'wave/skiing_mobile.png',
                    alt: 'medium.blog-video.alt2',
                    url: 'wave/skiing_mobile'
                },
                {
                    preview: 'wave/skiing_desktop.png',
                    alt: 'medium.blog-video.alt3',
                    url: 'wave/skiing_desktop'
                }
            ],
            editorRedirect: true,
            btn: 'medium.wave.video-slider.btn',
            btnUrl: '/wave/signup'
        }
    }
]);


/***/ }),

/***/ "2MCb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/ru_8bf2cbb1d8e3c18210eee8ebc18558da.json";

/***/ }),

/***/ "2SCq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("jYQ6");
var UserProjectCountSvc = (function () {
    UserProjectCountSvc.$inject = ["AnimatronProjects"];
    function UserProjectCountSvc(AnimatronProjects) {
        this.AnimatronProjects = AnimatronProjects;
    }
    UserProjectCountSvc.prototype.getCount = function () {
        var params = {
            product: 'WAVE',
            offset: 0,
            limit: 0
        };
        var animatronProjects = new this.AnimatronProjects(params, true);
        return animatronProjects.nextPage().then(function () { return animatronProjects.count; });
    };
    return UserProjectCountSvc;
}());
exports.UserProjectCountSvc = UserProjectCountSvc;
module_1.default.service('userProjectCountSvc', UserProjectCountSvc);


/***/ }),

/***/ "2wJH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/8.svg";

/***/ }),

/***/ "2wXK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/banner/help-img-8.png";

/***/ }),

/***/ "390S":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/6.svg";

/***/ }),

/***/ "3H1O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var underscore_extensions_1 = __webpack_require__("R0iF");
var EditableCtrl = (function () {
    EditableCtrl.$inject = ["$scope", "$element", "$filter", "$timeout", "$compile"];
    function EditableCtrl($scope, $element, $filter, $timeout, $compile) {
        this.$scope = $scope;
        this.$element = $element;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$compile = $compile;
        this.onChange = this.onChange || angular.noop;
        this.maxlength = this.maxlength || 500;
        this.editorEnabled = false;
        if (this.isEditable) {
            this.enableEditor();
        }
    }
    EditableCtrl.prototype.$postLink = function () {
        this.textareaE = this.$element[0].querySelector('.textarea');
        var textEl = this.$element[0].querySelector('#text-el');
        textEl.innerHTML = textEl.innerHTML.replace(/div/, this.tag);
        this.$compile(textEl)(this.$scope);
    };
    EditableCtrl.prototype.unEdit = function ($event) {
        var _this = this;
        this.editorEnabled = false;
        if (this.notAllowEmpty && this.editModel === '') {
            this.editModel = this.model;
        }
        else {
            this.model = this.$filter('stripTags')(angular.copy(this.editModel));
        }
        if (this.model === this.prevModel) {
            this.prevModel = '';
            return;
        }
        this.prevModel = this.model;
        this.$element[0].classList.remove('editing');
        if ($event != null)
            $event.preventDefault();
        this.onChange({ $event: this.model });
        underscore_extensions_1.Utils.rAF(function () { return _this.textareaE.blur(); });
    };
    EditableCtrl.prototype.unEditNoSave = function ($event) {
        this.editorEnabled = false;
        this.$element[0].classList.remove('editing');
        this.editModel = this.model;
        if ($event != null)
            $event.preventDefault();
    };
    EditableCtrl.prototype.enableEditor = function () {
        var _this = this;
        if (!this.owner)
            return;
        this.editModel = angular.copy(this.model);
        this.editorEnabled = true;
        this.$element[0].classList.add('editing');
        underscore_extensions_1.Utils.rAF(function () {
            _this.textareaE.focus();
            _this.textareaE.select();
            _this.textareaE.setSelectionRange(0, 9999); // fix for IOS
        });
    };
    return EditableCtrl;
}());
module_1.default.component('editable', {
    bindings: {
        'model': '=model',
        'owner': '=',
        'defaultMsg': '@',
        'tag': '@',
        isEditable: '<?',
        notAllowEmpty: '<?',
        maxlength: '<?',
        onChange: '&?'
    },
    controller: EditableCtrl,
    templateUrl: __webpack_require__("GgDZ")
});


/***/ }),

/***/ "3PSy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/section-logo-video-sign-up_81d700b246d7392faa1c4e87d9070ea4.css";

/***/ }),

/***/ "3Rv0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("jYQ6");
var underscore_extensions_1 = __webpack_require__("R0iF");
var HttpProjectSvc = (function () {
    HttpProjectSvc.$inject = ["$rootScope", "$q", "$state", "$http", "HttpSvc"];
    function HttpProjectSvc($rootScope, $q, $state, $http, HttpSvc) {
        this.$rootScope = $rootScope;
        this.$q = $q;
        this.$state = $state;
        this.$http = $http;
        this.HttpSvc = HttpSvc;
        this.product = underscore_extensions_1.Utils.getProduct();
    }
    HttpProjectSvc.prototype.removeProject = function (id, stopDefaultConfirm, showSuccessMessage) {
        var _this = this;
        if (stopDefaultConfirm === void 0) { stopDefaultConfirm = false; }
        if (showSuccessMessage === void 0) { showSuccessMessage = true; }
        var productWord = this.product === 'WAVE' ? 'video' : 'project';
        if (!stopDefaultConfirm && !confirm(this.$rootScope.t(productWord + ".remove.confirm"))) {
            return this.$q.reject();
        }
        return this.$http
            .delete(options.apiDomain + "/project/" + id, { headers: options.headers })
            .then(function () {
            showSuccessMessage && _.notification.showSuccess(_this.$rootScope.t(productWord + ".remove.success"));
            _this.$rootScope.$emit('project:remove', id);
        });
    };
    HttpProjectSvc.prototype.getRenderedVideo = function (id) {
        var _this = this;
        return this.HttpSvc('project/resources/video', id)
            .get()
            .then(function (res) {
            return res.data.code ? _this.$q.reject(res.data.message) : res.data;
        });
    };
    return HttpProjectSvc;
}());
exports.HttpProjectSvc = HttpProjectSvc;
module_1.default.service('httpProjectSvc', HttpProjectSvc);


/***/ }),

/***/ "3Sex":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/landing-new_e07c1a85372ce9833323a8c62f96997c.css";

/***/ }),

/***/ "3ksy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/main_091824a70a4e76c009183e7050f30488.css";

/***/ }),

/***/ "3qhd":
/***/ (function(module, exports) {

/**
 * oclazyload - Load modules on demand (lazy load) with angularJS
 * @version v0.5.2
 * @link https://github.com/ocombe/ocLazyLoad
 * @license MIT
 * @author Olivier Combe <olivier.combe@gmail.com>
 */
(function() {
  'use strict';
  var regModules = ['ng'],
    initModules = [],
    regInvokes = {},
    regConfigs = [],
    justLoaded = [],
    runBlocks = {},
    ocLazyLoad = angular.module('oc.lazyLoad', ['ng']),
    broadcast = angular.noop;

  ocLazyLoad.provider('$ocLazyLoad', ['$controllerProvider', '$provide', '$compileProvider', '$filterProvider', '$injector', '$animateProvider',
    function($controllerProvider, $provide, $compileProvider, $filterProvider, $injector, $animateProvider) {
      var modules = {},
        providers = {
          $controllerProvider: $controllerProvider,
          $compileProvider: $compileProvider,
          $filterProvider: $filterProvider,
          $provide: $provide, // other things
          $injector: $injector,
          $animateProvider: $animateProvider
        },
        anchor = document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0],
        jsLoader, cssLoader, templatesLoader,
        debug = false,
        events = false;

      // Let's get the list of loaded modules & components
      init(angular.element(window.document));

      this.$get = ['$log', '$q', '$templateCache', '$http', '$rootElement', '$rootScope', '$cacheFactory', '$interval', function($log, $q, $templateCache, $http, $rootElement, $rootScope, $cacheFactory, $interval) {
        var instanceInjector,
          filesCache = $cacheFactory('ocLazyLoad'),
          uaCssChecked = false,
          useCssLoadPatch = false;

        if(!debug) {
          $log = {};
          $log['error'] = angular.noop;
          $log['warn'] = angular.noop;
          $log['info'] = angular.noop;
        }

        // Make this lazy because at the moment that $get() is called the instance injector hasn't been assigned to the rootElement yet
        providers.getInstanceInjector = function() {
          return (instanceInjector) ? instanceInjector : (instanceInjector = ($rootElement.data('$injector') || angular.injector()));
        };

        broadcast = function broadcast(eventName, params) {
          if(events) {
            $rootScope.$broadcast(eventName, params);
          }
          if(debug) {
            $log.info(eventName, params);
          }
        }

        /**
         * Load a js/css file
         * @param type
         * @param path
         * @returns promise
         */
        var buildElement = function buildElement(type, path, params) {
          var deferred = $q.defer(),
            el, loaded,
            cacheBuster = function cacheBuster(url) {
              var dc = new Date().getTime();
              if(url.indexOf('?') >= 0) {
                if(url.substring(0, url.length - 1) === '&') {
                  return url + '_dc=' + dc;
                }
                return url + '&_dc=' + dc;
              } else {
                return url + '?_dc=' + dc;
              }
            };

          // Store the promise early so the file load can be detected by other parallel lazy loads
          // (ie: multiple routes on one page) a 'true' value isn't sufficient
          // as it causes false positive load results.
          if(angular.isUndefined(filesCache.get(path))) {
            filesCache.put(path, deferred.promise);
          }

          // Switch in case more content types are added later
          switch(type) {
            case 'css':
              el = document.createElement('link');
              el.type = 'text/css';
              el.rel = 'stylesheet';
              el.href = params.cache === false ? cacheBuster(path) : path;
              break;
            case 'js':
              el = document.createElement('script');
              el.src = params.cache === false ? cacheBuster(path) : path;
              break;
            default:
              deferred.reject(new Error('Requested type "' + type + '" is not known. Could not inject "' + path + '"'));
              break;
          }
          el.onload = el['onreadystatechange'] = function(e) {
            if((el['readyState'] && !(/^c|loade/.test(el['readyState']))) || loaded) return;
            el.onload = el['onreadystatechange'] = null
            loaded = 1;
            broadcast('ocLazyLoad.fileLoaded', path);
            deferred.resolve();
          }
          el.onerror = function(e) {
            deferred.reject(new Error('Unable to load ' + path));
          }
          el.async = params.serie ? 0 : 1;

          var insertBeforeElem = anchor.lastChild;
          if(params.insertBefore) {
            var element = angular.element(params.insertBefore);
            if(element && element.length > 0) {
              insertBeforeElem = element[0];
            }
          }
          anchor.insertBefore(el, insertBeforeElem);

          /*
           The event load or readystatechange doesn't fire in:
           - iOS < 6       (default mobile browser)
           - Android < 4.4 (default mobile browser)
           - Safari < 6    (desktop browser)
           */
          if(type == 'css') {
            if(!uaCssChecked) {
              var ua = navigator.userAgent.toLowerCase();

              // iOS < 6
              if(/iP(hone|od|ad)/.test(navigator.platform)) {
                var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
                var iOSVersion = parseFloat([parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)].join('.'));
                useCssLoadPatch = iOSVersion < 6;
              } else if(ua.indexOf("android") > -1) { // Android < 4.4
                var androidVersion = parseFloat(ua.slice(ua.indexOf("android") + 8));
                useCssLoadPatch = androidVersion < 4.4;
              } else if(ua.indexOf('safari') > -1 && ua.indexOf('chrome') == -1 && ua.indexOf('phantomjs') == -1) {
                var safariVersion = parseFloat(ua.match(/version\/([\.\d]+)/i)[1]);
                useCssLoadPatch = safariVersion < 6;
              }
            }

            if(useCssLoadPatch) {
              var tries = 1000; // * 20 = 20000 miliseconds
              var interval = $interval(function() {
                try {
                  el.sheet.cssRules;
                  $interval.cancel(interval);
                  el.onload();
                } catch(e) {
                  if(--tries <= 0) {
                    el.onerror();
                  }
                }
              }, 20);
            }
          }

          return deferred.promise;
        }

        if(angular.isUndefined(jsLoader)) {
          /**
           * jsLoader function
           * @type Function
           * @param paths array list of js files to load
           * @param callback to call when everything is loaded. We use a callback and not a promise
           * @param params object config parameters
           * because the user can overwrite jsLoader and it will probably not use promises :(
           */
          jsLoader = function(paths, callback, params) {
            var promises = [];
            angular.forEach(paths, function loading(path) {
              promises.push(buildElement('js', path, params));
            });
            $q.all(promises).then(function success() {
              callback();
            }, function error(err) {
              callback(err);
            });
          }
          jsLoader.ocLazyLoadLoader = true;
        }

        if(angular.isUndefined(cssLoader)) {
          /**
           * cssLoader function
           * @type Function
           * @param paths array list of css files to load
           * @param callback to call when everything is loaded. We use a callback and not a promise
           * @param params object config parameters
           * because the user can overwrite cssLoader and it will probably not use promises :(
           */
          cssLoader = function(paths, callback, params) {
            var promises = [];
            angular.forEach(paths, function loading(path) {
              promises.push(buildElement('css', path, params));
            });
            $q.all(promises).then(function success() {
              callback();
            }, function error(err) {
              callback(err);
            });
          }
          cssLoader.ocLazyLoadLoader = true;
        }

        if(angular.isUndefined(templatesLoader)) {
          /**
           * templatesLoader function
           * @type Function
           * @param paths array list of css files to load
           * @param callback to call when everything is loaded. We use a callback and not a promise
           * @param params object config parameters for $http
           * because the user can overwrite templatesLoader and it will probably not use promises :(
           */
          templatesLoader = function(paths, callback, params) {
            var promises = [];
            angular.forEach(paths, function(url) {
              var deferred = $q.defer();
              promises.push(deferred.promise);
              $http.get(url, params).then(function(response) {
                  return response.data;
              }).then(function (data) {
                  if (angular.isString(data) && data.length > 0) {
                      $templateCache.put(url, data);
                  }
                  if (angular.isUndefined(filesCache.get(url))) {
                      filesCache.put(url, true);
                  }
                  deferred.resolve();
              }).catch(function (err) {
                deferred.reject(new Error('Unable to load template file "' + url + '": ' + err));
              });
            });
            return $q.all(promises).then(function success() {
              callback();
            }, function error(err) {
              callback(err);
            });
          }
          templatesLoader.ocLazyLoadLoader = true;
        }

        var filesLoader = function(config, params) {
          var cssFiles = [],
            templatesFiles = [],
            jsFiles = [],
            promises = [],
            cachePromise = null;

          angular.extend(params || {}, config);

          var pushFile = function(path) {
            cachePromise = filesCache.get(path);
            if(angular.isUndefined(cachePromise) || params.cache === false) {
              if(/\.(css|less)[^\.]*$/.test(path) && cssFiles.indexOf(path) === -1) {
                cssFiles.push(path);
              } else if(/\.(htm|html)[^\.]*$/.test(path) && templatesFiles.indexOf(path) === -1) {
                templatesFiles.push(path);
              } else if(jsFiles.indexOf(path) === -1) {
                jsFiles.push(path);
              }
            } else if(cachePromise) {
              promises.push(cachePromise);
            }
          }

          if(params.serie) {
            pushFile(params.files.shift());
          } else {
            angular.forEach(params.files, function(path) {
              pushFile(path);
            });
          }

          if(cssFiles.length > 0) {
            var cssDeferred = $q.defer();
            cssLoader(cssFiles, function(err) {
              if(angular.isDefined(err) && cssLoader.hasOwnProperty('ocLazyLoadLoader')) {
                $log.error(err);
                cssDeferred.reject(err);
              } else {
                cssDeferred.resolve();
              }
            }, params);
            promises.push(cssDeferred.promise);
          }

          if(templatesFiles.length > 0) {
            var templatesDeferred = $q.defer();
            templatesLoader(templatesFiles, function(err) {
              if(angular.isDefined(err) && templatesLoader.hasOwnProperty('ocLazyLoadLoader')) {
                $log.error(err);
                templatesDeferred.reject(err);
              } else {
                templatesDeferred.resolve();
              }
            }, params);
            promises.push(templatesDeferred.promise);
          }

          if(jsFiles.length > 0) {
            var jsDeferred = $q.defer();
            jsLoader(jsFiles, function(err) {
              if(angular.isDefined(err) && jsLoader.hasOwnProperty('ocLazyLoadLoader')) {
                $log.error(err);
                jsDeferred.reject(err);
              } else {
                jsDeferred.resolve();
              }
            }, params);
            promises.push(jsDeferred.promise);
          }

          if(params.serie && params.files.length > 0) {
            return $q.all(promises).then(function success() {
              return filesLoader(config, params);
            });
          } else {
            return $q.all(promises);
          }
        }

        return {
          /**
           * Let you get a module config object
           * @param moduleName String the name of the module
           * @returns {*}
           */
          getModuleConfig: function(moduleName) {
            if(!angular.isString(moduleName)) {
              throw new Error('You need to give the name of the module to get');
            }
            if(!modules[moduleName]) {
              return null;
            }
            return modules[moduleName];
          },

          /**
           * Let you define a module config object
           * @param moduleConfig Object the module config object
           * @returns {*}
           */
          setModuleConfig: function(moduleConfig) {
            if(!angular.isObject(moduleConfig)) {
              throw new Error('You need to give the module config object to set');
            }
            modules[moduleConfig.name] = moduleConfig;
            return moduleConfig;
          },

          /**
           * Returns the list of loaded modules
           * @returns {string[]}
           */
          getModules: function() {
            return regModules;
          },

          /**
           * Let you check if a module has been loaded into Angular or not
           * @param modulesNames String/Object a module name, or a list of module names
           * @returns {boolean}
           */
          isLoaded: function(modulesNames) {
            var moduleLoaded = function(module) {
              var isLoaded = regModules.indexOf(module) > -1;
              if(!isLoaded) {
                isLoaded = !!moduleExists(module);
              }
              return isLoaded;
            }
            if(angular.isString(modulesNames)) {
              modulesNames = [modulesNames];
            }
            if(angular.isArray(modulesNames)) {
              var i, len;
              for(i = 0, len = modulesNames.length; i < len; i++) {
                if(!moduleLoaded(modulesNames[i])) {
                  return false;
                }
              }
              return true;
            } else {
              throw new Error('You need to define the module(s) name(s)');
            }
          },

          /**
           * Load a module or a list of modules into Angular
           * @param module Mixed the name of a predefined module config object, or a module config object, or an array of either
           * @param params Object optional parameters
           * @returns promise
           */
          load: function(module, params) {
            var self = this,
              config = null,
              moduleCache = [],
              deferredList = [],
              deferred = $q.defer(),
              moduleName,
              errText;

            if(angular.isUndefined(params)) {
              params = {};
            }

            // If module is an array, break it down
            if(angular.isArray(module)) {
              // Resubmit each entry as a single module
              angular.forEach(module, function(m) {
                if(m) {
                  deferredList.push(self.load(m, params));
                }
              });

              // Resolve the promise once everything has loaded
              $q.all(deferredList).then(function success() {
                deferred.resolve(module);
              }, function error(err) {
                deferred.reject(err);
              });

              return deferred.promise;
            }

            moduleName = getModuleName(module);

            // Get or Set a configuration depending on what was passed in
            if(typeof module === 'string') {
              config = self.getModuleConfig(module);
              if(!config) {
                config = {
                  files: [module]
                };
                moduleName = null;
              }
            } else if(typeof module === 'object') {
              config = self.setModuleConfig(module);
            }

            if(config === null) {
              errText = 'Module "' + moduleName + '" is not configured, cannot load.';
              $log.error(errText);
              deferred.reject(new Error(errText));
            } else {
              // deprecated
              if(angular.isDefined(config.template)) {
                if(angular.isUndefined(config.files)) {
                  config.files = [];
                }
                if(angular.isString(config.template)) {
                  config.files.push(config.template);
                } else if(angular.isArray(config.template)) {
                  config.files.concat(config.template);
                }
              }
            }

            moduleCache.push = function(value) {
              if(this.indexOf(value) === -1) {
                Array.prototype.push.apply(this, arguments);
              }
            };

            // If this module has been loaded before, re-use it.
            if(angular.isDefined(moduleName) && moduleExists(moduleName) && regModules.indexOf(moduleName) !== -1) {
              moduleCache.push(moduleName);

              // if we don't want to load new files, resolve here
              if(angular.isUndefined(config.files)) {
                deferred.resolve();
                return deferred.promise;
              }
            }

            var localParams = {};
            angular.extend(localParams, params, config);

            var loadDependencies = function loadDependencies(module) {
              var moduleName,
                loadedModule,
                requires,
                diff,
                promisesList = [];

              moduleName = getModuleName(module);
              if(moduleName === null) {
                return $q.when();
              } else {
                try {
                  loadedModule = getModule(moduleName);
                } catch(e) {
                  var deferred = $q.defer();
                  $log.error(e.message);
                  deferred.reject(e);
                  return deferred.promise;
                }
                requires = getRequires(loadedModule);
              }

              angular.forEach(requires, function(requireEntry) {
                // If no configuration is provided, try and find one from a previous load.
                // If there isn't one, bail and let the normal flow run
                if(typeof requireEntry === 'string') {
                  var config = self.getModuleConfig(requireEntry);
                  if(config === null) {
                    moduleCache.push(requireEntry); // We don't know about this module, but something else might, so push it anyway.
                    return;
                  }
                  requireEntry = config;
                }

                // Check if this dependency has been loaded previously
                if(moduleExists(requireEntry.name)) {
                  if(typeof module !== 'string') {
                    // compare against the already loaded module to see if the new definition adds any new files
                    diff = requireEntry.files.filter(function(n) {
                      return self.getModuleConfig(requireEntry.name).files.indexOf(n) < 0;
                    });

                    // If the module was redefined, advise via the console
                    if(diff.length !== 0) {
                      $log.warn('Module "', moduleName, '" attempted to redefine configuration for dependency. "', requireEntry.name, '"\n Additional Files Loaded:', diff);
                    }

                    // Push everything to the file loader, it will weed out the duplicates.
                    promisesList.push(filesLoader(requireEntry.files, localParams).then(function() {
                      return loadDependencies(requireEntry);
                    }));
                  }
                  return;
                } else if(typeof requireEntry === 'object') {
                  if(requireEntry.hasOwnProperty('name') && requireEntry['name']) {
                    // The dependency doesn't exist in the module cache and is a new configuration, so store and push it.
                    self.setModuleConfig(requireEntry);
                    moduleCache.push(requireEntry['name']);
                  }

                  // CSS Loading Handler
                  if(requireEntry.hasOwnProperty('css') && requireEntry['css'].length !== 0) {
                    // Locate the document insertion point
                    angular.forEach(requireEntry['css'], function(path) {
                      buildElement('css', path, localParams);
                    });
                  }
                  // CSS End.
                }

                // Check if the dependency has any files that need to be loaded. If there are, push a new promise to the promise list.
                if(requireEntry.hasOwnProperty('files') && requireEntry.files.length !== 0) {
                  if(requireEntry.files) {
                    promisesList.push(filesLoader(requireEntry, localParams).then(function() {
                      return loadDependencies(requireEntry);
                    }));
                  }
                }
              });

              // Create a wrapper promise to watch the promise list and resolve it once everything is done.
              return $q.all(promisesList);
            }

            filesLoader(config, localParams).then(function success() {
              if(moduleName === null) {
                deferred.resolve(module);
              } else {
                moduleCache.push(moduleName);
                loadDependencies(moduleName).then(function success() {
                  try {
                    justLoaded = [];
                    register(providers, moduleCache, localParams);
                  } catch(e) {
                    $log.error(e.message);
                    deferred.reject(e);
                    return;
                  }
                  deferred.resolve(module);
                }, function error(err) {
                  deferred.reject(err);
                });
              }
            }, function error(err) {
              deferred.reject(err);
            });

            return deferred.promise;
          }
        };
      }];

      this.config = function(config) {
        if(angular.isDefined(config.jsLoader) || angular.isDefined(config.asyncLoader)) {
          if(!angular.isFunction(config.jsLoader || config.asyncLoader)) {
            throw('The js loader needs to be a function');
          }
          jsLoader = config.jsLoader || config.asyncLoader;
        }

        if(angular.isDefined(config.cssLoader)) {
          if(!angular.isFunction(config.cssLoader)) {
            throw('The css loader needs to be a function');
          }
          cssLoader = config.cssLoader;
        }

        if(angular.isDefined(config.templatesLoader)) {
          if(!angular.isFunction(config.templatesLoader)) {
            throw('The template loader needs to be a function');
          }
          templatesLoader = config.templatesLoader;
        }

        // If we want to define modules configs
        if(angular.isDefined(config.modules)) {
          if(angular.isArray(config.modules)) {
            angular.forEach(config.modules, function(moduleConfig) {
              modules[moduleConfig.name] = moduleConfig;
            });
          } else {
            modules[config.modules.name] = config.modules;
          }
        }

        if(angular.isDefined(config.debug)) {
          debug = config.debug;
        }

        if(angular.isDefined(config.events)) {
          events = config.events;
        }
      };
    }]);

  ocLazyLoad.directive('ocLazyLoad', ['$ocLazyLoad', '$compile', '$animate', '$parse',
    function($ocLazyLoad, $compile, $animate, $parse) {
      return {
        restrict: 'A',
        terminal: true,
        priority: 1000,
        compile: function(element, attrs) {
          // we store the content and remove it before compilation
          var content = element[0].innerHTML;
          element.html('');

          return function($scope, $element, $attr) {
            var model = $parse($attr.ocLazyLoad);
            $scope.$watch(function() {
              // it can be a module name (string), an object, an array, or a scope reference to any of this
              return model($scope) || $attr.ocLazyLoad;
            }, function(moduleName) {
              if(angular.isDefined(moduleName)) {
                $ocLazyLoad.load(moduleName).then(function success(moduleConfig) {
                  $animate.enter($compile(content)($scope), null, $element);
                });
              }
            }, true);
          };
        }
      };
    }]);

  /**
   * Get the list of required modules/services/... for this module
   * @param module
   * @returns {Array}
   */
  function getRequires(module) {
    var requires = [];
    angular.forEach(module.requires, function(requireModule) {
      if(regModules.indexOf(requireModule) === -1) {
        requires.push(requireModule);
      }
    });
    return requires;
  }

  /**
   * Check if a module exists and returns it if it does
   * @param moduleName
   * @returns {boolean}
   */
  function moduleExists(moduleName) {
    try {
      return angular.module(moduleName);
    } catch(e) {
      if(/No module/.test(e) || (e.message.indexOf('$injector:nomod') > -1)) {
        return false;
      }
    }
  }

  function getModule(moduleName) {
    try {
      return angular.module(moduleName);
    } catch(e) {
      // this error message really suxx
      if(/No module/.test(e) || (e.message.indexOf('$injector:nomod') > -1)) {
        e.message = 'The module "' + moduleName + '" that you are trying to load does not exist. ' + e.message
      }
      throw e;
    }
  }

  function invokeQueue(providers, queue, moduleName, reconfig) {
    if(!queue) {
      return;
    }

    var i, len, args, provider;
    for(i = 0, len = queue.length; i < len; i++) {
      args = queue[i];
      if(angular.isArray(args)) {
        if(providers !== null) {
          if(providers.hasOwnProperty(args[0])) {
            provider = providers[args[0]];
          } else {
            throw new Error('unsupported provider ' + args[0]);
          }
        }
        var isNew = registerInvokeList(args, moduleName);
        if(args[1] !== 'invoke') {
          if(isNew && angular.isDefined(provider)) {
            provider[args[1]].apply(provider, args[2]);
          }
        } else { // config block
          var callInvoke = function(fct) {
            var invoked = regConfigs.indexOf(moduleName + '-' + fct);
            if(invoked === -1 || reconfig) {
              if(invoked === -1) {
                regConfigs.push(moduleName + '-' + fct);
              }
              if(angular.isDefined(provider)) {
                provider[args[1]].apply(provider, args[2]);
              }
            }
          }
          if(angular.isFunction(args[2][0])) {
            callInvoke(args[2][0]);
          } else if(angular.isArray(args[2][0])) {
            for(var j = 0, jlen = args[2][0].length; j < jlen; j++) {
              if(angular.isFunction(args[2][0][j])) {
                callInvoke(args[2][0][j]);
              }
            }
          }
        }
      }
    }
  }

  /**
   * Register a new module and load it
   * @param providers
   * @param registerModules
   * @returns {*}
   */
  function register(providers, registerModules, params) {
    if(registerModules) {
      var k, r, moduleName, moduleFn, tempRunBlocks = [];
      for(k = registerModules.length - 1; k >= 0; k--) {
        moduleName = registerModules[k];
        if(typeof moduleName !== 'string') {
          moduleName = getModuleName(moduleName);
        }
        if(!moduleName || justLoaded.indexOf(moduleName) !== -1) {
          continue;
        }
        var newModule = regModules.indexOf(moduleName) === -1;
        moduleFn = angular.module(moduleName);
        if(newModule) { // new module
          regModules.push(moduleName);
          register(providers, moduleFn.requires, params);
        }
        if(moduleFn._runBlocks.length > 0) {
          // new run blocks detected! Replace the old ones (if existing)
          runBlocks[moduleName] = [];
          while(moduleFn._runBlocks.length > 0) {
            runBlocks[moduleName].push(moduleFn._runBlocks.shift());
          }
        }
        if(angular.isDefined(runBlocks[moduleName]) && (newModule || params.rerun)) {
          tempRunBlocks = tempRunBlocks.concat(runBlocks[moduleName]);
        }
        invokeQueue(providers, moduleFn._invokeQueue, moduleName, params.reconfig);
        invokeQueue(providers, moduleFn._configBlocks, moduleName, params.reconfig); // angular 1.3+
        broadcast(newModule ? 'ocLazyLoad.moduleLoaded' : 'ocLazyLoad.moduleReloaded', moduleName);
        registerModules.pop();
        justLoaded.push(moduleName);
      }
      // execute the run blocks at the end
      var instanceInjector = providers.getInstanceInjector();
      angular.forEach(tempRunBlocks, function(fn) {
        instanceInjector.invoke(fn);
      });
    }
  }

  /**
   * Register an invoke
   * @param args
   * @returns {*}
   */
  function registerInvokeList(args, moduleName) {
    var invokeList = args[2][0],
      type = args[1],
      newInvoke = false;
    if(angular.isUndefined(regInvokes[moduleName])) {
      regInvokes[moduleName] = {};
    }
    if(angular.isUndefined(regInvokes[moduleName][type])) {
      regInvokes[moduleName][type] = [];
    }
    var onInvoke = function(invokeName) {
      newInvoke = true;
      regInvokes[moduleName][type].push(invokeName);
      broadcast('ocLazyLoad.componentLoaded', [moduleName, type, invokeName]);
    }
    if(angular.isString(invokeList) && regInvokes[moduleName][type].indexOf(invokeList) === -1) {
      onInvoke(invokeList);
    } else if(angular.isObject(invokeList)) {
      angular.forEach(invokeList, function(invoke) {
        if(angular.isString(invoke) && regInvokes[moduleName][type].indexOf(invoke) === -1) {
          onInvoke(invoke);
        }
      });
    } else {
      return false;
    }
    return newInvoke;
  }

  function getModuleName(module) {
    var moduleName = null;
    if(angular.isString(module)) {
      moduleName = module;
    } else if(angular.isObject(module) && module.hasOwnProperty('name') && angular.isString(module.name)) {
      moduleName = module.name;
    }
    return moduleName;
  }

  /**
   * Get the list of existing registered modules
   * @param element
   */
  function init(element) {
    if(initModules.length === 0) {
      var elements = [element],
        names = ['ng:app', 'ng-app', 'x-ng-app', 'data-ng-app'],
        NG_APP_CLASS_REGEXP = /\sng[:\-]app(:\s*([\w\d_]+);?)?\s/,
        append = function append(elm) {
          return (elm && elements.push(elm));
        };

      angular.forEach(names, function(name) {
        names[name] = true;
        append(document.getElementById(name));
        name = name.replace(':', '\\:');
        if(element[0].querySelectorAll) {
          angular.forEach(element[0].querySelectorAll('.' + name), append);
          angular.forEach(element[0].querySelectorAll('.' + name + '\\:'), append);
          angular.forEach(element[0].querySelectorAll('[' + name + ']'), append);
        }
      });

      angular.forEach(elements, function(elm) {
        if(initModules.length === 0) {
          var className = ' ' + element.className + ' ';
          var match = NG_APP_CLASS_REGEXP.exec(className);
          if(match) {
            initModules.push((match[2] || '').replace(/\s+/g, ','));
          } else {
            angular.forEach(elm.attributes, function(attr) {
              if(initModules.length === 0 && names[attr.name]) {
                initModules.push(attr.value);
              }
            });
          }
        }
      });
    }
    if(initModules.length === 0) {
      throw 'No module found during bootstrap, unable to init ocLazyLoad';
    }

    var addReg = function addReg(moduleName) {
      if(regModules.indexOf(moduleName) === -1) {
        // register existing modules
        regModules.push(moduleName);
        var mainModule = angular.module(moduleName);

        // register existing components (directives, services, ...)
        invokeQueue(null, mainModule._invokeQueue, moduleName);
        invokeQueue(null, mainModule._configBlocks, moduleName); // angular 1.3+

        angular.forEach(mainModule.requires, addReg);
      }
    };

    angular.forEach(initModules, function(moduleName) {
      addReg(moduleName);
    });
  }

  var bootstrap = angular.bootstrap;
  angular.bootstrap = function(element, modules, config) {
    initModules = modules.slice(); // make a clean copy
    return bootstrap(element, modules, config);
  };
})();


/***/ }),

/***/ "44/O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var module_1 = __webpack_require__("jYQ6");
var Strings_1 = __webpack_require__("fxc3");
var underscore_extensions_1 = __webpack_require__("R0iF");
var visitControl = __webpack_require__("LKwz");
exports.clearVisitStore = visitControl.clear;
var AnalyticSvc = (function () {
    AnalyticSvc.$inject = ["$location", "$state", "$rootScope", "$log", "landingTemplateSvc", "ipCookie", "LocalStorageSvc"];
    function AnalyticSvc($location, $state, $rootScope, $log, landingTemplateSvc, ipCookie, LocalStorageSvc) {
        var _this = this;
        this.$location = $location;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$log = $log;
        this.landingTemplateSvc = landingTemplateSvc;
        this.ipCookie = ipCookie;
        this.LocalStorageSvc = LocalStorageSvc;
        this.mixpanelEnabled = true;
        this.activateKeyName = 'analytic_track_activate_page_';
        this.getGaHeader = function () { return ({
            'anm-mkt-ga': _this.ipCookie('_ga')
        }); };
        $rootScope.$on('$stateChangeSuccess', function () {
            _this.registerCommonProperties();
            _this.trackVisit();
        });
    }
    AnalyticSvc.prototype.upgradeShown = function (action, plan) {
        if (plan === void 0) { plan = this.getDefaultPlan(); }
        var opt = (_a = {},
            _a[this.getProduct() + " Plan"] = plan,
            _a);
        this.registerUserProperties();
        this.trackMixpanel(Strings_1.Strings.capitalize(action) + " Shown", opt);
        var _a;
    };
    AnalyticSvc.prototype.changeBillingPeriod = function (oldPeriod, newPeriod) {
        var opt = tslib_1.__assign({}, this.getPlan(), { 'Old Period': oldPeriod, 'New Period': newPeriod });
        this.registerUserProperties();
        this.trackMixpanel('Change Billing Period', opt);
    };
    AnalyticSvc.prototype.changeSubscription = function (action, oldPlan, oldPeriod, toPlan, toPeriod, chargedAmount, coupon) {
        // this.gaChangeSubscription(action, toPlan);
        if (toPlan === void 0) { toPlan = this.getDefaultPlan(); }
        this.mpChangeSubscription(action, oldPlan, oldPeriod, toPlan, toPeriod, chargedAmount, coupon);
        this.fbqChangeSubscription(oldPlan, toPlan, toPeriod);
    };
    AnalyticSvc.prototype.addTransaction = function (price, subscriptionName) {
        var transactionId = options.user.userId + " - " + Date.now();
        this.gaAddTransaction(transactionId, price, subscriptionName);
        this.fbqAddTransaction(transactionId, price, subscriptionName);
    };
    AnalyticSvc.prototype.gaAddTransaction = function (id, price, name) {
        this.ga('ecommerce:addTransaction', {
            id: id,
            revenue: price
        });
        this.ga('ecommerce:addItem', {
            id: id,
            name: name,
            price: price,
            quantity: 1
        });
        this.ga('ecommerce:send');
    };
    AnalyticSvc.prototype.fbqAddTransaction = function (id, price, planName) {
        this.fbq('track', 'Purchase', {
            id: id,
            planName: planName,
            value: price,
            currency: 'USD'
        });
    };
    AnalyticSvc.prototype.signUpSubmit = function () {
        var _this = this;
        // this.gaSignUpEvent('Submit');
        // this.gaProductSignUpEvent();
        this.getMixPanel(function (mixpanel) {
            _this.registerUserProperties();
            mixpanel.track('Sign Up Submit', { Provider: 'EMAIL' });
        });
    };
    AnalyticSvc.prototype.signUpActivate = function (hash) {
        var _this = this;
        var currentHash = this.LocalStorageSvc.get(this.activateKeyName);
        if (hash && hash !== currentHash) {
            // this.gaSignUpEvent('Activate');
            this.getMixPanel(function (mixpanel) {
                _this.registerUserProperties();
                mixpanel.track('Sign Up Activation', { Provider: 'EMAIL' });
            });
            this.LocalStorageSvc.set(this.activateKeyName, hash);
        }
    };
    AnalyticSvc.prototype.signUpComplete = function () {
        // this.gaSignUpEvent('Complete');
        this.fbPixelSignUpComplete();
        this.trackSignUp('Email');
    };
    AnalyticSvc.prototype.signUpProfileComplete = function (provider) {
        // this.gaSignUpEvent('ProfileComplete', provider);
    };
    AnalyticSvc.prototype.signUpSocialSubmit = function (provider) {
        // this.gaSignUpEvent('Submit', provider);
    };
    AnalyticSvc.prototype.signUpSocialComplete = function (provider) {
        // this.gaSignUpEvent('Complete', provider);
        this.fbPixelSignUpComplete();
        this.trackSignUp(provider);
    };
    AnalyticSvc.prototype.login = function (user) {
        // this.gaSetUserId(user.userId); // TODO maybe need in the future
        this.trackLoginMixpanel();
    };
    AnalyticSvc.prototype.logout = function () {
        // this.gaSetUserId(null);// TODO maybe need in the future
        this.mixpanelLogout();
    };
    AnalyticSvc.prototype.visitPage = function (pageName, additionalParams) {
        if (additionalParams === void 0) { additionalParams = {}; }
        this.registerCommonProperties();
        var params = tslib_1.__assign({ Product: this.getProduct() }, additionalParams);
        this.trackMixpanel("Visit " + pageName + " Page", params);
    };
    AnalyticSvc.prototype.changePage = function () {
        if (!window.ga)
            return;
        this.ga('set', 'page', this.$location.url());
        this.ga('send', 'pageview');
    };
    AnalyticSvc.prototype.getPlan = function () {
        var _a = options.user.subscriptionDetails, wave = _a.wave, studio = _a.studio;
        return {
            'WAVE Plan': wave.displayName,
            'STUDIO Plan': studio.displayName
        };
    };
    AnalyticSvc.prototype.selectProduct = function (product) {
        this.mpSelectProduct(product);
    };
    AnalyticSvc.prototype.fbq = function () {
        var arg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arg[_i] = arguments[_i];
        }
        return window.fbq && window.fbq.apply(window, arg);
    };
    AnalyticSvc.prototype.ga = function () {
        var arg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arg[_i] = arguments[_i];
        }
        return window.ga && window.ga.apply(window, arg);
    };
    AnalyticSvc.prototype.mpSelectProduct = function (product) {
        return this.getMixPanel(function (mixpanel) {
            mixpanel.track('Selected Product', { 'Product': product });
        });
    };
    AnalyticSvc.prototype.fbPixelSignUpComplete = function () {
        var _a = options.user.meta, industry = _a.industry, goals = _a.goals, occupation = _a.occupation;
        var params = {
            product: this.getProduct(),
            industry: industry,
            goals: goals
        };
        if (occupation) {
            params['occupation'] = occupation;
        }
        this.fbq('trackCustom', 'CompleteRegistration', params);
    };
    AnalyticSvc.prototype.fbqChangeSubscription = function (oldPlan, toPlan, toPeriod) {
        if (toPlan === void 0) { toPlan = this.getDefaultPlan(); }
        this.fbq('trackCustom', 'ChangePlan', {
            product: this.getProduct(),
            new_plan: toPlan,
            old_plan: oldPlan,
            period: toPeriod
        });
    };
    AnalyticSvc.prototype.mpChangeSubscription = function (action, oldPlan, oldPeriod, toPlan, toPeriod, chargedAmount, coupon) {
        var _this = this;
        if (toPlan === void 0) { toPlan = this.getDefaultPlan(); }
        this.getMixPanel(function (mixpanel) {
            var params = (_a = {},
                _a[_this.getProduct() + " Plan"] = toPlan,
                _a[_this.getProduct() + " Old Plan"] = oldPlan,
                _a['Old Period'] = oldPeriod,
                _a.Period = toPeriod,
                _a);
            if (chargedAmount && action === 'upgrade') {
                params['Charged'] = chargedAmount.toString();
                mixpanel.people.track_charge(chargedAmount);
            }
            if (coupon)
                params['Coupon'] = coupon;
            var eventName = Strings_1.Strings.capitalize(action) + 'd';
            _this.registerUserProperties();
            _this.trackMixpanel(eventName, params);
            var _a;
        });
    };
    AnalyticSvc.prototype.gaChangeSubscription = function (action, toPlan) {
        var isFree = ['WaveFree', 'Free'].includes(toPlan);
        if (action === 'upgrade' || isFree) {
            var eventName = Strings_1.Strings.capitalize(action);
            this.ga('send', 'event', this.getProduct(), eventName);
        }
    };
    AnalyticSvc.prototype.trackVisit = function () {
        var _this = this;
        return this.getMixPanel(function (mixpanel) {
            var userId = options.user && options.user.userId;
            var canVisit = !_this.$state.current.name.includes('activate') &&
                visitControl.canVisit(userId);
            if (!canVisit)
                return;
            var params = { Source: _this.getSource() };
            mixpanel.register_once(params);
            mixpanel.people.set_once(params);
            if (options.user.anonymous) {
                var first_params = AnalyticSvc.campaignParams();
                var landingInfoParams = _this.landingTemplateSvc.getTrackInfo();
                mixpanel.people.set_once(first_params);
                mixpanel.track('Guest Visit', tslib_1.__assign({}, landingInfoParams, first_params));
            }
            else {
                mixpanel.identify(options.user.userIdAsString);
                mixpanel.track('Visit', {});
            }
            visitControl.visit(userId);
        });
    };
    AnalyticSvc.getQueryParam = function (url, param) {
        // Expects a raw URL
        param = param.replace(/[[]/, "\[").replace(/[]]/, "\]");
        var regexS = "[\?&]" + param + "=([^&#]*)", regex = new RegExp(regexS), results = regex.exec(url);
        if (results === null || (results && typeof (results[1]) !== 'string' && results[1].length)) {
            return '';
        }
        else {
            return decodeURIComponent(results[1]).replace(/\W/gi, ' ');
        }
    };
    ;
    AnalyticSvc.campaignParams = function () {
        var campaign_keywords = 'utm_source utm_medium utm_campaign utm_content utm_term'.split(' '), kw = '', first_params = {};
        var index;
        for (index = 0; index < campaign_keywords.length; ++index) {
            kw = AnalyticSvc.getQueryParam(document.URL, campaign_keywords[index]);
            if (kw.length) {
                first_params[campaign_keywords[index] + ' [first touch]'] = kw;
            }
        }
        return first_params;
    };
    AnalyticSvc.prototype.getSource = function () {
        var referrer = document.referrer;
        if (referrer.search('https?://(.*)google.([^/?]*)') === 0) {
            return 'Google';
        }
        else if (referrer.search('https?://(.*)bing.([^/?]*)') === 0) {
            return 'Bing';
        }
        else if (referrer.search('https?://(.*)quora.([^/?]*)') === 0) {
            return 'Quora';
        }
        else if (referrer.search('https?://(.*)facebook.([^/?]*)') === 0) {
            return 'Facebook';
        }
        else if (referrer.search('https?://(.*)twitter.([^/?]*)') === 0) {
            return 'Twitter';
        }
        else if (referrer.search('https?://(.*)animatron.([^/?]*)') === 0) {
            return 'Animatron';
        }
        else if (referrer.search('https?://(.*)youtube.([^/?]*)') === 0) {
            return 'Youtube';
        }
        else if (referrer.search('https?://(.*)yahoo.([^/?]*)') === 0) {
            return 'Yahoo';
        }
        else if (referrer.search('https?://(.*)naver.([^/?]*)') === 0) {
            return 'Naver';
        }
        else {
            return referrer;
        }
    };
    AnalyticSvc.prototype.mixpanelLogout = function () {
        return this.getMixPanel(function (mixpanel) {
            mixpanel.reset();
        });
    };
    AnalyticSvc.prototype.getMixPanel = function (func) {
        return this.mixpanelEnabled && window.mixpanel && func(window.mixpanel);
    };
    AnalyticSvc.prototype.registerCommonProperties = function () {
        var props = {
            Place: 'Website'
        };
        if (this.getProduct() !== 'ANY') {
            props['Product'] = this.getProduct();
        }
        return this.getMixPanel(function (mixpanel) { return mixpanel.register(props); });
    };
    AnalyticSvc.prototype.registerUserProperties = function () {
        var _this = this;
        this.getMixPanel(function (mixpanel) {
            var props = tslib_1.__assign({}, _this.getPlan(), { '$name': options.user.displayName, Username: options.user.username, Product: _this.getProduct() });
            if (options.user.email) {
                props['$email'] = options.user.email;
            }
            mixpanel.register(props);
        });
    };
    AnalyticSvc.prototype.userInfoMixpanel = function () {
        var displayName = options.user.displayName, idx = displayName.indexOf(' ');
        var props = tslib_1.__assign({}, this.getPlan(), { '$name': displayName, '$first_name': idx >= 0 ? displayName.substring(0, idx) : displayName, '$last_name': idx >= 0 ? displayName.substring(idx + 1) : '', userId: options.user.userIdAsString, Username: options.user.username, Industry: options.user.meta.industry, Occupation: options.user.meta.occupation, Goals: options.user.meta.goals });
        if (options.user.email) {
            props['$email'] = options.user.email;
        }
        return props;
    };
    AnalyticSvc.prototype.trackMixpanel = function (eventName, opts) {
        var _this = this;
        return this.getMixPanel(function (m) {
            // the setTimeout fix some problem with browser request canceled
            setTimeout(function () {
                m.track(eventName, opts);
                (_a = _this.$log).debug.apply(_a, ['Mixpanel track: '].concat(m[0]));
                var _a;
            }, 100);
            return m;
        });
    };
    AnalyticSvc.prototype.trackLoginMixpanel = function () {
        var _this = this;
        return this.getMixPanel(function (mixpanel) {
            _this.registerUserProperties();
            _this.trackVisit();
            mixpanel.people.set(_this.userInfoMixpanel());
        });
    };
    AnalyticSvc.prototype.isAllowedMethod = function (provider) {
        return !_.isUndefined(provider) &&
            ['google', 'facebook', 'email', 'twitter'].indexOf(provider.toLowerCase()) !== 1;
    };
    AnalyticSvc.prototype.trackSignUp = function (provider) {
        var _this = this;
        if (this.isAllowedMethod(provider)) {
            this.getMixPanel(function (mixpanel) {
                mixpanel.alias(options.user.userIdAsString);
                mixpanel.people.set(_.extend({
                    '$created': new Date().toISOString(),
                    Provider: provider,
                    Place: 'Website',
                    Product: options.user.meta.product
                }, _this.userInfoMixpanel()));
                _this.registerUserProperties();
                mixpanel.track('Sign Up', { Provider: Strings_1.Strings.capitalize(provider) });
            });
        }
    };
    AnalyticSvc.prototype.getDefaultPlan = function () {
        return this.getProduct() === 'WAVE' ? 'WaveFree' : 'Free';
    };
    AnalyticSvc.prototype.getProduct = function () {
        return underscore_extensions_1.Utils.getProduct();
    };
    AnalyticSvc.prototype.gaSetUserId = function (userId) {
        this.ga('set', 'userId', userId);
    };
    AnalyticSvc.prototype.gaSignUpEvent = function (eventName, provider) {
        if (provider === void 0) { provider = 'Email'; }
        this.ga('send', 'event', 'SignUp', eventName, Strings_1.Strings.capitalize(provider.toLowerCase()));
    };
    AnalyticSvc.prototype.gaProductSignUpEvent = function () {
        this.ga('send', 'event', this.getProduct(), 'Sign Up');
    };
    return AnalyticSvc;
}());
exports.AnalyticSvc = AnalyticSvc;
module_1.default.service('analyticSvc', AnalyticSvc);


/***/ }),

/***/ "4HmH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var RescaleSvc_1 = __webpack_require__("7T+Z");
var underscore_extensions_1 = __webpack_require__("R0iF");
module_1.default.directive('pickPreviewImage', ["AnimatronPreviews", function (AnimatronPreviews) {
    return function (scope, element, attrs) {
        var project = scope.project || (scope.$ctrl && scope.$ctrl.project);
        var opts = scope.$eval(attrs.pickPreviewImage) || {};
        var width = opts.width || 720;
        if (opts.rescale) {
            underscore_extensions_1.Utils.rAF(function () {
                var w = element[0].getBoundingClientRect().width - 20;
                var dim = RescaleSvc_1.RescaleSvc.resizeWithAspectRatio(project.width * 9999, project.height * 9999, w, opts.rescale.height);
                element[0].style.width = dim.width + 'px';
                element[0].style.height = dim.height + 'px';
            });
        }
        var preview = AnimatronPreviews
            .pickPreview(opts.images || project.preview_metadata, width)
            .replace(/(http:|https:)/, '');
        var image = document.createElement('img');
        image.classList.add('preview');
        image.src = preview;
        if (project) {
            image.style.color = 'transparent';
            image.alt = project.name;
        }
        element[0].appendChild(image);
        image.onerror = function () {
            element.addClass('animatron-hero-background');
            image.style.display = 'none';
        };
        // image.onload  = () => element[0].appendChild(image);
    };
}]);


/***/ }),

/***/ "4NXJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var underscore_extensions_1 = __webpack_require__("R0iF");
var OpenEditor = (function () {
    OpenEditor.$inject = ["$state", "userProjectCountSvc"];
    function OpenEditor($state, userProjectCountSvc) {
        this.$state = $state;
        this.userProjectCountSvc = userProjectCountSvc;
        this.action = this.action || 'openVideoTemplates';
    }
    OpenEditor.prototype.clickHandler = function () {
        switch (this.action) {
            case 'create':
                this.createNew();
                break;
            case 'openVideoTemplates':
                this.openVideoTemplates();
                break;
            case 'edit':
                this.edit();
                break;
            case 'duplicate':
                this.duplicate();
                break;
        }
    };
    OpenEditor.prototype.goUpgrade = function () {
        var _this = this;
        this.$state
            .go('wave-pricing')
            .then(function () { return (_this.isUpgradeDialog = false); });
    };
    OpenEditor.prototype.edit = function () {
        if (this.canOpen && this.projectId) {
            window.open(options.waveEditorDomain + "#p=" + this.projectId, '_blank');
        }
    };
    OpenEditor.prototype.duplicate = function () {
        if (this.canOpen && this.projectId) {
            window.open(options.waveEditorDomain + "#d=" + this.projectId, '_blank');
        }
    };
    OpenEditor.prototype.createNew = function () {
        var _this = this;
        var query = '';
        if (this.params) {
            query = underscore_extensions_1.Utils.toParams(this.params);
            query = "&" + query;
        }
        this.setVideosCount().then(function () {
            if (_this.canCreate) {
                if (_this.canOpen) {
                    window.open(options.waveEditorDomain + "#new=1" + query, '_self');
                }
            }
            else {
                _this.isUpgradeDialog = true;
            }
        });
    };
    OpenEditor.prototype.openVideoTemplates = function () {
        this.$state.go('video-templates');
    };
    OpenEditor.prototype.setVideosCount = function () {
        var _this = this;
        return this.userProjectCountSvc
            .getCount()
            .then(function (count) { return (_this.videosCount = count); });
    };
    Object.defineProperty(OpenEditor.prototype, "canOpen", {
        get: function () {
            if (options.handHeld) {
                this.$state.go('editor-redirect');
                return false;
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OpenEditor.prototype, "canCreate", {
        get: function () {
            return (this.details.name !== 'WaveFree' ||
                this.videosCount < this.videosLimit);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OpenEditor.prototype, "details", {
        get: function () {
            return options.user.subscriptionDetails.wave;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OpenEditor.prototype, "videosLimit", {
        get: function () {
            return this.details.features.PrivateUnlistedProjects.numProjects;
        },
        enumerable: true,
        configurable: true
    });
    return OpenEditor;
}());
exports.OpenEditor = OpenEditor;
module_1.default.component('openEditor', {
    bindings: {
        className: '@',
        action: '@?',
        params: '<',
        projectId: '<?'
    },
    transclude: true,
    controller: OpenEditor,
    templateUrl: __webpack_require__("tp6s")
});


/***/ }),

/***/ "4Y92":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/challenges-list_4ccaa71978dc9f423e5384f4e5a041ad.css";

/***/ }),

/***/ "4eYb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/tabs_32e7a08c8e5a8da5185273ffab5307fb.css";

/***/ }),

/***/ "4jE+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/10.png";

/***/ }),

/***/ "4sGx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
module_1.default.directive('buttonSpinner', ["$timeout", function ($timeout) { return ({
    restrict: 'E',
    require: '?^form',
    transclude: true,
    scope: {
        loading: '=',
        onClick: '&',
        minDelay: '=?',
        type: '@?'
    },
    template: "<button type=\"{{type || 'submit'}}\" ng-class=\"{loading:loadingShow}\" class=\"button button-spinner\" ng-disabled=\"loadingShow\" ng-click=\"click()\">\n    <span ng-transclude></span>\n    <loader-horizontal ng-show=\"loadingShow\"></loader-horizontal>\n    </button>",
    compile: function (el, attrs) {
        if (_.isString(attrs.btnClass)) {
            var classes = attrs.btnClass.split(' ');
            classes.forEach(function (v) { return el[0].querySelector('.button').classList.add(v); });
        }
        return this.link;
    },
    link: function (scope, element, attrs, FormCtrl) {
        scope.minDelay = scope.minDelay || 800;
        var timeOn = 0;
        var timeoutHideSpinner;
        // animation for appear loader - add padding-right and CSS3 will animate
        scope.$watch('loading', function (loading) {
            if (loading) {
                scope.loadingShow = true; // show spinner
                timeOn = _.now(); // get current date
            }
            else {
                var delay = _.now() - timeOn; //show - how much time passed after spinner was started
                timeoutHideSpinner = $timeout(function () {
                    scope.loadingShow = false; // hide spinner
                }, delay > scope.minDelay ? 0 : scope.minDelay - delay); // spinner must work 800 more
            }
        });
        scope.click = function () {
            if (scope.type === 'submit' && FormCtrl)
                FormCtrl.$setSubmitted();
            scope.onClick();
        };
        scope.$on('$destroy', function () { return $timeout.cancel(timeoutHideSpinner); });
    }
}); }]);


/***/ }),

/***/ "4uz1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/subscription-billing-info-form_d41d8cd98f00b204e9800998ecf8427e.css";

/***/ }),

/***/ "4zkA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/12.svg";

/***/ }),

/***/ "57HE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/section-video-statistics_92c24a88b8034bde76441db81bb6e76d.css";

/***/ }),

/***/ "5G1g":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/icon-text-list_f860b2e82ef7ac88f4c121666f854125.css";

/***/ }),

/***/ "5MIU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/contest-days-top-section_a351dd78454d42385c4e42ae3ba62c57.css";

/***/ }),

/***/ "5TC1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/f_bsh-button_e9d9078c1eb087f46811f3ddb485d0b8.css";

/***/ }),

/***/ "5W2z":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/title-block_2a4adc6506cca5788081e149c97ecbee.css";

/***/ }),

/***/ "5hi/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var Strings_1 = __webpack_require__("fxc3");
module_1.default.filter('uniqueFilter', function () { return function (items, filterOn) {
    return _.unique(items, false, function (item) { return item[filterOn]; });
}; });
module_1.default.filter('prependHttp', function () { return function (url) {
    if (Strings_1.Strings.isBlank(url))
        return '';
    var withHttp = url.indexOf('http://') === 0 || url.indexOf('https://') === 0;
    return withHttp ? url : 'http://' + url;
}; });
module_1.default.filter('visibilityExplanation', ["TranslateSvc", function (TranslateSvc) {
    var visibilities = {
        'public': TranslateSvc.get('visibility.public'),
        'unlisted': TranslateSvc.get('visibility.unlisted'),
        'private': TranslateSvc.get('visibility.private')
    };
    return function (visibility) { return visibilities[(visibility || 'public').toLowerCase()]; };
}]);
module_1.default.filter('encodeUrl', function () { return function (url) { return encodeURIComponent(url); }; });
module_1.default.filter('trust', ["$sce", function ($sce) { return function (html) { return $sce.trustAsHtml(html); }; }]);
module_1.default.filter('encodeUsername', function () { return function (username) { return Strings_1.Strings.encodeUsername(username); }; });
module_1.default.filter('formatNumbers', function () {
    return function (num) {
        num = num.toString();
        if (num.length >= 5) {
            return num.replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
        }
        return num;
    };
});
module_1.default.filter('removeUrlProtocol', function () { return function (url) { return Strings_1.Strings.removeUrlProtocol(url); }; });
module_1.default.filter('toCardId', function () {
    var cards = {
        'american express': 'amex',
        'diners club': 'diners'
    };
    return function (str) {
        return angular.isString(str) ? cards[str] || str : '';
    };
});
module_1.default.filter('parseDate', function () {
    return function (str) {
        if (_.isString(str)) {
            var conventionalDate = str.split('/').reverse().join('/');
            return new Date(conventionalDate).getTime().toString();
        }
        else {
            return '';
        }
    };
});
module_1.default.filter('stripTags', function () { return function (input) { return Strings_1.Strings.stripTags(input); }; });
module_1.default.filter('linky', ["$sce", function ($sce) {
    var LINKY_URL_REGEXP = /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"”’]/, MAILTO_REGEXP = /^mailto:/;
    return function (text, target) {
        if (!text)
            return text;
        var match;
        var raw = text;
        var html = [];
        var url;
        var i;
        while ((match = raw.match(LINKY_URL_REGEXP))) {
            // We can not end in these as they are sometimes found at the end of the sentence
            url = match[0];
            // if we did not match ftp/http/www/mailto then assume mailto
            if (!match[2] && !match[4]) {
                url = (match[3] ? 'http://' : 'mailto:') + url;
            }
            i = match.index;
            addText(raw.substr(0, i));
            addLink(url, match[0].replace(MAILTO_REGEXP, ''));
            raw = raw.substring(i + match[0].length);
        }
        addText(raw);
        return $sce.trustAsHtml(html.join(''));
        function addText(text) {
            if (text) {
                html.push(text);
            }
        }
        function addLink(url, text) {
            html.push('<a ');
            if (angular.isDefined(target)) {
                html.push('target="', target, '" ');
            }
            html.push('href="', url.replace(/"/g, '&quot;'), '">');
            addText(text);
            html.push('</a>');
        }
    };
}]);


/***/ }),

/***/ "5j0l":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/feedback-slider_3ab61f6136cf8a2b22ba00d33a33d897.css";

/***/ }),

/***/ "5l58":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/11.svg";

/***/ }),

/***/ "5uTM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var underscore_extensions_1 = __webpack_require__("R0iF");
module_1.default.directive('headroom', ["$rootScope", "$state", "LocalStorageSvc", function ($rootScope, $state, LocalStorageSvc) {
    return function (scope, element) {
        var header = element[0];
        var headerHeight = 72; // just hardcode, can be even null, but this should be better
        var isTop = true;
        var lastKnownScrollY = 0;
        window.addEventListener('scroll', _.throttle(function () { return underscore_extensions_1.Utils.rAF(function () {
            if (document.documentElement.classList.contains('noscroll')) {
                return;
            }
            var scrollY = window.scrollY || window.pageYOffset;
            if (scrollY >= headerHeight && isTop) {
                isTop = false;
                header.classList.add('not-top');
                if (!LocalStorageSvc.get('banner-shown')) {
                    $rootScope.$apply(function () {
                        $rootScope.headerNotTop = true;
                        LocalStorageSvc.set('banner-shown', true);
                    });
                }
            }
            else if (scrollY < headerHeight && !isTop) {
                isTop = true;
                header.classList.remove('not-top');
            }
            if (scrollY < lastKnownScrollY) {
                header.classList.add('scrolled-up');
            }
            else if (scrollY > lastKnownScrollY) {
                header.classList.remove('scrolled-up');
            }
            lastKnownScrollY = scrollY;
        }); }, 50));
    };
}]);


/***/ }),

/***/ "5zD6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/spin.png";

/***/ }),

/***/ "67wm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/countdown-section_6cec200ba43d472947cfe678c2734922.css";

/***/ }),

/***/ "6JEJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/favicon-wave.ico";

/***/ }),

/***/ "6M8O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var underscore_extensions_1 = __webpack_require__("R0iF");
var module_1 = __webpack_require__("hfrq");
var getLoginState = function () {
    return underscore_extensions_1.Utils.getProduct() === 'WAVE' ? 'login' : 'studio-login';
};
exports.handlerClickLogin = function (state, AuthenticationSvc) { return function () {
    return options.handHeld
        ? state.go(getLoginState())
        : AuthenticationSvc.toggleLoginModal();
}; };
exports.handlerClickSignUp = function (productName) { return function () {
    var redirectAfterSignUpUrls = ['workshops', 'tutorial'];
    var isRedirectUrl = redirectAfterSignUpUrls.includes(location.pathname.replace('/', ''));
    var redirectParam = isRedirectUrl ? "?redirectUrl=" + location.href : '';
    return underscore_extensions_1.Utils.redirectToReact("signup" + redirectParam, productName);
}; };
exports.canShowLoginButton = function (state) { return function () {
    return !(state.is('login') || state.is('studio-login'));
}; };
var StudioHeader = (function () {
    StudioHeader.$inject = ["$state", "AuthenticationSvc"];
    function StudioHeader($state, AuthenticationSvc) {
        this.$state = $state;
        this.AuthenticationSvc = AuthenticationSvc;
        this.handlerClickLogin = exports.handlerClickLogin(this.$state, this.AuthenticationSvc);
        this.handlerClickSignUp = exports.handlerClickSignUp('STUDIO');
        this.canShowLoginButton = exports.canShowLoginButton(this.$state);
    }
    return StudioHeader;
}());
module_1.default.component('studioHeader', {
    controller: StudioHeader,
    templateUrl: __webpack_require__("1aEF")
});


/***/ }),

/***/ "6XG8":
/***/ (function(module, exports, __webpack_require__) {

var path = 'https://assets.animatron.com/html/explore.html';
var html = "<news class=\"fix-margin\"></news> <div class=\"projects-header clearfix\"> <tabs-sub-path change-tab=\"ExploreCtrl.onTabChange(currentTab)\" default-tab=\"staff-picks\" config=\"ExploreCtrl.tabsConfig\" tabs=\"ExploreCtrl.tabs\"> </tabs-sub-path> <div class=\"search-box explore-page\" ng-hide=\"true\"> <search></search> </div> <div class=\"billing-period-block\" ng-if=\"ExploreCtrl.currentTab === 'contest-submissions'\"> <label class=\"radio\" for=\"regular-tab\"> <input type=\"radio\" id=\"regular-tab\" value=\"USER\" ng-model=\"ExploreCtrl.contestType\"/> <span class=\"fake-radio\"> <span class=\"subscription-period\">{{::$root.t('user')}}</span> </span> </label> <label class=\"radio\" for=\"sponsored-tab\"> <input type=\"radio\" id=\"sponsored-tab\" value=\"SPONSORED\" ng-model=\"ExploreCtrl.contestType\"/> <span class=\"fake-radio\"> <span class=\"subscription-period\">{{::$root.t('sponsored')}}</span> </span> </label> </div> </div> <static-include src=\"" + __webpack_require__("b6Iv") + "\"></static-include> <div ng-if=\"!animatron.busy && animatron.loaded\" class=\"icon-status-msg-box\"> <div class=\"not-found-msg icon-status-msg icon-no-projects\" ng-if=\"animatron.count === 0 && ExploreCtrl.currentTab === 'my-projects'\"> <span>{{::$root.t('project.you.empty')}}</span> </div> </div> ";
var angular = window.angular;
var injector = angular.element(document).injector();
if (injector) {
injector.get('$templateCache').put(path, html);
} else {
angular.module('templates').run(['$templateCache', function(c) { c.put(path, html) }]);
}
module.exports = path;

/***/ }),

/***/ "6bdG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/company_19e8160a5ce445bcdf2d67254067ea5c.css";

/***/ }),

/***/ "6cC1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/week3_df0f716fff2548446c827d7199219752.html";

/***/ }),

/***/ "6cdR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("jYQ6");
var CookieSettings_1 = __webpack_require__("wz+r");
var TranslateSvc = (function () {
    TranslateSvc.$inject = ["$http", "$log", "$ocLazyLoad", "$q", "ipCookie", "AuthenticationSvc", "HttpSvc"];
    function TranslateSvc($http, $log, $ocLazyLoad, $q, ipCookie, AuthenticationSvc, HttpSvc) {
        var _this = this;
        this.$http = $http;
        this.$log = $log;
        this.$ocLazyLoad = $ocLazyLoad;
        this.$q = $q;
        this.ipCookie = ipCookie;
        this.AuthenticationSvc = AuthenticationSvc;
        this.HttpSvc = HttpSvc;
        this.map = {};
        this.initialized = false;
        this.domainToLang = {
            kr: 'ko'
        };
        this.supportedLangs = _.object(_.pairs({
            en: 'English',
            ko: '한국어'
        }).filter(function (l) { return !true || TranslateSvc.productionLangs.includes(l[0]); }));
        this.async = function (key) { return _this.fetchTranslations().then(function () { return _this.get(key); }); };
        this.fetchTranslations = _.once(function () { return _this.$q(function (resolve) {
            var current = _this.currentLang();
            _this.changeLocale(current);
            var url = __webpack_require__("U56v")("./" + current + ".json");
            return _this.$http.get(url).then(function (r) { return _this.set(r.data, current, resolve); });
        }); });
    }
    TranslateSvc.prototype.has = function (key) {
        return !!this.map[this.formattedKey(key)];
    };
    TranslateSvc.prototype.get = function (key) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var k = this.formattedKey(key);
        if (k && this.initialized && !this.map[k]) {
            if (false) {
                this.$log.error("missing translation for '" + k + "'");
                _.notification.showError("missing translation for '" + k + "'");
            }
            return k;
        }
        if (key && !_.isString(key))
            this.$log.error("wrong key used for translation: '" + key + "'");
        return this.map[k] ? params.reduce(function (str, param) { return str.replace(/{\d}/, param); }, this.map[k]) : undefined;
    };
    ;
    TranslateSvc.prototype.langChange = function (lang) {
        if (!(lang in this.supportedLangs))
            throw new Error("how come? " + lang);
        if (lang === this.lang)
            return;
        this.ipCookie(TranslateSvc.cookieName, lang, CookieSettings_1.CookieSettings.get());
        new Promise(function () { return document.body.style.cursor = 'progress'; });
        if (!options.user.anonymous) {
            var newProps = { meta: { lang: lang } };
            this.AuthenticationSvc.extendUser(newProps);
            this.HttpSvc('profile').securePut(newProps).then(function () { return location.reload(); });
        }
        else {
            location.reload();
        }
    };
    ;
    TranslateSvc.prototype.currentLang = function () {
        var langProps = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'];
        try {
            var foundLang = (options.user.meta && options.user.meta.lang) ||
                this.ipCookie(TranslateSvc.cookieName) ||
                this.langFromTLD() ||
                navigator[_.find(langProps, function (l) { return l in navigator; })].split('_')[0].split('-')[0].toLowerCase();
            return foundLang in this.supportedLangs ? foundLang : TranslateSvc.defaultLang;
        }
        catch (e) {
            this.$log.error(e);
            return TranslateSvc.defaultLang;
        }
    };
    ;
    TranslateSvc.prototype.set = function (map, current, resolve) {
        this.lang = current;
        this.map = map;
        Object.freeze(this.map);
        this.initialized = true;
        this.ipCookie(TranslateSvc.cookieName, this.lang, CookieSettings_1.CookieSettings.get());
        document.documentElement.lang = this.lang;
        Object.freeze(this);
        resolve(this.map);
    };
    TranslateSvc.prototype.changeLocale = function (lang) {
        if (lang === 'en')
            return;
        this.$ocLazyLoad.load({
            name: 'ngLocale',
            files: ["https://cdnjs.cloudflare.com/ajax/libs/angular-i18n/1.6.7/angular-locale_" + lang + ".min.js"]
        }).then(function () {
            try {
                angular.merge(angular.element(document).injector().get('$locale'), angular.injector(['ngLocale']).get('$locale'));
            }
            catch (e) {
                console.error('error chaning $locale', e);
            }
        });
    };
    TranslateSvc.prototype.langFromTLD = function () {
        return this.domainToLang[location.hostname.split('.').pop()];
    };
    TranslateSvc.prototype.formattedKey = function (key) {
        return (_.isString(key) && key.replace(/\s+/g, '.')) || null;
    };
    return TranslateSvc;
}());
TranslateSvc.cookieName = '_animatron_lang';
TranslateSvc.defaultLang = 'en';
TranslateSvc.productionLangs = ['en', 'ko'];
exports.TranslateSvc = TranslateSvc;
module_1.default
    .service('TranslateSvc', TranslateSvc)
    .directive('tHtml', ["$sce", "TranslateSvc", function ($sce, TranslateSvc) { return ({
    scope: false,
    restrict: 'A',
    link: function (scope, element, attrs) {
        element.html($sce.trustAs('html', TranslateSvc.get(attrs.tHtml)));
    }
}); }]);


/***/ }),

/***/ "6gbB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/editor-redirect_bbe3d07ad3c6be2564d9d9be71acb767.css";

/***/ }),

/***/ "6w4i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Strings_1 = __webpack_require__("fxc3");
var AnimatronSvc = (function () {
    function AnimatronSvc(query, secure, api, callback) {
        if (query === void 0) { query = {}; }
        if (secure === void 0) { secure = false; }
        if (api === void 0) { api = ''; }
        if (callback === void 0) { callback = angular.noop; }
        this.callback = callback;
        this.retries = 0;
        this.retriesMax = 120;
        this.results = [];
        this.pages = [];
        this.busy = false;
        this.currentPage = 0;
        this.count = 0;
        this.totalPages = 0;
        this.shownAll = false;
        this.loaded = false;
        this.seoPage = +this.$stateParams.page;
        this.query = {
            product: 'STUDIO',
            offset: 0,
            limit: 10
        };
        this.setSecure(secure, api);
        this.modifyQuery(query);
        if (this.onCreate)
            this.onCreate();
        this.addSeoPagination();
    }
    /*abstract*/
    AnimatronSvc.prototype.onCreate = function () {
    };
    /*abstract*/
    AnimatronSvc.prototype.decorate = function (results) {
    };
    AnimatronSvc.prototype.setSecure = function (secure, api) {
        if (api === void 0) { api = ''; }
        if (secure && Strings_1.Strings.isBlank(options.headers['Animatron-Security-Token'])) {
            if (console.trace)
                console.trace();
            throw new Error('Empty cookie');
        }
        this.owner = secure;
        this.httpGet = this.makeHttpSvc(secure, api);
    };
    AnimatronSvc.prototype.modifyQuery = function (query) {
        if (!_.isObject(query))
            throw new Error('incorrect query');
        if (!this.owner && this.foreignAccess)
            this.query.scope = 'FOREIGN';
        _.extend(this.query, query);
    };
    AnimatronSvc.prototype.reset = function () {
        this.busy = this.shownAll = false;
        this.currentPage = this.count = 0;
    };
    AnimatronSvc.prototype.getResultsOnPage = function (pageNum) {
        if (pageNum === void 0) { pageNum = this.currentPage; }
        return this.pages[pageNum];
    };
    AnimatronSvc.prototype.nextPage = function (shuffle) {
        var _this = this;
        if (shuffle === void 0) { shuffle = false; }
        if (this.busy || this.shownAll || (this.seoPage && this.results.length > 0))
            return this.$q.reject();
        return this.loadPage(++this.currentPage).then(function (result) {
            if (shuffle)
                _this.results = _.shuffle(_this.results);
            var lastPage = _.last(_this.pages);
            if (lastPage && lastPage.length > 0)
                _this.callback(lastPage);
            return result;
        });
    };
    AnimatronSvc.prototype.reorderPages = function () {
        var _this = this;
        if (this.pages.length === 0)
            return;
        var prevIndex;
        var pageNumber = 1;
        var pages = [];
        var itemsList = [];
        this.pages.forEach(function (items, index) {
            if (!prevIndex) {
                prevIndex = index;
            }
            if (!_.isEmpty(items) && prevIndex++ === index) {
                itemsList.push.apply(itemsList, items);
            }
        });
        itemsList.forEach(function (item) {
            if (pages[pageNumber] && pages[pageNumber].length >= _this.query.limit) {
                pageNumber++;
            }
            if (!pages[pageNumber]) {
                pages[pageNumber] = [];
            }
            pages[pageNumber].push(item);
        });
        var lastPageList = pages[pages.length - 1];
        if (lastPageList.length !== this.query.limit && !this.shownAll) {
            pages.pop();
        }
        this.totalPages = this.getTotalPages();
        this.pages = pages;
    };
    AnimatronSvc.prototype.changeLimit = function (limit) {
        this.query.limit = limit;
        this.reorderPages();
    };
    AnimatronSvc.prototype.loadPage = function (pageNum) {
        var _this = this;
        if (pageNum === void 0) { pageNum = this.currentPage; }
        if (!this.httpGet)
            return this.$q.reject('no httpGet');
        var resultsOnPage = this.getResultsOnPage(pageNum);
        if (resultsOnPage) {
            this.busy = false;
            return this.$q.resolve({ count: this.count, results: resultsOnPage });
        }
        this.busy = true;
        var pgNm = this.results.length === 0 ? this.seoPage || pageNum : pageNum;
        var params = _.extend({}, this.query, {
            offset: (pgNm - 1) * this.query.limit || 0
        });
        return this.httpGet({
            params: params,
            headers: this.headers
        }).then(function (r) { return r.data; }).then(function (data) {
            _this.loaded = true;
            if (_this.decorate)
                _this.decorate(data.results);
            _this.pages[pageNum] = data.results;
            _this.flattenResults();
            _this.count = data.count || _this.results.length;
            _this.totalPages = _this.getTotalPages();
            _this.shownAll = (!_this.query.noCount && _this.count <= _this.results.length) || data.results.length === 0;
            if (_this.shownAll) {
                _this.$rootScope.$emit('$projects:shownAll', _this);
            }
            _this.apiUnavaliable = _this.busy = false;
            return data;
        }, function (response) {
            var data = response.data, status = response.status;
            _this.loaded = true;
            if (status <= 0) {
                _this.apiUnavaliable = true;
                _this.$log.error('Error occurred getting results: ' + data + ',status: ' + status);
                return _this.retry(pageNum);
            }
            else {
                var message = data.message || 'Something went completely wrong';
                _.notification.showError(message);
                return Promise.reject(message);
            }
        });
    };
    AnimatronSvc.prototype.getTotalPages = function () {
        return Math.abs(Math.ceil(this.count / this.query.limit));
    };
    AnimatronSvc.prototype.flattenResults = function () {
        var _this = this;
        var flatResults = [];
        for (var i = 1; i < this.pages.length; i++) {
            var page = this.pages[i];
            if (!page)
                break;
            page.forEach(function (prj) { return flatResults.push(prj); });
        }
        if (this.uniqueId) {
            this.results = _.unique(flatResults, false, function (item) { return item[_this.uniqueId]; });
        }
        else {
            this.results = flatResults;
        }
    };
    AnimatronSvc.prototype.retry = function (pageNum) {
        var _this = this;
        var deferred = this.$q.defer();
        if (this.retries < this.retriesMax) {
            var timeoutId_1 = this.$timeout(function () {
                _this.$log.debug(_this.retries + " retry out of " + _this.retriesMax);
                _this.retries += 1;
                _this.busy = false;
                deferred.resolve(_this.loadPage(pageNum));
            }, 1000);
            this.$rootScope.$on('$stateChangeStart', function () { return _this.$timeout.cancel(timeoutId_1); });
        }
        else {
            var message = "retry was called over " + this.retriesMax;
            this.$log.warn(message);
            deferred.reject(message);
        }
        return deferred.promise;
    };
    AnimatronSvc.prototype.addSeoPagination = function () {
        if (this.$stateParams.hasOwnProperty('page')) {
            var mkLink_1 = function (rel) {
                return document.head.querySelector("[rel=" + rel + "]") ||
                    document.head.appendChild(document.createElement('link'));
            };
            var pageNum = this.seoPage || 1;
            [['prev', pageNum - 1], ['next', pageNum + 1]]
                .filter(function (_a) {
                var _ = _a[0], n = _a[1];
                return n > 0;
            })
                .forEach(function (_a) {
                var rel = _a[0], n = _a[1];
                var source = { rel: rel, href: location.pathname + "?page=" + n };
                var target = mkLink_1(rel);
                Object.assign(target, source);
            });
        }
    };
    return AnimatronSvc;
}());
exports.AnimatronSvc = AnimatronSvc;


/***/ }),

/***/ "70FE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("jYQ6");
var EventSvc = (function () {
    EventSvc.$inject = ["$rootScope", "$state", "$log"];
    function EventSvc($rootScope, $state, $log) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$log = $log;
    }
    EventSvc.prototype.init = function () {
        var _this = this;
        this.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
            //remove all listeners on page change. Can be dangerous, watch out!
            var hasTemplate = fromState.templateUrl
                || fromState.template
                || toState.templateUrl
                || toState.template;
            var isStateProject = function () {
                return options.animatronProducts.some(function (product) {
                    return _this.$state.is(product.toLowerCase() + "-project");
                });
            };
            var isStateLogout = function () { return _this.$state.is('logout'); };
            if (!isStateProject() && hasTemplate && !isStateLogout) {
                var listeners_1 = _this.$rootScope.$$listeners;
                Object.keys(listeners_1)
                    .filter(function (l) { return l.lastIndexOf('$', 0) !== 0 && listeners_1[l].length > 0; })
                    .forEach(function (listener) {
                    _this.$log.debug('Removing listener', listener);
                    listeners_1[listener] = [];
                });
            }
        });
    };
    return EventSvc;
}());
exports.EventSvc = EventSvc;
module_1.default.service('EventSvc', EventSvc);


/***/ }),

/***/ "74nn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/wave-tutorials-list_91660c45f5caf31f576954095680b815.css";

/***/ }),

/***/ "7JoK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/_slider_795fc02fb686f021c4c87e86580ad452.css";

/***/ }),

/***/ "7T+Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RescaleSvc = (function () {
    function RescaleSvc() {
    }
    RescaleSvc.resizeWithAspectRatio = function (w, h, maxWidth, maxHeight, round, upscale) {
        if (round === void 0) { round = true; }
        if (upscale === void 0) { upscale = false; }
        var ratio, width = w, height = h, newDimension = {
            width: w,
            height: h
        };
        if (upscale) {
            width = width * 9999;
            height = height * 9999;
        }
        if (width > maxWidth) {
            ratio = maxWidth / width;
            newDimension.width = maxWidth;
            newDimension.height = height * ratio;
            height = height * ratio;
            width = width * ratio;
        }
        if (height > maxHeight) {
            ratio = maxHeight / height;
            newDimension.height = maxHeight;
            newDimension.width = width * ratio;
        }
        if (round) {
            Object.keys(newDimension).forEach(function (k) { return newDimension[k] = Math.round(newDimension[k]); });
        }
        return newDimension;
    };
    return RescaleSvc;
}());
exports.RescaleSvc = RescaleSvc;


/***/ }),

/***/ "7UG8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/6.png";

/***/ }),

/***/ "7c9p":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/_checkbox_be1160f9b5847427b2dc1cad1e0a2dbc.css";

/***/ }),

/***/ "7f+t":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/section-company-quote_c3058a7abffcc0071f36f4e6ccc8f55e.css";

/***/ }),

/***/ "7s+J":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/section-bitmap_88b11cfb92b21fc2f06214ea40b84f7f.css";

/***/ }),

/***/ "7zPr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/privacy_4b324e662dcfee78a76a75663c189aae.html";

/***/ }),

/***/ "8Acd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/analytics_6744ac07d00ac27c141443f7cbed0893.css";

/***/ }),

/***/ "8IAX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/9.svg";

/***/ }),

/***/ "8ReI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/multi-share_05ce42ebf563f400b84c8f61e4027e04.html";

/***/ }),

/***/ "8dlX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var studioHeader_1 = __webpack_require__("6M8O");
var module_1 = __webpack_require__("hfrq");
exports.canShowUpgradeButton = function (state) { return function () {
    return options.user.subscriptionDetails.wave.name === 'WaveFree' &&
        !(state.is('wave-pricing') || state.is('studio-pricing'));
}; };
var WaveHeader = (function () {
    WaveHeader.$inject = ["$state", "AuthenticationSvc", "userProjectCountSvc"];
    function WaveHeader($state, AuthenticationSvc, userProjectCountSvc) {
        var _this = this;
        this.$state = $state;
        this.AuthenticationSvc = AuthenticationSvc;
        this.userProjectCountSvc = userProjectCountSvc;
        this.handlerClickLogin = studioHeader_1.handlerClickLogin(this.$state, this.AuthenticationSvc);
        this.handlerClickSignUp = studioHeader_1.handlerClickSignUp('WAVE');
        this.canShowLoginButton = studioHeader_1.canShowLoginButton(this.$state);
        this.canShowUpgradeButton = exports.canShowUpgradeButton(this.$state);
        this.hasUserProjects = false;
        !options.user.anonymous &&
            this.userProjectCountSvc
                .getCount()
                .then(function (count) { return (_this.hasUserProjects = !!count); });
    }
    return WaveHeader;
}());
module_1.default.component('waveHeader', {
    controller: WaveHeader,
    templateUrl: __webpack_require__("eXN9")
});


/***/ }),

/***/ "8gLI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

AnimatronUsersSvcFactory.$inject = ["$rootScope", "$log", "$timeout", "$q", "$stateParams", "HttpSvc"];
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var module_1 = __webpack_require__("jYQ6");
var AnimatronSvc_1 = __webpack_require__("6w4i");
var AnimatronUsersSvc = (function (_super) {
    tslib_1.__extends(AnimatronUsersSvc, _super);
    function AnimatronUsersSvc(keyword, query, secure) {
        if (query === void 0) { query = {}; }
        if (secure === void 0) { secure = false; }
        var _this = _super.call(this, query, secure) || this;
        _this.keyword = encodeURIComponent(keyword);
        _this.setSecure(secure);
        return _this;
    }
    AnimatronUsersSvc.prototype.makeHttpSvc = function () {
        return this.HttpSvc('profile', 'search', this.keyword).get;
    };
    return AnimatronUsersSvc;
}(AnimatronSvc_1.AnimatronSvc));
exports.AnimatronUsersSvc = AnimatronUsersSvc;
function AnimatronUsersSvcFactory($rootScope, $log, $timeout, $q, $stateParams, HttpSvc) {
    _.extend(AnimatronUsersSvc.prototype, {
        $rootScope: $rootScope, $log: $log, $timeout: $timeout, $q: $q, $stateParams: $stateParams, HttpSvc: HttpSvc
    });
    return AnimatronUsersSvc;
}
module_1.default.factory('AnimatronUsers', AnimatronUsersSvcFactory);


/***/ }),

/***/ "8gmB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/le-share-button_6603000fba95f99339d40540bf251d27.css";

/***/ }),

/***/ "9+MG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/8.svg";

/***/ }),

/***/ "9/76":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ([
    {
        url: 'wave',
        title: 'wv.landing.title',
        description: 'head.wave.description',
        preview: 'https://assets.animatron.com/images/landing/wavevideo_mainpage_preview.jpg',
        settings: {
            isHeader: true,
            footer: 'big'
        },
        sections: [
            {
                name: 'video-time',
                title: 'wave.main.video-time.title',
                description: 'wave.main.video-time.description',
                isScrollButton: true,
                buttons: true,
                timeSteps: [
                    {
                        isActive: true,
                        title: 'wave.main.video-time.time-step-1.tile',
                        time: 1
                    },
                    {
                        title: 'wave.main.video-time.time-step-2.tile',
                        time: 13.7
                    },
                    {
                        title: 'wave.main.video-time.time-step-3.tile',
                        time: 25.2
                    },
                    {
                        title: 'wave.main.video-time.time-step-4.tile',
                        time: 31.7
                    }
                ],
                video: {
                    isMobile: true,
                    wistiaId: 'bmq75gd0v6',
                    mobileWistiaId: 'bmq75gd0v6'
                }
            },
            {
                name: 'different-devices',
                buttons: true
            },
            {
                name: 'bitmap',
                title: 'wave.main.bitmap.title',
                description: 'wave.main.bitmap.description'
            },
            {
                name: 'horizontal-text-video',
                title: 'wave.main.horizontal-text-video.title',
                description: 'wave.main.horizontal-text-video.description',
                buttons: true,
                video: {
                    wistiaId: 's7su99epyz',
                    preview: 'https://assets.animatron.com/images/landing/template/video-previews/upload.jpg'
                }
            },
            {
                name: 'vertical-text-video',
                title: 'wave.main.vertical-text-video.title',
                description: 'wave.main.vertical-text-video.description',
                buttons: true,
                video: {
                    wistiaId: 'lg67y8tmvu',
                    preview: 'https://assets.animatron.com/images/landing/template/video-previews/effects_2.jpg'
                }
            },
            {
                name: 'video-steps',
                steps: [
                    {
                        title: 'wave.main.video-step1.title',
                        content: 'wave.main.video-step1.description',
                        buttons: true,
                        video: {
                            isMobile: false,
                            isShadow: false,
                            wistiaId: 'bqzdooz0uw',
                            preview: 'https://assets.animatron.com/images/landing/template/video-previews/several_clips.jpg'
                        }
                    },
                    {
                        title: 'wave.main.video-step2.title',
                        content: 'wave.main.video-step2.description',
                        buttons: true,
                        video: {
                            isMobile: false,
                            isShadow: false,
                            wistiaId: 'y5qrr37gmx',
                            preview: 'https://assets.animatron.com/images/landing/template/video-previews/music.jpg'
                        }
                    },
                    {
                        title: 'wave.main.video-step3.title',
                        content: 'wave.main.video-step3.description',
                        buttons: true,
                        video: {
                            isMobile: false,
                            isShadow: false,
                            wistiaId: 'w69rszq49x',
                            preview: 'https://assets.animatron.com/images/landing/template/video-previews/cta.jpg'
                        }
                    }
                ],
                reverse: true
            },
            {
                name: 'video-gallery',
                title: 'wave.main.examples.title',
                description: 'wave.main.examples.description',
                videos: ['pu5q1q8os1', 'w6dlbyzpek', 'twoktydxrp']
            },
            {
                name: 'feedback',
                title: 'wave.text-on-video.feedback.title',
                list: ['smith1', 'aandpete1', 'guy_kawasaki', 'andy_crestodina', 'jeff_sieh', 'amy-schmittauer_landino', 'lilach_bullock', 'donna_moritz']
            },
            {
                name: 'sign-up'
            }
        ]
    },
    {
        url: 'wave/text-on-video',
        title: 'wave.text-on-video.title',
        description: 'wave.text-on-video.description',
        preview: 'https://assets.animatron.com/images/landing/template/page-previews/add_text.jpg',
        settings: {
            isHeader: false,
            footer: 'small'
        },
        sections: [
            {
                name: 'video-sign-up',
                title: 'wave.text-on-video.video-sign-up.title',
                description: 'wave.text-on-video.video-sign-up.description',
                button: 'wv.landing.no-signup.button.1',
                video: {
                    isShadow: true,
                    wistiaId: '9s5vbyut5r',
                    preview: 'https://assets.animatron.com/images/landing/template/video-previews/preview-top-video.png',
                    alt: 'wv.landing.text-on-video.alt'
                }
            },
            {
                name: 'video-gallery',
                title: 'wave.text-on-video.video-gallery.title',
                description: 'wave.text-on-video.video-gallery.description',
                videos: ['pw4b7fmh5u', 'isujvqsudd', 'twoktydxrp'],
                buttons: true
            },
            {
                name: 'feedback',
                title: 'wave.text-on-video.feedback.title',
                list: ['smith1', 'aandpete1', 'guy_kawasaki', 'andy_crestodina', 'jeff_sieh', 'amy-schmittauer_landino', 'lilach_bullock', 'donna_moritz']
            },
            {
                name: 'sign-up'
            }
        ]
    },
    {
        url: 'wave/app-to-add-text-on-video',
        title: 'wave.app-to-add-text-on-video.title',
        description: 'wave.app-to-add-text-on-video.description',
        preview: 'https://assets.animatron.com/images/landing/template/page-previews/add_text.jpg',
        settings: {
            isHeader: false,
            footer: 'small'
        },
        sections: [
            {
                name: 'video-sign-up',
                title: 'wave.app-to-add-text-on-video.video-sign-up.title',
                description: 'wave.app-to-add-text-on-video.video-sign-up.description',
                button: 'wv.landing.no-signup.button.1',
                video: {
                    isShadow: true,
                    wistiaId: '9s5vbyut5r',
                    preview: 'https://assets.animatron.com/images/landing/template/video-previews/preview-top-video.png',
                    alt: 'wv.landing.app-text-on-video.alt'
                }
            },
            {
                name: 'video-steps',
                title: 'wave.app-to-add-text-on-video.video-gallery.title',
                steps: [
                    {
                        title: 'wv.app-to-add-text-on-video.content.block1.title',
                        content: 'wv.app-to-add-text-on-video.content.block1.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'w57pc408i9'
                        }
                    },
                    {
                        title: 'wv.app-to-add-text-on-video.content.block2.title',
                        content: 'wv.app-to-add-text-on-video.content.block2.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'ky7rhf536t'
                        }
                    },
                    {
                        title: 'wv.app-to-add-text-on-video.content.block3.title',
                        content: 'wv.app-to-add-text-on-video.content.block3.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'jgsith3l13'
                        }
                    }
                ],
                reverse: true,
                buttons: true
            },
            {
                name: 'video-gallery',
                title: 'wave.text-on-video.video-gallery.title',
                description: 'wave.app-to-add-text-on-video.video-gallery.description',
                videos: ['pw4b7fmh5u', 'isujvqsudd', 'twoktydxrp'],
                buttons: true
            },
            {
                name: 'feedback',
                title: 'wave.text-on-video.feedback.title',
                list: ['smith1', 'aandpete1', 'guy_kawasaki', 'andy_crestodina', 'jeff_sieh', 'amy-schmittauer_landino', 'lilach_bullock', 'donna_moritz']
            },
            {
                name: 'sign-up'
            }
        ]
    },
    {
        url: 'wave/animated-text',
        title: 'wave.animated-text.title',
        description: 'wave.animated-text.description',
        preview: 'https://assets.animatron.com/images/landing/template/animated-text/animated_text.png',
        settings: {
            isHeader: false,
            footer: 'small'
        },
        sections: [
            {
                name: 'video-sign-up',
                title: 'wave.animated-text.video-sign-up.title',
                description: 'wave.animated-text.video-sign-up.description',
                button: 'wv.landing.no-signup.button.1',
                video: {
                    isShadow: true,
                    wistiaId: '9s5vbyut5r',
                    preview: 'https://assets.animatron.com/images/landing/template/video-previews/preview-top-video.png',
                    alt: 'wv.landing.animated-text.alt'
                }
            },
            {
                name: 'video-steps',
                title: 'wave.animated-text.video-gallery.title',
                steps: [
                    {
                        title: 'wv.animated-text.content.block1.title',
                        content: 'wv.animated-text.content.block1.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: '8g73wb2uvy'
                        }
                    },
                    {
                        title: 'wv.animated-text.content.block2.title',
                        content: 'wv.animated-text.content.block2.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'ky7rhf536t'
                        }
                    },
                    {
                        title: 'wv.animated-text.content.block3.title',
                        content: 'wv.animated-text.content.block3.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'sfpvf5w9ie'
                        }
                    }
                ],
                reverse: true,
                buttons: true
            },
            {
                name: 'video-gallery',
                title: 'wave.animated-text1.video-gallery.title',
                description: 'wave.app-to-add-text-on-video.video-gallery.description',
                videos: ['pw4b7fmh5u', 'isujvqsudd', 'twoktydxrp'],
                buttons: true
            },
            {
                name: 'feedback',
                title: 'wave.text-on-video.feedback.title',
                list: ['smith1', 'aandpete1', 'guy_kawasaki', 'andy_crestodina', 'jeff_sieh', 'amy-schmittauer_landino', 'lilach_bullock', 'donna_moritz']
            },
            {
                name: 'sign-up'
            }
        ]
    },
    {
        url: 'wave/make-facebook-video',
        title: 'wave.make-facebook-video.title',
        description: 'wave.make-facebook-video.description',
        preview: 'https://assets.animatron.com/images/landing/template/make-facebook-video/screen.jpg',
        settings: {
            isHeader: false,
            footer: 'small'
        },
        sections: [
            {
                name: 'video-sign-up',
                title: 'wave.make-facebook-video.video-sign-up.title',
                description: 'wave.make-facebook-video.video-sign-up.description',
                button: 'wv.landing.no-signup.button.3',
                video: {
                    isShadow: true,
                    wistiaId: '9s5vbyut5r',
                    preview: 'https://assets.animatron.com/images/landing/template/make-facebook-video/facebook_cover.jpg',
                    alt: 'wv.landing.make-facebook-video.alt'
                }
            },
            {
                name: 'video-gallery',
                title: 'wave.make-facebook-video.video-gallery.title',
                description: 'wave.make-facebook-video.video-gallery.description',
                videos: ['pw4b7fmh5u', 'isujvqsudd', 'twoktydxrp'],
                buttons: true
            },
            {
                name: 'feedback',
                title: 'wave.text-on-video.feedback.title',
                list: ['smith1', 'aandpete1', 'guy_kawasaki', 'andy_crestodina', 'jeff_sieh', 'amy-schmittauer_landino', 'lilach_bullock', 'donna_moritz']
            },
            {
                name: 'sign-up'
            }
        ]
    },
    {
        url: 'wave/how-to-make-facebook-video',
        title: 'wave.how-facebook.title',
        description: 'wave.how-facebook.description',
        preview: 'https://assets.animatron.com/images/landing/template/make-facebook-video/make_fb_videos.png',
        settings: {
            isHeader: false,
            footer: 'small'
        },
        sections: [
            {
                name: 'video-sign-up',
                title: 'wave.how-facebook.video-sign-up.title',
                description: 'wave.how-facebook.video-sign-up.description',
                button: 'wv.landing.no-signup.button.2',
                video: {
                    isShadow: true,
                    wistiaId: '9s5vbyut5r',
                    preview: 'https://assets.animatron.com/images/landing/template/make-facebook-video/facebook_cover.jpg',
                    alt: 'wv.landing.how-facebook-video.alt'
                }
            },
            {
                name: 'video-steps',
                title: 'wave.how-facebook.video-gallery.title',
                steps: [
                    {
                        title: 'wv.how-facebook.content.block1.title',
                        content: 'wv.how-facebook.content.block1.content',
                        buttons: false,
                        imageUrl: 'https://assets.animatron.com/images/landing/template/how-to-fb/library.jpg',
                        alt: 'wave.how-facebook.video-sign-up.title'
                    },
                    {
                        title: 'wv.how-facebook.content.block2.title',
                        content: 'wv.how-facebook.content.block2.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: '3tw9smphnd'
                        }
                    },
                    {
                        title: 'wv.how-facebook.content.block3.title',
                        content: 'wv.how-facebook.content.block3.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: '3rv17y4i47'
                        }
                    },
                    {
                        title: 'wv.facebook-cover.content.block4.title',
                        content: 'wv.how-facebook.content.block4.content',
                        buttons: false,
                        imageUrl: 'https://assets.animatron.com/images/landing/template/facebook-cover-video/download.png',
                        alt: 'wave.how-facebook.video-sign-up.title'
                    }
                ],
                reverse: true,
                buttons: true
            },
            {
                name: 'video-gallery',
                title: 'wave.how-facebook1.video-gallery.title',
                description: 'wave.how-facebook1.video-gallery.description',
                videos: ['pw4b7fmh5u', 'isujvqsudd', 'twoktydxrp'],
                buttons: true
            },
            {
                name: 'feedback',
                title: 'wave.text-on-video.feedback.title',
                list: ['smith1', 'aandpete1', 'guy_kawasaki', 'andy_crestodina', 'jeff_sieh', 'amy-schmittauer_landino', 'lilach_bullock', 'donna_moritz']
            },
            {
                name: 'sign-up'
            }
        ]
    },
    {
        url: 'wave/instagram-video-editor',
        title: 'wave.instagram-video.title',
        description: 'wave.instagram-video.description',
        preview: 'https://assets.animatron.com/images/landing/template/instagram-video-editor/make_ig_video.png',
        keywords: 'head.wave.keywords.test',
        settings: {
            isHeader: false,
            footer: 'small'
        },
        sections: [
            {
                name: 'video-sign-up',
                title: 'wave.instagram-video.video-sign-up.title',
                description: 'wave.instagram-video.video-sign-up.description',
                button: 'wv.landing.no-signup.button.4',
                video: {
                    isShadow: true,
                    wistiaId: '9s5vbyut5r',
                    preview: 'https://assets.animatron.com/images/landing/template/instagram-video-editor/ig_video_editor.jpg',
                    alt: 'wv.landing.instagram-video-editor.alt'
                }
            },
            {
                name: 'video-steps',
                title: 'wave.instagram-video.video-gallery.title',
                steps: [
                    {
                        title: 'wv.instagram-video.content.block1.title',
                        content: 'wv.instagram-video.content.block1.content',
                        buttons: false,
                        imageUrl: 'https://assets.animatron.com/images/landing/template/how-to-fb/library_collection.jpg',
                        alt: 'wave.instagram-video.video-sign-up.title'
                    },
                    {
                        title: 'wv.instagram-video.content.block2.title',
                        content: 'wv.instagram-video.content.block2.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: '3tw9smphnd'
                        }
                    },
                    {
                        title: 'wv.how-facebook.content.block3.title',
                        content: 'wv.instagram-video.content.block3.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: '3rv17y4i47'
                        }
                    },
                    {
                        title: 'wv.instagram-video.content.block4.title',
                        content: 'wv.instagram-video.content.block4.content',
                        buttons: false,
                        imageUrl: 'https://assets.animatron.com/images/landing/template/how-to-fb/publish.jpg',
                        alt: 'wave.instagram-video.video-sign-up.title'
                    }
                ],
                reverse: true,
                buttons: true
            },
            {
                name: 'video-gallery',
                title: 'wv.instagram-video.video-gallery.title',
                description: 'wave.instagram-video.video-gallery.description',
                videos: ['pw4b7fmh5u', 'isujvqsudd', 'twoktydxrp'],
                buttons: true
            },
            {
                name: 'feedback',
                title: 'wave.text-on-video.feedback.title',
                list: ['smith1', 'aandpete1', 'guy_kawasaki', 'andy_crestodina', 'jeff_sieh', 'amy-schmittauer_landino', 'lilach_bullock', 'donna_moritz']
            },
            {
                name: 'sign-up'
            }
        ]
    },
    {
        url: 'wave/make-instagram-video',
        title: 'wave.make-instagram-video.title',
        description: 'wave.make-instagram-video.description',
        preview: 'https://assets.animatron.com/images/landing/template/instagram-video-editor/ig_preview.png',
        settings: {
            isHeader: false,
            footer: 'small'
        },
        sections: [
            {
                name: 'video-sign-up',
                title: 'wave.make-instagram-video.video-sign-up.title',
                description: 'wave.make-instagram-video.video-sign-up.description',
                button: 'wv.landing.no-signup.button.4',
                video: {
                    isShadow: true,
                    wistiaId: '9s5vbyut5r',
                    preview: 'https://assets.animatron.com/images/landing/template/instagram-video-editor/ig_video_editor.jpg',
                    alt: 'wv.landing.make-instagram-videos.alt'
                }
            },
            {
                name: 'video-gallery',
                title: 'wv.instagram-video.video-gallery.title',
                description: 'wave.instagram-video.video-gallery.description',
                videos: ['pw4b7fmh5u', 'isujvqsudd', 'twoktydxrp'],
                buttons: true
            },
            {
                name: 'feedback',
                title: 'wave.text-on-video.feedback.title',
                list: ['smith1', 'aandpete1', 'guy_kawasaki', 'andy_crestodina', 'jeff_sieh', 'amy-schmittauer_landino', 'lilach_bullock', 'donna_moritz']
            },
            {
                name: 'sign-up'
            }
        ]
    },
    {
        url: 'wave/online-video-editor',
        title: 'wave.video-editor.title',
        description: 'wave.video-editor.description',
        preview: 'https://assets.animatron.com/images/landing/template/online-video-editor/video_editor.jpg',
        settings: {
            isHeader: true,
            footer: 'big'
        },
        sections: [
            {
                name: 'video-sign-up',
                logo: false,
                title: 'wave.video-editor.video-sign-up.title',
                description: 'wave.video-editor.video-sign-up.description',
                button: 'wv.landing.no-signup.button.1',
                video: {
                    isShadow: true,
                    wistiaId: 't3rvoc1lwn',
                    preview: 'https://assets.animatron.com/images/landing/template/online-video-editor/online_video_editor_cover.jpg',
                    alt: 'wv.landing.online-video-editor.alt'
                }
            },
            {
                name: 'video-steps',
                title: 'wave.video-editor.video-gallery.title',
                steps: [
                    {
                        title: 'wv.video-editor.content.block1.title',
                        content: 'wv.video-editor.content.block1.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'rajf0u25q2'
                        }
                    },
                    {
                        title: 'wv.video-editor.content.block2.title',
                        content: 'wv.video-editor.content.block2.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'go1mecdxla'
                        }
                    },
                    {
                        title: 'wv.video-editor.content.block3.title',
                        content: 'wv.video-editor.content.block3.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'ap4d6rqm11'
                        }
                    },
                    {
                        title: 'wv.video-editor.content.block4.title',
                        content: 'wv.video-editor.content.block4.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'w4vau9mem1'
                        }
                    },
                    {
                        title: 'wv.video-editor.content.block5.title',
                        content: 'wv.video-editor.content.block5.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'mt53cvnpk3'
                        }
                    }
                ],
                reverse: true,
                buttons: true
            },
            {
                name: 'video-gallery',
                title: 'wv.video-editor.video-gallery.title',
                description: 'wave.video-editor.video-gallery.description',
                videos: ['fk2bckaos0', 'u8u54wr4gp', 'xe1mo9knog'],
                buttons: true
            },
            {
                name: 'feedback',
                title: 'wave.text-on-video.feedback.title',
                list: ['smith1', 'aandpete1', 'guy_kawasaki', 'andy_crestodina', 'jeff_sieh', 'amy-schmittauer_landino', 'lilach_bullock', 'donna_moritz']
            },
            {
                name: 'sign-up'
            }
        ]
    },
    {
        url: 'wave/combine-media',
        title: 'wave.combine-media.title',
        description: 'wave.combine-media.description',
        preview: 'https://assets.animatron.com/images/landing/video-previews/landing_combine_media_top.png',
        settings: {
            isHeader: false,
            footer: 'small'
        },
        sections: [
            {
                name: 'video-sign-up',
                logo: true,
                title: 'wave.landing.combine-media.top.title',
                description: 'wave.landing.combine-media.top.desc',
                button: 'wv.landing.no-signup.button.1',
                video: {
                    isShadow: false,
                    wistiaId: '9s5vbyut5r',
                    preview: 'https://assets.animatron.com/images/landing/video-previews/landing_combine_media_top.png',
                    alt: 'wv.landing.combine-media.alt'
                },
                isScrollButton: true
            },
            {
                name: 'video-gallery',
                title: 'wave.landing.combine-media.video-slider.title',
                description: 'wave.landing.combine-media.description',
                videos: ['pw4b7fmh5u', 'isujvqsudd', 'twoktydxrp'],
                buttons: true
            },
            {
                name: 'video-steps',
                title: 'wv.landing.content.block2.title',
                steps: [
                    {
                        title: 'wv.landing.content.block2.import-files.title',
                        content: 'wv.landing.content.block2.import-files.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: '6vbj1v1hq4'
                        }
                    },
                    {
                        title: 'wv.landing.content.block2.choose-video-2.title',
                        content: 'wv.landing.content.block2.choose-video-2.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'nk1irybap8'
                        }
                    },
                    {
                        title: 'wv.landing.content.block2.customize-video.title',
                        content: 'wv.landing.content.block2.customize-video.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'w9pcneinkv'
                        }
                    },
                    {
                        title: 'wv.landing.content.block2.preview-results.title',
                        content: 'wv.landing.content.block2.preview-results.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'rj6o2v8dus'
                        }
                    }
                ],
                buttons: true
            },
            {
                name: 'feedback',
                title: 'wave.text-on-video.feedback.title',
                list: ['smith1', 'aandpete1', 'guy_kawasaki', 'andy_crestodina', 'jeff_sieh', 'amy-schmittauer_landino', 'lilach_bullock', 'donna_moritz']
            },
            {
                name: 'sign-up'
            }
        ]
    },
    {
        url: 'wave/facebook-cover-video',
        title: 'wave.facebook-cover.title',
        description: 'wave.facebook-cover.description',
        button: 'wv.landing.no-signup.button.2',
        preview: 'https://assets.animatron.com/images/landing/template/facebook-cover-video/make.png',
        settings: {
            isHeader: true,
            footer: 'big'
        },
        sections: [
            {
                name: 'video-sign-up',
                logo: false,
                title: 'wave.facebook-cover.video-sign-up.title',
                description: 'wave.facebook-cover.video-sign-up.description',
                button: 'wv.landing.no-signup.button.1',
                video: {
                    isShadow: true,
                    wistiaId: 'judgtrwj03',
                    preview: 'https://assets.animatron.com/images/landing/template/facebook-cover-video/facebook-cover-video.jpg',
                    alt: 'wv.landing.facebook-cover-video.alt'
                }
            },
            {
                name: 'video-steps',
                title: 'wave.facebook-cover.video-gallery.title',
                steps: [
                    {
                        title: 'wv.facebook-cover.content.block1.title',
                        content: 'wv.facebook-cover.content.block1.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'nk1irybap8'
                        }
                    },
                    {
                        title: 'wv.facebook-cover.content.block2.title',
                        content: 'wv.facebook-cover.content.block2.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'lirnbs1689'
                        }
                    },
                    {
                        title: 'wv.facebook-cover.content.block3.title',
                        content: 'wv.facebook-cover.content.block3.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'rj6o2v8dus'
                        }
                    },
                    {
                        title: 'wv.facebook-cover.content.block4.title',
                        content: 'wv.facebook-cover.content.block4.content',
                        buttons: false,
                        imageUrl: 'https://assets.animatron.com/images/landing/template/facebook-cover-video/download.png',
                        alt: 'wv.landing.facebook-cover-video.alt1'
                    }
                ],
                reverse: true,
                buttons: true
            },
            {
                name: 'feedback',
                title: 'wave.text-on-video.feedback.title',
                list: ['smith1', 'aandpete1', 'guy_kawasaki', 'andy_crestodina', 'jeff_sieh', 'amy-schmittauer_landino', 'lilach_bullock', 'donna_moritz']
            },
            {
                name: 'sign-up'
            }
        ]
    },
    {
        url: 'wave/how-to-make-instagram-videos',
        title: 'wave.how-to-instagram.title',
        description: 'wave.how-to-instagram.description',
        preview: 'https://assets.animatron.com/images/landing/template/how-to-make-instagram-videos/how-ig-cover.png',
        settings: {
            isHeader: false,
            footer: 'small'
        },
        sections: [
            {
                name: 'video-sign-up',
                title: 'wave.how-to-instagram.video-sign-up.title',
                description: 'wave.how-to-instagram.video-sign-up.description',
                button: 'wv.landing.no-signup.button.4',
                video: {
                    isShadow: true,
                    wistiaId: 'i4fl562kt3',
                    preview: 'https://assets.animatron.com/images/landing/template/how-to-make-instagram-videos/ig-cover-new.jpg',
                    alt: 'wv.landing.how-to-instagram.alt'
                }
            },
            {
                name: 'video-steps',
                title: 'wave.how-to-instagram.video-gallery.title',
                steps: [
                    {
                        title: 'wv.how-facebook.content.block1.title',
                        content: 'wv.how-facebook.content.block1.content',
                        buttons: false,
                        imageUrl: 'https://assets.animatron.com/images/landing/template/how-to-fb/library_collection.jpg',
                        alt: 'wv.landing.how-to-instagram.alt1'
                    },
                    {
                        title: 'wv.how-to-instagram.content.block2.title',
                        content: 'wv.how-to-instagram.content.block2.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: '3tw9smphnd'
                        }
                    },
                    {
                        title: 'wv.how-facebook.content.block3.title',
                        content: 'wv.instagram-video.content.block3.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: '3rv17y4i47'
                        }
                    },
                    {
                        title: 'wv.instagram-video.content.block4.title',
                        content: 'wv.how-to-instagram.content.block4.content',
                        buttons: false,
                        imageUrl: 'https://assets.animatron.com/images/landing/template/how-to-make-instagram-videos/ig-download.jpg',
                        alt: 'wv.landing.how-to-instagram.alt2'
                    }
                ],
                reverse: true,
                buttons: true
            },
            {
                name: 'video-gallery',
                title: 'wv.instagram-video.video-gallery.title',
                description: 'wave.instagram-video.video-gallery.description',
                videos: ['pw4b7fmh5u', 'isujvqsudd', 'twoktydxrp'],
                buttons: true
            },
            {
                name: 'feedback',
                title: 'wave.text-on-video.feedback.title',
                list: ['smith1', 'aandpete1', 'guy_kawasaki', 'andy_crestodina', 'jeff_sieh', 'amy-schmittauer_landino', 'lilach_bullock', 'donna_moritz']
            },
            {
                name: 'sign-up'
            }
        ]
    },
    {
        url: 'wave/how-to-make-youtube-videos',
        title: 'wave.how-to-youtube.title',
        description: 'wave.how-to-youtube.description',
        preview: 'https://assets.animatron.com/images/landing/template/how-to-make-youtube-videos/youtube-videos.jpg',
        settings: {
            isHeader: false,
            footer: 'small'
        },
        sections: [
            {
                name: 'video-sign-up',
                title: 'wave.how-to-youtube.video-sign-up.title',
                description: 'wave.how-to-youtube.video-sign-up.description',
                button: 'wv.landing.no-signup.button.5',
                video: {
                    isShadow: true,
                    wistiaId: '9s5vbyut5r',
                    preview: 'https://assets.animatron.com/images/landing/template/how-to-make-youtube-videos/2.jpg',
                    alt: 'wv.landing.how-to-youtube-video.alt'
                }
            },
            {
                name: 'video-steps',
                title: 'wave.how-to-youtube.video-gallery.title',
                steps: [
                    {
                        title: 'wv.how-facebook.content.block1.title',
                        content: 'wv.how-facebook.content.block1.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'nk1irybap8'
                        }
                    },
                    {
                        title: 'wv.how-to-youtube.content.block2.title',
                        content: 'wv.how-to-youtube.content.block2.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: '3rv17y4i47'
                        }
                    },
                    {
                        title: 'wv.how-to-youtube.content.block3.title',
                        content: 'wv.how-to-youtube.content.block3.content',
                        buttons: false,
                        imageUrl: 'https://assets.animatron.com/images/landing/template/how-to-make-youtube-videos/how-to-youtube.png',
                        alt: 'wv.landing.how-to-youtube-video.alt1'
                    }
                ],
                reverse: true,
                buttons: true
            },
            {
                name: 'feedback',
                title: 'wave.text-on-video.feedback.title',
                list: ['smith1', 'aandpete1', 'guy_kawasaki', 'andy_crestodina', 'jeff_sieh', 'amy-schmittauer_landino', 'lilach_bullock', 'donna_moritz']
            },
            {
                name: 'sign-up'
            }
        ]
    },
    {
        url: 'wave/real-estate-video',
        title: 'wave.real-estate.title',
        description: 'wave.real-estate.description',
        preview: 'https://assets.animatron.com/images/landing/template/real-estate-video/landing_laptop_img.png',
        settings: {
            isHeader: false,
            footer: 'small'
        },
        sections: [
            {
                name: 'video-sign-up',
                title: 'wave.landing.real-estate.top.title',
                description: 'wave.landing.real-estate.top.desc',
                button: 'wv.landing.no-signup.button.6',
                video: {
                    isShadow: false,
                    wistiaId: '9s5vbyut5r',
                    preview: 'https://assets.animatron.com/images/landing/template/real-estate-video/landing_laptop_img.png',
                    alt: 'wv.landing.real-estate.alt'
                },
                isScrollButton: true
            },
            {
                name: 'video-gallery',
                title: 'wave.landing.real-estate.video-slider.title',
                videos: ['trppod8rcb', 'isujvqsudd', '3ci2sswcd4'],
                buttons: true
            },
            {
                name: 'video-steps',
                title: 'wv.landing.content.block2.title',
                steps: [
                    {
                        title: 'wv.landing.content.block2.import-files.title',
                        content: 'wv.landing.content.block2.import-files.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: '6vbj1v1hq4'
                        }
                    },
                    {
                        title: 'wv.landing.content.block2.real-estate2.title',
                        content: 'wv.landing.content.block2.choose-video-2.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'nk1irybap8'
                        }
                    },
                    {
                        title: 'wv.landing.content.block2.customize-video.title',
                        content: 'wv.landing.content.block2.customize-video.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'vdtw7vgixo'
                        }
                    },
                    {
                        title: 'wv.landing.content.block2.real-estate4.title',
                        content: 'wv.landing.content.block2.real-estate4.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'rj6o2v8dus'
                        }
                    }
                ],
                buttons: true
            },
            {
                name: 'feedback',
                title: 'wave.text-on-video.feedback.title',
                list: ['smith1', 'aandpete1', 'guy_kawasaki', 'andy_crestodina', 'jeff_sieh', 'amy-schmittauer_landino', 'lilach_bullock', 'donna_moritz']
            },
            {
                name: 'sign-up'
            }
        ]
    },
    {
        url: 'wave/how-to-make-video-ads',
        title: 'wave.how-to-video-ad.title',
        description: 'wave.how-to-video-ad.description',
        preview: 'https://assets.animatron.com/images/landing/template/how-to-make-video-ads/5.jpg',
        settings: {
            isHeader: false,
            footer: 'small'
        },
        sections: [
            {
                name: 'video-sign-up',
                title: 'wave.how-to-video-ad.video-sign-up.title',
                description: 'wave.how-to-video-ad.video-sign-up.description',
                button: 'wv.landing.no-signup.button.7',
                video: {
                    isShadow: true,
                    wistiaId: '9s5vbyut5r',
                    preview: 'https://assets.animatron.com/images/landing/template/how-to-make-video-ads/5.jpg',
                    alt: 'wv.landing.how-to-video-ad.alt'
                }
            },
            {
                name: 'video-steps',
                title: 'wave.how-to-video-ad.video-gallery.title',
                steps: [
                    {
                        title: 'wv.how-facebook.content.block1.title',
                        content: 'wv.how-facebook.content.block1.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'nk1irybap8'
                        }
                    },
                    {
                        title: 'wv.how-to-video-ad.content.block2.title',
                        content: 'wv.how-to-video-ad.content.block2.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: '3tw9smphnd'
                        }
                    },
                    {
                        title: 'wv.how-to-video-ad.content.block3.title',
                        content: 'wv.how-to-video-ad.content.block3.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: '3rv17y4i47'
                        }
                    },
                    {
                        title: 'wv.how-to-video-ad.content.block4.title',
                        content: 'wv.how-to-video-ad.content.block4.content',
                        buttons: false,
                        imageUrl: 'https://assets.animatron.com/images/landing/template/how-to-make-video-ads/4.jpg',
                        alt: 'wv.landing.how-to-video-ad.alt1'
                    }
                ],
                reverse: true,
                buttons: true
            },
            {
                name: 'feedback',
                title: 'wave.text-on-video.feedback.title',
                list: ['smith1', 'aandpete1', 'guy_kawasaki', 'andy_crestodina', 'jeff_sieh', 'amy-schmittauer_landino', 'lilach_bullock', 'donna_moritz']
            },
            {
                name: 'sign-up'
            }
        ]
    },
    {
        url: 'wave/make-video-for-blog',
        title: 'wave.blog-video.title',
        description: 'wave.blog-video.description',
        preview: 'https://assets.animatron.com/images/landing/template/make-video-for-blog/make_video_for_blogpost.jpg',
        settings: {
            isHeader: false,
            footer: 'small'
        },
        sections: [
            {
                name: 'video-sign-up',
                title: 'wave.landing.blog-video.top.title',
                description: 'wave.landing.blog-video.top.desc',
                button: 'wv.landing.no-signup.button.8',
                video: {
                    isShadow: false,
                    wistiaId: '9s5vbyut5r',
                    preview: 'https://assets.animatron.com/images/landing/template/make-video-for-blog/make-blog-videos-cover.png',
                    alt: 'wv.landing.make-video-for-blog.alt'
                },
                isScrollButton: true
            },
            {
                name: 'video-gallery',
                title: 'wave.landing.blog-video.video-slider.title',
                description: 'wave.landing.blog-video.description',
                videos: ['yrg8tmhc1o', '6nuk3l0wnk', '3ci2sswcd4'],
                buttons: true
            },
            {
                name: 'video-steps',
                title: 'wv.landing.content.block2.title',
                steps: [
                    {
                        title: 'wv.landing.content.block1.blog-video.title',
                        content: 'wv.landing.content.block1.blog-video.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'dj1r7aia3k'
                        }
                    },
                    {
                        title: 'wv.landing.content.block2.blog-video.title',
                        content: 'wv.landing.content.block2.blog-video.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'nk1irybap8'
                        }
                    },
                    {
                        title: 'wv.landing.content.block3.blog-video.title',
                        content: 'wv.landing.content.block3.blog-video.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'ky7rhf536t'
                        }
                    },
                    {
                        title: 'wv.landing.content.block4.blog-video.title',
                        content: 'wv.landing.content.block4.blog-video.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'rj6o2v8dus'
                        }
                    },
                    {
                        title: 'wv.landing.content.block5.blog-video.title',
                        content: 'wv.landing.content.block5.blog-video.content',
                        buttons: false,
                        imageUrl: 'https://assets.animatron.com/images/landing/template/how-to-make-video-ads/4.jpg',
                        alt: 'wv.landing.make-video-for-blog.alt1'
                    }
                ],
                buttons: true
            },
            {
                name: 'feedback',
                title: 'wave.text-on-video.feedback.title',
                list: ['smith1', 'aandpete1', 'guy_kawasaki', 'andy_crestodina', 'jeff_sieh', 'amy-schmittauer_landino', 'lilach_bullock', 'donna_moritz']
            },
            {
                name: 'sign-up'
            }
        ]
    },
    {
        url: 'wave/video-email',
        title: 'wave.video-email.title',
        description: 'wave.video-email.description',
        preview: 'https://assets.animatron.com/images/landing/template/video-email/laptop_email_img.png',
        settings: {
            isHeader: false,
            footer: 'small'
        },
        sections: [
            {
                name: 'video-sign-up',
                title: 'wave.landing.video-email.top.title',
                description: 'wave.landing.video-email.top.desc',
                button: 'wv.landing.no-signup.button.9',
                video: {
                    isShadow: false,
                    wistiaId: '9s5vbyut5r',
                    preview: 'https://assets.animatron.com/images/landing/template/video-email/laptop_email_img.png',
                    alt: 'wv.landing.video-email.alt'
                },
                isScrollButton: true
            },
            {
                name: 'video-gallery',
                title: 'wave.landing.video-email.video-slider.title',
                description: 'wave.landing.video-email.description',
                videos: ['3ci2sswcd4', '6nuk3l0wnk', 'yrg8tmhc1o'],
                buttons: true
            },
            {
                name: 'video-steps',
                title: 'wv.landing.content.block2.title',
                steps: [
                    {
                        title: 'wv.landing.content.block2.import-files.title',
                        content: 'wv.landing.content.block2.video-email.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: '6vbj1v1hq4'
                        }
                    },
                    {
                        title: 'wv.landing.content.block2.real-estate2.title',
                        content: 'wv.landing.content.block2.choose-video-2.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'nk1irybap8'
                        }
                    },
                    {
                        title: 'wv.landing.content.block2.customize-video.title',
                        content: 'wv.landing.content.block3.video-email.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'ky7rhf536t'
                        }
                    },
                    {
                        title: 'wv.landing.content.block4.video-email.title',
                        content: 'wv.landing.content.block4.video-email.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'nk38l9atrd'
                        }
                    }
                ],
                buttons: true
            },
            {
                name: 'feedback',
                title: 'wave.text-on-video.feedback.title',
                list: ['smith1', 'aandpete1', 'guy_kawasaki', 'andy_crestodina', 'jeff_sieh', 'amy-schmittauer_landino', 'lilach_bullock', 'donna_moritz']
            },
            {
                name: 'sign-up'
            }
        ]
    },
    {
        url: 'wave/success-stories',
        title: 'wv.ss.list.title',
        description: 'wv.ss.list.description',
        preview: 'https://assets.animatron.com/images/landing/success_stories/homestars_upd_logo.jpg',
        settings: {
            isHeader: true,
            footer: 'big'
        },
        sections: [
            {
                name: 'background-text',
                title: 'wv.ss.list.title',
                description: 'wv.ss.list.description',
                background: {
                    style: 'horizontal-blue-gradient'
                }
            },
            {
                name: 'template-pages-list',
                matchCondition: '/success-stories/'
            },
            {
                name: 'horizontal-image-text',
                title: 'wv.pricing.call-to-action.title',
                text: 'wv.pricing.call-to-action.text',
                imageUrl: 'https://assets.animatron.com/images/landing/template/common/cta_block.png',
                alt: 'wv.landing.success-stories.alt',
                buttons: true
            }
        ]
    },
    {
        url: 'wave/integrations',
        title: 'wv.integrations.list.title',
        description: 'wv.integrations.list.description',
        preview: 'https://assets.animatron.com/images/landing/success_stories/homestars_upd_logo.jpg',
        settings: {
            isHeader: true,
            footer: 'big'
        },
        sections: [
            {
                name: 'background-text',
                title: 'wv.integrations.list.title',
                description: 'wv.integrations.list.description',
                background: {
                    style: 'horizontal-blue-gradient'
                }
            },
            {
                name: 'template-pages-list',
                matchCondition: '/integrations/'
            },
            {
                name: 'horizontal-image-text',
                title: 'wv.pricing.call-to-action.title',
                text: 'wv.pricing.call-to-action.text',
                imageUrl: 'https://assets.animatron.com/images/landing/template/common/cta_block.png',
                alt: 'wv.integrations.cta.title',
                buttons: true
            }
        ]
    },
    {
        url: 'wave/success-stories/981-media',
        title: 'wv.981-media.title',
        description: 'wv.981-media.description',
        preview: 'https://assets.animatron.com/images/landing/template/video-email/laptop_email_img.png',
        settings: {
            isHeader: true,
            footer: 'big'
        },
        sections: [
            {
                name: 'company-info',
                title: 'wv.ss1.title',
                title2: 'wv.ss1.title1',
                description: 'wv.ss1.description',
                background: {
                    imageUrl: 'https://assets.animatron.com/images/landing/success_stories/981-media/header_img.jpg',
                    alt: 'wv.981-media.alt.title'
                },
                logoUrl: '/assets/images/landing/success_stories/981_logo2.jpg',
                logoAlt: 'wv.ss1.title',
                list: [
                    {
                        iconClass: 'location',
                        iconName: 'wv.ss.location',
                        text: 'wv.ss1.location'
                    },
                    {
                        iconClass: 'industry',
                        iconName: 'wv.ss.industry',
                        text: 'wv.ss1.industry'
                    },
                    {
                        iconClass: 'use_cases',
                        iconName: 'wv.ss.use_cases',
                        list: ['wv.ss1.use_cases1', 'wv.ss1.use_cases2']
                    },
                    {
                        iconClass: 'site',
                        iconName: 'wv.ss.website',
                        link: {
                            url: 'https://www.981media.com/',
                            title: 'wv.ss1.website'
                        }
                    }
                ]
            },
            {
                name: 'text-aside',
                title: 'wv.ss1.text-aside.text.title',
                text: 'wv.ss1.text-aside.text.content',
                relationList: [
                    'edit-social-video-5-steps'
                ]
            },
            {
                name: 'company-quote',
                username: 'wv.ss1.quote.author',
                description: 'wv.ss1.quote.author.position',
                avatar: 'https://assets.animatron.com/images/landing/success_stories/succes_story_avatar_981.png',
                alt: 'wv.ss1.quote.author',
                text: 'wv.ss1.quote'
            },
            {
                name: 'text-aside',
                title: 'wv.ss1.text-aside2.text.title',
                text: 'wv.ss1.text-aside2.text.content',
                imageUrl: 'https://assets.animatron.com/images/landing/success_stories/mobile.png',
                alt: 'wv.981-media.alt.title1'
            },
            {
                name: 'video-gallery',
                title: 'wv.ss1.videos.title',
                videos: ['139fa2vsci', 'h5zebqa72w', 'a5sb1vfe2e']
            },
            {
                name: 'text-aside',
                title: 'wv.ss1.text-aside3.text.title',
                text: 'wv.ss1.text-aside3.text.content',
                relationList: [
                    'make-video-never-done-before'
                ]
            },
            {
                name: 'horizontal-image-text',
                title: 'wv.ss.call-to-action.title',
                text: 'wv.ss.call-to-action.text',
                imageUrl: 'https://assets.animatron.com/images/landing/template/common/cta_block.png',
                alt: 'wv.981-media.alt.title3',
                buttons: true
            }
        ]
    },
    {
        url: 'wave/success-stories/be-brilliant',
        title: 'wv.be-brilliant.title',
        description: 'wv.be-brilliant.description',
        preview: 'https://assets.animatron.com/images/landing/template/video-email/laptop_email_img.png',
        settings: {
            isHeader: true,
            footer: 'big'
        },
        sections: [
            {
                name: 'company-info',
                title: 'wv.ss2.title',
                title2: 'wv.ss2.title1',
                description: 'wv.ss2.description',
                background: {
                    imageUrl: 'https://assets.animatron.com/images/landing/success_stories/be-brilliant/header_img.jpg',
                    alt: 'wv.be-brilliant.title'
                },
                logoUrl: '/assets/images/landing/success_stories/be_brilliant_logo2.jpg',
                list: [
                    {
                        iconClass: 'location',
                        iconName: 'wv.ss.location',
                        text: 'wv.ss2.location'
                    },
                    {
                        iconClass: 'industry',
                        iconName: 'wv.ss.industry',
                        text: 'wv.ss2.industry'
                    },
                    {
                        iconClass: 'use_cases',
                        iconName: 'wv.ss.use_cases',
                        list: ['wv.ss2.use_cases1', 'wv.ss2.use_cases2', 'wv.ss2.use_cases3', 'wv.ss2.use_cases4', 'wv.ss2.use_cases5']
                    },
                    {
                        iconClass: 'site',
                        iconName: 'wv.ss.website',
                        link: {
                            url: 'https://www.bebrilliant.com/',
                            title: 'wv.ss2.website'
                        }
                    }
                ]
            },
            {
                name: 'company-quote',
                username: 'wv.ss2.quote.author',
                description: 'wv.ss2.quote.author.position',
                avatar: 'https://assets.animatron.com/images/landing/success_stories/success_story_avatar_be_brilliant.png',
                alt: 'wv.ss2.quote.author',
                text: 'wv.ss2.quote'
            },
            {
                name: 'text-aside',
                title: 'wv.ss2.text-aside.text.title',
                text: 'wv.ss2.text-aside.text.content'
            },
            {
                name: 'text-aside',
                title: 'wv.ss2.text-aside2.text.title',
                text: 'wv.ss2.text-aside2.text.content',
                relationList: [
                    'mari1'
                ]
            },
            {
                name: 'text-aside',
                text: 'wv.ss2.text-aside2.text2.content',
                relationList: [
                    'fb-cover'
                ]
            },
            {
                name: 'video-gallery',
                title: 'wv.be-brilliant.video-gallery.title',
                videos: ['m6f026jfzb']
            },
            {
                name: 'text-aside',
                title: 'wv.ss2.text-aside3.text.title',
                text: 'wv.ss2.text-aside3.text.content',
                relationList: [
                    'edit-social-video-5-steps'
                ]
            },
            {
                name: 'horizontal-image-text',
                title: 'wv.be-brilliant.call-to-action.title',
                text: 'wv.be-brilliant.call-to-action.text',
                imageUrl: 'https://assets.animatron.com/images/landing/template/common/cta_block.png',
                alt: 'wv.be-brilliant.img.alt',
                buttons: true
            }
        ]
    },
    {
        url: 'wave/success-stories/homestars',
        title: 'wv.homestars.title',
        description: 'wv.homestars.description',
        preview: 'https://assets.animatron.com/images/landing/success_stories/homestars_upd_logo.jpg',
        settings: {
            isHeader: true,
            footer: 'big'
        },
        sections: [
            {
                name: 'company-info',
                title: 'wv.ss.homestars.title',
                title2: 'wv.ss.homestars.title2',
                description: 'wv.ss.homestars.description',
                background: {
                    imageUrl: 'https://assets.animatron.com/images/landing/success_stories/homestars/header_img.jpg',
                    alt: 'wv.homestars.img.alt'
                },
                logoUrl: '/assets/images/landing/success_stories/homestars_logo.jpg',
                list: [
                    {
                        iconClass: 'location',
                        iconName: 'wv.ss.location',
                        text: 'wv.homestars.location'
                    },
                    {
                        iconClass: 'industry',
                        iconName: 'wv.ss.industry',
                        text: 'wv.homestars.industry'
                    },
                    {
                        iconClass: 'use_cases',
                        iconName: 'wv.ss.use_cases',
                        list: ['wv.homestars.use_cases']
                    },
                    {
                        iconClass: 'site',
                        iconName: 'wv.ss.website',
                        link: {
                            url: 'https://homestars.com/ ',
                            title: 'wv.homestars.website'
                        }
                    }
                ]
            },
            {
                name: 'text-aside',
                title: 'wv.ss1.text-aside.text.title',
                text: 'wv.homestars.challenge.text.content',
                relationList: [
                    'what-is-video-marketing'
                ]
            },
            {
                name: 'company-quote',
                username: 'wv.homestars.quote.author',
                description: 'wv.homestars.quote.author.position',
                avatar: 'https://assets.animatron.com/images/landing/success_stories/homestars_author.png',
                text: 'wv.homestars.quote'
            },
            {
                name: 'text-aside',
                title: 'wv.ss1.text-aside2.text.title',
                text: 'wv.homestars.solution',
                imageUrl: 'https://assets.animatron.com/images/landing/success_stories/homestars_mob.png',
                alt: 'wv.homestars.img.alt1'
            },
            {
                name: 'video-statistics',
                title: 'wv.ss.homestars.video-statistics.title',
                statistics: [
                    {
                        title: 'wv.ss.homestars.video-statistics-1.title',
                        description: 'wv.ss.homestars.video-statistics-1.description',
                        circleProgress: [
                            {
                                icon: 'https://assets.animatron.com/images/landing/template/homestars/circle-progress-yellow.svg',
                                title: 'wv.ss.homestars.video-statistics-1.progress-1.title',
                                bigVal: '3,996',
                                smallVal: 895,
                                val: 346
                            },
                            {
                                icon: 'https://assets.animatron.com/images/landing/success_stories/circle-progress-blue.svg',
                                title: 'wv.ss.homestars.video-statistics-1.progress-2.title',
                                bigVal: '1,294',
                                smallVal: 47,
                                val: '2,653'
                            },
                            {
                                icon: 'https://assets.animatron.com/images/landing/success_stories/circle-progress-green.svg',
                                title: 'wv.ss.homestars.video-statistics-1.progress-3.title',
                                bigVal: '19',
                                smallVal: 6,
                                val: 217
                            }
                        ],
                        video: {
                            isMobile: true,
                            wistiaId: 'oeagpgadm7',
                            mobileWistiaId: 'oeagpgadm7',
                            preview: 'https://assets.animatron.com/images/landing/template/homestars/video-statistic-1.png',
                            alt: 'wv.homestars.img.alt4'
                        }
                    },
                    {
                        title: 'wv.ss.homestars.video-statistics-2.title',
                        description: 'wv.ss.homestars.video-statistics-1.description',
                        reverse: true,
                        circleProgress: [
                            {
                                icon: 'https://assets.animatron.com/images/landing/template/homestars/circle-progress-yellow.svg',
                                title: 'wv.ss.homestars.video-statistics-1.progress-1.title',
                                bigVal: '5,568',
                                smallVal: '1,107',
                                val: 403
                            },
                            {
                                icon: 'https://assets.animatron.com/images/landing/success_stories/circle-progress-blue-2.svg',
                                title: 'wv.ss.homestars.video-statistics-1.progress-2.title',
                                bigVal: '1,959',
                                smallVal: 19,
                                val: '10,211'
                            },
                            {
                                icon: 'https://assets.animatron.com/images/landing/success_stories/circle-progress-green-2.svg',
                                title: 'wv.ss.homestars.video-statistics-1.progress-3.title',
                                bigVal: '15',
                                smallVal: 6,
                                val: 150
                            }
                        ],
                        video: {
                            isMobile: true,
                            wistiaId: 'kpjr3jxatx',
                            mobileWistiaId: 'kpjr3jxatx',
                            preview: 'https://assets.animatron.com/images/landing/template/homestars/video-statistic-2.png',
                            alt: 'wv.homestars.img.alt3'
                        }
                    }
                ]
            },
            {
                name: 'text-aside',
                title: 'wv.ss2.text-aside3.text.title',
                text: 'wv.homestars.results.description1',
                relationList: [
                    'mari1'
                ]
            },
            {
                name: 'text-aside',
                text: 'wv.homestars.results.description2',
                relationList: [
                    'sm-cheat-sheet'
                ]
            },
            {
                name: 'horizontal-image-text',
                title: 'wv.homestars.call-to-action.title',
                imageUrl: 'https://assets.animatron.com/images/landing/template/common/cta_block.png',
                alt: 'wv.homestars.img.alt2',
                buttons: true
            }
        ]
    },
    {
        url: 'wave/integrations/hubspot',
        title: 'wave.integrations.hubspot.title',
        description: 'wave.integrations.hubspot.description',
        preview: 'https://assets.animatron.com/images/landing/template/integration-hubspot/hubspot_cover.jpg',
        settings: {
            isHeader: true,
            footer: 'big'
        },
        sections: [
            {
                name: 'background-text',
                title: 'wave.integration-hubspot.video-sign-up.title',
                description: 'wave.integration-hubspot.video-sign-up.description',
                logoUrl: '/assets/images/landing/template/integration-hubspot/hubspot-logo.png',
                background: {
                    imageUrl: 'https://assets.animatron.com/images/landing/template/integration-hubspot/hubspot_bkg1.jpg',
                    alt: 'wave.integrations.hubspot.alt'
                }
            },
            {
                name: 'video-steps',
                title: 'wave.hubspot-integration.video-gallery.title',
                steps: [
                    {
                        title: 'wv.hubspot-integration.content.block1.title',
                        content: 'wv.hubspot-integrationcontent.block1.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'pcte5apcav'
                        }
                    },
                    {
                        title: 'wv.hubspot-integration.content.block2.title',
                        content: 'wv.hubspot-integration.content.block2.content',
                        buttons: false,
                        imageUrl: 'https://assets.animatron.com/images/landing/template/integration-hubspot/hubspot_screen2.jpg',
                        alt: 'wave.integrations.hubspot.alt1'
                    },
                    {
                        title: 'wv.hubspot-integration.content.block3.title',
                        content: 'wv.hubspot-integration.content.block3.content',
                        buttons: false,
                        imageUrl: 'https://assets.animatron.com/images/landing/template/integration-hubspot/hubspot_screen3.jpg',
                        alt: 'wave.integrations.hubspot.alt2'
                    },
                    {
                        title: 'wv.hubspot-integration.content.block4.title',
                        content: 'wv.hubspot-integration.content.block4.content',
                        buttons: false,
                        imageUrl: 'https://assets.animatron.com/images/landing/template/integration-hubspot/hubspot_screen4.jpg',
                        alt: 'wave.integrations.hubspot.alt3'
                    }
                ],
                reverse: true,
                buttons: true
            },
            {
                name: 'sign-up'
            }
        ]
    },
    {
        url: 'wave/integrations/wistia',
        title: 'wave.integrations.wistia.title',
        description: 'wave.integrations.wistia.description',
        preview: 'https://assets.animatron.com/images/landing/template/integration-wistia/wistia_cover.jpg',
        settings: {
            isHeader: true,
            footer: 'big'
        },
        sections: [
            {
                name: 'background-text',
                title: 'wave.wistia-integration.video-sign-up.title',
                description: 'wave.wistia-integration.video-sign-up.description',
                logoUrl: '/assets/images/landing/template/integration-wistia/wistia-logo.png',
                background: {
                    imageUrl: 'https://assets.animatron.com/images/landing/template/integration-wistia/wistiaintegration_bkg1.jpg',
                    alt: 'wv.landing.wistia.alt'
                }
            },
            {
                name: 'video-steps',
                title: 'wave.wistia-integration.video-gallery.title',
                steps: [
                    {
                        title: 'wv.wistia-integration.content.block1.title',
                        content: 'wv.wistia-integration.content.block1.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'pcte5apcav'
                        }
                    },
                    {
                        title: 'wv.wistia-integration.content.block2.title',
                        content: 'wv.wistia-integration.content.block2.content',
                        buttons: false,
                        video: {
                            isShadow: true,
                            wistiaId: 'n95b2k3sl1'
                        }
                    },
                    {
                        title: 'wv.wistia-integration.content.block3.title',
                        content: 'wv.wistia-integration.content.block3.content',
                        buttons: false,
                        imageUrl: 'https://assets.animatron.com/images/landing/template/integration-wistia/video_stats.png',
                        alt: 'wv.wistia-integration.video-stats.alt'
                    },
                    {
                        title: 'wv.wistia-integration.content.block4.title',
                        content: 'wv.wistia-integration.content.block4.content',
                        buttons: false,
                        imageUrl: 'https://assets.animatron.com/images/landing/template/integration-wistia/wistia_signup.png',
                        alt: 'wv.wistia-integration.video-stats.alt1'
                    }
                ],
                reverse: true,
                buttons: true
            },
            {
                name: 'horizontal-image-text',
                title: 'wv.wistia-integration.call-to-action.title',
                text: 'wv.wistia-integration.call-to-action.text',
                imageUrl: 'https://assets.animatron.com/images/landing/template/common/cta_block.png',
                alt: 'wv.landing.wistia.alt1',
                buttons: true
            }
        ]
    },
    {
        url: 'wave/integrations/vimeo',
        title: 'wave.integrations.vimeo.title',
        description: 'wave.integrations.vimeo.description',
        preview: '/assets/images/landing/template/integration-vimeo/vimeo_preview.png',
        settings: {
            isHeader: true,
            footer: 'big'
        },
        sections: [
            {
                name: 'background-text',
                title: 'wave.vimeo-integration.video-sign-up.title',
                description: 'wave.vimeo-integration.video-sign-up.description',
                logoUrl: '/assets/images/landing/template/integration-vimeo/vimeo-logo.png',
                background: {
                    imageUrl: '/assets/images/landing/template/integration-vimeo/vimeo_bkg.png',
                    alt: 'wave.integrations.vimeo.alt'
                }
            },
            {
                name: 'video-steps',
                title: 'wave.vimeo-integration.video-gallery.title',
                steps: [
                    {
                        title: 'wv.vimeo-integration.content.block1.title',
                        content: 'wv.vimeo-integration.content.block1.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'lg67y8tmvu'
                        }
                    },
                    {
                        title: 'wv.vimeo-integration.content.block2.title',
                        content: 'wv.vimeo-integration.content.block2.content',
                        buttons: false,
                        video: {
                            isShadow: true,
                            wistiaId: 'pcte5apcav'
                        }
                    },
                    {
                        title: 'wv.vimeo-integration.content.block3.title',
                        content: 'wv.vimeo-integration.content.block3.content',
                        buttons: false,
                        video: {
                            isShadow: true,
                            wistiaId: '25i2e73cbh'
                        }
                    },
                    {
                        title: 'wv.vimeo-integration.content.block4.title',
                        content: 'wv.vimeo-integration.content.block4.content',
                        buttons: false,
                        imageUrl: '/assets/images/landing/template/integration-vimeo/vimeo_integration.png',
                        alt: 'wave.integrations.vimeo.alt1'
                    }
                ],
                reverse: true,
                buttons: true
            },
            {
                name: 'horizontal-image-text',
                title: 'wv.vimeo-integration.call-to-action.title',
                text: 'wv.vimeo-integration.call-to-action.text',
                imageUrl: '/assets/images/pricing/cta_block.png',
                alt: 'wave.integrations.vimeo.alt2',
                buttons: true
            }
        ]
    },
    {
        url: 'wave/DMlab',
        title: 'wv.dmlab.title',
        description: 'wv.dmlab.description',
        preview: 'https://assets.animatron.com/images/landing/wavevideo_mainpage_preview.jpg',
        settings: {
            isHeader: false,
            footer: 'big'
        },
        sections: [
            {
                name: 'logo-video-sign-up',
                logo: true,
                brandLogo: 'https://assets.animatron.com/images/landing/dm_Certified_partner.png',
                title: 'wv.dmlab.title',
                sbTitle: 'wv.dmlab.signup.title',
                description: 'wv.dmlab.description',
                video: {
                    wistiaId: 'bmq75gd0v6',
                    preview: 'https://s3.amazonaws.com/assets.animatron.com/images/landing/fs.png',
                    alt: 'wv.landing.dmlab.alt'
                }
            },
            {
                name: 'different-devices',
                buttons: true
            },
            {
                name: 'bitmap',
                title: 'wave.main.bitmap.title',
                description: 'wave.main.bitmap.description'
            },
            {
                name: 'horizontal-text-video',
                title: 'wave.main.horizontal-text-video.title',
                description: 'wave.main.horizontal-text-video.description',
                buttons: true,
                video: {
                    wistiaId: 's7su99epyz',
                    preview: 'https://assets.animatron.com/images/landing/template/video-previews/upload.jpg'
                }
            },
            {
                name: 'vertical-text-video',
                title: 'wave.main.vertical-text-video.title',
                description: 'wave.main.vertical-text-video.description',
                buttons: true,
                video: {
                    wistiaId: 'lg67y8tmvu',
                    preview: 'https://assets.animatron.com/images/landing/template/video-previews/effects_2.jpg',
                    alt: 'wv.landing.dmlab.alt1'
                }
            },
            {
                name: 'video-steps',
                steps: [
                    {
                        title: 'wave.main.video-step1.title',
                        content: 'wave.main.video-step1.description',
                        buttons: true,
                        video: {
                            isMobile: false,
                            isShadow: false,
                            wistiaId: 'bqzdooz0uw',
                            preview: 'https://assets.animatron.com/images/landing/template/video-previews/several_clips.jpg',
                            alt: 'wv.landing.dmlab.alt2'
                        }
                    },
                    {
                        title: 'wave.main.video-step2.title',
                        content: 'wave.main.video-step2.description',
                        buttons: true,
                        video: {
                            isMobile: false,
                            isShadow: false,
                            wistiaId: 'y5qrr37gmx',
                            preview: 'https://assets.animatron.com/images/landing/template/video-previews/music.jpg',
                            alt: 'wv.landing.dmlab.alt3'
                        }
                    },
                    {
                        title: 'wave.main.video-step3.title',
                        content: 'wave.main.video-step3.description',
                        buttons: true,
                        video: {
                            isMobile: false,
                            isShadow: false,
                            wistiaId: 'w69rszq49x',
                            preview: 'https://assets.animatron.com/images/landing/template/video-previews/cta.jpg',
                            alt: 'wv.landing.dmlab.alt4'
                        }
                    }
                ],
                reverse: true
            },
            {
                name: 'video-gallery',
                title: 'wave.main.examples.title',
                videos: ['pw4b7fmh5u', 'isujvqsudd', 'twoktydxrp']
            },
            {
                name: 'feedback',
                title: 'wave.text-on-video.feedback.title',
                list: ['smith1', 'aandpete1', 'guy_kawasaki', 'andy_crestodina', 'jeff_sieh', 'amy-schmittauer_landino', 'lilach_bullock', 'donna_moritz']
            },
            {
                name: 'sign-up'
            }
        ]
    },
    {
        url: 'wave/online-video-maker',
        title: 'wave.video-maker.title',
        description: 'wave.video-maker.description',
        preview: 'https://assets.animatron.com/images/landing/template/online-video-maker/online-video-maker.jpg',
        settings: {
            isHeader: true,
            footer: 'big'
        },
        sections: [
            {
                name: 'video-sign-up',
                logo: false,
                title: 'wave.video-maker.video-sign-up.title',
                description: 'wave.video-maker.video-sign-up.description',
                button: 'wv.landing.no-signup.button.1',
                video: {
                    isShadow: true,
                    wistiaId: 't3rvoc1lwn',
                    preview: 'https://assets.animatron.com/images/landing/template/online-video-maker/online-video-maker.jpg',
                    alt: 'wave.video-maker.title'
                }
            },
            {
                name: 'video-steps',
                title: 'wave.video-maker.video-gallery.title',
                steps: [
                    {
                        title: 'wv.video-maker.content.block1.title',
                        content: 'wv.video-maker.content.block1.content',
                        buttons: false,
                        imageUrl: 'https://assets.animatron.com/images/landing/template/online-video-maker/beautiful_videos.png',
                        alt: 'wv.landing.online-video-maker.alt1'
                    },
                    {
                        title: 'wv.video-maker.content.block2.title',
                        content: 'wv.video-maker.content.block2.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'go1mecdxla'
                        }
                    },
                    {
                        title: 'wv.video-maker.content.block3.title',
                        content: 'wv.video-maker.content.block3.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'tc98w68e4f'
                        }
                    },
                    {
                        title: 'wv.video-maker.content.block4.title',
                        content: 'wv.video-maker.content.block4.content',
                        buttons: false,
                        video: {
                            isShadow: false,
                            wistiaId: 'pdk5pn14jr'
                        }
                    }
                ],
                reverse: true,
                buttons: true
            },
            {
                name: 'video-gallery',
                title: 'wv.video-maker.video-gallery.title',
                description: 'wave.video-editor.video-gallery.description',
                videos: ['fk2bckaos0', 'u8u54wr4gp', 'xe1mo9knog'],
                buttons: true
            },
            {
                name: 'feedback',
                title: 'wave.text-on-video.feedback.title',
                list: ['smith1', 'aandpete1', 'guy_kawasaki', 'andy_crestodina', 'jeff_sieh', 'amy-schmittauer_landino', 'lilach_bullock', 'donna_moritz']
            },
            {
                name: 'sign-up'
            }
        ]
    }
]);


/***/ }),

/***/ "9IMG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/subscription-payment-details-container_949027a0f96e5c564506a0f35bed3fc3.css";

/***/ }),

/***/ "9UtH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var underscore_extensions_1 = __webpack_require__("R0iF");
var DocumentNoScroll = (function () {
    function DocumentNoScroll() {
        this.documentEl = document.documentElement;
        this.className = 'noscroll';
    }
    DocumentNoScroll.prototype.disableScroll = function () {
        if (DocumentNoScroll.isDisabled) {
            return;
        }
        DocumentNoScroll.isDisabled = true;
        var scrollTop = window.scrollY || window.pageYOffset;
        this.documentEl.classList.add(this.className);
        document.body.style.top = "-" + scrollTop + "px";
    };
    ;
    DocumentNoScroll.prototype.enableScroll = function () {
        if (!DocumentNoScroll.isDisabled) {
            return;
        }
        DocumentNoScroll.isDisabled = false;
        var scrollTop = document.body.style.top ? parseInt(document.body.style.top, 10) : 0;
        document.body.style.top = '';
        this.documentEl.classList.remove(this.className);
        window.scrollTo(0, Math.abs(scrollTop));
    };
    ;
    DocumentNoScroll.prototype.$onChanges = function (onChangesObj) {
        var _this = this;
        var _a = onChangesObj.documentNoScroll, currentValue = _a.currentValue, previousValue = _a.previousValue;
        underscore_extensions_1.Utils.rAF(function () {
            if (currentValue) {
                _this.disableScroll();
            }
            else if (!currentValue && previousValue) {
                _this.enableScroll();
            }
        });
    };
    DocumentNoScroll.prototype.$onDestroy = function () {
        this.enableScroll();
    };
    return DocumentNoScroll;
}());
DocumentNoScroll.isDisabled = false;
module_1.default.directive('documentNoScroll', function () { return ({
    controller: DocumentNoScroll,
    bindToController: {
        documentNoScroll: '<'
    }
}); });


/***/ }),

/***/ "9VVx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/landing-top-common_9dab38b26eb02de4cb6323aaf894aa3b.css";

/***/ }),

/***/ "9uog":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/banner/help-img-3b.png";

/***/ }),

/***/ "9uvP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/popup_b0ea154d0a6e90d9f2b2a57c5c5aeea9.css";

/***/ }),

/***/ "AbyD":
/***/ (function(module, exports) {

/*! 
 * angular-loading-bar v0.8.0
 * https://chieffancypants.github.io/angular-loading-bar
 * Copyright (c) 2015 Wes Cruver
 * License: MIT
 */
/*
 * angular-loading-bar
 *
 * intercepts XHR requests and creates a loading bar.
 * Based on the excellent nprogress work by rstacruz (more info in readme)
 *
 * (c) 2013 Wes Cruver
 * License: MIT
 */


(function() {

'use strict';

// Alias the loading bar for various backwards compatibilities since the project has matured:
angular.module('angular-loading-bar', ['cfp.loadingBarInterceptor']);
angular.module('chieffancypants.loadingBar', ['cfp.loadingBarInterceptor']);


/**
 * loadingBarInterceptor service
 *
 * Registers itself as an Angular interceptor and listens for XHR requests.
 */
angular.module('cfp.loadingBarInterceptor', ['cfp.loadingBar'])
  .config(['$httpProvider', function ($httpProvider) {

    var interceptor = ['$q', '$cacheFactory', '$timeout', '$rootScope', '$log', 'cfpLoadingBar', function ($q, $cacheFactory, $timeout, $rootScope, $log, cfpLoadingBar) {

      /**
       * The total number of requests made
       */
      var reqsTotal = 0;

      /**
       * The number of requests completed (either successfully or not)
       */
      var reqsCompleted = 0;

      /**
       * The amount of time spent fetching before showing the loading bar
       */
      var latencyThreshold = cfpLoadingBar.latencyThreshold;

      /**
       * $timeout handle for latencyThreshold
       */
      var startTimeout;


      /**
       * calls cfpLoadingBar.complete() which removes the
       * loading bar from the DOM.
       */
      function setComplete() {
        $timeout.cancel(startTimeout);
        cfpLoadingBar.complete();
        reqsCompleted = 0;
        reqsTotal = 0;
      }

      /**
       * Determine if the response has already been cached
       * @param  {Object}  config the config option from the request
       * @return {Boolean} retrns true if cached, otherwise false
       */
      function isCached(config) {
        var cache;
        var defaultCache = $cacheFactory.get('$http');
        var defaults = $httpProvider.defaults;

        // Choose the proper cache source. Borrowed from angular: $http service
        if ((config.cache || defaults.cache) && config.cache !== false &&
          (config.method === 'GET' || config.method === 'JSONP')) {
            cache = angular.isObject(config.cache) ? config.cache
              : angular.isObject(defaults.cache) ? defaults.cache
              : defaultCache;
        }

        var cached = cache !== undefined ?
          cache.get(config.url) !== undefined : false;

        if (config.cached !== undefined && cached !== config.cached) {
          return config.cached;
        }
        config.cached = cached;
        return cached;
      }


      return {
        'request': function(config) {
          // Check to make sure this request hasn't already been cached and that
          // the requester didn't explicitly ask us to ignore this request:
          if (!config.ignoreLoadingBar && !isCached(config)) {
            $rootScope.$broadcast('cfpLoadingBar:loading', {url: config.url});
            if (reqsTotal === 0) {
              startTimeout = $timeout(function() {
                cfpLoadingBar.start();
              }, latencyThreshold);
            }
            reqsTotal++;
            cfpLoadingBar.set(reqsCompleted / reqsTotal);
          }
          return config;
        },

        'response': function(response) {
          if (!response || !response.config) {
            $log.error('Broken interceptor detected: Config object not supplied in response:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
            return response;
          }

          if (!response.config.ignoreLoadingBar && !isCached(response.config)) {
            reqsCompleted++;
            $rootScope.$broadcast('cfpLoadingBar:loaded', {url: response.config.url, result: response});
            if (reqsCompleted >= reqsTotal) {
              setComplete();
            } else {
              cfpLoadingBar.set(reqsCompleted / reqsTotal);
            }
          }
          return response;
        },

        'responseError': function(rejection) {
          if (!rejection || !rejection.config) {
            $log.error('Broken interceptor detected: Config object not supplied in rejection:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
            return $q.reject(rejection);
          }

          if (!rejection.config.ignoreLoadingBar && !isCached(rejection.config)) {
            reqsCompleted++;
            $rootScope.$broadcast('cfpLoadingBar:loaded', {url: rejection.config.url, result: rejection});
            if (reqsCompleted >= reqsTotal) {
              setComplete();
            } else {
              cfpLoadingBar.set(reqsCompleted / reqsTotal);
            }
          }
          return $q.reject(rejection);
        }
      };
    }];

    $httpProvider.interceptors.push(interceptor);
  }]);


/**
 * Loading Bar
 *
 * This service handles adding and removing the actual element in the DOM.
 * Generally, best practices for DOM manipulation is to take place in a
 * directive, but because the element itself is injected in the DOM only upon
 * XHR requests, and it's likely needed on every view, the best option is to
 * use a service.
 */
angular.module('cfp.loadingBar', [])
  .provider('cfpLoadingBar', function() {

    this.autoIncrement = true;
    this.includeSpinner = true;
    this.includeBar = true;
    this.latencyThreshold = 100;
    this.startSize = 0.02;
    this.parentSelector = 'body';
    this.spinnerTemplate = '<div id="loading-bar-spinner"><div class="spinner-icon"></div></div>';
    this.loadingBarTemplate = '<div id="loading-bar"><div class="bar"><div class="peg"></div></div></div>';

    this.$get = ['$injector', '$document', '$timeout', '$rootScope', function ($injector, $document, $timeout, $rootScope) {
      var $animate;
      var $parentSelector = this.parentSelector,
        loadingBarContainer = angular.element(this.loadingBarTemplate),
        loadingBar = loadingBarContainer.find('div').eq(0),
        spinner = angular.element(this.spinnerTemplate);

      var incTimeout,
        completeTimeout,
        started = false,
        status = 0;

      var autoIncrement = this.autoIncrement;
      var includeSpinner = this.includeSpinner;
      var includeBar = this.includeBar;
      var startSize = this.startSize;

      /**
       * Inserts the loading bar element into the dom, and sets it to 2%
       */
      function _start() {
        if (!$animate) {
          $animate = $injector.get('$animate');
        }

        var $parent = $document.find($parentSelector).eq(0);
        $timeout.cancel(completeTimeout);

        // do not continually broadcast the started event:
        if (started) {
          return;
        }

        $rootScope.$broadcast('cfpLoadingBar:started');
        started = true;

        if (includeBar) {
          $animate.enter(loadingBarContainer, $parent, angular.element($parent[0].lastChild));
        }

        if (includeSpinner) {
          $animate.enter(spinner, $parent, angular.element($parent[0].lastChild));
        }

        _set(startSize);
      }

      /**
       * Set the loading bar's width to a certain percent.
       *
       * @param n any value between 0 and 1
       */
      function _set(n) {
        if (!started) {
          return;
        }
        var pct = (n * 100) + '%';
        loadingBar.css('width', pct);
        status = n;

        // increment loadingbar to give the illusion that there is always
        // progress but make sure to cancel the previous timeouts so we don't
        // have multiple incs running at the same time.
        if (autoIncrement) {
          $timeout.cancel(incTimeout);
          incTimeout = $timeout(function() {
            _inc();
          }, 250);
        }
      }

      /**
       * Increments the loading bar by a random amount
       * but slows down as it progresses
       */
      function _inc() {
        if (_status() >= 1) {
          return;
        }

        var rnd = 0;

        // TODO: do this mathmatically instead of through conditions

        var stat = _status();
        if (stat >= 0 && stat < 0.25) {
          // Start out between 3 - 6% increments
          rnd = (Math.random() * (5 - 3 + 1) + 3) / 100;
        } else if (stat >= 0.25 && stat < 0.65) {
          // increment between 0 - 3%
          rnd = (Math.random() * 3) / 100;
        } else if (stat >= 0.65 && stat < 0.9) {
          // increment between 0 - 2%
          rnd = (Math.random() * 2) / 100;
        } else if (stat >= 0.9 && stat < 0.99) {
          // finally, increment it .5 %
          rnd = 0.005;
        } else {
          // after 99%, don't increment:
          rnd = 0;
        }

        var pct = _status() + rnd;
        _set(pct);
      }

      function _status() {
        return status;
      }

      function _completeAnimation() {
        status = 0;
        started = false;
      }

      function _complete() {
        if (!$animate) {
          $animate = $injector.get('$animate');
        }

        $rootScope.$broadcast('cfpLoadingBar:completed');
        _set(1);

        $timeout.cancel(completeTimeout);

        // Attempt to aggregate any start/complete calls within 500ms:
        completeTimeout = $timeout(function() {
          var promise = $animate.leave(loadingBarContainer, _completeAnimation);
          if (promise && promise.then) {
            promise.then(_completeAnimation);
          }
          $animate.leave(spinner);
        }, 500);
      }

      return {
        start            : _start,
        set              : _set,
        status           : _status,
        inc              : _inc,
        complete         : _complete,
        autoIncrement    : this.autoIncrement,
        includeSpinner   : this.includeSpinner,
        latencyThreshold : this.latencyThreshold,
        parentSelector   : this.parentSelector,
        startSize        : this.startSize
      };


    }];     //
  });       // wtf javascript. srsly
})();       //


/***/ }),

/***/ "AgC3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var SmoothScroll_1 = __webpack_require__("OSKg");
module_1.default.directive('smoothScroll', function () { return function (scope, element, attr) {
    var offset = parseInt(attr.smoothOffset, 10) || 0;
    var scrollSvc = new SmoothScroll_1.SmoothScroll(element[0], offset);
    element.on('click', function () { return (attr.smoothScroll !== '' && scope[attr.smoothScroll]) && scrollSvc.scroll(); });
}; });


/***/ }),

/***/ "Ao4C":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/judge-item_e7ff0f2e037025e2d772b2af67aeb787.css";

/***/ }),

/***/ "Argd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/ng-tags-input_fe8b4c708dc49b84c9c095cc9fc3e5d7.css";

/***/ }),

/***/ "B6ri":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Strings_1 = __webpack_require__("fxc3");
var module_1 = __webpack_require__("hfrq");
var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
var createFormatter = function (formatterName) {
    module_1.default.directive(formatterName, ['PaymentHelpers', function (PaymentHelpers) {
            return {
                scope: false,
                restrict: 'A',
                link: function (scope, element) { return PaymentHelpers[formatterName](element); }
            };
        }]);
};
createFormatter('formatCardNumber');
createFormatter('formatCardExpiry');
createFormatter('formatCardCvc');
createFormatter('restrictNumeric');
var createBlurValidator = function (validatorName, validate, parserCallback) {
    return module_1.default.directive(validatorName, ['$timeout', 'PaymentHelpers', function ($timeout, PaymentHelpers) {
            if (PaymentHelpers[validatorName]) {
                validate = PaymentHelpers[validatorName];
            }
            return {
                require: 'ngModel',
                link: function (scope, element, attrs, ctrl) {
                    var isValid = true;
                    var parser = function (viewValue) {
                        if (parserCallback)
                            parserCallback(scope, viewValue, PaymentHelpers);
                        isValid = validate(viewValue);
                        if (isValid) {
                            ctrl.$setValidity(validatorName, true);
                            if (ctrl.isValid)
                                element.addClass('is-valid');
                        }
                        else {
                            element.removeClass('is-valid');
                        }
                        ctrl.isValid = ctrl.$valid && isValid;
                        return viewValue;
                    };
                    ctrl.$parsers.unshift(parser);
                    element.on('blur', function () {
                        if (!isValid) {
                            scope.$apply(function () {
                                return ctrl.$setValidity(validatorName, false);
                            });
                        }
                    });
                    if (attrs[validatorName] === 'onStart') {
                        $timeout(function () {
                            if (ctrl.$viewValue) {
                                parser(ctrl.$viewValue);
                                element.triggerHandler('blur');
                            }
                        });
                    }
                }
            };
        }]);
};
createBlurValidator('validateName', function (str) {
    return !angular.isString(str) || str.length < 30 && /^[A-Z.'\- ]*$/.test(str);
});
createBlurValidator('validateCardNumber');
createBlurValidator('validateCardExpiry', angular.noop(), function (scope, viewValue, PaymentHelpers) {
    var cardExpiry = PaymentHelpers.cardExpiryVal(viewValue || '');
    scope.card_exp_month = cardExpiry.month;
    scope.card_exp_year = cardExpiry.year;
});
createBlurValidator('validateCardCvc');
createBlurValidator('validateZip', function (value) {
    return !value || value.length === 0 || /^\d{5}(-\d{4})?$/.test(value.trim());
});
createBlurValidator('validateEmailOnblur', function (s) { return !Strings_1.Strings.isBlank(s) && EMAIL_REGEXP.test(s); });
createBlurValidator('requiredOnblur', function (s) { return !Strings_1.Strings.isBlank(s); });


/***/ }),

/***/ "BCWO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/subscription-invoice-history-container_90a939514f0abab315c34ba136a09c50.css";

/***/ }),

/***/ "BGDY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/m-medium-landing_9d28a6855a0274832dc4bbd0ad8ebced.css";

/***/ }),

/***/ "BH+f":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/pricing_e10d020bc9ded7b97360c9f326f0f91d.css";

/***/ }),

/***/ "BJa0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/subscription-router-modals-container_d41d8cd98f00b204e9800998ecf8427e.css";

/***/ }),

/***/ "BTge":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/m-wave-typography_ec4c1dc356d024bccb9509b4fbe756f7.css";

/***/ }),

/***/ "Bdsd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/dropdown-menu_93321f5575dd89c7b9b8efd6c924ca72.css";

/***/ }),

/***/ "BjM0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/any-landing_a869a1c853fd8e90e8fd9b81b218cbe9.css";

/***/ }),

/***/ "Bkei":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/_checkbox-tab_51ea558bff237cdf7084d128a9e406eb.css";

/***/ }),

/***/ "C4lS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Strings_1 = __webpack_require__("fxc3");
var module_1 = __webpack_require__("hfrq");
module_1.default.factory('keypressHelper', ["$parse", function ($parse) {
    var keysByCode = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'insert',
        46: 'delete'
    };
    var capitaliseFirstLetter = function (string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };
    return function (mode, scope, elm, attrs) {
        var params;
        var combinations = [];
        params = scope.$eval(attrs['ui' + capitaliseFirstLetter(mode)]);
        // Prepare combinations for simple checking
        angular.forEach(params, function (v, k) {
            var combination;
            var expression;
            expression = $parse(v);
            angular.forEach(k.split(' '), function (variation) {
                combination = {
                    expression: expression,
                    keys: {}
                };
                angular.forEach(variation.split('-'), function (value) {
                    combination.keys[value] = true;
                });
                combinations.push(combination);
            });
        });
        // Check only matching of pressed keys one of the conditions
        elm.bind(mode, function (event) {
            // No need to do that inside the cycle
            var altPressed = event.metaKey || event.altKey;
            var ctrlPressed = event.ctrlKey;
            var shiftPressed = event.shiftKey;
            var keyCode = event.keyCode;
            // normalize keycodes
            if (mode === 'keypress' && !shiftPressed && keyCode >= 97 && keyCode <= 122) {
                keyCode = keyCode - 32;
            }
            // Iterate over prepared combinations
            angular.forEach(combinations, function (combination) {
                var mainKeyPressed = (combination.keys[keysByCode[event.keyCode]] || combination.keys[event.keyCode.toString()]) || false;
                var altRequired = combination.keys.alt || false;
                var ctrlRequired = combination.keys.ctrl || false;
                var shiftRequired = combination.keys.shift || false;
                if (mainKeyPressed &&
                    (altRequired == altPressed) &&
                    (ctrlRequired == ctrlPressed) &&
                    (shiftRequired == shiftPressed)) {
                    // Run the function
                    scope.$apply(function () {
                        combination.expression(scope, { '$event': event });
                    });
                }
            });
        });
    };
}]);
/**
 * Bind one or more handlers to particular keys or their combination
 * @param hash {mixed} keyBindings Can be an object or string where keybinding expression of keys or keys combinations and AngularJS Exspressions are set. Object syntax: "{ keys1: expression1 [, keys2: expression2 [ , ... ]]}". String syntax: ""expression1 on keys1 [ and expression2 on keys2 [ and ... ]]"". Expression is an AngularJS Expression, and key(s) are dash-separated combinations of keys and modifiers (one or many, if any. Order does not matter). Supported modifiers are 'ctrl', 'shift', 'alt' and key can be used either via its keyCode (13 for Return) or name. Named keys are 'backspace', 'tab', 'enter', 'esc', 'space', 'pageup', 'pagedown', 'end', 'home', 'left', 'up', 'right', 'down', 'insert', 'delete'.
 * @example <input ui-keypress="{enter:'x = 1', 'ctrl-shift-space':'foo()', 'shift-13':'bar()'}" /> <input ui-keypress="foo = 2 on ctrl-13 and bar('hello') on shift-esc" />
 **/
var actions = ['down', 'press', 'up'];
angular.forEach(actions, function (action) {
    var event = 'key' + action;
    var directiveName = 'ui' + Strings_1.Strings.capitalize(event);
    module_1.default.directive(directiveName, ['keypressHelper', function (keypressHelper) {
            return function (scope, elm, attrs) {
                return keypressHelper(event, scope, elm, attrs);
            };
        }]);
});


/***/ }),

/***/ "CDOh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/wave-tutorial-page_b4455556f5086409604655ee33b8a766.css";

/***/ }),

/***/ "CFmk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/16.svg";

/***/ }),

/***/ "CM5t":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/week1_2b0e67ae8ee824687a6011ff84556633.html";

/***/ }),

/***/ "CRNW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var lazy_modules_1 = __webpack_require__("bUzP");
var AnimatronProjectsSvc_1 = __webpack_require__("P9JW");
var underscore_extensions_1 = __webpack_require__("R0iF");
var MasonryCtrl = (function () {
    MasonryCtrl.$inject = ["$scope", "$rootScope", "$element", "$q"];
    function MasonryCtrl($scope, $rootScope, $element, $q) {
        var _this = this;
        this.$onInit = function () { return underscore_extensions_1.Utils.rAF(function () {
            var anmDefered = $q.defer();
            var destroy = $scope.$watch('animatron', function (a) {
                if (_.isObject(a)) {
                    anmDefered.resolve(a);
                    destroy();
                }
            });
            _this.anmSvcPromise = anmDefered.promise;
            var container = $element[0];
            var columnWidth = container.querySelector('.projects-column-width').offsetWidth;
            var deferred = $q.defer();
            _this.cache = [];
            loadScripts([lazy_modules_1.masonryLib], function () {
                var Masonry = window.Masonry;
                _this.anmSvcPromise.then(function (a) { return a.computedWidth = columnWidth; });
                var msnry = new Masonry(container, {
                    itemSelector: 'masonry-brick',
                    gutter: container.querySelector('.projects-gutter'),
                    columnWidth: columnWidth,
                    fitWidth: true,
                    containerStyle: null,
                    stagger: 30,
                    initLayout: true,
                    transitionDuration: (options.isIE ? '0' : '0.4s')
                });
                _this.anmSvcPromise.then(function (a) { return a.nextPage(); });
                var destroyMsnry = function () {
                    msnry.items = [];
                    msnry.destroy();
                    msnry.layout();
                    msnry.bindResize();
                };
                $rootScope.$on('project:remove', function (e, pid) {
                    msnry.remove(document.getElementById('brick-' + pid));
                    msnry.layout();
                });
                $rootScope.$on('masonry:layout', function () { return msnry.layout(); });
                $rootScope.$on('masonry:destroy', function () { return destroyMsnry(); });
                $rootScope.$on(AnimatronProjectsSvc_1.PROJECT_ADD, function (e, _a) {
                    var project = _a.project;
                    return setTimeout(function () {
                        var el = document.getElementById('brick-' + project.id);
                        msnry.appended(el);
                        msnry.reloadItems();
                        msnry.layout();
                    }, 0);
                });
                if (_this.ExploreCtrl) {
                    var onTabChangeFromCtrl_1 = _this.ExploreCtrl.onTabChange.bind(_this.ExploreCtrl);
                    _this.ExploreCtrl.onTabChange = function (args) {
                        destroyMsnry();
                        onTabChangeFromCtrl_1(args);
                    };
                }
                deferred.resolve(msnry);
            });
            _this.msnryPromise = deferred.promise;
        }); };
    }
    return MasonryCtrl;
}());
module_1.default.directive('masonry', function () {
    return {
        scope: false,
        bindToController: true,
        require: { ExploreCtrl: '^?explorePage' },
        controller: MasonryCtrl
    };
});
module_1.default.directive('masonryBrick', function () {
    return {
        require: '^masonry',
        scope: false,
        restrict: 'E',
        link: function (scope, element, attrs, masonryCtrl) {
            masonryCtrl.msnryPromise && masonryCtrl.msnryPromise.then(function (msnry) {
                element[0].classList.add('msnry-item');
                masonryCtrl.cache.push(element[0]);
                if (scope.$last) {
                    underscore_extensions_1.Utils.rAF(function () {
                        msnry.appended(masonryCtrl.cache);
                        msnry.reloadItems();
                        msnry.layout();
                        masonryCtrl.cache = [];
                        masonryCtrl.anmSvcPromise.then(function (a) { return a.busy = false; });
                    });
                }
            });
        }
    };
});


/***/ }),

/***/ "ClZ7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/1.svg";

/***/ }),

/***/ "Cw72":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/video-folder-bottom_3dee4ebb64472d66338320e123655759.css";

/***/ }),

/***/ "CxL4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/subscription-payment-details-enter-card_0851159b9b911c19f8c8bec2a6404db0.css";

/***/ }),

/***/ "D9F/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/11.png";

/***/ }),

/***/ "DDR7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/6.svg";

/***/ }),

/***/ "DFGL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/3.svg";

/***/ }),

/***/ "DHQn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/week2_4369c87474f907beb97b1160e6b38a1d.html";

/***/ }),

/***/ "DMU6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/pre-register_c89215ecbde9aca4f2c56bfd2c6f86cb.css";

/***/ }),

/***/ "Dc98":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/13.svg";

/***/ }),

/***/ "Dg8K":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/random-fact_e42d570c918f0f4af827079bd40182f1.css";

/***/ }),

/***/ "DhCa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/m-landing-common_83a760e8f429e1af34e83cb6a3ff7dfc.css";

/***/ }),

/***/ "Dmwp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var Logo = (function () {
    Logo.$inject = ["$location", "landingTemplateSvc"];
    function Logo($location, landingTemplateSvc) {
        this.$location = $location;
        this.landingTemplateSvc = landingTemplateSvc;
        this.islogoClickable = this.isLink || this.landingTemplateSvc.isLink;
    }
    Logo.prototype.logoHandler = function () {
        if (this.isLink || this.landingTemplateSvc.isLink) {
            var url = this.href ? this.href : '/wave';
            if (this.openInNewWindow) {
                window.open("" + window.location.origin + url, '_blank');
            }
            else {
                this.$location.path(url);
            }
        }
    };
    return Logo;
}());
module_1.default.component('logo', {
    bindings: {
        product: '@',
        logoStyle: '@',
        additionalLogo: '@',
        isLink: '<?',
        href: '<?',
        openInNewWindow: '<?'
    },
    controller: Logo,
    template: "<div class=\"animatron-logo product-{{ $ctrl.product }} style-{{ $ctrl.logoStyle }}\"\n                    ng-click=\"$ctrl.logoHandler()\"\n                    ng-class=\"{'is-clickable': $ctrl.islogoClickable}\"\n                    data=\"{{ $ctrl.additionalLogo }}\"\n               ><i></i></div>"
});


/***/ }),

/***/ "Du2S":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/countdown_00505d8b81346a11d40d0d17e7c4a5f7.css";

/***/ }),

/***/ "DuQD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/17.png";

/***/ }),

/***/ "EHgq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/banner/help-img-9.png";

/***/ }),

/***/ "EXaJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var SpinnerSvc_1 = __webpack_require__("pPBV");
var underscore_extensions_1 = __webpack_require__("R0iF");
var ProjectPageCanvasCtrl = (function () {
    ProjectPageCanvasCtrl.$inject = ["$scope", "$element", "$stateParams", "Player", "OldPlayer", "AnimatronPreviews"];
    function ProjectPageCanvasCtrl($scope, $element, $stateParams, Player, OldPlayer, AnimatronPreviews) {
        var _this = this;
        this.$scope = $scope;
        this.$element = $element;
        this.$stateParams = $stateParams;
        this.Player = Player;
        this.OldPlayer = OldPlayer;
        this.AnimatronPreviews = AnimatronPreviews;
        this.canvas = this.$element[0].firstChild;
        this.resize = function (player) { return function () {
            var _a = _this.calculate(), width = _a[0], height = _a[1];
            if (player) {
                player.setSize(width, height);
            }
        }; };
    }
    ProjectPageCanvasCtrl.prototype.$onInit = function () {
        var _this = this;
        this.ProjectPageCtrl.projectPromise.then(function (p) {
            _this.project = p;
            _this.playerSelector = _this.$element[0].parentElement;
            _this.projectModalSelector = document.querySelector('.wrapper-proj');
            if (_this.ProjectPageCtrl.twoPlayers) {
                _this.playerSelector.style.minWidth = 'initial';
            }
            _this.$scope.fullscreen = options.handHeld;
            if (_this.project && _this.project.id === _this.$stateParams.projectId) {
                _this.createPlayer();
            }
            underscore_extensions_1.Utils.scopedEvent('keyup', _this.$scope, function (e) {
                if (e.keyCode === 27 && document.querySelector('#project-player').classList.contains('fullscreen')) {
                    _this.ProjectPageCtrl.toggleFullscreen();
                }
            });
            _this.ProjectPageCtrl.toggleFullscreen = function () {
                document.querySelector('#project-player').classList.toggle('fullscreen');
                _this.projectWidth = window.innerWidth;
                _this.ProjectPageCtrl.player.then(function (p) { return _this.resize(p)(); });
                _this.$scope.fullscreen = true;
            };
        });
    };
    ProjectPageCanvasCtrl.prototype.getHeightMargin = function () {
        return this.$scope.fullscreen ? (options.handHeld ? document.querySelector('header').offsetHeight : 0) : 210;
    };
    ProjectPageCanvasCtrl.prototype.calculate = function () {
        if (_.isUndefined(this.projectWidth)) {
            this.projectWidth = Math.max(this.project.width, 640);
        }
        var width = this.$scope.fullscreen ? window.innerWidth : this.projectWidth, height = Math.round(this.project.height * width / this.project.width);
        var bodyDimension = document.body.getBoundingClientRect(), windowWidth = bodyDimension.width / (this.ProjectPageCtrl.twoPlayers ? 2 : 1), windowHeight = bodyDimension.height, heightMargin = this.getHeightMargin(), widthMargin = this.$scope.fullscreen || options.handHeld ? 0 : 160, windowHeightScaled = windowHeight - heightMargin, windowWidthScaled = windowWidth - widthMargin, displayedProjectHeight = Math.round(height * windowWidthScaled / width), displayedProjectWidth = Math.round(width * windowHeightScaled / height);
        if (width > windowWidthScaled) {
            width = windowWidthScaled;
            height = displayedProjectHeight;
        }
        if (height > windowHeightScaled) {
            width = displayedProjectWidth;
            height = windowHeightScaled;
        }
        this.projectModalSelector.style.width = (this.old ? 2 : 1) * Math.max(width + 20, 390) + 'px';
        this.playerSelector.style.width = width + 'px';
        this.playerSelector.style.height = height + 'px';
        this.projectModalSelector.classList[(windowWidth - width < 250) ? 'add' : 'remove']('left-movie-buttons');
        return [width, height];
    };
    ProjectPageCanvasCtrl.prototype.createPlayer = function () {
        var _this = this;
        var suffix = this.ProjectPageCtrl.twoPlayers ? Math.random() : '';
        this.canvas.id = 'project-canvas-' + this.project.id + suffix;
        this.thumbnail = this.AnimatronPreviews.pickPreview(this.project.preview_metadata);
        var img = this.canvas.querySelector('.preview-image');
        img.onerror = function () { return img.style.display = 'none'; };
        var _a = this.calculate(), width = _a[0], height = _a[1];
        var svc = this.old ? this.OldPlayer : this.Player;
        if (window.isPhantom || this.$stateParams.stopPlay === 'true')
            return;
        this.ProjectPageCtrl.player = svc.createPlayer(this.project, this.canvas.id, {
            autoPlay: !options.handHeld && !this.ProjectPageCtrl.twoPlayers,
            width: width, height: height, thumbnail: this.thumbnail
        }, function (player) {
            _this.canvas.removeChild(img);
            SpinnerSvc_1.default.hide();
            if (_this.ProjectPageCtrl.twoPlayers) {
                ProjectPageCanvasCtrl.players.push(player);
                if (ProjectPageCanvasCtrl.players.length === 2) {
                    setTimeout(function () { return ProjectPageCanvasCtrl.players.forEach(function (p) { return p.play(); }); });
                }
            }
        }).then(function (player) {
            underscore_extensions_1.Utils.scopedEvent('resize', _this.$scope, _.throttle(_this.resize(player), 300));
            _this.$scope.$watch(function () { return _this.ProjectPageCtrl.sizes.projectSize; }, function (newWidth) {
                if (_.isUndefined(newWidth) || newWidth === _this.projectWidth.toString()) {
                    return;
                }
                _this.projectWidth = parseInt(newWidth, 10);
                _this.resize(player)();
            });
            return player;
        });
    };
    ProjectPageCanvasCtrl.prototype.$onDestroy = function () {
        this.Player.resetPlayer(this.ProjectPageCtrl.player);
    };
    return ProjectPageCanvasCtrl;
}());
ProjectPageCanvasCtrl.players = [];
module_1.default.component('projectPageCanvas', {
    bindings: {
        old: '<'
    },
    controller: ProjectPageCanvasCtrl,
    require: { ProjectPageCtrl: '^projectPage' },
    template: "<div><img class=\"preview-image\" ng-src=\"{{$ctrl.thumbnail}}\" alt=\"{{$ctrl.project.name}}\"/></div>"
});


/***/ }),

/***/ "EepZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/pre-register-section_4c15b2f3ddffaaa8b4004f665f71e257.css";

/***/ }),

/***/ "EsqY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * To add new page, create new json object with the same structure as the ones below.
 * Most values should be key references to i18n files. So translations should also be written in app/assets/i18n/m_*.properties files
 * It is essential that all properties are present and have correct names.
 * Images are stored in app/assets/images/landing/banner folder, but here should only be filename.
 */

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        image: 'help-img-1',
        alt: 'explainer.help1.alt1',
        title: 'explainer.help1.title',
        shortTitle: 'short.presentation.title',
        description: 'explainer.help1.desc',
        url: '/studio/presentation-maker'
    },
    {
        image: 'help-img-8',
        alt: 'explainer.help8.alt8',
        title: 'explainer.help8.title',
        shortTitle: 'short.agencies.title',
        description: 'explainer.help8.desc',
        url: '/studio/animation-for-agencies'
    },
    {
        image: 'help-img-3',
        alt: 'explainer.help3.alt3',
        title: 'explainer.help3.title',
        shortTitle: 'short.explainer.title',
        description: 'explainer.help3.desc',
        url: '/studio/explainer-video-maker'
    },
    {
        image: 'help-img-3b',
        alt: 'explainer.help3b.alt3b',
        title: 'explainer.help3b.title',
        description: 'explainer.help3b.desc',
        url: '/studio/html5-banner-maker'
    },
    {
        image: 'help-img-4',
        alt: 'explainer.help4.alt3',
        title: 'explainer.help4.title',
        shortTitle: 'short.cards.title',
        description: 'explainer.help4.desc',
        url: '/studio/online-card-maker'
    },
    {
        image: 'help-img-5',
        alt: 'explainer.help5.alt5',
        title: 'explainer.help5.title',
        shortTitle: 'short.creativity.title',
        description: 'explainer.help5.desc',
        url: '/studio/creativity-in-classroom'
    },
    {
        image: 'help-img-6',
        alt: 'explainer.help6.alt6',
        title: 'explainer.help6.title',
        shortTitle: 'short.political.title',
        description: 'explainer.help6.desc',
        url: '/studio/political-cartoon-maker'
    },
    {
        image: 'help-img-7',
        alt: 'explainer.help7.alt7',
        title: 'explainer.help7.title',
        shortTitle: 'short.whiteboard.title',
        description: 'explainer.help7.desc',
        url: '/studio/whiteboard-animation-software'
    },
    {
        image: 'help-img-2',
        alt: 'explainer.help2.alt2',
        title: 'explainer.help2.title',
        shortTitle: 'short.video.title',
        description: 'explainer.help2.desc',
        url: '/studio/online-video-maker'
    },
    {
        image: 'help-img-9',
        alt: 'explainer.help9.alt9',
        title: 'explainer.help9.title',
        shortTitle: 'short.designers.title',
        description: 'explainer.help9.desc',
        url: '/studio/animation-for-designers'
    }
];


/***/ }),

/***/ "Exe7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/video-banner_73fe5fd387625f5d16dba9802b8fcc1d.html";

/***/ }),

/***/ "F3zo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/21.png";

/***/ }),

/***/ "F6N9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/section-template-pages-list_8cfe2872b7dc9fc7cc8b2bd007f0aefd.css";

/***/ }),

/***/ "FD1p":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Strings_1 = __webpack_require__("fxc3");
var module_1 = __webpack_require__("hfrq");
var UserAvatar = (function () {
    UserAvatar.$inject = ["$scope", "$element", "$filter", "$attrs"];
    function UserAvatar($scope, $element, $filter, $attrs) {
        var _this = this;
        this.$scope = $scope;
        this.$element = $element;
        this.$filter = $filter;
        this.$attrs = $attrs;
        var avatarCode = function () {
            var code = Array.prototype.map.call(_this.user.username, function (c) { return c.charCodeAt(0); })
                .reduce(function (a, b) { return a + b; }) % 13;
            return __webpack_require__("V16h")("./" + Math.max(1, code) + ".svg");
        };
        var encodeUsername = $filter('encodeUsername');
        var imgElement = $element[0].getElementsByTagName('img')[0];
        var setDefaultAvatar = function () {
            imgElement.src = avatarCode();
            imgElement.onerror = undefined;
        };
        var getSizedUrl = function (url) {
            if (_.isNumber(_this.size)) {
                if (/google/.test(url)) {
                    return url + '?sz=' + _this.size;
                }
                else if (/facebook/.test(url)) {
                    return url.replace(/\?type=.*$/, '') + ("?width=" + _this.size + "&height=" + _this.size);
                }
                else if (/gravatar/.test(url)) {
                    return url + '?s=' + _this.size;
                }
                else if (/animatron/.test(url) && !/svg/.test(url)) {
                    return UserAvatar.ConversionUrl + "?u=" + url + "&p=r" + _this.size + ":" + _this.size + ":0&o=jpg";
                }
            }
            return url;
        };
        var matchAvatarApi = function (url) {
            var match = url.match(/profile\/avatar\/(.*)/);
            return match && match.length > 0 ?
                url.replace(match[1], encodeUsername(match[1])) : url;
        };
        var setUrl = function (url) {
            url = matchAvatarApi(url);
            if (Strings_1.Strings.isBlank(url)) {
                setDefaultAvatar();
            }
            else {
                imgElement.onerror = function () { return setDefaultAvatar(); };
                imgElement.src = getSizedUrl(url);
            }
        };
        var watchObject = this.url ? 'url' : 'user.avatar';
        var watcher = $scope.$watch('$ctrl.' + watchObject, function (url) {
            if ((imgElement && !_.isUndefined(url)) || (_this.user && !_this.user.avatar)) {
                setUrl(url || '');
                var enableWatch = angular.isString($attrs.watch);
                if (!enableWatch) {
                    watcher();
                    setTimeout(function () { return $scope.$destroy(); });
                }
            }
        });
    }
    return UserAvatar;
}());
UserAvatar.ConversionUrl = "https://conv.animatron" + ( true ? '' : '-test') + ".com";
UserAvatar.avatars = __webpack_require__("QI9i");
module_1.default.component('userAvatar', {
    bindings: {
        url: '<',
        size: '<',
        user: '<'
    },
    controller: UserAvatar,
    template: '<img width="{{::$ctrl.size}}" height="{{::$ctrl.size}}" alt="{{::$ctrl.user.displayName}}"/>'
});


/***/ }),

/***/ "FHxu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/5.svg";

/***/ }),

/***/ "FUIZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
module_1.default.directive('validateUsername', ["$filter", "$q", "HttpSvc", function ($filter, $q, HttpSvc) {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ctrl) {
            var usernameAvailChecker = function (username) {
                return HttpSvc($filter('encodeUsername')(username) + '/profile')
                    .get().then(function (response) { return response.data.code === 404; });
            };
            ctrl.$asyncValidators['validateUsername'] = function (viewValue) { return ((function () {
                if (viewValue && viewValue.length > 0 && viewValue !== options.user.username) {
                    return usernameAvailChecker(viewValue);
                }
                else {
                    return $q.resolve(true);
                }
            })()).then(function (r) { return r ? $q.resolve() : $q.reject(); }); };
        }
    };
}]);
module_1.default.directive('validateEmail', ["$q", "HttpSvc", function ($q, HttpSvc) {
    var apiSvc = HttpSvc('profile', 'check-email');
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ctrl) {
            var emailAvailChecker = function (email) {
                return apiSvc.chain(email).get()
                    .then(function (response) { return response.data.code === 404; })
                    .catch(function () { return true; });
            };
            ctrl.$asyncValidators['validateEmail'] = function (viewValue) { return $q(function (resolve, reject) {
                if (viewValue && viewValue.length > 0 && viewValue !== options.user.email) {
                    emailAvailChecker(viewValue).then(function (r) { return r ? resolve() : reject(); });
                }
                else {
                    resolve();
                }
            }); };
        }
    };
}]);
module_1.default.directive('match', [function () {
        return {
            require: 'ngModel',
            scope: {
                match: '='
            },
            link: function (scope, elem, attrs, ctrl) {
                scope.$watch('match', function () {
                    ctrl.$validate();
                });
                ctrl.$validators['match'] = function (modelValue) {
                    return (scope.match === undefined || ctrl.$pristine && (angular.isUndefined(modelValue) || modelValue === '')) || modelValue === scope.match;
                };
            }
        };
    }]);
module_1.default.directive('resetField', [function () {
        return {
            require: 'ngModel',
            link: function (scope, elem, attrs, ctrl) {
                ctrl.$parsers.unshift(function (viewValue) {
                    ctrl.$setValidity(attrs.resetField, true);
                    return viewValue;
                });
            }
        };
    }]);


/***/ }),

/***/ "Fa/p":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/19.svg";

/***/ }),

/***/ "FdTb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var AdBanner = (function () {
    function AdBanner() {
    }
    return AdBanner;
}());
module_1.default.component('adBanner', {
    bindings: {
        ad: '<'
    },
    controller: AdBanner,
    templateUrl: __webpack_require__("Exe7")
});


/***/ }),

/***/ "FnqE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/light-landing_00139a0deae1d2b1f8ced18569d5ca74.html";

/***/ }),

/***/ "FoMv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var underscore_extensions_1 = __webpack_require__("R0iF");
var LandingPage = (function () {
    function LandingPage() {
        this.videoOptions = {
            volume: 0
        };
        this.video = {
            wistiaId: '0mvyjstgpk',
            preview: 'https://assets.animatron.com/images/landing/video-previews/studio_preview.jpg'
        };
        this.tabs = ['startup', 'teachers', 'animators', 'everyone'];
    }
    LandingPage.prototype.tabChange = function () {
        var selectors = '.tabs-animated-content, .quote-wrapper';
        var all = [].slice.call(document.querySelectorAll(selectors));
        all.forEach(function (el) { return el.classList.remove(LandingPage.animationActiveClz); });
        setTimeout(function () { return underscore_extensions_1.Utils.rAF(function () {
            return all.forEach(function (el) { return el.classList.add(LandingPage.animationActiveClz); });
        }); });
    };
    return LandingPage;
}());
LandingPage.animationActiveClz = 'stager--active';
module_1.default.component('landingPage', {
    controller: LandingPage,
    templateUrl: __webpack_require__("nAeZ")
});


/***/ }),

/***/ "G1du":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

AdminSvcFactory.$inject = ["$http", "$q", "$rootScope", "TagsSvc", "HttpSvc", "BackendSvc", "TranslateSvc"];
Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("jYQ6");
var SpinnerSvc_1 = __webpack_require__("pPBV");
var underscore_extensions_1 = __webpack_require__("R0iF");
var AnimatronProjectsSvc_1 = __webpack_require__("P9JW");
var AdminSvc = (function () {
    function AdminSvc(project) {
        var _this = this;
        this.project = project;
        this.exportActions = ['json', 'anm', 'zip', 'svg', 'png'];
        this.roles = options.user.subscriptionDetails.studio.features;
        this.staffPickTag = { name: 'Staff Picks', type: 'SUPER' };
        this.duplicating = false;
        this.exportProject = function (action) {
            return _this.BackendSvc.getServerUrl(_this.project).then(function (url) {
                var exportUrl = url + "/project/export/" + action + "/" + _this.project.id + "?params={}&t=0";
                window.open(exportUrl, '_self');
            });
        };
        this.doctor = function (action) {
            return _this.BackendSvc.getServerUrl(_this.project).then(function (url) {
                var doctorUrl = url + "/doctor/show/" + _this.project.id;
                window.open(doctorUrl, '_blank');
            });
        };
    }
    AdminSvc.prototype.staffLike = function () {
        var _this = this;
        SpinnerSvc_1.default.show();
        this.project.staffPicked = true;
        this.TagsSvc.saveTag(this.staffPickTag, this.project.id)
            .then(function () { return _this.project.tags.push(_this.staffPickTag); })
            .catch(this.errorFunction.bind(this)).finally(function () { return SpinnerSvc_1.default.hide(); });
    };
    ;
    AdminSvc.prototype.staffDislike = function () {
        var _this = this;
        SpinnerSvc_1.default.show();
        this.project.staffPicked = false;
        this.TagsSvc.tagRemoved(this.staffPickTag, this.project.id).then(function () {
            _this.project.tags = _this.project.tags.filter(function (tag) { return tag.name !== _this.staffPickTag.name; });
        }).finally(function () { return SpinnerSvc_1.default.hide(); });
    };
    ;
    AdminSvc.prototype.duplicateProject = function (folderId, copySuffix) {
        var _this = this;
        if (copySuffix === void 0) { copySuffix = 'Copy_from_website'; }
        SpinnerSvc_1.default.show();
        this.duplicating = true;
        var folderParam = folderId ? "&folderId=" + folderId : '';
        var url = "project-api?oldProjectId=" + this.project.id + "&product=" + this.project.product + folderParam;
        var opts = { headers: _.extend({ 'Content-Type': 'text/plain' }, options.headers) };
        return this.HttpSvc(url)
            .post({}, opts)
            .then(function (r) { return r.data; })
            .then(function (projectServerMapping) {
            var newName = _this.project.name + copySuffix, path = '/project/duplicate', params = "?name=" + encodeURIComponent(newName) + "&oldId=" + _this.project.id, duplicateUrl = projectServerMapping.url.replace('http:', 'https:') + path + params, duplicateProjectId = projectServerMapping['project-id'];
            opts.headers['Animatron-Project-ID'] = duplicateProjectId;
            var requestWrapper = function (request) {
                return request.then(function (r) { return r.data; }).then(function (data) {
                    return underscore_extensions_1.Utils.isApiError(data)
                        ? _this.$q.reject(data)
                        : _this.$q.resolve(data);
                });
            };
            var duplicateRequest = requestWrapper(_this.$http.post(duplicateUrl, '', opts));
            var getProjectRequest = requestWrapper(_this.HttpSvc('project', duplicateProjectId).secureGet());
            return duplicateRequest
                .then(function () { return getProjectRequest; })
                .then(function (project) {
                _this.$rootScope.$emit(AnimatronProjectsSvc_1.PROJECT_ADD, { project: project });
            });
        })
            .finally(function () {
            _this.duplicating = false;
            SpinnerSvc_1.default.hide();
        });
    };
    ;
    AdminSvc.prototype.errorFunction = function (error) {
        console.log(error);
        _.notification.showError('Failed to modify staff picks');
    };
    ;
    return AdminSvc;
}());
exports.AdminSvc = AdminSvc;
function AdminSvcFactory($http, $q, $rootScope, TagsSvc, HttpSvc, BackendSvc, TranslateSvc) {
    _.extend(AdminSvc.prototype, {
        $http: $http, $q: $q, TagsSvc: TagsSvc, HttpSvc: HttpSvc, BackendSvc: BackendSvc, $rootScope: $rootScope, TranslateSvc: TranslateSvc
    });
    return AdminSvc;
}
module_1.default.service('AdminSvc', AdminSvcFactory);


/***/ }),

/***/ "G8ZG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var underscore_extensions_1 = __webpack_require__("R0iF");
module_1.default.component('oauthSignInButtons', {
    controller: ["$timeout", "$state", "analyticSvc", "OAuthCallbackSvc", "LocalStorageSvc", function ($timeout, $state, analyticSvc, OAuthCallbackSvc, LocalStorageSvc) {
        var originProduct = underscore_extensions_1.Utils.getProduct().toLowerCase();
        var makeCallback = function (service) {
            var s = (false || originProduct === 'wave') ? location.origin : location.origin.replace(/(https?:\/\/)(www.)?/, '$1www.');
            return s + "/callback/" + service;
        };
        var buildOAuthUrl = function (endpoint, apiKey, callback) {
            return endpoint + "?response_type=token&client_id=" + apiKey + "&redirect_uri=" + callback;
        };
        var google = (function () {
            var apiKey = options.social.googleApiKey;
            var endpoint = 'https://accounts.google.com/o/oauth2/auth';
            //https://developers.google.com/+/web/api/rest/oauth
            return buildOAuthUrl(endpoint, apiKey, makeCallback('google')) + "&scope=profile email";
        })();
        var facebook = (function () {
            var apiKey = options.social.facebookApiKey;
            var endpoint = 'https://www.facebook.com/dialog/oauth';
            return buildOAuthUrl(endpoint, apiKey, makeCallback('facebook')) + "&scope=email&display=popup";
        })();
        var twitter = options.apiDomain + "/authenticate/twitter?redirect_uri=" + location.origin + "/callback/twitter/";
        var dribbble = (function () {
            var apiKey = options.social.dribbbleApiKey;
            var callback =  false ? location.origin + "/callback/dribbble" : options.social.oauthCallback.replace('WEBFB', 'WEBDR');
            return "https://dribbble.com/oauth/authorize?client_id=" + apiKey + "&redirect_uri=" + callback;
        })();
        this.open = function (link, provider) { return $timeout(function () {
            analyticSvc.signUpSocialSubmit(provider);
            window.open(link, 'Auth', 'width=640, height=480,resizable,scrollbars,status');
        }); };
        this.providers = { facebook: facebook, google: google, twitter: twitter };
        window.addEventListener('storage', function listener(e) {
            if (LocalStorageSvc.get('auth') || (e.key === 'auth' && e.newValue)) {
                window.removeEventListener('storage', listener);
                LocalStorageSvc.remove('auth');
                var value_1 = JSON.parse(e.newValue);
                $timeout(function () { return OAuthCallbackSvc.doLogin(value_1.params, value_1.stateParams); });
            }
        }, false);
    }],
    template: "<div class=\"sign-in-buttons-wrapper\">\n            <a ng-click=\"$ctrl.open(link, provider)\" ng-repeat=\"(provider, link) in ::$ctrl.providers\"\n               target=\"Auth\" class=\"sign-in {{provider}}-signin\"></a>\n               </div>"
});


/***/ }),

/***/ "GIoJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/wave-user-page_83ad6a4b121102f63ca01b8ed9ad5382.css";

/***/ }),

/***/ "GOYa":
/***/ (function(module, exports) {

var path = 'https://assets.animatron.com/html/tabs.html';
var html = "<nav class=\"tabs\" ng-class=\"{'mobile-mode': Tabs.isMobileMode}\"> <button type=\"button\" class=\"tabs-trigger\" toggle-class=\"open\"> {{$root.t(Tabs.currentTab ? Tabs.currentTab.toLowerCase() + '.tab' : null)}} </button> <ul class=\"tabs-list\" ng-class=\"{'enable-animation': Tabs.enableAnimation }\"> <li class=\"tab {{::tab | lowercase}}\" ng-repeat=\"tab in Tabs.tabs\" ng-class=\"{active: Tabs.isActive(tab) }\"> <a id=\"{{::tab | lowercase}}\" href=\"\" ng-click=\"Tabs.isActive(tab) || Tabs.activateTab(tab)\"> <ng-transclude></ng-transclude> <span>{{::$root.t(tab.toLowerCase() + '.tab')}}</span> <span class=\"tab-label\" ng-if=\"Tabs.labels\">{{Tabs.labels[tab]}} </span> </a> </li> </ul> </nav> ";
var angular = window.angular;
var injector = angular.element(document).injector();
if (injector) {
injector.get('$templateCache').put(path, html);
} else {
angular.module('templates').run(['$templateCache', function(c) { c.put(path, html) }]);
}
module.exports = path;

/***/ }),

/***/ "GWJA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var underscore_extensions_1 = __webpack_require__("R0iF");
module_1.default.directive('fixedTabs', function () {
    return function (scope, element) {
        var header = element[0];
        var offset;
        scope.fixedTab = false;
        setTimeout(function () {
            offset = header.offsetTop;
        }, 0);
        underscore_extensions_1.Utils.scopedEvent('resize', scope, _.throttle(function () {
            offset = header.offsetTop || offset;
        }, 100));
        underscore_extensions_1.Utils.scopedEvent('scroll', scope, _.throttle(function () {
            underscore_extensions_1.Utils.rAF(function () {
                var atBottom = ((window.scrollY || window.pageYOffset) - offset) > -55;
                if (scope.fixedTab && !atBottom) {
                    scope.fixedTab = false;
                    header.classList.remove('fixed-tabs--pinned');
                }
                else if (!scope.fixedTab && atBottom) {
                    scope.fixedTab = true;
                    header.classList.add('fixed-tabs--pinned');
                }
            });
        }, 100));
    };
});


/***/ }),

/***/ "GgDZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/editable_db996aafcea7c65151268513181eb155.html";

/***/ }),

/***/ "HAK0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

UserChangeWatcherSvc.$inject = ["$interval", "$timeout", "$log", "ipCookie", "AuthenticationSvc"];
Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("jYQ6");
function UserChangeWatcherSvc($interval, $timeout, $log, ipCookie, AuthenticationSvc) {
    var checkInterval = 3000;
    var userTracker = _.once(function () {
        $timeout(function () {
            var token = ipCookie(AuthenticationSvc.animatronCookieName);
            var inProgress = false;
            $interval(function () {
                if (!inProgress) {
                    token = ipCookie(AuthenticationSvc.animatronCookieName);
                    if (AuthenticationSvc.loggedIn && !token) {
                        $log.debug('User logged out.');
                        inProgress = true;
                        AuthenticationSvc.logoutAndGoRoot().then(function () { return inProgress = false; });
                    }
                    else if (!AuthenticationSvc.loggedIn && token) {
                        $log.debug('User logged in.');
                        inProgress = true;
                        AuthenticationSvc.loginFromCookie().then(function () { return inProgress = false; });
                    }
                }
            }, checkInterval);
        }, checkInterval);
    });
    this.init = _.once(function (callback) {
        if (AuthenticationSvc.isCookieEnabled()) {
            AuthenticationSvc.getUser(true).then(callback).then(userTracker);
        }
        else {
            AuthenticationSvc.setAnonymous().then(function () {
                callback();
                _.notification.showError('Oh no! It seems you have disabled cookies! To continue please enable cookies in your browser and refresh the page.', 0);
            });
        }
    });
}
module_1.default.service('UserChangeWatcherSvc', UserChangeWatcherSvc);


/***/ }),

/***/ "HCXh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/user-section_c2e64e32490205bcaa529c7f0e31a5c0.css";

/***/ }),

/***/ "HGeo":
/***/ (function(module, exports) {

var path = 'https://assets.animatron.com/html/search.html';
var html = "<div class=\"solr-checkbox\" ng-if=\"$root.user.staff && SearchPageCtrl\"> <input id=\"solr\" type=\"checkbox\" ng-model=\"Search.solr\" ng-change=\"Search.startSearch()\"> <label for=\"solr\">solr</label> </div> <div class=\"input-container\"> <input class=\"project-search search-query\" placeholder=\"{{::$root.t('search')}}\" type=\"text\" name=\"search_term_string\" required ng-model=\"Search.keyword\" ui-keypress=\"{13:'Search.startSearch()'}\"/> <button ng-click=\"Search.keyword = ''\" ng-show=\"Search.keyword\" class=\"button button-close\"></button> </div> ";
var angular = window.angular;
var injector = angular.element(document).injector();
if (injector) {
injector.get('$templateCache').put(path, html);
} else {
angular.module('templates').run(['$templateCache', function(c) { c.put(path, html) }]);
}
module.exports = path;

/***/ }),

/***/ "HN/J":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/light/creativity.png";

/***/ }),

/***/ "Hgg4":
/***/ (function(module, exports, __webpack_require__) {

var path = 'https://assets.animatron.com/html/project/project.html';
var html = "<div class=\"wrapper-proj\" ng-show=\"projectLoaded\"> <div ng-show=\"projectExist\" class=\"project-wrapper\"> <div id=\"project-player\" class=\"project-border\"> <div class=\"movie-body\" id=\"movie-body\"> <share-social-window></share-social-window> <project-page-canvas></project-page-canvas> </div> <div class=\"movie-body\" ng-if=\"::ProjectPageCtrl.twoPlayers\"> <share-social-window></share-social-window> <project-page-canvas old=\"true\"></project-page-canvas> </div> <static-include src=\"" + __webpack_require__("vhpm") + "\"></static-include> </div> <div class=\"project-summary\"> <static-include src=\"" + __webpack_require__("O3cu") + "\"></static-include> </div> <comments></comments> </div> <static-include class=\"wrapper-not-found not-found-msg\" ng-if=\"!busy && !projectExist\" src=\"" + __webpack_require__("mWZi") + "\"></static-include> </div> ";
var angular = window.angular;
var injector = angular.element(document).injector();
if (injector) {
injector.get('$templateCache').put(path, html);
} else {
angular.module('templates').run(['$templateCache', function(c) { c.put(path, html) }]);
}
module.exports = path;

/***/ }),

/***/ "Hh+C":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/subscription-page_3a85e49950317ccf94d8bd17ac253de0.css";

/***/ }),

/***/ "HmW0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/go-share-button_6031b57b3f20b9eb2040e00eb25f5a2f.css";

/***/ }),

/***/ "HnXD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/banner/business.png";

/***/ }),

/***/ "IFnZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/user-info-form_57fc806bcf3641168bb573fd1f60cc7f.css";

/***/ }),

/***/ "IGC9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var uploadProject = (function () {
    uploadProject.$inject = ["$scope", "$element", "$http", "$state", "HttpSvc"];
    function uploadProject($scope, $element, $http, $state, HttpSvc) {
        this.$scope = $scope;
        this.$element = $element;
        this.$http = $http;
        this.$state = $state;
        this.HttpSvc = HttpSvc;
    }
    uploadProject.prototype.$onInit = function () {
        var _this = this;
        this.$element[0].onchange = function (e) { return _this.$scope.$apply(function () {
            var fd = _this.getFormData();
            _this.upload(fd);
        }); };
    };
    uploadProject.prototype.getFileTag = function () {
        return (this.$element[0].querySelector('input[type="file"]'));
    };
    uploadProject.prototype.getFormData = function () {
        var file = this.getFileTag().files[0];
        var fd = new FormData();
        fd.append('file', file);
        return fd;
    };
    uploadProject.prototype.getProjectUrl = function () {
        return this.HttpSvc('project/list?product=wave')
            .get()
            .then(function (r) { return r.data; })
            .then(function (data) {
            var projectId = data.results[0].id;
            return "https://upload.animatron" + ( true ? '' : '-test') + ".com/assets/" + projectId + "/" + options.user.hash;
        });
    };
    uploadProject.prototype.upload = function (fd) {
        var _this = this;
        this.getProjectUrl()
            .then(function (url) { return _this.$http.post(url, fd, {
            transformRequest: angular.identity,
            transformResponse: angular.identity,
            headers: _.extend({ 'Content-Type': undefined }, options.headers)
        }); })
            .then(function (r) { return r.data; })
            .then(function (rawResponse) {
            var response = JSON.parse(rawResponse.replace('=', ':'));
            var projectId = response.projectId;
            _this.$state.go('project', { projectId: projectId });
        })
            .catch(function (err) {
            console.error(err);
            _.notification.showError('Couldn\'t upload project');
        })
            .finally(function () {
            _this.uploadingProject = false;
            _this.getFileTag().value = null;
        });
    };
    return uploadProject;
}());
module_1.default.component('uploadProject', {
    controller: uploadProject,
    template: "<button-spinner\n                 style=\"white-space: nowrap;\"\n                 loading=\"$ctrl.uploadingProject\">\n                   {{::$root.t('upload.project')}}\n                   <input type=\"file\" accept=\".anm\"/>\n              </button-spinner>"
});


/***/ }),

/***/ "IU0M":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/banner_bc5f360f3129765b964e7a2da5f0fe34.html";

/***/ }),

/***/ "IXUN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
module_1.default.directive('pauseHiddenPlayer', ["$compile", "$rootScope", "PlayerSvc", function ($compile, $rootScope, PlayerSvc) {
    return {
        restrict: 'A',
        scope: false,
        link: function (scope, element, attrs) {
            element.attr('is-on-screen', '');
            element.removeAttr('pause-hidden-player');
            $compile(element)(scope);
            var safePause = function (player) {
                if (player.isPlaying()) {
                    player.pause();
                }
            };
            var safePlay = function (player) {
                if (!player.isPlaying()) {
                    player.play(Math.max(0, player.getTime()));
                }
            };
            var findPlayer = function (callback) {
                var player = PlayerSvc.getPlayer(element[0].id);
                return player && callback(player);
            };
            scope.$watch(attrs['pauseHiddenPlayer'], function (should) {
                findPlayer(should ? safePlay : safePause);
            });
            $rootScope.$on('notOnScreen:' + attrs.id, function () { return findPlayer(safePause); });
            $rootScope.$on('onScreen:' + attrs.id, function () { return findPlayer(safePlay); });
            if (scope.$ctrl && scope.$ctrl.player) {
                scope.$ctrl.player.then(function (p) {
                    if (element[0].classList.contains('on-screen')) {
                        p && p.play();
                    }
                });
            }
        }
    };
}]);


/***/ }),

/***/ "Ir05":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/different-devices_061d17c1a50768d41228978c2744f738.css";

/***/ }),

/***/ "J0yb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/scroll-button_0568ad443dd70198f4be2a820bf7a82f.css";

/***/ }),

/***/ "J6t3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/subscription-alert_29b6c31568b6904f1c41754c194a407c.css";

/***/ }),

/***/ "JAU9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/section-horizontal-image-text_582b420c6b79e1d5ede15d3fe404d5b0.css";

/***/ }),

/***/ "JDnY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/subscription-invoice-history-table_3b8268700da22057376c196d0ced17bb.css";

/***/ }),

/***/ "JE8O":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/m-search-page_649a9590f13fdc1ff7ec19ea664e6869.css";

/***/ }),

/***/ "JfO/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/banner/social.png";

/***/ }),

/***/ "JiAo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/6.png";

/***/ }),

/***/ "Jqsy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/banner/help-img-7.png";

/***/ }),

/***/ "Jrnx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/media-sponsors-section_c6e1e2285e308f79f771dadc5424855d.css";

/***/ }),

/***/ "K3aT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("jYQ6");
var lazy_modules_1 = __webpack_require__("bUzP");
var TagsSvc = (function () {
    TagsSvc.$inject = ["$ocLazyLoad", "$q", "HttpSvc"];
    function TagsSvc($ocLazyLoad, $q, HttpSvc) {
        var _this = this;
        this.$ocLazyLoad = $ocLazyLoad;
        this.$q = $q;
        this.HttpSvc = HttpSvc;
        this.tagsCache = [];
        this.restTags = this.HttpSvc('tags');
        this.loadTags = function (query) { return _this.$q(function (resolve) {
            if (_this.tagsCache.length === 0) {
                _this.restTags.get({ params: { all: _this.canCreateSuper() } }).then(function (response) {
                    _this.tagsCache = _this.mapTagsCache(response.data);
                    resolve(_this.fuzzySearch(query));
                });
            }
            else {
                resolve(_this.fuzzySearch(query));
            }
        }); };
        this.saveTag = function (tag, projectId) { return _this.restTags.securePost({ projectId: projectId, tag: tag })
            .then(function () { return _this.tagsCache.push(tag); }); };
        this.tagAdded = function (tag, projectId) { return _this.saveTag(tag, projectId); };
        this.tagRemoved = function (tag, projectId) { return _this.restTags.chain('delete').securePost({ projectId: projectId, tag: tag }); };
        this.fuzzySearch = function (query) {
            return _.filter(_this.tagsCache, function (tag) {
                var j = 0;
                for (var i = 0; i < query.length; i++) {
                    var l = query[i];
                    if (l === ' ')
                        continue;
                    j = tag.name.indexOf(l, j);
                    if (j === -1)
                        return false;
                }
                return true;
            });
        };
        this.mapTagsCache = function (data) {
            if (_this.canCreateSuper()) {
                data = data.map(function (tag) {
                    if (tag.type === 'SUPER') {
                        tag.name = '!' + tag.name;
                    }
                    return tag;
                });
            }
            return data;
        };
        this.canCreateSuper = function () {
            var Admin = options.user.subscriptionDetails.studio.features.Admin;
            return Admin && Admin.canCreateSuperTags || null;
        };
        lazy_modules_1.tagsInput().then(function (m) { return $ocLazyLoad.load(m); }).then(function () { return _this.tagsLibLoaded = true; });
    }
    return TagsSvc;
}());
exports.TagsSvc = TagsSvc;
module_1.default.service('TagsSvc', TagsSvc);


/***/ }),

/***/ "KApX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/video-slider_f5ccdf0824648f1a5d99ec9741734968.css";

/***/ }),

/***/ "KBdS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
module_1.default.directive('isOnScreen', ["ViewPortSvc", function (ViewPortSvc) {
    return function (scope, element, attrs) {
        // observer.staticWindowHeight = attrs.isOnScreen;
        var centred = parseInt(attrs.isOnScreen, 10);
        ViewPortSvc.subscribe(element[0], centred);
        setTimeout(function () { return ViewPortSvc.checker(); }, 0);
        scope.unsubscribe = function (el) { return ViewPortSvc.unsubscribe(el); };
        scope.$on('$destroy', function () { return scope.unsubscribe(element[0]); });
    };
}]);


/***/ }),

/***/ "KLH/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/wave-tutorial-workshops_f7eb724260d6af155659e5d5d4a031df.css";

/***/ }),

/***/ "KLLA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/banner/help-img-6.png";

/***/ }),

/***/ "KV5y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/light/light-presentation-image.png";

/***/ }),

/***/ "KvyJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/video-gallery_1a93af951e5fe771d8c3a5abf6bef51c.css";

/***/ }),

/***/ "KxLd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/5.png";

/***/ }),

/***/ "L2qt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/title-shadow-block_2e8ab60e7c5d9e7779ce30b31b12c794.css";

/***/ }),

/***/ "LCXO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./blog.png": "akEf",
	"./business.png": "HnXD",
	"./help-img-1.png": "vjsU",
	"./help-img-2.png": "tV+N",
	"./help-img-3.png": "whPB",
	"./help-img-3b.png": "9uog",
	"./help-img-4.png": "ukZe",
	"./help-img-5.png": "wWYA",
	"./help-img-6.png": "KLLA",
	"./help-img-7.png": "Jqsy",
	"./help-img-8.png": "2wXK",
	"./help-img-9.png": "EHgq",
	"./social.png": "JfO/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "LCXO";

/***/ }),

/***/ "LKwz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var userVisitStorageName = 'analytic:visit:user';
var guestVisitStorageName = 'analytic:visit:guest';
exports.clear = function () {
    localStorage.removeItem(guestVisitStorageName);
    localStorage.removeItem(userVisitStorageName);
};
exports.canVisit = function (userId) {
    var storedUserId = localStorage.getItem(userVisitStorageName);
    var storedGuest = localStorage.getItem(guestVisitStorageName);
    if (storedUserId && storedGuest) {
        console.error('Error: Analytic: both guest and user visit were stored');
        return false;
    }
    var isFirstVisit = !storedUserId && !storedGuest;
    var isUserVisit = userId && (!storedUserId || userId !== storedUserId);
    var isGuestVisit = !userId && !storedGuest;
    return isFirstVisit || isUserVisit || isGuestVisit;
};
exports.visit = function (userId) {
    if (userId) {
        localStorage.removeItem(guestVisitStorageName);
        localStorage.setItem(userVisitStorageName, userId);
    }
    else {
        localStorage.removeItem(userVisitStorageName);
        localStorage.setItem(guestVisitStorageName, 'true');
    }
};


/***/ }),

/***/ "LT3T":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/landing-new-bottom_7c60dc7b10ebffa0e92221fbb8f1e200.css";

/***/ }),

/***/ "LT8D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/18.png";

/***/ }),

/***/ "LUYn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/aff-modal_1a161d787a406eb287d41a0749c106d2.css";

/***/ }),

/***/ "LaVb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/1.png";

/***/ }),

/***/ "Ldjh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/user-info_dac81fce0267bcb388942e6a232e1185.html";

/***/ }),

/***/ "LxjB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/section-different-devices_0ec793bed54add9e7e9d6aa5977b35fc.css";

/***/ }),

/***/ "Lxjv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("jYQ6");
var lazy_modules_1 = __webpack_require__("bUzP");
var underscore_extensions_1 = __webpack_require__("R0iF");
var AffiliateSvc = (function () {
    AffiliateSvc.$inject = ["$location", "$q", "LocalStorageSvc", "HttpSvc"];
    function AffiliateSvc($location, $q, LocalStorageSvc, HttpSvc) {
        var _this = this;
        this.$location = $location;
        this.$q = $q;
        this.LocalStorageSvc = LocalStorageSvc;
        this.HttpSvc = HttpSvc;
        this.tapId =  true ? '4142-17375a' : '4717-bb729d';
        this.storageName = 'anm_referrral_program';
        this.getReferralRequest = function () { return _this.HttpSvc("referral/foruser?product=" + underscore_extensions_1.Utils.getProduct()); };
    }
    AffiliateSvc.prototype.isAffiliate = function () {
        var _a = this.$location.search(), tap_a = _a.tap_a, cjevent = _a.cjevent;
        return tap_a || cjevent;
    };
    AffiliateSvc.prototype.isTapAffiliate = function () {
        var tap_a = this.$location.search().tap_a;
        return !!tap_a;
    };
    AffiliateSvc.prototype.init = function () {
        if (!this.isAffiliate())
            return;
        var _a = this.$location.search(), tap_a = _a.tap_a, cjevent = _a.cjevent;
        if (tap_a) {
            this.detectTap();
        }
        else if (cjevent) {
            this.setAffiliateInfo(cjevent, 'anm-ref-cjevent');
        }
    };
    AffiliateSvc.prototype.getAffiliateUser = function () {
        var _this = this;
        var request = this.getReferralRequest();
        return request.secureGet()
            .then(function (r) { return r.data; })
            .then(function (affiliateInfo) {
            return underscore_extensions_1.Utils.isApiError(affiliateInfo) ? _this.$q.reject() : affiliateInfo;
        });
    };
    AffiliateSvc.prototype.getAffiliateHeader = function () {
        var storage = this.LocalStorageSvc.get(this.storageName);
        if (!storage)
            return null;
        var id = storage.id, headerName = storage.headerName;
        return _a = {}, _a[headerName] = id, _a;
        var _a;
    };
    AffiliateSvc.prototype.setAffiliateInfo = function (id, headerName) {
        this.LocalStorageSvc.set(this.storageName, {
            id: id,
            headerName: headerName
        });
    };
    AffiliateSvc.prototype.loadLib = function () {
        var deferred = this.$q.defer();
        loadScripts([lazy_modules_1.tapfiliateLib], function () { return deferred.resolve(); });
        return deferred.promise;
    };
    AffiliateSvc.prototype.detectTap = function () {
        var _this = this;
        this.loadLib().then(function () {
            window.tap.create(_this.tapId);
            window.tap.detectClick(function (_a) {
                var id = _a.id;
                return _this.setAffiliateInfo(id, 'anm-ref-tap');
            });
        });
    };
    return AffiliateSvc;
}());
exports.AffiliateSvc = AffiliateSvc;
module_1.default.service('affiliateSvc', AffiliateSvc);


/***/ }),

/***/ "MJwn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/section-vertical-text-video_f2175cd105430d23ddbe8f25633d91b5.css";

/***/ }),

/***/ "MLEj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/landing-video-preview_c20cf6da122bfb39dfff0967c7c62053.css";

/***/ }),

/***/ "MT/e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

StopPlaySvcFactory.$inject = ["$rootScope", "ViewPortSvc"];
Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("jYQ6");
var StopPlaySvc = (function () {
    function StopPlaySvc($rootScope, ViewPortSvc, element, handlerPlay, scrollCentredOn) {
        this.$rootScope = $rootScope;
        this.ViewPortSvc = ViewPortSvc;
        this.element = element;
        this.handlerPlay = handlerPlay;
        this.scrollCentredOn = scrollCentredOn;
        this.pauseCount = 1;
        this.modalShowOff = angular.noop;
        this.modalCloseOff = angular.noop;
        this.onScreenOff = angular.noop;
        this.notOnScreenOff = angular.noop;
        this.windowOnFocusHandler = angular.noop;
        this.windowOnBlurHandler = angular.noop;
        this.windowControl();
        this.modalControl();
        this.scrollControl(scrollCentredOn);
    }
    StopPlaySvc.prototype.deactivate = function () {
        this.modalShowOff();
        this.modalCloseOff();
        this.onScreenOff();
        this.notOnScreenOff();
        this.ViewPortSvc.unsubscribe(this.element[0]);
        window.removeEventListener('focus', this.windowOnFocusHandler, false);
        window.removeEventListener('blur', this.windowOnBlurHandler, false);
    };
    StopPlaySvc.prototype.windowControl = function () {
        this.windowOnFocusHandler = this.getPlayHandler(true);
        this.windowOnBlurHandler = this.getPlayHandler(false);
        window.addEventListener('focus', this.windowOnFocusHandler, false);
        window.addEventListener('blur', this.windowOnBlurHandler, false);
    };
    StopPlaySvc.prototype.getPlayHandler = function (status) {
        var _this = this;
        return function () {
            _this.pauseCount = status ? Math.max(0, --_this.pauseCount) : ++_this.pauseCount;
            _this.handlerPlay(_this.pauseCount === 0);
        };
    };
    StopPlaySvc.prototype.modalControl = function () {
        this.modalShowOff = this.$rootScope.$on('modal:show', this.getPlayHandler(false));
        this.modalCloseOff = this.$rootScope.$on('modal:close', this.getPlayHandler(true));
    };
    StopPlaySvc.prototype.scrollControl = function (centredOn) {
        var _this = this;
        var id = "on-scroll-" + Date.now();
        this.element[0].id = id;
        this.onScreenOff = this.$rootScope.$on("onScreen:" + id, this.getPlayHandler(true));
        this.notOnScreenOff = this.$rootScope.$on("notOnScreen:" + id, this.getPlayHandler(false));
        this.ViewPortSvc.subscribe(this.element[0], centredOn);
        setTimeout(function () { return _this.ViewPortSvc.checker(); }, 0);
    };
    return StopPlaySvc;
}());
exports.StopPlaySvc = StopPlaySvc;
function StopPlaySvcFactory($rootScope, ViewPortSvc) {
    return function (element, handlerPlay, scrollCentredOn) { return new StopPlaySvc($rootScope, ViewPortSvc, element, handlerPlay, scrollCentredOn); };
}
module_1.default.service('stopPlaySvcFactory', StopPlaySvcFactory);


/***/ }),

/***/ "MfCV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var commonCompanyPages = ['company', 'privacy', 'terms-of-service', '404'];
exports.default = function () { return commonCompanyPages.some(function (url) { return new RegExp("^/" + url).test(location.pathname); }); };


/***/ }),

/***/ "Mzq4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("vcaf");
__webpack_require__("Us82");
__webpack_require__("eDeh");
__webpack_require__("lvE2");
__webpack_require__("Pv2I");
var SpinnerSvc_1 = __webpack_require__("pPBV");
var underscore_extensions_1 = __webpack_require__("R0iF");
var Strings_1 = __webpack_require__("fxc3");
var intercom_1 = __webpack_require__("P28g");
var analyticSupport_1 = __webpack_require__("c5t7");
loadScripts([underscore_extensions_1.Utils.getWebsiteUrl().replace('/studio', '') + "auth/token-sharing-plugin@1.3.4.js"]);
var initIntercom = function () {
    var intercomIds = {
        wave: {
            prod: '93c0bf3bdc0786f3e0f9eae1ce240e8bc01833da',
            test: 'nmrm9rdp'
        },
        studio: {
            prod: 'lmalds3q',
            test: 'n95k1p6d'
        }
    };
    intercom_1.default.init(underscore_extensions_1.Utils.getAnalyticId(intercomIds));
};
angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 250);
angular.module('animatronApp', [
    'oc.lazyLoad',
    'templates',
    'animatronApp.services',
    'animatronApp.directives',
    'cfp.loadingBar',
    'animatronApp.routes',
    'ipCookie',
    'infinite-scroll'
]
    .concat(window.Raven ? ['ngRaven'] : []))
    .config(["$anchorScrollProvider", "$qProvider", "$compileProvider", "$logProvider", "$sceDelegateProvider", "$ocLazyLoadProvider", "$httpProvider", function ($anchorScrollProvider, $qProvider, $compileProvider, $logProvider, $sceDelegateProvider, $ocLazyLoadProvider, $httpProvider) {
    $ocLazyLoadProvider.config({
        // jsLoader() { console.error('use webpack for scripts, pls', arguments);},
        jsLoader: loadScripts,
        loadedModules: ['animatronApp'],
        debug: !options.debug,
        events: options.debug
    });
    $qProvider.errorOnUnhandledRejections(options.debug);
    $logProvider.debugEnabled(options.debug);
    $compileProvider
        .debugInfoEnabled(options.debug)
        .preAssignBindingsEnabled(true)
        .commentDirectivesEnabled(false)
        .cssClassDirectivesEnabled(false);
    $anchorScrollProvider.disableAutoScrolling();
    $sceDelegateProvider.resourceUrlWhitelist([
        'self',
        'http://*.animatron.com/**', 'https://*.animatron.com/**',
        'http://*.animatron-test.com/**', 'https://*.animatron-test.com/**',
        'http://d110oqv827o66u.cloudfront.net/**', 'https://d110oqv827o66u.cloudfront.net/**',
        'http://d1nvrnigxcwebn.cloudfront.net/**', 'https://d1nvrnigxcwebn.cloudfront.net/**'
    ]);
    $httpProvider.useApplyAsync(true);
    $httpProvider.interceptors.push(["$q", "$injector", function ($q, $injector) {
        var retries = 0;
        var waitBetweenErrors = 1000;
        var maxRetries = 10;
        function onResponseError(httpConfig) {
            var $http = $injector.get('$http');
            var $timeout = $injector.get('$timeout');
            console.log('Error loading html, retrying', httpConfig.url);
            return $timeout(function () { return $http(httpConfig); }, waitBetweenErrors);
        }
        return {
            responseError: function (response) {
                if (response.config && ((/\.html$/.test(response.config.url) || /assets\/html/.test(response.config.url)))) {
                    if (retries < maxRetries) {
                        retries++;
                        return onResponseError(response.config);
                    }
                }
                retries = 0;
                return $q.reject(response);
            }
        };
    }]);
}])
    .run(["$rootScope", "$state", "$location", "UserChangeWatcherSvc", "$urlRouter", "ProjectModalSvc", "AuthenticationSvc", "analyticSvc", "affiliateSvc", "ipCookie", "cfpLoadingBar", "EventSvc", "TranslateSvc", function ($rootScope, $state, $location, UserChangeWatcherSvc, $urlRouter, ProjectModalSvc, AuthenticationSvc, analyticSvc, affiliateSvc, ipCookie, cfpLoadingBar, EventSvc, TranslateSvc) {
    initIntercom();
    analyticSupport_1.default();
    SpinnerSvc_1.default.set(cfpLoadingBar);
    EventSvc.init();
    $rootScope.redirectToReact = underscore_extensions_1.Utils.redirectToReact;
    $rootScope.TranslateSvc = TranslateSvc;
    $rootScope.t = TranslateSvc.get.bind(TranslateSvc);
    $rootScope.stateChangeSuccess = false;
    if ($location.search().apiProd) {
        options.apiDomain = '//api.animatron.com';
    }
    else if ($location.search().apiTest) {
        options.apiDomain = '//api.animatron-test.com';
    }
    else if (options.isWave) {
        options.apiDomain = "//api.wave" + ( true ? '' : '-test') + ".video";
    }
    //set options passed from Play Framework (in index.scala.html)
    $rootScope.options = options;
    $rootScope.user = options.user;
    $rootScope.authSvc = AuthenticationSvc;
    $rootScope.projectModalSvc = ProjectModalSvc;
    $rootScope.pendingUserEmail = function () { return ipCookie('_animatron_activate_pending'); };
    // init affiliates programs
    var affiliateRouteEventOff = $rootScope.$on('$stateChangeSuccess', function (ev, s) {
        affiliateSvc.init();
        affiliateRouteEventOff();
    });
    //don't resolve route(show anything) until user is loaded
    var load = $rootScope.$on('$locationChangeStart', function (e) {
        e.preventDefault();
        UserChangeWatcherSvc.init(function () {
            $urlRouter.sync();
            TranslateSvc.fetchTranslations();
            $rootScope.$on('$stateChangeStart', function () {
                SpinnerSvc_1.default.show();
                _.each(document.head.querySelectorAll('[rel=next], [rel=prev]'), function (el) {
                    return el.parentElement.removeChild(el);
                });
            });
            var prerenederStatus = document.head.querySelector('[name=prerender-status-code]');
            var robots = document.head.querySelector('[name=robots]');
            $rootScope.$on('$stateChangeSuccess', function (ev, s) {
                $rootScope.animatronProduct = underscore_extensions_1.Utils.getProduct();
                $rootScope.isWave = $rootScope.animatronProduct === 'WAVE';
                $rootScope.isStudio = $rootScope.animatronProduct === 'STUDIO';
                analyticSvc.changePage();
                if (!$rootScope.stateChangeSuccess) {
                    $rootScope.stateChangeSuccess = true;
                } // fix blink effect in Safari
                var faviconEl = document.querySelector('[rel="icon"]');
                faviconEl.href = $rootScope.isStudio ?
                    __webpack_require__("rU96") :
                    __webpack_require__("6JEJ");
                if (!_.find([/project-analytics/, /^project$/, /^explore/], function (r) { return r.test(s.name); })) {
                    SpinnerSvc_1.default.hide();
                }
                setTimeout(function () { return window.scroll(0, 0); });
                prerenederStatus.content = s.httpStatus ? s.httpStatus : '200';
                if (true) {
                    robots.content = s.noindex ? 'noindex' : 'all';
                }
                var urlTags = document.head.querySelectorAll('[name="twitter:url"], [property="og:url"], [rel="canonical"]');
                _.each(urlTags, function (el) {
                    return el[el.content ? 'content' : 'href'] = window.location.href.split('%3F')[0].split('?')[0];
                });
                if (typeof ga !== 'undefined') {
                    ga('send', 'pageview', $location.path());
                }
            });
            if (load)
                load();
        });
    });
    $rootScope.retina = options.retina;
    $rootScope.handHeld = options.handHeld;
    $rootScope.setTitle = function (key) {
        var param = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            param[_i - 1] = arguments[_i];
        }
        var productL = underscore_extensions_1.Utils.getProduct().toLowerCase();
        var productC = Strings_1.Strings.capitalize(productL);
        var defaultTitleKey = "default." + productL + ".title";
        var product = productC === 'Any' ? 'Animatron' : productC;
        return TranslateSvc.async(defaultTitleKey).then(function (defaultTitle) {
            var title = key && TranslateSvc.get.apply(TranslateSvc, [key].concat(param));
            if (typeof title === 'string' && title.length > 0) {
                var suffix_1 = TranslateSvc.get(productL + ".title.suffix");
                _.each(document.head.querySelectorAll('[name="twitter:title"], [property="og:title"]'), function (el) {
                    return el.content = title + " | " + suffix_1;
                });
                return $rootScope.title = title + " | " + suffix_1;
            }
            else {
                return $rootScope.title = defaultTitle;
            }
        }).catch(function (a) { return console.error("Missing key for title '" + key + "'"); });
    };
}]);


/***/ }),

/***/ "N3N4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/_lang_7d81ce518454a574f5e28b1b0b605892.css";

/***/ }),

/***/ "NFSG":
/***/ (function(module, exports) {

/*
 * Copyright 2013 Ivan Pusic
 * Contributors:
 *   Matjaz Lipus
 */
angular.module('ivpusic.cookie', ['ipCookie']);
angular.module('ipCookie', ['ng']).
factory('ipCookie', ['$document',
  function ($document) {
    'use strict';

    return (function () {
      function cookieFun(key, value, options) {

        var cookies,
          list,
          i,
          cookie,
          pos,
          name,
          hasCookies,
          all,
          expiresFor;

        options = options || {};

        if (value !== undefined) {
          // we are setting value
          value = typeof value === 'object' ? JSON.stringify(value) : String(value);

          if (typeof options.expires === 'number') {
            expiresFor = options.expires;
            options.expires = new Date();
            // Trying to delete a cookie; set a date far in the past
            if (expiresFor === -1) {
              options.expires = new Date('Thu, 01 Jan 1970 00:00:00 GMT');
              // A new 
            } else if (options.expirationUnit !== undefined) {
              if (options.expirationUnit === 'hours') {
                options.expires.setHours(options.expires.getHours() + expiresFor);
              } else if (options.expirationUnit === 'minutes') {
                options.expires.setMinutes(options.expires.getMinutes() + expiresFor);
              } else if (options.expirationUnit === 'seconds') {
                options.expires.setSeconds(options.expires.getSeconds() + expiresFor);
              } else {
                options.expires.setDate(options.expires.getDate() + expiresFor);
              }
            } else {
              options.expires.setDate(options.expires.getDate() + expiresFor);
            }
          }
          return ($document[0].cookie = [
            encodeURIComponent(key),
            '=',
            encodeURIComponent(value),
            options.expires ? '; expires=' + options.expires.toUTCString() : '',
            options.path ? '; path=' + options.path : '',
            options.domain ? '; domain=' + options.domain : '',
            options.secure ? '; secure' : ''
          ].join(''));
        }

        list = [];
        all = $document[0].cookie;
        if (all) {
          list = all.split('; ');
        }

        cookies = {};
        hasCookies = false;

        for (i = 0; i < list.length; ++i) {
          if (list[i]) {
            cookie = list[i];
            pos = cookie.indexOf('=');
            name = cookie.substring(0, pos);
            value = decodeURIComponent(cookie.substring(pos + 1));

            if (key === undefined || key === name) {
              try {
                cookies[name] = JSON.parse(value);
              } catch (e) {
                cookies[name] = value;
              }
              if (key === name) {
                return cookies[name];
              }
              hasCookies = true;
            }
          }
        }
        if (hasCookies && key === undefined) {
          return cookies;
        }
      }
      cookieFun.remove = function (key, options) {
        var hasCookie = cookieFun(key) !== undefined;

        if (hasCookie) {
          if (!options) {
            options = {};
          }
          options.expires = -1;
          cookieFun(key, '', options);
        }
        return hasCookie;
      };
      return cookieFun;
    }());
  }
]);


/***/ }),

/***/ "NGqW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/settings_776856bef84359c59e1697076ca1c0df.css";

/***/ }),

/***/ "NItV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/_mixins_198f98775fe601edc62e08bb581e1a77.css";

/***/ }),

/***/ "NNCM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/21.svg";

/***/ }),

/***/ "NTYq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/wistia-player_1645d0315205cb2cee7921827ed0e9a3.css";

/***/ }),

/***/ "NZ2j":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/section-video-gallery_61f642d71733235ea5e45dc5dee68ccb.css";

/***/ }),

/***/ "NaY7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
//require some deps that included from index.scala.html
__webpack_require__("3ksy");
__webpack_require__("0nYI");
//add html to templace cache
angular.module('templates', []);
__webpack_require__("23em");
__webpack_require__("GOYa");
__webpack_require__("HGeo");
__webpack_require__("Rium");
__webpack_require__("nAeZ");
__webpack_require__("6XG8");
__webpack_require__("v/Ys");
__webpack_require__("b6Iv");
__webpack_require__("c5FE");
__webpack_require__("0MDI");
__webpack_require__("qffX");
__webpack_require__("cq6s");
// require('landing/landing-top-footer.html');
__webpack_require__("Hgg4");
__webpack_require__("rU96");
function getMainView() {
    return document.querySelector('.main[ui-view]');
}
function showErrorPage() {
    var oReq = new XMLHttpRequest();
    oReq.onload = function () {
        document.querySelector('.wrapper').classList.add('wrapper-not-found');
        getMainView().innerHTML = this.responseText;
    };
    oReq.open('get', __webpack_require__("mWZi"), true);
    oReq.send();
}
window.onerror = function (msg, url, lineNumber, column, err) {
    if (msg.indexOf('c.apply is not a function') > -1) {
        console.error('Unable to load file, check paths');
    }
    if (options && !true && options.debugger) {
        debugger;
    }
    console.log(arguments);
    console.error(err || msg);
    if (!getMainView().innerHTML) {
        showErrorPage();
    }
    return true;
};
if (window.Raven && window.console) {
    Raven.setTagsContext({ build: options.buildNumber });
    var originalError_1 = console.error;
    var originalConsole_1 = console;
    window.console.error = function (err) {
        var args = [].slice.call(arguments);
        var msg = '' + args.join(' ');
        var data = { level: 'error', logger: 'console', extra: { 'arguments': args } };
        if (err instanceof Error) {
            Raven.captureException(err, data);
        }
        else {
            Raven.captureMessage(msg, data);
        }
        if (_.notification && options && !true) {
            _.notification.showError('Exception: ' + msg.substring(0, 200));
        }
        Function.prototype.bind
            .call(originalError_1, originalConsole_1)
            .apply(originalConsole_1, args);
    };
}
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        if (position === void 0) { position = 0; }
        return this.indexOf(searchString, position) === position;
    };
}
if (!Array.prototype.includes) {
    Array.prototype.includes = function (el) {
        return this.indexOf(el) !== -1;
    };
}
if (!String.prototype.includes) {
    String.prototype.includes = function (el) {
        return this.indexOf(el) !== -1;
    };
}
if (typeof Object.assign !== 'function')
    Object.assign = _.extend;
Object.defineProperty && Object.defineProperty(window, '_', {
    value: _,
    writable: false
});
try {
    var n = navigator.storage;
    n && n.persist && n.persist().catch(function (e) { return _.noop; });
}
catch (e) { }
var createScriptEl = function (src) {
    var node = document.getElementsByTagName('head')[0] || document.body;
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = src;
    node.appendChild(script);
    return script;
};
var cachePromise = {};
var requirejs = function (modules, callback, err) {
    return Promise.all(modules.filter(function (m) { return m; }).map(function (m) {
        var getPromise = function () { return new Promise(function (resolve, reject) {
            var script = createScriptEl(m);
            script.onload = script.onreadystatechange = function () { return resolve(); };
            script.onerror = reject;
        }); };
        if (!cachePromise[m]) {
            cachePromise[m] = getPromise();
        }
        return cachePromise[m];
    })).then(callback).catch(err);
};
window.loadScripts = function (modules, callback, silentFail) {
    if (silentFail === void 0) { silentFail = false; }
    var load = function (retries) { return requirejs(modules, callback, function (err) {
        if (silentFail)
            return;
        var failedId = err.requireModules && err.requireModules[0];
        // requirejs.undef(failedId);
        var query = "script[data-requiremodule=\"" + failedId + "\"]";
        var script = document.querySelector(query);
        if (script)
            script.parentNode.removeChild(script);
        if (retries >= 5) {
            console.error(err);
            callback(err);
        }
        else {
            console.log('Error loading, retrying', failedId);
            setTimeout(function () { return load(retries + 1); }, 500 * (retries + 1));
        }
    }); };
    load(0);
};
__webpack_require__("NFSG");
__webpack_require__("AbyD");
__webpack_require__("3qhd");
__webpack_require__("Mzq4");


/***/ }),

/***/ "Nlhm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/video-folder-masonry_012dc42dd0794b95b38e01f152218c4a.css";

/***/ }),

/***/ "NnQa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/10.png";

/***/ }),

/***/ "Nzyx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/10.svg";

/***/ }),

/***/ "O3cu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/project-summary_441f595237bb1a3c850834bc1605c003.html";

/***/ }),

/***/ "OAh3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/video-folder-tree-item_c3082cffb39afd618b88d6fdd01221c9.css";

/***/ }),

/***/ "OSKg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var underscore_extensions_1 = __webpack_require__("R0iF");
var SmoothScroll = (function () {
    function SmoothScroll(toElement, offset, duration) {
        if (offset === void 0) { offset = 0; }
        if (duration === void 0) { duration = 500; }
        this.toElement = toElement;
        this.offset = offset;
        this.duration = duration;
    }
    SmoothScroll.prototype.scroll = function () {
        var _this = this;
        var startTime;
        var scrollTopDocument = (window.scrollY || window.pageYOffset);
        var elementOffset = this.getOffsetTop();
        var deltaY = elementOffset - scrollTopDocument;
        var scrollEasing = function (x) {
            return x < 0.5 ? Math.pow(x * 2, 2) / 2 : 1 - Math.pow((1 - x) * 2, 2) / 2;
        };
        var animateFrame = function (timestamp) {
            if (!startTime)
                startTime = timestamp;
            var progress = timestamp - startTime;
            var percent = progress >= _this.duration ? 1 : scrollEasing(progress / _this.duration);
            window.scrollTo(0, scrollTopDocument + (percent * deltaY));
            if (percent < 1)
                underscore_extensions_1.Utils.rAF(animateFrame);
        };
        underscore_extensions_1.Utils.rAF(animateFrame);
    };
    ;
    SmoothScroll.prototype.getOffsetTop = function () {
        var el = this.toElement;
        var parent = el.offsetParent;
        while (parent !== document.body) {
            el = parent;
            parent = parent.offsetParent;
        }
        return el.offsetTop - this.offset;
    };
    ;
    return SmoothScroll;
}());
exports.SmoothScroll = SmoothScroll;


/***/ }),

/***/ "OdJD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/5.svg";

/***/ }),

/***/ "OjHm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/video-folder-breadcrumb_42fb50260c84c73669d30b00c837724e.css";

/***/ }),

/***/ "Om8q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var MoreTextCtrl = (function () {
    MoreTextCtrl.$inject = ["$filter"];
    function MoreTextCtrl($filter) {
        this.$filter = $filter;
    }
    MoreTextCtrl.prototype.$onChanges = function () {
        if (!this.text)
            return;
        this.filterLinky = this.$filter('linky');
        this.safeText = this.filterBlank(this.text);
        if (this.size >= this.text.length) {
            this.showAll = true;
        }
        else {
            var smallText = this.text.substr(0, this.size).trim() + '...';
            this.smallText = this.filterBlank(smallText);
        }
    };
    MoreTextCtrl.prototype.filterBlank = function (text) {
        return this.filterLinky(text, '_blank');
    };
    MoreTextCtrl.prototype.toggleShow = function () {
        this.showAll = !this.showAll;
    };
    return MoreTextCtrl;
}());
module_1.default.directive('moreText', function () { return ({
    restrict: 'E',
    scope: {},
    controller: MoreTextCtrl,
    controllerAs: 'moreTextCtrl',
    bindToController: {
        size: '@',
        text: '<'
    },
    templateUrl: __webpack_require__("d1XY")
}); });


/***/ }),

/***/ "OmPd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/section-text-aside_e13044f9f9b71ad1dc331941fe80b9b2.css";

/***/ }),

/***/ "Oquy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/week6_6b254876f39cd16354fe0f0e83084ab3.html";

/***/ }),

/***/ "Otff":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/contest_50d6d3cb44f5f0d47b4806531b98dcb7.css";

/***/ }),

/***/ "OzWi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/16.png";

/***/ }),

/***/ "P28g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var id;
function init(newId) {
    id = newId;
}
function intercom() {
    var a = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        a[_i] = arguments[_i];
    }
    window.Intercom && window.Intercom.apply(window, a);
}
function boot(userData) {
    if (userData === void 0) { userData = {}; }
    if (!id)
        throw new Error('Intercom: no id provided');
    intercom('boot', {
        app_id: id,
        user_data: userData
    });
}
function setUser(user) {
    var username = user.username, email = user.email, userId = user.userId, avatar = user.avatar;
    if (username && email && userId && avatar) {
        boot({
            email: email,
            avatar: avatar,
            user_id: userId,
            name: username
        });
    }
}
function setAnonymous() {
    intercom('shutdown');
    boot();
}
function show() {
    intercom('show');
}
function hide() {
    intercom('hide');
}
function unreadCountChange(cb) {
    intercom('onUnreadCountChange', cb);
}
exports.default = {
    init: init,
    boot: boot,
    setUser: setUser,
    setAnonymous: setAnonymous,
    show: show,
    hide: hide,
    unreadCountChange: unreadCountChange
};


/***/ }),

/***/ "P9JW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var module_1 = __webpack_require__("jYQ6");
var Strings_1 = __webpack_require__("fxc3");
var AnimatronSvc_1 = __webpack_require__("6w4i");
exports.PROJECT_ADD = 'anm:project:add';
var AnimatronProjects = (function (_super) {
    tslib_1.__extends(AnimatronProjects, _super);
    function AnimatronProjects() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.computedWidth = AnimatronProjects.computedWidth;
        _this.uniqueId = 'id';
        _this.query = Object.assign({
            sortOrder: 'desc',
            sortBy: 'modification_time',
            withTags: true,
            withCollaborators: true,
            withBackendUrl: true,
            withDuplicatesCount: true,
            withComments: true,
            withLikes: true
        }, _this.query);
        return _this;
    }
    AnimatronProjects.prototype.modifyQuery = function (query) {
        query.previewWidth = options.handHeld ? 720 : 320;
        if (options.retina)
            query.previewWidth *= 2;
        _super.prototype.modifyQuery.call(this, query);
    };
    AnimatronProjects.prototype.makeHttpSvc = function (secure, api) {
        if (api === void 0) { api = ''; }
        var svc = this.HttpSvc('project/list');
        if (!Strings_1.Strings.isBlank(api)) {
            svc.setApiUrl(api);
        }
        this.foreignAccess = !api && options.user.features.ForeignProjectPermissions && options.user.features.ForeignProjectPermissions.list;
        return svc[secure || this.foreignAccess ? 'secureGet' : 'get'];
    };
    AnimatronProjects.prototype.onCreate = function () {
        var _this = this;
        this.$rootScope.$on('project:remove', function (e, pid) { return _this.removeProject(pid); });
        this.$rootScope.$on(exports.PROJECT_ADD, function (e, _a) {
            var project = _a.project;
            return _this.addProject(project);
        });
    };
    AnimatronProjects.prototype.addProject = function (project) {
        if (this.results.some(function (p) { return p.id === project.id; }))
            return;
        this.pages[1] && this.pages[1].push(project);
        this.reorderPages();
        this.results.push(project);
        this.count++;
        this.decorate(this.results);
    };
    AnimatronProjects.prototype.removeProject = function (pid) {
        var currentCount = this.results.length;
        this.pages = this.pages.map(function (page) { return page.filter(function (p) { return p.id !== pid; }); });
        this.results = this.results.filter(function (p) { return p.id !== pid; });
        this.count = this.count - (currentCount - this.results.length);
    };
    AnimatronProjects.prototype.decorate = function (results) {
        var _this = this;
        results.forEach(function (project) {
            project.computedHeight = _this.AnimatronPreviews.computeHeight(project.height, project.width, _this.computedWidth);
            _this.ProjectAugmenter(project);
        });
    };
    return AnimatronProjects;
}(AnimatronSvc_1.AnimatronSvc));
AnimatronProjects.computedWidth = 290;
exports.AnimatronProjects = AnimatronProjects;
module_1.default.factory('AnimatronProjects', ["$rootScope", "$log", "$timeout", "$q", "$stateParams", "HttpSvc", "AnimatronPreviews", "ProjectAugmenter", function ($rootScope, $log, $timeout, $q, $stateParams, HttpSvc, AnimatronPreviews, ProjectAugmenter) {
    _.extend(AnimatronProjects.prototype, {
        $rootScope: $rootScope, $log: $log, $timeout: $timeout, $q: $q, $stateParams: $stateParams, HttpSvc: HttpSvc, AnimatronPreviews: AnimatronPreviews, ProjectAugmenter: ProjectAugmenter
    });
    return AnimatronProjects;
}]);


/***/ }),

/***/ "PAlv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/7.svg";

/***/ }),

/***/ "PXh8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var ComparisonCtrl = (function () {
    ComparisonCtrl.$inject = ["$rootScope", "$state", "$stateParams"];
    function ComparisonCtrl($rootScope, $state, $stateParams) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.products = ['GoAnimate', 'PowToon', 'Google Web Designer'];
        this.tabs = this.products.map(function (p) { return p.toLowerCase(); });
        this.stateTab = this.$stateParams.product.replace('-vs-animatron', '');
        this.defaultTab = _.find(this.tabs, function (p) { return p.replace(/\s+/g, '') === _this.stateTab; }) || this.tabs[0];
    }
    ComparisonCtrl.prototype.change = function (tb) {
        var tab = tb.replace(/\s+/g, '');
        var product = tab + "-vs-animatron";
        this.$state.transitionTo("studio-" + tab + "-landing-comparison", { product: tab }, { notify: false });
        this.$rootScope.setTitle(product + '.title');
    };
    return ComparisonCtrl;
}());
module_1.default.component('landingComparisonPage', {
    controller: ComparisonCtrl,
    controllerAs: 'ComparisonCtrl',
    templateUrl: __webpack_require__("Zx9N")
});


/***/ }),

/***/ "PZhr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/activate_08d23fecc14fe9acd6d4813e99c0efef.css";

/***/ }),

/***/ "PpkO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/contest-days_723bf84050ac6c57535dc0c3170fc418.css";

/***/ }),

/***/ "Pv2I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var Strings_1 = __webpack_require__("fxc3");
var AdSvc_1 = __webpack_require__("X7JN");
var underscore_extensions_1 = __webpack_require__("R0iF");
var LightLandingPages_1 = __webpack_require__("RDpK");
var MediumLandingPages_1 = __webpack_require__("28+3");
var TemplateLandingPages_1 = __webpack_require__("9/76");
var lazy_modules_1 = __webpack_require__("bUzP"); //TODO use `import * as modules from 'lazy_modules'`;
var RouteUtils_1 = __webpack_require__("+sRS");
//TODO remove duplicate check anonymous
var replaceOnEnter = function (path) { return ({
    onEnter: function () {
        setTimeout(function () { return location.replace("" + path + location.search); }, 0);
    }
}); };
var withRedirectToReact = function (url) {
    if (url === void 0) { url = ''; }
    return replaceOnEnter("https://wave" + ( true ? '' : '-test') + ".video/" + url);
};
var Routes = (function () {
    Routes.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider", "$urlMatcherFactoryProvider"];
    function Routes($stateProvider, $urlRouterProvider, $locationProvider, $urlMatcherFactoryProvider) {
        $urlMatcherFactoryProvider.caseInsensitive(true);
        $urlRouterProvider.rule(function ($injector, $location) {
            var path = $location.url();
            // check to see if the path has a trailing slash
            if ('/' === path[path.length - 1]) {
                return path.replace(/\/$/, '');
            }
            return false;
        });
        $urlRouterProvider.rule(function ($injector, $location) {
            var path = $location.path();
            var pathsToRedirect = ['pricing', 'tutorial'];
            var isStudioUrl = /^\/studio/gi.test(path);
            var isRedirectPath = pathsToRedirect.some(function (redirectPath) { return new RegExp("^/" + redirectPath).test(path); });
            var host = $location.host();
            var isStudioDomain = /animatron/gi.test(host);
            if (!isStudioUrl && isStudioDomain && isRedirectPath) {
                return "/studio" + path;
            }
        });
        // extendState($stateProvider);
        var subscriptionModalsParams = ':modal?period&plan&redeem&promo&special&coupon';
        var tutorialResolve = _.extend(RouteUtils_1.loadModule(lazy_modules_1.animatronTutorial), RouteUtils_1.setWrapper('wrapper-tutorial wrapper-long-head'));
        var projectsModules = RouteUtils_1.loadModule(lazy_modules_1.animatronProjects);
        var signUpState = tslib_1.__assign({}, withRedirectToReact('signup'));
        var getLandingParams = function () { return ({
            url: '/studio?signup&loginRedirect',
            template: "<landing-page></landing-page>",
            onEnter /*@ngInject*/: ["$stateParams", "analyticSvc", "$rootScope", "AuthenticationSvc", function ($stateParams, analyticSvc, $rootScope, AuthenticationSvc) {
                RouteUtils_1.createTrackVisit(analyticSvc, $rootScope)('Studio Main');
                var loginRedirect = $stateParams.loginRedirect;
                if (loginRedirect) {
                    AuthenticationSvc.toggleLoginModal(decodeURIComponent(loginRedirect));
                }
            }],
            resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.animatronLandingNewBottom), RouteUtils_1.setWrapper('wrapper-landing-common wrapper-landing-new'), RouteUtils_1.setTitle())
        }); };
        var SMMWParams = ['utm_source', 'utm_medium', 'utm_campaign'].join('&');
        var SMMWPages = ['Image', 'Video'];
        $locationProvider.html5Mode(true).hashPrefix('!');
        $urlRouterProvider.otherwise(function ($injector) {
            var pth = location.pathname.toLowerCase();
            if (pth.includes(Routes.ENCODED_QUESTIONMARK)) {
                var regexp = new RegExp(Routes.ENCODED_QUESTIONMARK, 'gi');
                var _a = location.pathname.split(regexp), path = _a[0], query = _a[1];
                location.href = path + '?' + query;
            }
            else {
                location.href = location.origin + "/404";
            }
        });
        $urlRouterProvider.when('', '/');
        $urlRouterProvider.when('/', function () { return location.reload(); });
        $urlRouterProvider.when('/studio/landing', '/studio');
        $urlRouterProvider.when('/wave/landing', '/wave');
        $urlRouterProvider.when('/cmw17', '/wave');
        $urlRouterProvider.when('/wave/?', ["$location", function ($location) {
            var url = $location.url().replace('/?', '?');
            $location.path(url).replace();
        }]);
        (function setupStates() {
            $stateProvider.state('wave-redirect', tslib_1.__assign({ url: "/wave", params: {
                    eventPath: {
                        value: null,
                        raw: true,
                        squash: true
                    }
                } }, withRedirectToReact()));
            $stateProvider.state('calendar', tslib_1.__assign({ url: "/calendar/{eventPath:any}", params: {
                    eventPath: {
                        value: null,
                        raw: true,
                        squash: true
                    }
                } }, withRedirectToReact('calendar')))
                .state('blog', {
                url: '/blog/{path:any}',
                params: {
                    path: {
                        value: null,
                        raw: true,
                        squash: true
                    }
                },
                onEnter: ["$stateParams", function ($stateParams) {
                    var path = $stateParams.path;
                    var article = path ? path + "/" : '';
                    location.replace("https://www.animatron.com/blog/" + article);
                }]
            })
                .state('mari-smith-tutorials', tslib_1.__assign({ url: '/videos-for-social-media-mari-smith', template: '<mari-smith-tutorials />' }, RouteUtils_1.onEnterTrackVisit('Landing', { Name: 'Social Video Workshop by Mari Smith' }), { resolve: _.extend(RouteUtils_1.setTitle('wv.mari.page.title'), RouteUtils_1.loadModule(lazy_modules_1.mariSmithTutorials()), RouteUtils_1.setWrapper('wrapper-landing-WAVE wrapper-landing-WAVE-webinar')) }))
                .state('video-marketing-strategy-salma-jafri', tslib_1.__assign({ url: '/video-marketing-strategy-salma-jafri', template: '<salma-webinars />' }, RouteUtils_1.onEnterTrackVisit('Landing', { Name: 'Video Strategy Workshop with Salma Jafri' }), { resolve: _.extend(RouteUtils_1.setTitle('wv.salma.title'), RouteUtils_1.loadModule(lazy_modules_1.salmaWebinars()), RouteUtils_1.setWrapper('wrapper-landing-WAVE wrapper-landing-WAVE-webinar')) }))
                .state('wave2', {
                url: "/wave-2?" + SMMWParams,
                noindex: true,
                onEnter: ["$location", "$stateParams", function ($location, $stateParams) {
                    var utm_source = $stateParams.utm_source, utm_medium = $stateParams.utm_medium, utm_campaign = $stateParams.utm_campaign;
                    var isSMMW = utm_source === 'SMExaminer'
                        && utm_medium === 'IndustryReport'
                        && utm_campaign === 'SMEad';
                    var SMMWPage = SMMWPages[_.random(1)];
                    if (isSMMW) {
                        var url = "/SMExaminerReport" + SMMWPage;
                        $location.path(url).replace();
                    }
                }],
                template: '<wave-landing></wave-landing>',
                resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.waveMain), RouteUtils_1.setWrapper('wrapper-landing-WAVE'), RouteUtils_1.setTitle('wv.landing.title'))
            })
                .state('user', tslib_1.__assign({ url: '/users/:username', params: {
                    folderId: {
                        value: null
                    }
                }, noindex: true, template: '<wave-user-page></wave-user-page>' }, RouteUtils_1.onEnterTrackVisit('Users'), { resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.waveUserPage), RouteUtils_1.setWrapper('wave-user-page-wrapper wrapper-wave-projects'), RouteUtils_1.setTitle(), RouteUtils_1.redirectResolve(function () { return !options.user.staff; }, '/wave')) }))
                .state('studio-user', tslib_1.__assign({ url: '/studio/users/:username?startFollowing&customize&bgColor&page&removed', params: { user: null }, noindex: true, template: '<user-page></user-page>' }, RouteUtils_1.onEnterTrackVisit('Users'), { resolve: _.extend(RouteUtils_1.loadModule(options.enableContests ? lazy_modules_1.animatronContest : lazy_modules_1.animatronUserPage), RouteUtils_1.setWrapper('userpage-wrapper'), RouteUtils_1.setTitle()) }))
                .state('studio-following', {
                url: '/studio/users/:username/following',
                params: { user: null },
                template: '<followers-page></followers-page>',
                resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.animatronUserPage), RouteUtils_1.setWrapper('follow-wrapper'), RouteUtils_1.setTitle())
            })
                .state('studio-followers', {
                url: '/studio/users/:username/followers',
                params: { user: null },
                template: '<followers-page></followers-page>',
                resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.animatronUserPage), RouteUtils_1.setWrapper('follow-wrapper'), RouteUtils_1.setTitle())
            })
                .state('studio-explore', tslib_1.__assign({ url: '/studio/explore?confirmationSent&login&isNew&page', template: '<explore-page></explore-page>', reloadOnSearch: false }, RouteUtils_1.onEnterTrackVisit('Explore'), { resolve: _.extend(RouteUtils_1.setWrapper('wrapper-explore'), RouteUtils_1.setTitle('explore.title'), projectsModules, {}) }))
                .state('studio-search', tslib_1.__assign({ url: '/studio/search?q&username&solr&myProjects&instant', template: '<search-page></search-page>' }, RouteUtils_1.onEnterTrackVisit('Search'), { resolve: _.extend(RouteUtils_1.setWrapper('wrapper-search'), RouteUtils_1.setTitle(), RouteUtils_1.loadModule(lazy_modules_1.animatronSearchPage)) }))
                .state('tag', {
                url: '/tags/:tag?super&user&page',
                noindex: true,
                controller: ["$scope", "$rootScope", "$stateParams", "AnimatronProjects", function ($scope, $rootScope, $stateParams, AnimatronProjects) {
                    var tag_type = _.findKey(_.omit($stateParams, 'tag'), function (param) { return param === 'true'; });
                    $rootScope.setTitle('tags.title', $stateParams.tag);
                    $scope.AdSvc = new AdSvc_1.AdSvc(false, $rootScope);
                    var adify = $scope.AdSvc.adify.bind($scope.AdSvc);
                    $scope.animatron = new AnimatronProjects({ tag: $stateParams.tag, tag_type: tag_type }, false, '', adify);
                }],
                templateUrl: __webpack_require__("b6Iv"),
                resolve: _.extend(RouteUtils_1.setWrapper(''), RouteUtils_1.setTitle(), projectsModules)
            })
                .state('studio-tutorial', tslib_1.__assign({ url: '/studio/tutorial/:video', reloadOnSearch: false, params: {
                    video: { value: null, squash: true }
                }, template: '<tutorials-page></tutorials-page>' }, RouteUtils_1.onEnterTrackVisit('Tutorial'), { resolve: _.extend(RouteUtils_1.setTitle('tutorial.title'), tutorialResolve) }))
                .state('workshops', tslib_1.__assign({ url: '/workshops', template: '<wave-tutorial-page current-tab="workshops"></wave-tutorial-page>' }, RouteUtils_1.onEnterTrackVisit('Workshops'), { resolve: _.extend(RouteUtils_1.setTitle('tutorial.title'), RouteUtils_1.setWrapper('wrapper-wave-tutorials'), RouteUtils_1.loadModule(lazy_modules_1.waveTutorialPage)) }))
                .state('tutorial', tslib_1.__assign({ url: '/tutorial/:video', reloadOnSearch: false, params: {
                    video: { value: null, squash: true }
                }, template: '<wave-tutorial-page></wave-tutorial-page>' }, RouteUtils_1.onEnterTrackVisit('Tutorial'), { resolve: _.extend(RouteUtils_1.setTitle('tutorial.title'), RouteUtils_1.setWrapper('wrapper-wave-tutorials'), RouteUtils_1.loadModule(lazy_modules_1.waveTutorialPage)) }))
                .state('studio-education', tslib_1.__assign({ url: '/studio/education', template: '<education-page></education-page>' }, RouteUtils_1.onEnterTrackVisit('Education'), { resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.animatronEdu), RouteUtils_1.setWrapper('wrapper-long-head wrapper-edu'), RouteUtils_1.setTitle('edu.title')) }))
                .state('studio-education.week', {
                url: '/:week',
                controller: ["$scope", "$stateParams", "$rootScope", function ($scope, $stateParams, $rootScope) {
                    $scope.week.number = parseInt($stateParams.week.substring(4), 10);
                    $rootScope.setTitle("edu.week" + $scope.week.number + ".title");
                }],
                templateUrl: function ($stateParams) { return __webpack_require__("1S0N")("./" + $stateParams.week + ".html"); }
            })
                .state('about', tslib_1.__assign({ url: '/about', noindex: true }, RouteUtils_1.onEnterTrackVisit('About'), { resolve: _.extend(RouteUtils_1.redirectResolve(function () { return true; }, '/company')) }))
                .state('company', tslib_1.__assign({ url: '/company/{tab}', params: {
                    tab: {
                        value: null,
                        squash: true
                    }
                }, template: '<company />' }, RouteUtils_1.onEnterTrackVisit('Company'), { resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.animatronCompany), RouteUtils_1.setWrapper('wrapper-press'), RouteUtils_1.setTitle('press.title')) }))
                .state('editor-redirect', {
                url: '/editor-redirect',
                template: '<editor-redirect></editor-redirect>',
                resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.animatronEditorRedirect), RouteUtils_1.setWrapper('wrapper-landing-WAVE editor-redirect-page'), RouteUtils_1.setTitle('wv.landing.title'))
            })
                .state('wave_signup', {
                url: '/wave-signup',
                onEnter: ["$location", function ($location) { $location.path('/wave').replace(); }]
            })
                .state('contractors', tslib_1.__assign({ url: '/contractors', template: '<contractors></contractors>' }, RouteUtils_1.onEnterTrackVisit('Contractors'), { resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.animatronContractors), RouteUtils_1.setWrapper('wrapper-contractors'), RouteUtils_1.setTitle('contractors.title')) }))
                .state('root', {
                url: '/?signup&login&redirect_to',
                template: '<main-landing />',
                resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.mainLanding()), RouteUtils_1.setWrapper('wrapper-landing-common wrapper-simple-page'), RouteUtils_1.setTitle(''), {
                    checkRedirect: /*@ngInject*/ ["$location", function ($location) {
                        return RouteUtils_1.redirect(!options.user.anonymous && $location.search().login, function () {
                            return $location.path('/login').replace();
                        });
                    }],
                    showModal: /*@ngInject*/ ["$location", "AuthenticationSvc", "LocalStorageSvc", function ($location, AuthenticationSvc, LocalStorageSvc) {
                        var redirect = $location.search().return_to || $location.search().login;
                        if (redirect) {
                            AuthenticationSvc.loginModalShown = true;
                            LocalStorageSvc.set('_animatron_redirect_onlogin', document.referrer);
                        }
                    }]
                })
            })
                .state('studio', getLandingParams())
                .state('landingWithAnimation', _.extend(getLandingParams(), {
                noindex: true,
                url: '/landing/:animation?signup'
            }))
                .state('studio-landing-banner', {
                url: '/studio/html5-banner-maker',
                templateUrl: __webpack_require__("IU0M"),
                resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.animatronBannerBottom), RouteUtils_1.setWrapper('wrapper-landing-common wrapper-landing-banner'), RouteUtils_1.setTitle('banner.title'))
            })
                .state('studio-special-annual-upgrade', {
                url: '/studio/special-annual-upgrade',
                template: "<special-annual-upgrade></special-annual-upgrade>",
                resolve: _.extend(RouteUtils_1.redirectForLogin(), RouteUtils_1.loadModule(lazy_modules_1.animatronSpecialUpgrade), RouteUtils_1.setWrapper('wrapper-special-annual-upgrade'), RouteUtils_1.setTitle('special.annual.upgrade.title'))
            })
                .state('studio-landing-explainer', {
                url: '/studio/explainer-video-maker',
                templateUrl: __webpack_require__("v09R"),
                resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.animatronExplainerBottom), RouteUtils_1.setWrapper('wrapper-landing-common wrapper-landing-banner wrapper-landing-explainer'), RouteUtils_1.setTitle('explainer.title'))
            })
                .state('studio-landing-political', {
                url: '/studio/political-cartoon-maker',
                controllerAs: '$ctrl',
                controller: ["$rootScope", "$scope", "$sce", function ($rootScope, $scope, $sce) {
                    var baseUrl = "https://videos.animatron.com/political_landing/political_cartoon" + (options.retina ? '_2x' : '');
                    this.videoUrl = $sce.trustAsResourceUrl(baseUrl + ".mp4");
                    this.imgUrl = $sce.trustAsResourceUrl(baseUrl + ".jpg");
                    $rootScope.editorParams = '&guide=political';
                    $scope.$on('$destroy', function () { return $rootScope.editorParams = ''; });
                }],
                templateUrl: __webpack_require__("kvRk"),
                resolve: _.extend(RouteUtils_1.setWrapper('wrapper-landing-common wrapper-landing-light wrapper-landing-political'), RouteUtils_1.setTitle('political.title'))
            })
                .state('privacy', tslib_1.__assign({ url: '/privacy', templateUrl: __webpack_require__("7zPr") }, RouteUtils_1.onEnterTrackVisit('Privacy'), { resolve: _.extend({ scrollTop: [function () { return window.scrollTo(0, 0); }] }, RouteUtils_1.loadModule(lazy_modules_1.animatronPrivacy), RouteUtils_1.setWrapper('wrapper-privacy'), RouteUtils_1.setTitle('privacy.title')) }))
                .state('oauthDoLogin', {
                url: '/oauth/{redirectUrl: any}',
                params: {
                    redirectUrl: {
                        value: null,
                        raw: true,
                        squash: true
                    }
                },
                noindex: true,
                template: '<div style="text-align: center">Authorization...</div>',
                resolve: RouteUtils_1.setTitle(),
                onEnter: ["$stateParams", "LocalStorageSvc", "OAuthCallbackSvc", function ($stateParams, LocalStorageSvc, OAuthCallbackSvc) {
                    var authLocalStoreName = 'auth';
                    var redirectUrl = $stateParams.redirectUrl;
                    var authValue = LocalStorageSvc.get(authLocalStoreName);
                    LocalStorageSvc.remove(authLocalStoreName);
                    if (authValue) {
                        redirectUrl && LocalStorageSvc.set('_animatron_redirect_onlogin', redirectUrl);
                        OAuthCallbackSvc.doLogin(authValue.params, authValue.stateParams);
                    }
                }]
            })
                .state('oauthCallback', {
                url: '/callback/:provider/:product?code',
                noindex: true,
                resolve: RouteUtils_1.setTitle(),
                onEnter: ["$stateParams", "$location", "OAuthCallbackSvc", function ($stateParams, $location, OAuthCallbackSvc) {
                    return OAuthCallbackSvc.onCallback($stateParams, $location.hash());
                }]
            })
                .state('404', tslib_1.__assign({ url: '/404', noindex: true, httpStatus: '404' }, withRedirectToReact('404')))
                .state('logout', {
                noindex: true,
                url: '/logout',
                template: '<div></div>',
                onEnter: ["AuthenticationSvc", function (AuthenticationSvc) {
                    AuthenticationSvc.logoutAndGoRoot();
                }],
                resolve: RouteUtils_1.setWrapper('.wrapper-ANY')
            })
                .state('terms-of-service', tslib_1.__assign({ url: '/terms-of-service', templateUrl: __webpack_require__("lGv7") }, RouteUtils_1.onEnterTrackVisit('Terms of service'), { resolve: _.extend({ scrollTop: [function () { return window.scrollTo(0, 0); }] }, RouteUtils_1.loadModule(lazy_modules_1.animatronTermsServices), RouteUtils_1.setWrapper('wrapper-terms-of-service'), RouteUtils_1.setTitle('terms.title')) }))
                .state('project-analytics', {
                url: '/project/{projectId}/analytics?rangeStart&rangeEnd',
                noindex: true,
                params: { project: null },
                template: '<project-analytics></project-analytics>',
                resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.animatronProjectAnalytics), RouteUtils_1.setWrapper('wrapper-analytics'), RouteUtils_1.setTitle('analytics.title'))
            })
                .state('pages', {
                url: '/pages',
                noindex: true,
                controller: ["$state", function ($state) {
                    return document.querySelector('.main').innerHTML =
                        $state.get().map(function (s) { return "<a href=\"" + $state.href(s.name, {}) + "\">" + s.name + "</a><br>"; }).join('');
                }]
            })
                .state('project-likes', {
                url: '/project/{projectId}/likes',
                noindex: true,
                params: { project: null },
                template: "<a class=\"liker\" style=\"text-align: center;\"\n                              ng-repeat=\"like in $ctrl.project.likes\"\n                              ui-sref=\"studio-user({username: (like.user.username | encodeUsername), user: like.user})\"\n                              ng-repeat=\"like in $ctrl.project.likes\">\n                                   <user-avatar user=\"like.user\" size=\"45\"></user-avatar>\n                                   {{::like.user.displayName}}\n                           </a>",
                controller: ["$stateParams", "HttpSvc", function ($stateParams, HttpSvc) {
                    var _this = this;
                    HttpSvc('project', $stateParams.projectId)[options.user.anonymous ? 'get' : 'secureGet']()
                        .then(function (res) { return _this.project = res.data; });
                }],
                controllerAs: '$ctrl',
                resolve: _.extend(RouteUtils_1.setWrapper(), RouteUtils_1.setTitle())
            })
                .state('contest-page', {
                url: '/contest/:contestId',
                template: "<contest-page></contest-page>",
                resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.animatronContest), RouteUtils_1.setWrapper('contest-wrapper'), RouteUtils_1.setTitle())
            })
                .state('contest-landing', {
                url: '/makewaves',
                template: "<contest-landing></contest-landing>",
                noindex: true,
                resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.animatronContestLanding), RouteUtils_1.setWrapper('contest-landing-wrapper wrapper-hide-header wrapper-footer-small'), RouteUtils_1.setTitle('wv.contest-landing.pagetitle'))
            })
                .state('contest-days', {
                url: '/makewaves/:day?iv',
                template: "<contest-days></contest-days>",
                noindex: true,
                resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.animatronContestDays), RouteUtils_1.setWrapper('contest-landing-wrapper contest-days-wrapper wrapper-hide-header wrapper-footer-small'), RouteUtils_1.setTitle('wv.contest-landing.pagetitle'))
            })
                .state('thanksgiving', {
                url: '/thanksgiving',
                noindex: true,
                resolve: _.extend(RouteUtils_1.redirectResolve(function () { return true; }, '/wave'))
            })
                .state('my-videos', {
                url: '/my-videos',
                noindex: true,
                resolve: _.extend(RouteUtils_1.redirectResolve(function () { return true; }, '/my-projects'))
            })
                .state('sharing', {
                url: '/share/:tag',
                noindex: true,
                controllerAs: '$ctrl',
                controller: ["$stateParams", "AnimatronProjects", function ($stateParams, AnimatronProjects) {
                    this.animatron = new AnimatronProjects({
                        noCount: true,
                        limit: 5000,
                        tag: $stateParams.tag,
                        tag_type: 'SUPER',
                        previewWidth: 320
                    }, false, 'https://api.animatron.com');
                    this.animatron.nextPage();
                }],
                templateUrl: __webpack_require__("8ReI"),
                resolve: _.extend(RouteUtils_1.loadModule([lazy_modules_1.animatronProjects, lazy_modules_1.animatronPublish]), RouteUtils_1.setWrapper(''), RouteUtils_1.setTitle(''), RouteUtils_1.redirectResolve(function () { return !options.user.staff; }, '/landing'))
            })
                .state('wave-pricing', tslib_1.__assign({ url: "/pricing/" + subscriptionModalsParams, params: {
                    modal: {
                        value: null,
                        squash: true
                    }
                }, template: '<wave-pricing></wave-pricing>', controller: ['$scope', function ($scope) {
                        $scope.alwaysShowFaq = true;
                        window.scrollTo(0, 0);
                    }] }, RouteUtils_1.onEnterTrackVisit('Pricing'), { resolve: _.extend(RouteUtils_1.setWrapper('wrapper-pricing wrapper-pricing-WAVE'), RouteUtils_1.loadModule(lazy_modules_1.wavePricing), RouteUtils_1.setTitle('pricing.title')) }))
                .state('studio-pricing', tslib_1.__assign({ url: "/studio/pricing/" + subscriptionModalsParams, params: {
                    modal: {
                        value: null,
                        squash: true
                    }
                }, templateUrl: __webpack_require__("v+R/"), controller: ['$scope', function ($scope) {
                        $scope.alwaysShowFaq = true;
                        window.scrollTo(0, 0);
                    }] }, RouteUtils_1.onEnterTrackVisit('Pricing'), { resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.animatronPricing), RouteUtils_1.setWrapper('wrapper-pricing'), RouteUtils_1.setTitle('pricing.title')) }))
                .state('my-projects', tslib_1.__assign({ url: '/my-projects/{folderPath:any}?t&e', params: {
                    folderPath: {
                        value: null,
                        raw: true,
                        squash: true
                    }
                }, template: '<wave-my-projects current-tab="my-projects"/>' }, RouteUtils_1.onEnterTrackVisit('My Projects'), { resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.waveMyProjects), RouteUtils_1.setWrapper('wrapper-wave-projects'), RouteUtils_1.redirectForLogin(), RouteUtils_1.setTitle('wv.my-projects.title')) }));
            SMMWPages.forEach(function (page) {
                var state = page.toLowerCase();
                $stateProvider.state("wave-landing-smmw-" + state, tslib_1.__assign({ url: "/SMExaminerReport" + page + "?" + SMMWParams, template: "<wave-landing-smmw view=\"'" + page + "'\"></wave-landing-smmw>" }, RouteUtils_1.onEnterTrackVisit('Landing', { Name: "SMExaminerReport" + page }), { resolve: _.extend(RouteUtils_1.setTitle(), RouteUtils_1.loadModule(lazy_modules_1.waveLandingSMMW), RouteUtils_1.setWrapper('wrapper-landing-WAVE-SMMW')) }));
            });
            ['video-templates', 'my-templates'].forEach(function (state) {
                $stateProvider.state(state, tslib_1.__assign({ url: "/" + state + "/{folderPath:any}", params: {
                        folderPath: {
                            value: null,
                            raw: true,
                            squash: true
                        }
                    } }, withRedirectToReact('video-templates')));
            });
            ['affiliate-program', 'affiliate'].forEach(function (state) {
                $stateProvider.state(state, {
                    url: "/" + state + "?" + SMMWParams,
                    onEnter: function () { location.href = 'https://animatron.tapfiliate.com/publisher/signup/wave-affiliate-program'; }
                });
            });
            ['home', 'studio/home'].forEach(function (state) {
                $stateProvider.state(state, {
                    url: "/" + state + "?login&isNew",
                    controller: ["$location", "$filter", function ($location, $filter) {
                        var redirectUrl = options.user.anonymous
                            ? '/studio'
                            : "/studio/users/" + $filter('encodeUsername')(options.user.username);
                        $location.path(redirectUrl);
                    }]
                });
            });
            ['powtoon', 'goanimate', 'googlewebdesigner'].forEach(function (product) {
                var state = "studio-" + product + "-landing-comparison";
                var url = "/studio/" + product + "-vs-animatron";
                $stateProvider.state(state, {
                    url: url,
                    params: { product: product },
                    template: "<landing-comparison-page></landing-comparison-page>",
                    resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.animatronComparisonBottom), RouteUtils_1.setWrapper('wrapper-landing-comparison wrapper-landing-common'), RouteUtils_1.setTitle())
                });
            });
            options.animatronProducts.forEach(function (product) {
                var productLower = product.toLowerCase();
                var _a = product === 'WAVE' ? ['', ''] : [productLower + "/", productLower + "-"], url = _a[0], state = _a[1];
                ['profile', 'subscription', 'password', 'notification'].forEach(function (s) {
                    var isSubscription = s === 'subscription';
                    var subscriptionState = {
                        url: "/subscription/" + subscriptionModalsParams,
                        params: {
                            modal: {
                                value: null,
                                squash: true
                            }
                        },
                        template: '<subscription-page></subscription-page>',
                        onEnter /*@ngInject*/: ["analyticSvc", "$rootScope", function (analyticSvc, $rootScope) {
                            var visitPage = RouteUtils_1.createTrackVisit(analyticSvc, $rootScope);
                            visitPage('Subscription');
                        }],
                        resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.animatronSubscriptionPage()), {
                            cardDetails: /*@ngInject*/ ["$ocLazyLoad", "$injector", "$q", function ($ocLazyLoad, $injector, $q) {
                                return lazy_modules_1.animatronSubscriptionSvc()
                                    .then(function (m) { return $ocLazyLoad.load(m); })
                                    .then(function () {
                                    var subscriptionSvc = $injector.get('subscriptionSvc');
                                    var readyLoadedData = subscriptionSvc.cardDetailsCashed
                                        || subscriptionSvc.cardDetailsErrorMessage;
                                    return readyLoadedData
                                        ? $q.resolve(readyLoadedData)
                                        : subscriptionSvc.getCardDetails()
                                            .catch(function () { return $q.resolve(true); }); // needed for resolve it in any cases
                                });
                            }]
                        })
                    };
                    var defaultState = {
                        url: "/" + s,
                        template: "<" + s + "></" + s + ">",
                        onEnter /*@ngInject*/: ["analyticSvc", "$rootScope", function (analyticSvc, $rootScope) {
                            var visitPage = RouteUtils_1.createTrackVisit(analyticSvc, $rootScope);
                            visitPage(Strings_1.Strings.capitalize(s));
                        }]
                    };
                    $stateProvider.state(state + "settings." + s, _.extend({ noindex: true }, isSubscription ? subscriptionState : defaultState));
                });
                $stateProvider
                    .state(state + "activate-email", {
                    noindex: true,
                    url: "/" + url + "activate-email/:hash",
                    onEnter: ["$rootScope", "$state", "$stateParams", "HttpSvc", "AuthenticationSvc", function ($rootScope, $state, $stateParams, HttpSvc, AuthenticationSvc) {
                        HttpSvc('profile/confirm-email')
                            .securePost($stateParams.hash)
                            .then(function (r) { return r.data; })
                            .then(function (res) {
                            AuthenticationSvc
                                .updateUser()
                                .then(function () { return $state.go(state + "settings.profile"); });
                            if (underscore_extensions_1.Utils.isApiError(res)) {
                                _.notification.showError(res.message);
                            }
                            else {
                                _.notification.showSuccess($rootScope.t('profile.updated'));
                            }
                        });
                    }],
                    resolve: _.extend(RouteUtils_1.redirectForLogin(), RouteUtils_1.setWrapper("wrapper-" + product))
                })
                    .state(state + "oauth-confirm", {
                    noindex: true,
                    url: "/" + url + "signup/oauth/confirm/:hash",
                    onEnter: ["$rootScope", "$state", "$stateParams", "HttpSvc", "AuthenticationSvc", function ($rootScope, $state, $stateParams, HttpSvc, AuthenticationSvc) {
                        HttpSvc('signup/oauth/confirm', $stateParams.hash)
                            .post()
                            .then(function (r) { return r.data; })
                            .then(function (res) {
                            AuthenticationSvc
                                .updateUser()
                                .then(function () { return $state.go(state + "settings.profile"); });
                            if (underscore_extensions_1.Utils.isApiError(res)) {
                                _.notification.showError(res.message);
                            }
                            else {
                                _.notification.showSuccess($rootScope.t('profile.updated'));
                            }
                        });
                    }],
                    resolve: _.extend(RouteUtils_1.redirectForLogin(), RouteUtils_1.setWrapper("wrapper-" + product))
                })
                    .state(state + "login", {
                    url: "/" + url + "login?redirectUrl",
                    params: {
                        redirectUrl: {
                            value: null,
                            raw: true,
                            squash: true
                        }
                    },
                    noindex: true,
                    template: '<login></login>',
                    onEnter: ["$stateParams", "analyticSvc", "$rootScope", "LocalStorageSvc", function ($stateParams, analyticSvc, $rootScope, LocalStorageSvc) {
                        RouteUtils_1.createTrackVisit(analyticSvc, $rootScope)('Login');
                        var redirectUrl = $stateParams.redirectUrl;
                        redirectUrl && LocalStorageSvc.set('_animatron_redirect_onlogin', redirectUrl);
                    }],
                    resolve: _.extend(RouteUtils_1.setWrapper("wrapper-" + product + " wrapper-long-head-login"), RouteUtils_1.setTitle('login.title'), RouteUtils_1.redirectResolve(function () { return !options.user.anonymous; }, (state === 'wave' ? 'wave/my-projects' : 'studio/explore')))
                })
                    .state(state + "recovery", tslib_1.__assign({ url: "/" + url + "recovery?email" }, withRedirectToReact('recovery')))
                    .state(state + "recovery-reset", {
                    url: "/" + url + "recovery/:hash",
                    template: '<recovery-reset-page></recovery-reset-page>',
                    resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.animatronRecoveryReset), RouteUtils_1.setWrapper("wrapper-activate"), RouteUtils_1.setTitle('recovery.reset.title'))
                })
                    .state(state + "settings", {
                    url: "/" + url + "settings",
                    noindex: true,
                    controller: 'SettingsCtrl as settings',
                    templateUrl: __webpack_require__("UTMY"),
                    resolve: _.extend(RouteUtils_1.redirectForLogin(), RouteUtils_1.loadModule(lazy_modules_1.animatronSettings), RouteUtils_1.setWrapper("wrapper-settings"), RouteUtils_1.setTitle())
                })
                    .state(state + "project", tslib_1.__assign({ url: "/" + url + "project/:projectId?staff&stopPlay", params: { project: null, stopPlay: null }, noindex: true, template: '<project-page></project-page>' }, RouteUtils_1.onEnterTrackVisit('Project'), { resolve: _.extend(RouteUtils_1.setWrapper("standalone-project "), RouteUtils_1.setTitle(), RouteUtils_1.loadModule(lazy_modules_1.animatronProject)) }))
                    .state(state + "activate-oauth", {
                    url: "/" + url + "activate-oauth?product",
                    noindex: true,
                    template: '<activate-oauth></activate-oauth>',
                    resolve: _.extend(RouteUtils_1.redirectResolve(function () { return !options.user.social; }), RouteUtils_1.loadModule(lazy_modules_1.animatronActivate), RouteUtils_1.setWrapper("wrapper-activate"), RouteUtils_1.setTitle('activate.title'))
                })
                    .state(state + "signup-with-redirect", tslib_1.__assign({ url: "/" + url + "signup/r/:email/:sendRequest/{redirectUrl: any}?product", params: {
                        email: {
                            value: null,
                            squash: true
                        },
                        sendRequest: {
                            value: null,
                            squash: true
                        },
                        redirectUrl: {
                            value: null,
                            raw: true,
                            squash: true
                        }
                    } }, signUpState))
                    .state(state + "signup", tslib_1.__assign({ url: "/" + url + "signup?email&product&sendRequest&redirectUrl" }, signUpState))
                    .state(state + "activate", {
                    url: "/" + url + "activate/:hash",
                    noindex: true,
                    template: '<activate-email></activate-email>',
                    resolve: _.extend(RouteUtils_1.loadModule(lazy_modules_1.animatronActivate), RouteUtils_1.setWrapper("wrapper-activate"), RouteUtils_1.setTitle('activate.title'))
                });
            });
            ['detailed-views', 'views-count', 'summarized'].forEach(function (state) {
                $stateProvider.state("project-analytics." + state, {
                    url: "/" + Strings_1.Strings.toCamelCase(state) + "?period",
                    noindex: true,
                    template: "<" + state + "analytics-directive></" + state + "-analytics-directive>"
                });
            });
            ['most-plays', 'recently-added', 'staff-picks', 'contest-submissions', 'my-projects'].forEach(function (state) {
                $stateProvider.state("studio-explore." + state, {
                    url: "/" + state + "?page&product",
                    noindex: state === 'my-projects',
                    resolve: _.extend(RouteUtils_1.setWrapper('wrapper-explore'))
                });
            });
            var landingGenerator = function (list, kind) {
                var resolveParams = [];
                for (var _i = 2; _i < arguments.length; _i++) {
                    resolveParams[_i - 2] = arguments[_i];
                }
                list.forEach(function (page) {
                    $stateProvider.state(page.url, {
                        url: '/' + page.url,
                        controller: function () { this.data = Object.assign({}, page); },
                        controllerAs: '$ctrl',
                        template: "<" + kind + "-landing data=\"$ctrl.data\"></" + kind + "-landing>",
                        resolve: _.extend.apply(_, [RouteUtils_1.setTitle(page.title),
                            RouteUtils_1.setWrapper("wrapper-landing-common wrapper-landing-" + kind)].concat(resolveParams))
                    });
                });
            };
            TemplateLandingPages_1.default.forEach(function (landing) {
                $stateProvider.state(landing.url, {
                    url: "/" + landing.url + "?t&d&iv&loginRedirect&" + SMMWParams,
                    onEnter: ["$state", "$window", function ($state, $window) {
                        $window.open("https://www.animatron" + ( true ? '' : '-test') + ".com/" + landing.url + location.search, '_self');
                    }]
                });
            });
            landingGenerator(LightLandingPages_1.default, 'light');
            landingGenerator(MediumLandingPages_1.default, 'medium', RouteUtils_1.loadModule(lazy_modules_1.animatronMediumLanding));
        })();
    }
    return Routes;
}());
Routes.ENCODED_QUESTIONMARK = '%3f';
angular.module('animatronApp.routes', ['ui.router'])
    .config(Routes);


/***/ }),

/***/ "Q9ed":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("jYQ6");
var LandingTemplateSvc = (function () {
    LandingTemplateSvc.$inject = ["$state"];
    function LandingTemplateSvc($state) {
        this.$state = $state;
        this.randomize();
    }
    LandingTemplateSvc.prototype.getTrackInfo = function () {
        return {
            'Landing Page': this.$state.current.name,
            'Test Variant': this.isLink ? 'with-links' : 'without-links'
        };
    };
    LandingTemplateSvc.prototype.randomize = function () {
        var val = _.random(0, 1);
        this.isLink = !!val;
    };
    return LandingTemplateSvc;
}());
exports.LandingTemplateSvc = LandingTemplateSvc;
module_1.default.service('landingTemplateSvc', LandingTemplateSvc);


/***/ }),

/***/ "QAC1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/section-feedback_4484ddc6138f0bbe74050e2749218a32.css";

/***/ }),

/***/ "QHsv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/m-wave-landing-smmw_f8ed42b70731a846a507a30d2ef6dab2.css";

/***/ }),

/***/ "QI9i":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./female/1.png": "LaVb",
	"./female/1.svg": "ClZ7",
	"./female/10.png": "4jE+",
	"./female/10.svg": "rrSb",
	"./female/11.png": "juL4",
	"./female/11.svg": "Zkh2",
	"./female/12.png": "x0FM",
	"./female/12.svg": "4zkA",
	"./female/13.png": "aRaM",
	"./female/13.svg": "Dc98",
	"./female/14.png": "z7A8",
	"./female/14.svg": "yCid",
	"./female/15.png": "sNLF",
	"./female/15.svg": "luA4",
	"./female/16.png": "OzWi",
	"./female/16.svg": "CFmk",
	"./female/17.png": "DuQD",
	"./female/17.svg": "SHV6",
	"./female/18.png": "LT8D",
	"./female/18.svg": "zpKr",
	"./female/19.png": "0eTi",
	"./female/19.svg": "Fa/p",
	"./female/2.png": "f37r",
	"./female/2.svg": "vlSI",
	"./female/20.png": "wuZI",
	"./female/20.svg": "+kS6",
	"./female/21.png": "F3zo",
	"./female/21.svg": "NNCM",
	"./female/3.png": "wpGM",
	"./female/3.svg": "DFGL",
	"./female/4.png": "rkOV",
	"./female/4.svg": "V5IG",
	"./female/5.png": "KxLd",
	"./female/5.svg": "FHxu",
	"./female/6.png": "JiAo",
	"./female/6.svg": "DDR7",
	"./female/7.png": "hflI",
	"./female/7.svg": "PAlv",
	"./female/8.png": "v+uJ",
	"./female/8.svg": "9+MG",
	"./female/9.png": "w2og",
	"./female/9.svg": "uaFb",
	"./male/1.png": "l8ep",
	"./male/1.svg": "xD0M",
	"./male/10.png": "NnQa",
	"./male/10.svg": "Nzyx",
	"./male/11.png": "D9F/",
	"./male/11.svg": "5l58",
	"./male/12.png": "wX/j",
	"./male/12.svg": "V3H0",
	"./male/13.png": "WHLm",
	"./male/13.svg": "XMqc",
	"./male/2.png": "Z9aV",
	"./male/2.svg": "T2uR",
	"./male/3.png": "hB9q",
	"./male/3.svg": "anIN",
	"./male/4.png": "brzu",
	"./male/4.svg": "bPu8",
	"./male/5.png": "fSNa",
	"./male/5.svg": "OdJD",
	"./male/6.png": "7UG8",
	"./male/6.svg": "390S",
	"./male/7.png": "ZawD",
	"./male/7.svg": "zJEW",
	"./male/8.png": "mQW2",
	"./male/8.svg": "2wJH",
	"./male/9.png": "ifp+",
	"./male/9.svg": "8IAX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "QI9i";

/***/ }),

/***/ "QQt/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/404-page_bb9c285e18f3d6b10ed41111de061d03.css";

/***/ }),

/***/ "QqRC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/contact-us-section_53bd61f44895f5410f573fd9fcba95cb.css";

/***/ }),

/***/ "R0iF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Strings_1 = __webpack_require__("fxc3");
var getProductByDomain_1 = __webpack_require__("YYsT");
var checkAnyProduct_1 = __webpack_require__("MfCV");
var Utils = (function () {
    function Utils() {
    }
    Utils.calcTime = function (time) {
        var floor = Math.floor, ceil = Math.ceil;
        var hrs = floor(time / 3600);
        var mins = floor((time % 3600) / 60);
        var secs = ceil(time % 60);
        // return '1:01' or '4:03:59' or '123:03:59'
        var ret = '';
        if (hrs > 0) {
            ret += '' + hrs + ':' + (mins < 10 ? '0' : '');
        }
        ret += '' + mins + ':' + (secs < 10 ? '0' : '');
        ret += '' + secs;
        return ret;
    };
    Utils.toHyphenCase = function (str) {
        return str.replace(/([A-Z])/g, function (letter) {
            var letterLowerCase = letter.toLowerCase();
            return letterLowerCase.replace(letterLowerCase, '-' + letterLowerCase);
        });
    };
    Utils.getStateByProduct = function (suffix) {
        if (suffix === void 0) { suffix = ''; }
        var product = Utils.getProduct();
        return product === 'WAVE' ? '' : "studio" + suffix;
    };
    Utils.scopedEvent = function (eventName, scope, func, element, useCapture) {
        if (element === void 0) { element = window; }
        if (useCapture === void 0) { useCapture = false; }
        var events = Array.isArray(eventName) ? eventName : [eventName];
        var destroy = events.map(function (name) {
            element.addEventListener(name, func, useCapture);
            scope.$on('$destroy', function () { return element.removeEventListener(name, func); });
            return function () { return element.removeEventListener(name, func); };
        });
        return function () { return destroy.forEach(function (f) { return f(); }); };
    };
    Utils.getBrowserName = function () {
        var browsers = ['Opera', 'Chrome', 'Safari', 'Firefox', 'MSIE', 'unknown'];
        var index = browsers.findIndex((function (browser) { return navigator.userAgent.includes(browser); }));
        return browsers[index];
    };
    Utils.oneTimeEvent = function (eventName, scope, func, element) {
        if (element === void 0) { element = window; }
        var destroy = null;
        var oneTime = _.once(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            func.apply(void 0, args);
            destroy && destroy();
        });
        destroy = Utils.scopedEvent(eventName, scope, oneTime, element);
        return destroy;
    };
    Utils.isApiError = function (a, code, msg) {
        return !!a.code &&
            a.code >= 400 &&
            (!code || a.code === code) &&
            (!msg || msg.test(a.message));
    };
    Utils.getProduct = function () {
        return checkAnyProduct_1.default() ? 'ANY' : getProductByDomain_1.default(location.host);
    };
    Utils.isUser = function (a) {
        return a.username && a.displayName;
    };
    Utils.redirect = function (url, $location, shouldReplace) {
        if (!url) {
            throw new Error('Empty url was passed to redirect');
        }
        if (/^http(s?):\/\//.test(url)) {
            location.href = url;
            return;
        }
        var _a = url.split('#'), path = _a[0], hash = _a[1];
        var _b = path.split('?'), state = _b[0], paramsStr = _b[1];
        var newLoc = $location
            .url(state)
            .search(Strings_1.Strings.toParams(paramsStr));
        if (hash) {
            newLoc.hash(hash).replace();
        }
        if (!hash && shouldReplace) {
            newLoc.replace();
        }
    };
    // _.filterObj = (obj: any, pred: any) => _.object(Object.keys(obj).filter(k => pred(k, obj[k])).map(k => [k, obj[k]]));
    Utils.safe = function (f) {
        try {
            f();
        }
        catch (e) { }
    };
    Utils.waitFor = function (check, cb) {
        if (check()) {
            cb();
        }
        else {
            setTimeout(function () { return Utils.waitFor(check, cb); }, 100);
        }
    };
    Utils.getMonthDaysCount = function () {
        var current = new Date();
        var d = new Date(current.getFullYear(), current.getMonth() + 1, 0);
        return d.getDate();
    };
    Utils.curry = function (f) {
        return function () {
            var x = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                x[_i] = arguments[_i];
            }
            return f.length <= 1 ? f.apply(void 0, x) : f = f.bind.apply(f, [null].concat(x));
        };
    };
    Utils.createElement = function (name, classes, child) {
        var el = document.createElement(name);
        if (classes)
            classes.forEach(function (className) { return el.classList.add(className); });
        if (child)
            el.appendChild(child);
        return el;
    };
    Utils.redirectToReact = function (url, productName, params) {
        var urlParams = _.isEmpty(params) ? '' : "?" + Utils.toParams(params);
        location.href = "" + Utils.getWebsiteUrl(productName) + url + urlParams;
    };
    Utils.getDomain = function (productName) {
        if (productName === void 0) { productName = Utils.getProduct(); }
        var localProductNameMap = {
            ANY: 'localhost:3000/',
            WAVE: 'localhost:3005/',
            STUDIO: 'localhost:3000/'
        };
        var productNameMap = {
            ANY: "animatron" + ( true ? '' : '-test') + ".com/",
            WAVE: "wave" + ( true ? '' : '-test') + ".video/",
            STUDIO: "animatron" + ( true ? '' : '-test') + ".com/studio/"
        };
        return ( false ? localProductNameMap : productNameMap)[productName];
    };
    Utils.getWebsiteUrl = function (productName) {
        if (productName === void 0) { productName = Utils.getProduct(); }
        var protocol =  false ? 'http://' : 'https://';
        return "" + protocol + Utils.getDomain(productName);
    };
    Utils.checkReferrerUrl = function (url) {
        return new RegExp(url, 'gi').test(document.referrer);
    };
    Utils.getEntry = function () {
        var entries = [
            { name: 'BUTTON', url: 'button' },
            { name: 'CALENDAR', url: 'calendar' },
            { name: 'CALENDAR', url: 'social-calendar' },
            { name: 'TEMPLATE', url: 'video-templates' }
        ];
        var entry = entries.find(function (_a) {
            var url = _a.url;
            return Utils.checkReferrerUrl("/wave/" + url);
        });
        return entry ? entry.name : 'LANDING';
    };
    return Utils;
}());
Utils.getAnalyticId = function (_a) {
    var wave = _a.wave, studio = _a.studio;
    var _b = Utils.getProduct() === 'WAVE' ? wave : studio, prod = _b.prod, test = _b.test;
    return  true ? prod : test;
};
Utils.isSecureUser = function (a) { return a.encryptedToken && a.userProfile; };
Utils.sequence = function (array, $ocLazyLoad) {
    return array.reduce(function (acc, val) { return acc.then(function () { return $ocLazyLoad.load(val); }); }, Promise.resolve());
};
Utils.toParams = function (obj) { return Object.keys(obj).map(function (k) { return k + "=" + encodeURIComponent(obj[k]); }).join('&'); };
Utils.matchesSelector = function (element, selector) {
    var ElementPrototype = Element.prototype;
    var fn = ElementPrototype.matches ||
        ElementPrototype.webkitMatchesSelector ||
        ElementPrototype.msMatchesSelector;
    return fn.call(element, selector);
};
Utils.rAF = (function () {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame']
            || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }
    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function (callback) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function () { return callback(currTime + timeToCall); }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function (id) { return clearTimeout(id); };
    return window.requestAnimationFrame.bind(window);
}());
exports.Utils = Utils;
_.mixin(Utils);


/***/ }),

/***/ "R8gk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/contest-landing_df13741e2d251a6ce2b4fe37f299e826.css";

/***/ }),

/***/ "R8wy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/template-pages-list_9fe1e728eb72618ba274b6ab4804ca0c.css";

/***/ }),

/***/ "RDpK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * To add new page, create new json object with the same structure as the ones below.
 * Most values should be key references to i18n files. So translations should also be written in app/assets/i18n/m_*.properties files
 * It is essential that all properties are present and have correct names.
 * Images are stored in app/assets/images/landing/light folder, but here should only be filename.
 */
exports.default = [
    {
        url: 'studio/online-video-maker',
        title: 'light.videomaker.title',
        h1: 'light.videomaker.h1',
        h2: 'light.videomaker.h2',
        playerUrl: 'https://publish.animatron.io/578e8efb8951d5959bda7752.json',
        width: 1920,
        height: 1080,
        preview: 'video-maker.png',
        alt: 'light.videomaker.alt1',
        editor: 'https://editor.animatron.com',
        button: 'light.videomaker.button',
        descriptionTitle: 'light.videomaker.description.title',
        description: 'light.videomaker.description',
        link: '/tags/Video?super=true',
        linkName: 'light.videomaker.name'
    },
    {
        url: 'studio/online-card-maker',
        title: 'light.card.title',
        h1: 'light.card.h1',
        h2: 'light.card.h2',
        playerUrl: 'https://publish.animatron.io/578e93857cb4bf921554b8d7.json',
        width: 400,
        height: 360,
        preview: 'card-maker.png',
        alt: 'explainer.help4.alt4',
        editor: 'https://editor.animatron.com',
        button: 'light.card.button',
        descriptionTitle: 'light.card.description.title',
        description: 'light.card.description',
        link: 'tags/Animated%20card?super=true',
        linkName: 'light.card.name'
    },
    {
        url: 'studio/creativity-in-classroom',
        title: 'light.creativity.title',
        h1: 'light.creativity.h1',
        h2: 'light.creativity.h2',
        playerUrl: 'https://publish.animatron.io/578e96eeaa3269e89ae552bd.json',
        width: 640,
        height: 360,
        preview: 'creativity.png',
        alt: 'explainer.help5.alt5',
        editor: 'https://editor.animatron.com',
        button: 'light.creativity.button',
        descriptionTitle: 'light.creativity.description.title',
        description: 'light.creativity.description',
        link: '/tags/edu?super=true',
        linkName: 'light.creativity.name'
    }
];


/***/ }),

/***/ "RIrZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var underscore_extensions_1 = __webpack_require__("R0iF");
var FooterCtrl = (function () {
    FooterCtrl.$inject = ["$rootScope", "$element", "$state"];
    function FooterCtrl($rootScope, $element, $state) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$element = $element;
        this.$state = $state;
        this.isLangMenuHide = ("ontouchstart" in document.documentElement);
        this.date = new Date();
        this.affUrl = "https://animatron" + ( true ? '' : 'test') + ".tapfiliate.com/";
        this.socials = [
            {
                href: 'github',
                className: 'gh'
            },
            {
                href: 'twitter',
                className: 'tw'
            },
            {
                href: 'facebook',
                className: 'fb'
            },
            {
                href: 'youtube',
                className: 'yt'
            },
            {
                href: 'instagram',
                className: 'inst'
            }
        ];
        this.followStates = ['studio-followers', 'studio-following'];
        var footer = $element[0];
        var windowHeight = window.innerHeight;
        window.addEventListener('scroll', _.throttle(function () { return underscore_extensions_1.Utils.rAF(function () {
            var scrollTopDocument = window.scrollY || window.pageYOffset;
            var action = scrollTopDocument > (windowHeight * 3) ? 'add' : 'remove';
            footer.classList[action]('fixed');
        }); }, 250));
        this.$rootScope.$on('$stateChangeStart', function () { return footer.classList.remove('shown'); });
        this.$rootScope.$on('$stateChangeSuccess', function () {
            return _this.product = underscore_extensions_1.Utils.getProduct();
        });
        this.$rootScope.$on('$projects:shownAll', function () { return footer.classList.add('shown'); });
        this.$rootScope.$on('$following:loaded', function () {
            return _this.followStates.includes(_this.$state.current.name) && footer.classList.add('shown');
        });
    }
    return FooterCtrl;
}());
module_1.default.component('anmFooter', {
    controller: FooterCtrl,
    templateUrl: __webpack_require__("Sm4n")
});


/***/ }),

/***/ "RJzm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("jYQ6");
var lazy_modules_1 = __webpack_require__("bUzP");
var SpinnerSvc_1 = __webpack_require__("pPBV");
var underscore_extensions_1 = __webpack_require__("R0iF");
var ProjectModalSvc = (function () {
    ProjectModalSvc.$inject = ["$rootScope", "$state", "$timeout", "$ocLazyLoad"];
    function ProjectModalSvc($rootScope, $state, $timeout, $ocLazyLoad) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$ocLazyLoad = $ocLazyLoad;
        this.prevState = $state.current;
        this.prevParams = $state.params;
        if (this.projectModalShown !== true) {
            this.projectModalShown = false;
        }
        this.$rootScope.$on('$stateChangeStart', function (e, toState, toParams) {
            if (($state.is('studio-project') || $state.is('project')) &&
                _this.projectModalShown) {
                e.preventDefault();
                _this.modalHide();
                if (_.isEqual(toParams, _this.prevParams) &&
                    toState.name === _this.prevState.name) {
                    // in case we go to some url from modal
                    _this.changeUrl(toState.name, toParams, true).then(function () {
                        SpinnerSvc_1.default.hide();
                    });
                }
                else {
                    _this.$timeout(function () { return $state.transitionTo(toState.name, toParams); });
                }
            }
        });
    }
    ProjectModalSvc.prototype.onModalClose = function () {
        window.history.back(); //It will call $stateChangeStart
    };
    ProjectModalSvc.prototype.modalHide = function () {
        this.projectModalShown = false;
    };
    ProjectModalSvc.prototype.modalShow = function (project) {
        var _this = this;
        SpinnerSvc_1.default.show();
        this.$ocLazyLoad.load(lazy_modules_1.animatronProject).then(function () {
            var params = {
                projectId: project.id,
                project: project
            };
            if (underscore_extensions_1.Utils.getProduct() === 'WAVE') {
                params.stopPlay = true;
            }
            var state = [underscore_extensions_1.Utils.getStateByProduct('-') + "project", params];
            if (options.handHeld) {
                (_a = _this.$state).go.apply(_a, state);
            }
            else {
                _this.prevState = _this.$state.current;
                _this.prevParams = _this.$state.params;
                delete _this.prevParams['#'];
                _this.projectModalShown = true;
                _this.changeUrl.apply(_this, state);
            }
            var _a;
        });
    };
    ProjectModalSvc.prototype.toggleProjectModal = function (project, $event) {
        if (!$event.metaKey && !$event.ctrlKey) {
            $event.preventDefault();
            $event.stopPropagation();
            if (this.projectModalShown) {
                this.modalHide();
            }
            else {
                this.modalShow(project);
            }
        }
    };
    ProjectModalSvc.prototype.changeUrl = function (state, params, replace) {
        if (replace === void 0) { replace = false; }
        var opts = {
            notify: false,
            location: replace ? 'replace' : true
        };
        return this.$state.transitionTo(state, params, opts);
    };
    return ProjectModalSvc;
}());
exports.ProjectModalSvc = ProjectModalSvc;
module_1.default.service('ProjectModalSvc', ProjectModalSvc);


/***/ }),

/***/ "Rium":
/***/ (function(module, exports) {

var path = 'https://assets.animatron.com/html/modal-template.html';
var html = "<div class=\"ng-modal\"> <div ng-if=\"!isScroll\" document-no-scroll=\"show\"></div> <div class=\"ng-modal-overlay\" plain-click=\"hideModal($event)\"> <div class=\"ng-modal-dialog {{additionalClasses}}\"> <div ng-if=\"closeButton\" class=\"ng-modal-close\"></div> <div class=\"ng-modal-dialog-content\" ng-if=\"modalUrl\" ng-include=\"modalUrl\" onload=\"includeLoaded()\"></div> <div class=\"ng-modal-dialog-content\" ng-show=\"!modalUrl && !directive\"></div> <transclude-directive></transclude-directive> </div> </div> </div> ";
var angular = window.angular;
var injector = angular.element(document).injector();
if (injector) {
injector.get('$templateCache').put(path, html);
} else {
angular.module('templates').run(['$templateCache', function(c) { c.put(path, html) }]);
}
module.exports = path;

/***/ }),

/***/ "Rpkd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/political-landing_13ec297054b85d789fa082bb6c9a03ff.css";

/***/ }),

/***/ "RySD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/contest-text-video-section_bbd71e3eebf6622ceaf597a366fa01aa.css";

/***/ }),

/***/ "S6Z6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/m-header_11e6adcd77ef86886065bf3d7b455419.css";

/***/ }),

/***/ "SDKh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/m-landing-banner_5e15667ed5ffc1fee009f8f765bf0a67.css";

/***/ }),

/***/ "SFnc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("jYQ6");
var LocalStorageSvc = (function () {
    LocalStorageSvc.$inject = ["$window", "$log"];
    function LocalStorageSvc($window, $log) {
        this.$window = $window;
        this.$log = $log;
        this.isSupported = false;
        try {
            var supported = $window && $window.localStorage !== null;
            var key = '__' + Math.round(Math.random() * 1e7);
            if (supported) {
                this.storage = $window.localStorage;
                this.storage.setItem(key, 'value');
                supported = this.storage.getItem(key) === 'value';
                this.storage.removeItem(key);
            }
            this.isSupported = supported;
        }
        catch (e) {
            $log.warn('LocalStorage is disabled');
            this.isSupported = false;
        }
    }
    LocalStorageSvc.prototype.set = function (key, value) {
        if (this.isSupported) {
            this.storage.setItem(key, JSON.stringify(value));
        }
        else {
            this.$log.debug('Cannot set ' + key + ' to localStorage');
        }
    };
    ;
    LocalStorageSvc.prototype.get = function (key) {
        var _this = this;
        var onError = function () {
            _this.$log.debug('Cannot get ' + key + ' from localStorage');
            return null;
        };
        if (this.isSupported) {
            return this.safeOperation(function () {
                return JSON.parse(_this.storage.getItem(key));
            }, onError);
        }
        else {
            return onError();
        }
    };
    ;
    LocalStorageSvc.prototype.remove = function (key) {
        if (this.isSupported) {
            var value = this.get(key);
            this.storage.removeItem(key);
            return value;
        }
        else {
            this.$log.debug('Cannot remove ' + key + ' from localStorage');
            return null;
        }
    };
    ;
    LocalStorageSvc.prototype.safeOperation = function (unsafeFunc, onError) {
        try {
            return unsafeFunc();
        }
        catch (e) {
            return onError();
        }
    };
    ;
    return LocalStorageSvc;
}());
exports.LocalStorageSvc = LocalStorageSvc;
module_1.default.service('LocalStorageSvc', LocalStorageSvc);


/***/ }),

/***/ "SHV6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/17.svg";

/***/ }),

/***/ "SW67":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/win-prizes-section_3f8c5ebc1c4528773e263450dc5bff31.css";

/***/ }),

/***/ "SXt6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/light/video-maker.png";

/***/ }),

/***/ "Sct3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var News = (function () {
    News.$inject = ["$scope", "$sce", "$interval", "$element", "NewsSvc"];
    function News($scope, $sce, $interval, $element, NewsSvc) {
        var _this = this;
        this.$scope = $scope;
        this.$sce = $sce;
        this.$interval = $interval;
        this.$element = $element;
        this.NewsSvc = NewsSvc;
        this.delayShowNews = 1e+1;
        this.newsList = [];
        $scope.$watch(function () { return NewsSvc.newsList; }, function (list) {
            if (!list)
                return;
            _this.newsList = list;
            _this.setCurrentNews();
            var appliedClassName = 'applied';
            if (_this.newsList.length) {
                setTimeout(function () { return _this.$element[0].classList.add(appliedClassName); }, _this.delayShowNews);
            }
            else {
                _this.$element[0].classList.remove(appliedClassName);
            }
        });
        $scope.$on('$destroy', function () { return $interval.cancel(_this.stopRepeatNews); });
    }
    Object.defineProperty(News.prototype, "currentNews", {
        get: function () {
            return this.$sce.trustAsHtml(this.currentNewsItem.html);
        },
        enumerable: true,
        configurable: true
    });
    News.prototype.setCurrentNews = function (index) {
        var _this = this;
        if (index === void 0) { index = this.NewsSvc.currentIndex; }
        this.currentNewsItem = this.newsList[index] || this.newsList[0];
        this.$interval.cancel(this.stopRepeatNews);
        this.stopRepeatNews = this.$interval(function () {
            _this.NewsSvc.currentIndex = index = ++index >= _this.newsList.length ? 0 : index;
            _this.currentNewsItem = _this.newsList[index];
        }, this.delayShowNews);
    };
    News.prototype.deleteNews = function () {
        this.NewsSvc.deleteNews(this.currentNewsItem.id);
    };
    return News;
}());
module_1.default.component('news', {
    controller: News,
    controllerAs: 'NewsCtrl',
    templateUrl: __webpack_require__("c5FE")
});


/***/ }),

/***/ "Skyp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/auth_15a606cbe5e8f3a674725fb147f4443d.css";

/***/ }),

/***/ "Sm4n":
/***/ (function(module, exports) {

var path = 'https://assets.animatron.com/html/footer.html';
var html = "<footer id=\"footer\"> <div> <div class=\"top\"> <section> <nav> <h5>{{::$root.t('footer.products')}}</h5> <div class=\"nav-link-container\"> <a ng-href=\"{{ $root.options.waveUrl }}\">{{::$root.t('footer.products.wave')}}</a> <a ng-click=\"$root.redirectToReact('social-calendar', 'WAVE')\">{{::$root.t('footer.products.socal')}}</a> <a ng-click=\"$root.redirectToReact('button', 'WAVE')\">{{::$root.t('footer.products.button')}}</a> <a ng-href=\"{{ $root.options.studioUrl }}\">{{::$root.t('footer.products.studio')}}</a> </div> </nav> <nav class=\"solutions\"> <h5>{{::$root.t('footer.solutions')}}</h5> <div class=\"nav-link-container\"> <a ng-href=\"{{ $root.options.animatronUrl + '/studio/presentation-maker' }}\">{{::$root.t('short.presentation.title')}}</a> <a class=\"plans-pricing\" ui-sref=\"studio-pricing\">{{::$root.t('footer.plans-pricing')}}</a> <a ng-href=\"{{ $root.options.animatronUrl + '/studio/html5-banner-maker' }}\">{{::$root.t('footer.html5banner')}}</a> <a ng-href=\"{{ $root.options.animatronUrl + '/studio/explainer-video-maker'}}\">{{::$root.t('footer.explainercreator')}}</a> <a class=\"education\" href=\"/studio/education/week1\">{{::$root.t('footer.education')}}</a> <a ng-href=\"{{ $root.options.animatronUrl + '/studio/animation-for-agencies'}}\">{{::$root.t('footer.agencies')}}</a> </div> </nav> <nav ng-if=\"$root.isWave\"> <h5>{{::$root.t('footer.resources')}}</h5> <div class=\"nav-link-container\"> <a ng-click=\"$root.redirectToReact('video-templates', 'WAVE')\">{{::$root.t('footer.templates')}}</a> <a href=\"https://wave.video/blog\">{{::$root.t('footer.blog')}}</a> <a ng-click=\"$root.redirectToReact('success-stories', 'WAVE')\">{{::$root.t('footer.ss')}}</a> <a ng-click=\"$root.redirectToReact('integrations', 'WAVE')\">{{::$root.t('footer.integrations')}}</a> <a ng-href=\"{{$ctrl.affUrl}}\" target=\"_blank\">{{::$root.t('footer.affiliates')}}</a> <a ng-href=\"{{$root.options.animatronUrl + '/company/press'}}\" target=\"_blank\" rel=\"noopener\">{{::$root.t('footer.press')}}</a> </div> </nav> <nav ng-if=\"$root.isWave\"> <h5>{{::$root.t('footer.learn')}}</h5> <div class=\"nav-link-container\"> <a ui-sref=\"tutorial\">{{::$root.t('footer.tutorials')}}</a> <a ui-sref=\"workshops\">{{::$root.t('footer.workshops')}}</a> <a target=\"_blank\" ng-href=\"{{ $root.options.kbUrl }}\">{{::$root.t('footer.knowledgebase')}}</a> </div> </nav> <nav> <h5>{{::$root.t('footer.company')}}</h5> <div class=\"nav-link-container\"> <a ng-href=\"{{ $root.isWave ? $root.options.animatronUrl : '' }}/company/about\">{{::$root.t('about.title')}}</a> <a ng-href=\"privacy\">{{::$root.t('footer.privacy')}}</a> <a ng-href=\"terms-of-service\">{{::$root.t('footer.terms')}}</a> <a ng-if=\"$root.isStudio\" href=\"mailto:feedback@animatron.com\">{{::$root.t('footer.contact')}}</a> <a ng-if=\"$root.isWave\" href=\"mailto:feedback@wave.video\">{{::$root.t('footer.contact')}}</a> </div> </nav> <nav class=\"support\" ng-if=\"$root.animatronProduct !== 'WAVE'\"> <h5>{{::$root.t('footer.support')}}</h5> <div class=\"nav-link-container\"> <a target=\"_blank\" class=\"knowledgebase\" ng-href=\"{{ $root.options.kbUrl }}\">{{::$root.t('footer.knowledgebase')}}</a> <a ng-if=\"$root.isStudio\" ui-sref=\"studio-tutorial\">{{::$root.t('tutorial.title')}}</a> <a ng-if=\"$root.isWave\" ui-sref=\"tutorial\">{{::$root.t('tutorial.title')}}</a> <a href=\"//forum.animatron.com/latest\">{{::$root.t('header.nav.forum')}}</a> </div> </nav> <nav class=\"subscribe\"> <h5>{{::$root.t('footer.subscribe')}}</h5> <form class=\"footer-subscribe-wrapper\"> <input class=\"footer-subscribe-input\" type=\"email\" placeholder=\"{{::$root.t('footer.subscribe.placeholder')}}\"/> <input class=\"footer-subscribe-button\" type=\"submit\" value=\"\"/> </form> <div class=\"footer-social-buttons\"> <common-link ng-repeat=\"social in $ctrl.socials\" class-name=\"fsb {{social.className}}\" name=\"{{social.href}}\" product=\"{{$ctrl.product}}\"></common-link> </div> </nav> </section> </div> <div class=\"copy\"> <div class=\"copy-content\"> <a ng-if=\"$root.animatronProduct !== 'WAVE'\" ng-href=\"{{ $root.options.animatronUrl }}\" class=\"footer-logo\"> </a> <span class=\"copyright-text\">{{::$root.t('footer.copyright', $ctrl.date| date:'yyyy')}}</span> <div class=\"tiny-footer-link\"> <a href=\"/privacy\">{{::$root.t('footer.privacy')}}</a> <span>|</span> <a href=\"/terms-of-service\">{{::$root.t('footer.terms')}}</a> </div> </div> <div ng-if=\"$root.animatronProduct !== 'WAVE'\" class=\"language-wrapper\"> <div class=\"dropdown-button dropdown-top lite-gray-dropdown lang\" ng-click=\"$ctrl.isLangMenuHide = !$ctrl.isLangMenuHide\" ng-mouseleave=\"$ctrl.isLangMenuHide = false\" ng-class=\"{hide: $ctrl.isLangMenuHide}\"> <span class=\"title flag {{$root.TranslateSvc.lang}}\"> {{$root.TranslateSvc.supportedLangs[$root.TranslateSvc.lang]}} </span> <div class=\"dropdown-menu\"> <ul> <li ng-repeat=\"(key, lang) in $root.TranslateSvc.supportedLangs\" ng-if=\"key !== $root.TranslateSvc.lang\"> <a href=\"#\" class=\"flag {{key}}\" ng-click=\"$root.TranslateSvc.langChange(key)\" ng-bind=\"lang\"> </a> </li> </ul> </div> </div> </div> </div> <div class=\"footer-small\"> <logo product=\"wave\" logo-style=\"black\"></logo> <span class=\"copyright-text\">{{::$root.t('footer.copyright', '2019')}}</span> </div> </div> </footer> ";
var angular = window.angular;
var injector = angular.element(document).injector();
if (injector) {
injector.get('$templateCache').put(path, html);
} else {
angular.module('templates').run(['$templateCache', function(c) { c.put(path, html) }]);
}
module.exports = path;

/***/ }),

/***/ "SzCq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/press-twitter-gallery_d37316aa6e4c02d2c0f1364e79240426.html";

/***/ }),

/***/ "T1Il":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var underscore_extensions_1 = __webpack_require__("R0iF");
var shareSocialSvc = { show: false };
var networks = {
    facebook: "https://www.facebook.com/sharer/sharer.php?s=100&p[url]={{::$ctrl.url}}",
    twitter: "https://twitter.com/intent/tweet?url={{::$ctrl.url}}",
    'google+': "https://plus.google.com/share?url={{::$ctrl.url}}",
    tumblr: "https://www.tumblr.com/share/photo?source={{$ctrl.preview}}&caption={{::$ctrl.info}}&click_thru={{::$ctrl.url}}",
    email: "mailto:?subject={{$ctrl.ProjectPageCtrl.project.name}}%20by%20{{$ctrl.ProjectPageCtrl.project.author.displayName}}&body={{$ctrl.url}}"
};
module_1.default.component('shareSocialButton', {
    controller: (function () {
        function ShareSocialButton() {
            this.shareSocialSvc = shareSocialSvc;
        }
        ShareSocialButton.prototype.onClick = function () {
            shareSocialSvc.show = !shareSocialSvc.show;
            if (shareSocialSvc.show && this.ProjectPageCtrl.player) {
                this.ProjectPageCtrl.player.then(function (p) { return p && p.pause(); });
            }
        };
        ;
        return ShareSocialButton;
    }()),
    require: { ProjectPageCtrl: '^projectPage' },
    template: "\n              <span class=\"popup-opener animatron-grey-btn dropdown-toggle share control\"\n                ng-click=\"$ctrl.onClick()\" ng-class=\"{show:$ctrl.shareSocialSvc.show}\">\n                  <span class=\"title\">{{::$root.t('share')}}</span>\n               </span>"
});
module_1.default.component('shareSocialWindow', {
    controller: (function () {
        ShareSocialWindow.$inject = ["$scope", "$timeout", "$location", "$element"];
        function ShareSocialWindow($scope, $timeout, $location, $element) {
            var _this = this;
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.$location = $location;
            this.$element = $element;
            this.shareSocialSvc = shareSocialSvc;
            this.$onInit = function () { return _this.ProjectPageCtrl.projectPromise.then(function (prj) {
                if (_this.ProjectPageCtrl.twoPlayers)
                    return;
                _this.url = encodeURIComponent(_this.$location.absUrl());
                _this.preview = encodeURIComponent(prj.preview_metadata[0]);
                _this.info = encodeURIComponent(prj.name + '\n' + prj.description + '\nby ' + prj.author.displayName);
                var destroy = _this.$scope.$watch(function () { return _this.ProjectPageCtrl.player; }, function (player) {
                    if (player && player.then) {
                        destroy();
                        player.then(function (p) {
                            if (!p)
                                return;
                            var showOnPause = _.once(function () {
                                p.on(anm.C.S_PAUSE, function () { return _this.$timeout(function () { return shareSocialSvc.show = true; }); });
                            });
                            var repeats = 0;
                            if (window.anm) {
                                p.on(anm.C.S_COMPLETE, function () {
                                    repeats += 1;
                                    if (!p.repeat && !p.repeating && !p.anim.repeat) {
                                        _this.$timeout(function () { return shareSocialSvc.show = true; });
                                    }
                                    else if (repeats >= 1) {
                                        showOnPause();
                                    }
                                });
                                p.on(anm.C.S_PLAY, function () { return _this.$timeout(function () { return shareSocialSvc.show = false; }); });
                            }
                            underscore_extensions_1.Utils.scopedEvent('click', _this.$scope, function (e) {
                                var target = e.target;
                                if (shareSocialSvc.show && !target.classList.contains('share')) {
                                    p.play();
                                }
                                return e;
                            }, _this.$element[0]);
                        });
                    }
                });
                _this.$scope.$on('$destroy', function () { return shareSocialSvc.show = false; });
            }); };
        }
        return ShareSocialWindow;
    }()),
    require: { ProjectPageCtrl: '^projectPage' },
    template: function () {
        var items = _.map(networks, function (href, network) {
            return "<a target=\"_blank\" ng-href=\"" + href + "\" class=\"popup-opener\">\n                        <div class=\"share share-" + network + "\"><i class=\"icon-" + network + "\"></i></div>\n                    </a>";
        }).join('');
        return "\n                <div class=\"animatron-share-menu\" ng-class=\"{show:$ctrl.shareSocialSvc.show}\">\n                    <div class=\"share-title\">{{::$root.t('project.share')}}</div>\n                    <div class=\"items\">" + items + "</div>\n                </div>";
    }
});


/***/ }),

/***/ "T2uR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/2.svg";

/***/ }),

/***/ "T3B4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var underscore_extensions_1 = __webpack_require__("R0iF");
var RescaleSvc_1 = __webpack_require__("7T+Z");
var ModalVideoComponent = (function () {
    ModalVideoComponent.$inject = ["$element", "$sce", "$timeout", "Player"];
    function ModalVideoComponent($element, $sce, $timeout, Player) {
        this.$element = $element;
        this.$sce = $sce;
        this.$timeout = $timeout;
        this.Player = Player;
        this.onModalShown = this.onModalShown || angular.noop;
    }
    ModalVideoComponent.prototype.$onChanges = function () {
        this.modalShown = this.canModalShow;
    };
    ModalVideoComponent.prototype.$onInit = function () {
        if (this.youtubeId) {
            this.youtubeUrl = this.$sce.trustAsResourceUrl("https://www.youtube.com/embed/" + this.youtubeId + "?autoplay=1");
        }
        else if (this.wistiaId) {
            this.wistiaUrl = this.$sce.trustAsResourceUrl("https://animatron.wistia.com/embed/iframe/" + this.wistiaId + "?videoFoam=true");
        }
    };
    ModalVideoComponent.prototype.$onDestroy = function () {
        this.Player.resetPlayer(this.player);
    };
    Object.defineProperty(ModalVideoComponent.prototype, "modalShown", {
        get: function () {
            return this.isModalShown;
        },
        set: function (shown) {
            var _this = this;
            this.isModalShown = shown;
            this.onModalShown({ isModalShown: shown });
            if (shown && !this.youtubeId && !this.wistiaId && this.playerUrl) {
                this.$timeout(function () { return underscore_extensions_1.Utils.rAF(function () {
                    var maxWidth = (window.innerWidth / 2);
                    var maxHeight = (window.innerHeight / 1.4515503875968991);
                    var _a = RescaleSvc_1.RescaleSvc.resizeWithAspectRatio(_this.playerWidth, _this.playerHeight, maxWidth, maxHeight, true, true), width = _a.width, height = _a.height;
                    var el = _this.$element[0].querySelector('.ng-modal-dialog-content');
                    Object.assign(el.style, {
                        width: width + "px",
                        height: height + "px"
                    });
                    _this.player = _this.Player.createPlayer(_this.playerUrl, 'player', {
                        width: width,
                        height: height,
                        repeat: false,
                        autoPlay: true,
                        controlsEnabled: true
                    }, function () { return _this.$element[0].querySelector('#player').style.background = ''; });
                }); });
            }
            else if (!shown && this.player) {
                this.$onDestroy();
            }
        },
        enumerable: true,
        configurable: true
    });
    return ModalVideoComponent;
}());
exports.ModalVideoComponent = ModalVideoComponent;
module_1.default.component('modalVideo', {
    bindings: {
        previewUrl: '<?',
        alt: '<?',
        youtubeId: '<?',
        wistiaId: '<?',
        playerUrl: '<?',
        playerWidth: '<?',
        playerHeight: '<?',
        canModalShow: '<?',
        onModalShown: '&?',
        hideBorder: '<'
    },
    controller: ModalVideoComponent,
    templateUrl: __webpack_require__("ldoD")
});


/***/ }),

/***/ "TBjL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/edu_79af8a19a747b6287d49c4fd17609ba5.css";

/***/ }),

/***/ "TToO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { if (o[n]) i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; }; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator];
    return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


/***/ }),

/***/ "TnCe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/discount-dialog_5b1a945f0cc8011e81e2cc1c706e41dd.css";

/***/ }),

/***/ "U56v":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": "aY29",
	"./es.json": "+lAx",
	"./ko.json": "a8i3",
	"./ru.json": "2MCb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "U56v";

/***/ }),

/***/ "UAPN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/subscription-messages_fdc9a72ec85f6b45392f1c6eb2617d8c.css";

/***/ }),

/***/ "UTMY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/settings_c9c127e77be01124d624a1776c596de6.html";

/***/ }),

/***/ "UVgn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/library_d41d8cd98f00b204e9800998ecf8427e.css";

/***/ }),

/***/ "UYjX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
module_1.default.directive('toggleProjectModal', ["$compile", function ($compile) {
    return {
        restrict: 'A',
        terminal: true,
        priority: 1000,
        scope: false,
        link: function (scope, element) {
            if (!scope.project)
                scope.project = scope.$ctrl.project;
            element.attr('ng-href', '/project/{{::project.id}}');
            element.attr('ng-click', '$root.projectModalSvc.toggleProjectModal(project, $event)');
            element.removeAttr('toggle-project-modal');
            $compile(element)(scope);
        }
    };
}]);
module_1.default.directive('projectModalLink', function () {
    return {
        scope: false,
        restrict: 'E',
        template: "<a class=\"project-name p-info\"\n                          toggle-project-modal\n                          title=\"{{::(project.name || $ctrl.project.name)}}\">\n                        {{::(project.name || $ctrl.project.name)}}\n                      </a>"
    };
});


/***/ }),

/***/ "Us82":
/***/ (function(module, exports) {

/* ng-infinite-scroll - v1.1.2 - 2014-05-21 */
var mod;

mod = angular.module('infinite-scroll', []);

mod.value('THROTTLE_MILLISECONDS', null);

mod.directive('infiniteScroll', [
    '$rootScope', '$window', '$timeout', 'THROTTLE_MILLISECONDS', function ($rootScope, $window, $timeout, THROTTLE_MILLISECONDS) {
        return {
            scope: {
                infiniteScroll: '&',
                infiniteScrollContainer: '=',
                infiniteScrollDistance: '=',
                infiniteScrollDisabled: '=',
                infiniteScrollUseDocumentBottom: '='
            },
            link: function (scope, elem, attrs) {
                var changeContainer, checkWhenEnabled, container, handleInfiniteScrollContainer, handleInfiniteScrollDisabled, handleInfiniteScrollDistance, handleInfiniteScrollUseDocumentBottom, handler, immediateCheck, scrollDistance, scrollEnabled, increment, useDocumentBottom;
                $window = angular.element($window);
                scrollDistance = null;
                scrollEnabled = null;
                checkWhenEnabled = null;
                container = null;
                immediateCheck = true;
                useDocumentBottom = false;
                var originalHandler;
                handler = function () {
                    var containerBottom, elementBottom, remaining, shouldScroll, containerHeight;
                    containerHeight = window.innerHeight;
                    containerBottom = containerHeight + (window.scrollY || window.pageYOffset);
                    elementBottom = elem[0].offsetTop + elem[0].offsetHeight;

                    remaining = elementBottom - containerBottom;
                    increment = elementBottom < 1200 ? 1300 : 500;
                    shouldScroll = remaining <= containerHeight + increment;
                    if (shouldScroll) {
                        checkWhenEnabled = true;
                        if (scrollEnabled) {
                            if (scope.$$phase || $rootScope.$$phase) {
                                scope.infiniteScroll();
                            } else {
                                scope.$apply(scope.infiniteScroll);
                            }
                            angular.element(window).triggerHandler('scroll');
                        }
                    } else {
                        return checkWhenEnabled = false;
                    }
                };
                if (THROTTLE_MILLISECONDS != null) {
                    originalHandler = handler;
                    handler = _.throttle(handler, THROTTLE_MILLISECONDS);
                }
                scope.$on('$destroy', function () {
                    return container.off('scroll', handler);
                });
                handleInfiniteScrollDistance = function (v) {
                    return scrollDistance = parseInt(v, 10) || 0;
                };
                scope.$watch('infiniteScrollDistance', handleInfiniteScrollDistance);
                handleInfiniteScrollDistance(scope.infiniteScrollDistance);
                handleInfiniteScrollDisabled = function (v) {
                    scrollEnabled = !v;
                    if (scrollEnabled && checkWhenEnabled) {
                        checkWhenEnabled = false;
                        return handler();
                    }
                };
                scope.$watch('infiniteScrollDisabled', handleInfiniteScrollDisabled);
                handleInfiniteScrollDisabled(scope.infiniteScrollDisabled);
                handleInfiniteScrollUseDocumentBottom = function (v) {
                    return useDocumentBottom = v;
                };
                scope.$watch('infiniteScrollUseDocumentBottom', handleInfiniteScrollUseDocumentBottom);
                handleInfiniteScrollUseDocumentBottom(scope.infiniteScrollUseDocumentBottom);
                changeContainer = function (newContainer) {
                    if (container != null) {
                        container.off('scroll', handler);
                    }
                    container = typeof newContainer.last === 'function' && newContainer !== $window ? newContainer.last() : newContainer;
                    if (newContainer != null) {
                        return container.on('scroll', handler);
                    }
                };
                changeContainer($window);
                handleInfiniteScrollContainer = function (newContainer) {
                    if ((!(newContainer != null)) || newContainer.length === 0) {
                        return;
                    }
                    newContainer = angular.element(newContainer);
                    if (newContainer != null) {
                        return changeContainer(newContainer);
                    } else {
                        throw new Error("invalid infinite-scroll-container attribute.");
                    }
                };
                scope.$watch('infiniteScrollContainer', handleInfiniteScrollContainer);
                handleInfiniteScrollContainer(scope.infiniteScrollContainer || []);
                if (attrs.infiniteScrollParent != null) {
                    changeContainer(angular.element(elem.parent()));
                }
                if (attrs.infiniteScrollImmediateCheck != null) {
                    immediateCheck = scope.$eval(attrs.infiniteScrollImmediateCheck);
                }
                return $timeout((function () {
                    if (immediateCheck) {
                        return originalHandler();
                    }
                }), 0);
            }
        };
    }
]);


/***/ }),

/***/ "V16h":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1.svg": "xD0M",
	"./10.svg": "Nzyx",
	"./11.svg": "5l58",
	"./12.svg": "V3H0",
	"./13.svg": "XMqc",
	"./2.svg": "T2uR",
	"./3.svg": "anIN",
	"./4.svg": "bPu8",
	"./5.svg": "OdJD",
	"./6.svg": "390S",
	"./7.svg": "zJEW",
	"./8.svg": "2wJH",
	"./9.svg": "8IAX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "V16h";

/***/ }),

/***/ "V3H0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/12.svg";

/***/ }),

/***/ "V5IG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/4.svg";

/***/ }),

/***/ "VLpl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createActivityEvent = function (cb) {
    var events = [
        'click'
    ];
    events.forEach(function (eventName) {
        return document.addEventListener(eventName, cb);
    });
    return function () {
        return events.forEach(function (eventName) {
            return document.removeEventListener(eventName, cb);
        });
    };
};
exports.default = function (doActive) { return createActivityEvent(doActive); };


/***/ }),

/***/ "Vc67":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/video-folder-item_d7e157f3e7090020247859001a63f873.css";

/***/ }),

/***/ "WHLm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/13.png";

/***/ }),

/***/ "WgFx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/double-circle-progress_d7d55eb0ce0d675df20ccd009671ab1e.css";

/***/ }),

/***/ "Wmao":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/week4_be107073bc11a3eda14ce6557a397430.html";

/***/ }),

/***/ "X7JN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ObjectId_1 = __webpack_require__("j1Q3");
var AnimatronProjectsSvc_1 = __webpack_require__("P9JW");
var AdSvc = (function () {
    function AdSvc(enabled, $rootScope, ProjectInfoHeight) {
        if (enabled === void 0) { enabled = true; }
        if (ProjectInfoHeight === void 0) { ProjectInfoHeight = 124; }
        var _this = this;
        this.enabled = enabled;
        this.$rootScope = $rootScope;
        this.ProjectInfoHeight = ProjectInfoHeight;
        this.results = [];
        this.banners = AdSvc.chooseBanners();
        this.currentIdx = this.banners && _.random(this.banners.videoUrls.length - 1);
        this.currentPage = 0;
        this.$rootScope.$on('project:remove', function (e, pid) { return _this.results = _this.results.filter(function (p) { return p.id !== pid; }); });
        this.$rootScope.$on(AnimatronProjectsSvc_1.PROJECT_ADD, function (e, _a) {
            var project = _a.project;
            return _this.results.unshift(_this.wrapProject(project));
        });
    }
    AdSvc.prototype.adify = function (page) {
        var _this = this;
        var newRes = page.map(function (project) { return _this.wrapProject(project); });
        this.insertBanner(newRes);
        this.results = _.unique(this.results.concat(newRes), false, function (item) { return item.id; });
    };
    AdSvc.prototype.wrapProject = function (project) {
        return {
            id: project.id,
            project: project,
            width: AdSvc.getWidth(),
            height: project.computedHeight + this.ProjectInfoHeight
        };
    };
    AdSvc.prototype.getBanner = function () {
        return this.banners && this.banners.videoUrls[this.currentIdx++ % this.banners.videoUrls.length];
    };
    AdSvc.prototype.insertBanner = function (projects) {
        if (!this.enabled || this.currentPage++ % 2 !== 0)
            return;
        var banner = this.getBanner();
        if (banner) {
            var ad = {
                id: 'ad-' + ObjectId_1.ObjectId.get(),
                ad: true,
                videoUrl: banner,
                href: this.banners.href,
                width: AdSvc.getWidth(),
                height: (AdSvc.getWidth() / 290 * 242)
            };
            var position = _.random(projects.length - 1);
            projects.splice(position, 0, ad);
        }
    };
    AdSvc.getWidth = function () {
        if (!AdSvc.width) {
            AdSvc.width = options.handHeld ? AdSvc.mobileWidth() : AnimatronProjectsSvc_1.AnimatronProjects.computedWidth;
        }
        return AdSvc.width;
    };
    AdSvc.chooseBanners = function () {
        switch (options.user.subscriptionDetails.studio.displayName.toLowerCase()) {
            case 'guest':
                return AdSvc.SignupBanners;
            case 'free':
            case 'starter':
                return AdSvc.UpgradeBanners;
            default:
                return null;
        }
    };
    AdSvc.mobileWidth = function () {
        var projects = document.querySelector('.projects');
        return projects.offsetWidth || AnimatronProjectsSvc_1.AnimatronProjects.computedWidth;
    };
    return AdSvc;
}());
AdSvc.UpgradeBanners = {
    href: '/settings/subscription',
    videoUrls: [
        'https://videos.animatron.com/banners/upgrade',
        'https://videos.animatron.com/banners/upgrade_screens'
    ]
};
AdSvc.SignupBanners = {
    href: '/signup',
    videoUrls: [
        'https://videos.animatron.com/banners/join_the_magic_banner',
        'https://videos.animatron.com/banners/as_easy_as_that'
    ]
};
exports.AdSvc = AdSvc;


/***/ }),

/***/ "XKv6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/week7_033b0421ff8c67019dd86e0ea4fe2bfd.html";

/***/ }),

/***/ "XMqc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/13.svg";

/***/ }),

/***/ "XaSg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var lazy_modules_1 = __webpack_require__("bUzP");
var underscore_extensions_1 = __webpack_require__("R0iF");
var ProjectPageCtrl = (function () {
    ProjectPageCtrl.$inject = ["$scope", "$rootScope", "$timeout", "$http", "$stateParams", "$state", "$location", "$filter", "TranslateSvc", "TagsSvc", "AdminSvc", "httpProjectSvc", "ProjectAugmenter", "ProjectModalSvc", "BackendSvc", "AuthenticationSvc", "$q"];
    function ProjectPageCtrl($scope, $rootScope, $timeout, $http, $stateParams, $state, $location, $filter, TranslateSvc, TagsSvc, AdminSvc, httpProjectSvc, ProjectAugmenter, 
        // private upgradeOneProjectSvc: UpgradeOneProjectSvc,
        ProjectModalSvc, BackendSvc, AuthenticationSvc, $q) {
        var _this = this;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$http = $http;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$location = $location;
        this.$filter = $filter;
        this.TranslateSvc = TranslateSvc;
        this.TagsSvc = TagsSvc;
        this.AdminSvc = AdminSvc;
        this.httpProjectSvc = httpProjectSvc;
        this.ProjectAugmenter = ProjectAugmenter;
        this.ProjectModalSvc = ProjectModalSvc;
        this.BackendSvc = BackendSvc;
        this.AuthenticationSvc = AuthenticationSvc;
        this.$q = $q;
        this.animatronPublish = lazy_modules_1.animatronPublish;
        this.animatronProjectPreviewPicker = lazy_modules_1.animatronProjectPreviewPicker;
        this.animatronUpgrade = lazy_modules_1.animatronUpgrade;
        this.animatronHtml5Offline = lazy_modules_1.animatronHtml5Offline;
        this.projectDeferred = this.$q.defer();
        this.projectPromise = this.projectDeferred.promise;
        /** created in projectPageCanvasDirective */
        this.player = this.$q.resolve(null);
        this.editTagsMode = false;
        this.twoPlayers = this.$location.search().twoPlayers;
        var destroy = $scope.$watch(function () { return _this.$stateParams.projectId; }, function (id) {
            if (id) {
                _this.init();
                destroy();
            }
        });
    }
    ProjectPageCtrl.prototype.init = function () {
        var _this = this;
        this.$scope.projectExist = true;
        this.$scope.busy = true;
        this.$scope.staffUrl = this.$stateParams.staff;
        this.$scope.staffButtons = options.user.staff || this.$stateParams.staff;
        this.$scope.isProduction = true;
        this.$scope.authSvc = this.AuthenticationSvc;
        this.$rootScope.$watch('user', function (user) { return _this.$scope.user = user; });
        var headers = {};
        if (options.user.hash.length > 0) {
            headers['Animatron-Security-Token'] = options.user.hash;
        }
        this.$scope.tagPattern = options.user.staff ? '^[!0-9a-zA-Z _\'"-]+$' : '^[0-9a-zA-Z가-힣 _\'"-]+$';
        var handleProject = function (project) {
            _this.$scope.projectLoaded = true;
            _this.$scope.busy = false;
            if (!project || underscore_extensions_1.Utils.isApiError(project)) {
                var params = underscore_extensions_1.Utils.toParams({ title: 'Oh no, bad luck!', description: 'The requested project has not been found.' });
                location.href = underscore_extensions_1.Utils.getWebsiteUrl() + "error?" + params;
                return;
            }
            _this.$rootScope.setTitle('project.title', project.name);
            _this.ProjectAugmenter(project);
            _this.project = _this.$scope.project = project;
            _this.projectDeferred.resolve(project);
            var Admin = options.user.subscriptionDetails.studio.features.Admin;
            _this.$scope.canEditTags = project.isOwner || (Admin && Admin.canCreateSuperTags);
            if (_this.$scope.canEditTags) {
                _this.$scope.tagsSvc = _this.TagsSvc;
            }
            var minWidth = 640;
            _this.projectSizes = _.chain([320, 640, 720, 1080, 1650, 1920, 2048, project.width])
                .uniq()
                .sortBy()
                .value();
            _this.sizes = { projectSize: _this.$location.search().width || _this.$location.search().w || Math.max(project.width, minWidth) };
            _this.$scope.adminSvc = new _this.AdminSvc(_this.$scope.project);
        };
        var projId = this.$stateParams.projectId;
        var findProj = function () {
            if (options.project && options.project.id === projId) {
                return options.project;
            }
            return _this.$stateParams.project; //nullable
        };
        var foundProject = findProj();
        if (foundProject) {
            this.$scope.$watch(function () { return _this.project; }, function (p) { return _.extend(_this.$stateParams.project, p); }, true);
            handleProject(foundProject);
        }
        if (!foundProject || !foundProject.author) {
            var url = options.apiDomain + '/project/' + projId;
            this.$http.get(url, { headers: headers })
                .then(function (r) { return handleProject(r.data); })
                .catch(handleProject);
        }
        this.$scope.showAddTagsBtn = function () { return _this.$scope.canEditTags && !_this.editTagsMode && _.isEmpty(_this.$scope.project.tags); };
        this.$scope.toggleEditMode = function () {
            _this.$timeout(function () {
                if (_this.$scope.canEditTags) {
                    _this.editTagsMode = !_this.editTagsMode;
                    setTimeout(function () {
                        var tagsInput = document.querySelector('.tags input');
                        if (_this.editTagsMode && tagsInput) {
                            tagsInput.focus();
                        }
                    }, 0);
                }
            });
        };
        this.$scope.removeProject = function () { return _this.$timeout(function () {
            _this.httpProjectSvc
                .removeProject(_this.$scope.project.id)
                .then(function () {
                if (_this.ProjectModalSvc.projectModalShown) {
                    _this.ProjectModalSvc.projectModalShown = false;
                }
                else {
                    _this.$state.go('home');
                }
            });
        }); };
        var updateRequest = function (field, newVal) {
            return _this.BackendSvc.getServerUrl(_this.$scope.project).then(function (serverUrl) {
                var data = (_a = {}, _a[field] = newVal, _a);
                var u = serverUrl + ("/project/update/meta/" + _this.$scope.project.id);
                return _this.$http.put(u, data, { headers: headers });
                var _a;
            });
        };
        var setupFieldWatch = function (field, callback) {
            _this.$scope.$watch("project." + field, function (newVal, old) {
                if (_.isUndefined(newVal))
                    return;
                var sanitized = _this.$filter('stripTags')(newVal);
                if (newVal === old || sanitized === old || _.isUndefined(old))
                    return;
                updateRequest(field, sanitized);
                if (callback)
                    callback(sanitized);
            });
        };
        setupFieldWatch('description');
        setupFieldWatch('name', function (val) {
            var projSelector = document.getElementById(_this.$scope.project.id);
            if (projSelector) {
                var nameSelector = angular.element(projSelector.querySelector('.project-name'));
                nameSelector.html(val);
                nameSelector.attr('title', val);
            }
        });
        this.$scope.duplicateProject = function () {
            _this.$scope.adminSvc.duplicateProject()
                .then(function () { return _.notification.showSuccess(_this.TranslateSvc.get('wave.video.copy.alert')); })
                .catch(function () { return _.notification.showError(_this.TranslateSvc.get('wave.video.copy.error')); });
        };
    };
    // TODO refactor, shown is not used, passing foreign scope is a sign of a bad design
    // public upgradeShown = (foreignScope: any, shown: boolean) => {
    //     foreignScope.upgrade = {
    //         project: true,
    //         currentPrice: 500,
    //         monthPrice: 500,
    //         yearPrice: 2000,
    //         foreverPrice: 5000,
    //         projectId: this.$scope.project.id
    //     };
    //     foreignScope.upgradeModal = {chosen: true};
    // };
    //
    // setUpgradeProject(project: anm.Project) {
    //     this.upgradeOneProjectSvc.setUpgradeProject(project);
    // }
    ProjectPageCtrl.prototype.restore = function () {
        var _this = this;
        this.$http.get(options.apiDomain + '/project/undelete/' + this.$scope.project.id, { headers: options.headers })
            .then(function () {
            _.notification.showSuccess(_this.$rootScope.t('project.restore.success'));
        });
    };
    return ProjectPageCtrl;
}());
exports.ProjectPageCtrl = ProjectPageCtrl;
module_1.default.component('projectPage', {
    controllerAs: 'ProjectPageCtrl',
    controller: ProjectPageCtrl,
    templateUrl: __webpack_require__("Hgg4")
});


/***/ }),

/***/ "Xo4n":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/subscription-credit-info_65a2b96ff0ce0b27464a8b568f35a763.css";

/***/ }),

/***/ "XrJM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var LightLanding = (function () {
    function LightLanding() {
    }
    LightLanding.prototype.$onInit = function () {
        this.previewUrl = __webpack_require__("0zt+")("./" + this.data.preview);
    };
    return LightLanding;
}());
module_1.default.component('lightLanding', {
    bindings: {
        data: '<'
    },
    controller: LightLanding,
    templateUrl: __webpack_require__("FnqE")
});


/***/ }),

/***/ "Xy+x":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/pagination_dd456ddf66f27a9f93bab28d06e78227.css";

/***/ }),

/***/ "Y8iI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var SearchText = (function () {
    SearchText.$inject = ["$element"];
    function SearchText($element) {
        this.$element = $element;
        this.hideClassName = 'ng-hide';
    }
    SearchText.prototype.$onChanges = function (onChangesObj) {
        var _this = this;
        if (onChangesObj.searchText.isFirstChange())
            return;
        var el = this.$element[0];
        this.searchText = this.searchText.toLocaleLowerCase();
        if (this.searchElement) {
            this.elements = el.querySelectorAll(this.searchElement);
            var isElements = !!_.filter(this.elements, function (el) { return _this.check(el); }).length;
            this.hideEl(el, !isElements);
        }
        else {
            this.check(el);
        }
    };
    SearchText.prototype.check = function (el) {
        var text = el.innerText.toLocaleLowerCase();
        var matched = !this.searchText || text.includes(this.searchText);
        this.hideEl(el, !matched);
        return matched;
    };
    SearchText.prototype.hideEl = function (el, isHide) {
        if (isHide) {
            el.classList.add(this.hideClassName);
        }
        else {
            el.classList.remove(this.hideClassName);
        }
    };
    return SearchText;
}());
module_1.default.directive('searchText', function () { return ({
    restrict: 'A',
    bindToController: {
        searchText: '<',
        searchElement: '@?'
    },
    controller: SearchText
}); });


/***/ }),

/***/ "YAt/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var SmoothScroll_1 = __webpack_require__("OSKg");
module_1.default.directive('scrollTo', function () {
    return function (scope, element, attrs) { return angular.element(function () {
        var scrollSvc = new SmoothScroll_1.SmoothScroll(document.getElementById(attrs.scrollTo));
        element.on('click', function () { return scrollSvc.scroll(); });
    }); };
});


/***/ }),

/***/ "YYsT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var domainProductMap = {
    'localhost:3000': 'WAVE',
    'localhost:3005': 'WAVE',
    'wave-test.video': 'WAVE',
    'wave.video': 'WAVE',
    'animatron-test': 'STUDIO',
    'animatron': 'STUDIO'
};
exports.default = function (domain) {
    return Object.keys(domainProductMap)
        .filter(function (key) { return domain.includes(key); })
        .map(function (key) { return domainProductMap[key]; })[0];
};


/***/ }),

/***/ "YeFr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var underscore_extensions_1 = __webpack_require__("R0iF");
var modalDialogDirective_1 = __webpack_require__("a8RW");
var AffiliatePopup = (function () {
    AffiliatePopup.$inject = ["$rootScope", "affiliateSvc"];
    function AffiliatePopup($rootScope, affiliateSvc) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.affiliateSvc = affiliateSvc;
        this.discount = 10;
        this.signupUrl = "/" + underscore_extensions_1.Utils.getProduct().toLowerCase() + "/signup";
        this.canShow = true;
        this.delayHandlerScroll = _.noop;
        this.affiliateSvc.isTapAffiliate() && this.showPopups();
        this.$rootScope.$on('$stateChangeSuccess', function (e, to) {
            _this.canShow = to.name !== 'wave-signup';
            _this.closeBigPopup();
        });
    }
    AffiliatePopup.prototype.closeBigPopup = function () {
        this.bigModalShown = true;
        this.affModalShow = false;
    };
    AffiliatePopup.prototype.closeBottomPopup = function () {
        document.removeEventListener('scroll', this.delayHandlerScroll);
        this.affModalBottomShow = false;
    };
    AffiliatePopup.prototype.showPopups = function () {
        var _this = this;
        setTimeout(function () { return _this.affModalShow = _this.canShow; }, 5 * 1000);
        var handlerScroll = function () {
            var _a = document.documentElement, scrollHeight = _a.scrollHeight, offsetHeight = _a.offsetHeight, scrollTop = _a.scrollTop;
            var isBottom = scrollTop >= scrollHeight - offsetHeight;
            _this.affModalBottomShow = isBottom && _this.bigModalShown && _this.canShow;
            if (!_this.affModalBottomShow) {
                modalDialogDirective_1.removeHtmlClass();
            }
        };
        this.delayHandlerScroll = _.debounce(handlerScroll, 50);
        document.addEventListener('scroll', this.delayHandlerScroll);
    };
    return AffiliatePopup;
}());
module_1.default.component('affiliatePopup', {
    controller: AffiliatePopup,
    templateUrl: __webpack_require__("svkI")
});


/***/ }),

/***/ "Z9aV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/2.png";

/***/ }),

/***/ "ZSj8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/template-pages-list-item_ba3ffd9eca0e5e431b6322cfd9b13f13.css";

/***/ }),

/***/ "ZawD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/7.png";

/***/ }),

/***/ "Zkh2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/11.svg";

/***/ }),

/***/ "Zou0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

ProjectAugmenter.$inject = ["$filter", "AnimatronPreviews"];
Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("jYQ6");
function ProjectAugmenter($filter, AnimatronPreviews) {
    var hasTag = function (tags, name) { return tags && tags.some(function (t) {
        return t.name.toLowerCase() === name.toLowerCase() && t.type === 'SUPER';
    }); };
    return function (project) {
        var _a = options.user.features, Admin = _a.Admin, ForeignProjectPermissions = _a.ForeignProjectPermissions;
        var foreignRead = ForeignProjectPermissions && ForeignProjectPermissions.read;
        project.name = $filter('stripTags')(project.name);
        project.description = $filter('stripTags')(project.description);
        project.author = project.author || Object.assign({}, options.anonymous);
        project.owner = project.owner || Object.assign({}, options.anonymous);
        if (project.owner.accountTypes.STUDIO === 'Guest')
            Object.assign(project.owner, options.anonymous);
        project.likes = project.likes || [];
        project.comments = project.comments || [];
        project.collaborators = (project.collaborators || []).filter(function (c) {
            return !_.contains([project.author.username, project.owner.username], c.username);
        });
        project.isCollaborator = project.collaborators && project.collaborators.some(function (c) {
            return c.username === options.user.username;
        });
        project.isOwner = project.owner && options.user.username === project.owner.username;
        project.canEdit = project.editorReadAccess || project.isOwner || foreignRead;
        project.tags = project.tags || [];
        project.staffPicked = project.staffPicked || hasTag(project.tags, 'Staff Picks');
        project.hallOfFame = project.hallOfFame || hasTag(project.tags, 'Hall-of-Fame');
        project.contest = project.contest || project.tags.some(function (t) { return t.type === 'CONTEST'; });
        if (!Admin || !Admin.canCreateSuperTags) {
            project.tags = project.tags.filter(function (t) { return t.type === 'USER'; });
        }
    };
}
module_1.default.factory('ProjectAugmenter', ProjectAugmenter);


/***/ }),

/***/ "Zx9N":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/comparison_a1e72fa591122522769c82176ace0f5a.html";

/***/ }),

/***/ "a+yw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var lazy_modules_1 = __webpack_require__("bUzP");
var LandingPages_1 = __webpack_require__("EsqY");
var RelatedPagesSwipable = (function () {
    RelatedPagesSwipable.$inject = ["$element", "$state", "$q"];
    function RelatedPagesSwipable($element, $state, $q) {
        this.$element = $element;
        this.$state = $state;
        this.$q = $q;
        this.pagesList = this.pagesList || LandingPages_1.default;
        this.currentUrl = $state.current.url;
        this.flicktyPromise = !options.handHeld ?
            $q(function (resolve) { return loadScripts([lazy_modules_1.flickityLib], resolve); }) :
            $q.reject(null);
    }
    RelatedPagesSwipable.prototype.$postLink = function () {
        var _this = this;
        this.flicktyPromise.then(function () {
            var Flickity = window.Flickity;
            new Flickity(_this.$element[0].firstChild, {
                cellSelector: '.help-item',
                prevNextButtons: true,
                wrapAround: true,
                resize: false,
                cellAlign: 'left',
                adaptiveHeight: true,
                setGallerySize: false,
                pageDots: false
            });
        });
    };
    RelatedPagesSwipable.prototype.getImageUrl = function (image) {
        return __webpack_require__("LCXO")("./" + image + ".png");
    };
    return RelatedPagesSwipable;
}());
module_1.default.component('relatedPagesSwipable', {
    bindings: {
        pagesList: '<?'
    },
    controller: RelatedPagesSwipable,
    templateUrl: __webpack_require__("kmnB")
});


/***/ }),

/***/ "a8RW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var underscore_extensions_1 = __webpack_require__("R0iF");
exports.removeHtmlClass = function () { return document.documentElement.classList.remove('modal-shown'); };
module_1.default.directive('modalDialog', ["$timeout", "$rootScope", "$compile", "$animate", "PlayerSvc", function ($timeout, $rootScope, $compile, $animate, PlayerSvc) {
    var animationClass = 'animation';
    return {
        restrict: 'EA',
        scope: {
            show: '=',
            isScroll: '<?',
            outside: '<',
            dialogTitle: '@',
            onClose: '&?',
            onClickOutside: '&?',
            modalUrl: '@',
            additionalClasses: '@',
            onChange: '&?',
            disableClickOutside: '=?',
            directive: '@'
        },
        transclude: true,
        templateUrl: __webpack_require__("Rium"),
        link: function (scope, element, attrs, ctrl, transclude) {
            var _this = this;
            var modalEl;
            var directiveScope = scope.$new(true);
            var container = scope.outside ? angular.element(document.querySelector('.wrapper')) : element;
            var modalTemplate = element[0].firstElementChild;
            element[0].removeChild(element[0].firstElementChild);
            var appendModal = function () {
                modalEl = $compile(angular.copy(modalTemplate))(scope);
                container.append(modalEl);
            };
            var close = function () { return animationClose(function () {
                if (!attrs.hasOwnProperty('dontAutoClose'))
                    scope.show = false;
                if (_.isFunction(scope.onClickOutside))
                    scope.onClickOutside();
                _.isFunction(scope.onClose) && scope.onClose();
                exports.removeHtmlClass();
                modalEl.remove();
                $rootScope.$emit('modal:close');
            }); };
            var stateChangeSuccessOff = $rootScope.$on('$stateChangeStart', function () {
                exports.removeHtmlClass();
            });
            scope.$on('$destroy', function () {
                stateChangeSuccessOff();
                modalEl && modalEl.remove();
            });
            scope.closeButton = typeof attrs.closeButton === 'string';
            var animatedEl = function (f) { return modalEl[0] && f(modalEl[0]); };
            var animationClose = function (callback) {
                var onceExecuted = _.once(callback).bind(_this);
                animatedEl(function (el) {
                    el.addEventListener('transitionend', function (e) { return scope.$apply(function () { return onceExecuted(); }); });
                    underscore_extensions_1.Utils.rAF(function () { return el.classList.remove(animationClass); });
                });
            };
            scope.includeLoaded = function () { return underscore_extensions_1.Utils.rAF(function () { return animatedEl(function (e) { return e.classList.add(animationClass); }); }); };
            scope.hideModal = function (e) {
                var target = e.target;
                if ((!scope.disableClickOutside && target === modalEl[0].querySelector('.ng-modal-overlay'))
                    || target === modalEl[0].querySelector('.ng-modal-close')) {
                    if (!attrs.hasOwnProperty('dontAutoClose')) {
                        scope.show = false;
                    }
                    else {
                        close();
                    }
                    e.stopPropagation();
                    e.preventDefault();
                }
            };
            if (!scope.disableClickOutside) {
                var isInput_1 = function () { return document.activeElement.getAttribute('contenteditable')
                    || document.activeElement.tagName.toLowerCase() === 'input'; };
                underscore_extensions_1.Utils.scopedEvent('keydown', scope, function (e) {
                    if (scope.show && (e.keyCode || e.which) === 27 && !isInput_1()) {
                        close();
                    }
                }, document, true);
            }
            scope.$watch('show', function (newVal, oldVal) {
                if (options.isPhantom)
                    return;
                directiveScope.$destroy();
                if (angular.isFunction(scope.onChange) && scope.onChange()) {
                    scope.onChange()(newVal, oldVal);
                }
                if (!newVal && oldVal) {
                    close();
                }
                else if (newVal && !scope.modalUrl) {
                    document.documentElement.classList.add('modal-shown');
                    appendModal();
                    $rootScope.$emit('modal:show');
                    if (scope.directive) {
                        directiveScope = scope.$new(true);
                        var compiled = $compile(document.createElement(scope.directive))(directiveScope);
                        $animate.enter(compiled, null, modalEl.find('transclude-directive')).then(function () {
                            $timeout(function () { return scope.includeLoaded(); });
                        });
                    }
                    else {
                        transclude(function (el) {
                            angular.element(modalEl[0].querySelector('.ng-modal-dialog-content')).append(el);
                            $timeout(function () { return scope.includeLoaded(); });
                        });
                    }
                }
                !_.isUndefined(newVal) && togglePlayers(newVal);
            });
            function togglePlayers(modalOpened) {
                PlayerSvc.instances().forEach(function (p) {
                    if (modalOpened && p.isPlaying()) {
                        p.pause();
                        p._pauseBecauseOfModal = true;
                    }
                    else if (!modalOpened && p._pauseBecauseOfModal) {
                        p._pauseBecauseOfModal = false;
                        p.play();
                    }
                });
            }
        }
    };
}]);


/***/ }),

/***/ "a8i3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/ko_dffd90e9e2bd67177207b41a3ba9eabf.json";

/***/ }),

/***/ "aLLS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var SpinnerSvc_1 = __webpack_require__("pPBV");
module_1.default.directive('toggleClass', function () {
    return function (scope, element, attrs) {
        var className = attrs.toggleClass, classList = element[0].classList, handlerClickOutside = function (e) {
            document.body.removeEventListener('click', handlerClickOutside, true);
            if (element[0] !== e.target) {
                classList.remove(className);
            }
        }, handlerClickOnElement = function () {
            if (classList.contains(className)) {
                classList.remove(className);
            }
            else {
                classList.add(className);
                document.body.addEventListener('click', handlerClickOutside, true);
            }
        };
        element[0].addEventListener('click', handlerClickOnElement);
        scope.$on('$destroy', function () {
            element[0].removeEventListener('click', handlerClickOnElement);
            document.body.removeEventListener('click', handlerClickOutside, true);
        });
    };
});
module_1.default.directive('disableTouch', function () { return function (scope, element) {
    return element.on('touchstart', function (event) { return event.preventDefault(); });
}; });
module_1.default.directive('eatClick', function () { return function (scope, element) {
    return element.on('click', function (event) { return event.preventDefault(); });
}; });
module_1.default.directive('plainClick', ["$parse", function ($parse) {
    return function (scope, element, attrs) {
        var fn = $parse(attrs.plainClick, null, true);
        element.on('click', function (e) { return scope.$apply(function () { return fn(scope, { $event: e }); }); });
    };
}]);
module_1.default.directive('staticInclude', ["$compile", "$templateRequest", function ($compile, $templateRequest) {
    return function (scope, element, attrs) {
        $templateRequest(attrs.staticInclude || attrs.src).then(function (response) {
            var contents = element.html(response).contents();
            $compile(contents)(scope);
        });
    };
}]);
module_1.default.component('loadingSpin', {
    template: "<div id=\"loading-spin\">\n                <img class=\"spin\" ng-src=\"" + __webpack_require__("5zD6") + "\" width=\"224\" height=\"224\"/>\n               </div>"
});
module_1.default.component('spinner', {
    template: (function () {
        return "<div class=\"spinner\">" + new Array(13).join('<div class="spinner-blade"></div>') + "</div>";
    })()
});
module_1.default.component('loaderHorizontal', {
    template: "<div class=\"loader-horizontal\">\n                    <div class=\"bounce1\"></div>\n                    <div class=\"bounce2\"></div>\n                    <div class=\"bounce3\"></div>\n               </div>"
});
module_1.default.directive('initScope', function () { return ({
    priority: 10000,
    link: function (scope, element, attrs) {
        var expressions = attrs.initScope.split(';');
        expressions.forEach(function (exp) {
            return scope.$watch(exp.split('=')[1], function () {
                return scope.$eval(attrs.initScope);
            });
        });
    }
}); });
module_1.default.directive('checkAutofill', ["$interval", function ($interval) {
    return function (scope, element) {
        var intervalId = $interval(function () {
            element.triggerHandler('input').triggerHandler('change').triggerHandler('keydown');
        }, 250);
        scope.$on('$destroy', function () { return $interval.cancel(intervalId); });
    };
}]);
var model = function (name, link) {
    return module_1.default
        .directive(name, function () { return ({ require: 'ngModel', link: link }); });
};
model('uppercase', function (scope, element, attrs, ngModel) {
    ngModel.$parsers.unshift(function (input) { return input ? input.toUpperCase() : ''; });
    element[0].style.textTransform = 'uppercase';
});
model('stringToNumber', function (scope, element, attrs, ngModel) {
    ngModel.$parsers.push(function (value) { return '' + value; });
    ngModel.$formatters.push(function (value) { return parseInt(value, 10); });
});
module_1.default.directive('lazyIf', ["$animate", "$compile", function ($animate, $compile) {
    return {
        restrict: 'A',
        scope: false,
        terminal: true,
        priority: 1000,
        compile: function (element, attrs) {
            var content = element[0].innerHTML;
            element.html('');
            return function (scope) {
                var unwatch = scope.$watch(attrs.lazyIf, function (value) {
                    if (value) {
                        element.append(content);
                        element.removeAttr('lazy-if');
                        $animate.enter($compile(element)(scope), null, element).then(function () {
                            unwatch();
                            content = null;
                        });
                    }
                });
            };
        }
    };
}]);
//works only in ProjectPage
module_1.default.directive('lazyButton', ["$compile", "$parse", "$location", "$ocLazyLoad", function ($compile, $parse, $location, $ocLazyLoad) {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            module: '=',
            onShown: '=?',
            onClick: '&?'
        },
        link: function (scope, element, attr) {
            scope.shown = false;
            scope.title = attr.btnName;
            scope.enable = _.once(function () {
                SpinnerSvc_1.default.show();
                scope.loading = true;
                var module = _.isFunction(scope.module) ? scope.module() : scope.module;
                module.then(function (m) { return $ocLazyLoad.load(m); }).then(function () {
                    scope.$watch(function () { return scope.$parent.project; }, function (p) {
                        p && $compile(element[0].querySelector('ng-transclude').firstElementChild)(scope);
                    });
                    scope.loading = false;
                    SpinnerSvc_1.default.hide();
                });
            });
            if ($location.search()[attr.queryParam]) {
                scope.enable();
                scope.shown = true;
            }
            scope.show = function () {
                scope.enable();
                scope.shown = !scope.shown;
                if (_.isFunction(scope.onClick)) {
                    scope.onClick();
                }
                if (_.isFunction(scope.onShown)) {
                    scope.onShown(scope, scope.shown);
                }
            };
        },
        template: "<a href=\"#\" ng-click=\"show()\" class=\"control lazy-link\"\n                      ng-class=\"{loading:loading}\"><span class=\"title\">{{::title}}</span></a>\n                   <ng-transclude></ng-transclude>"
    };
}]);
module_1.default.filter('startFrom', function () { return function (input, start) { return input.slice(parseInt(start, 10)); }; });
module_1.default.directive('focusMe', function () { return function (scope, element) { return new Promise(function () { return element[0].focus(); }); }; });
module_1.default.directive('unFocusMe', function () { return function (scope, element, attr) {
    return scope.$watch(function () { return scope.$eval(attr.unFocusMe); }, function (a) { return a && element[0].blur(); });
}; });
module_1.default.directive('modelChange', function () { return ({
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attr, ctrl) {
        scope.$watch(function () { return ctrl.$viewValue; }, function () { return scope.$eval(attr.modelChange); });
    }
}); });
module_1.default.directive('translateModel', ["TranslateSvc", function (TranslateSvc) { return ({
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attr, ctrl) {
        ctrl.$formatters.push(function (s) { return s && s.split(',').map(function (v) { return TranslateSvc.get(v.trim()); }).join(', '); });
    }
}); }]);
module_1.default.directive('typer', ["TranslateSvc", function (TranslateSvc) { return ({
    scope: { typer: '=' },
    link: function (scope, element) {
        var n = scope.typer.length;
        var current = 0;
        var id = null;
        var changeText = function () {
            element[0].innerHTML = '';
            var letters = TranslateSvc.get(scope.typer[current++ % n] + '.tab').split('');
            var type = function () {
                element[0].innerHTML += letters.shift();
                if (letters.length > 0) {
                    id = setTimeout(function () { return type(); }, 40 + Math.round(Math.random() * 30));
                }
                else {
                    id = setTimeout(function () { return changeText(); }, 2000);
                }
            };
            type();
        };
        changeText();
        scope.$on('$destroy', function () { return clearTimeout(id); });
    }
}); }]);
module_1.default.directive('longText', ["TranslateSvc", function (TranslateSvc) { return ({
    scope: {
        longText: '=',
        longTextCb: '&?'
    },
    link: function (scope, element) {
        setTimeout(function () {
            var len = element.text().length;
            if (scope.longText < len)
                scope.longTextCb();
        }, 0);
    }
}); }]);


/***/ }),

/***/ "aOC8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var commonLinks_1 = __webpack_require__("eE93");
var Header = (function () {
    Header.$inject = ["AuthenticationSvc"];
    function Header(AuthenticationSvc) {
        this.AuthenticationSvc = AuthenticationSvc;
        this.links = commonLinks_1.default('ANY');
    }
    return Header;
}());
module_1.default.component('anmHeader', {
    controller: Header,
    templateUrl: __webpack_require__("vuk9")
});


/***/ }),

/***/ "aRaM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/13.png";

/***/ }),

/***/ "aTCW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/wave-template-item_743c4039a4836d556ea5daf2ea0eea69.css";

/***/ }),

/***/ "aY29":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/en_a8acef468ed08886a31c80edfcb59a27.json";

/***/ }),

/***/ "acIy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/project-upgrade_d4b39416723f49cc9c6d3f75e057570b.css";

/***/ }),

/***/ "aiHC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/m-any-landing_9ebaba559c8d82a938f6e8d15a0533df.css";

/***/ }),

/***/ "akEf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/banner/blog.png";

/***/ }),

/***/ "anIN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/3.svg";

/***/ }),

/***/ "awAO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var module_1 = __webpack_require__("jYQ6");
var intercom_1 = __webpack_require__("P28g");
var CookieSettings_1 = __webpack_require__("wz+r");
var underscore_extensions_1 = __webpack_require__("R0iF");
exports.USER_LOGOUT = 'user:logout';
exports.USER_UPDATE_SUCCESS = 'website/user/updated';
var AuthenticationSvc = (function () {
    AuthenticationSvc.$inject = ["$rootScope", "$state", "$q", "$timeout", "$location", "$log", "$cacheFactory", "analyticSvc", "affiliateSvc", "ipCookie", "LocalStorageSvc", "HttpSvc", "NewsSvc"];
    function AuthenticationSvc($rootScope, $state, $q, $timeout, $location, $log, $cacheFactory, analyticSvc, affiliateSvc, ipCookie, LocalStorageSvc, HttpSvc, NewsSvc) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$q = $q;
        this.$timeout = $timeout;
        this.$location = $location;
        this.$log = $log;
        this.$cacheFactory = $cacheFactory;
        this.analyticSvc = analyticSvc;
        this.affiliateSvc = affiliateSvc;
        this.ipCookie = ipCookie;
        this.LocalStorageSvc = LocalStorageSvc;
        this.HttpSvc = HttpSvc;
        this.NewsSvc = NewsSvc;
        this.animatronCookieName = '_animatronauth';
        this.signupRedirectPropName = 'signupRedirectUrl';
        this.loginRedirect = '';
        this.loggedIn = false;
        this.loaded = false;
        this.loginRedirectMessage = '';
        this.signupModalShown = false;
        this.loginModalShown = false;
        this.lastUpdated = _.now();
        this.isCookieEnabled = _.once(function () {
            var enabled;
            var checkerCookieName = '__animatron_check_cookie_enabled';
            _this.ipCookie(checkerCookieName, 'isEnabled');
            enabled = 'isEnabled' === _this.ipCookie(checkerCookieName);
            _this.ipCookie.remove(checkerCookieName);
            return enabled;
        });
        $rootScope.updateUser = this.updateUser;
        $timeout(function () { return $rootScope.$on('$locationChangeStart', function () {
            _this.loginRedirect = '';
            _this.closeModals();
        }); });
    }
    AuthenticationSvc.prototype.setUserGlobals = function (user) {
        var getProduct = function () {
            var defaultProducts = 'studio';
            var products = ['studio', 'wave'];
            var currentProduct = underscore_extensions_1.Utils.getProduct().toLowerCase();
            return products.includes(currentProduct)
                ? currentProduct
                : defaultProducts;
        };
        user.accountTypes = {};
        user.features = user.subscriptionDetails[getProduct()].features;
        user.staff = user.subscriptionDetails[getProduct()].name === 'Staff' || user.subscriptionDetails[getProduct()].name === 'Jedi';
        user.meta = user.meta || {};
        user.accountTypes.STUDIO = user.subscriptionDetails.studio.displayName;
        user.accountTypes.WAVE = user.subscriptionDetails.wave.displayName;
        user.isStripe = function () {
            var _a = user.subscriptionDetails[getProduct()], hasStripeSubscription = _a.hasStripeSubscription, hasStripeUser = _a.hasStripeUser;
            return hasStripeSubscription || hasStripeUser;
        };
        user.stripeKey = function () { return user.zoneCode === 'kr' ? options.stripePubKeyKr : options.stripePubKey; };
        this.$rootScope.user = user;
        options.user = user;
        options.headers = { 'Animatron-Security-Token': user.hash };
        this.NewsSvc.onUserChanged(user);
        this.loaded = true;
        return user;
    };
    AuthenticationSvc.prototype.setUser = function (user, token) {
        var _this = this;
        return this.$timeout(function () {
            _this.loggedIn = true;
            _this.setSubscription(user);
            user.hash = token;
            user.anonymous = user.anonymous || user.username === 'Anonymous';
            if (user.staff) {
                options.debug = true;
            }
            if (window.Raven) {
                Raven.setUserContext({
                    id: user.username,
                    email: user.email,
                    subscription: user.subscriptionDetails.studio.displayName
                });
            }
            _this.setUserGlobals(user);
            intercom_1.default.setUser(user);
            _this.$rootScope.$emit(exports.USER_UPDATE_SUCCESS);
            _this.LocalStorageSvc.set('animatron:secure:user', user);
            return user;
        });
    };
    AuthenticationSvc.prototype.extendUser = function (newProps) {
        this.$rootScope.user = angular.merge(options.user, newProps);
        this.LocalStorageSvc.set('animatron:secure:', options.user);
        this.notifyUserChange();
    };
    AuthenticationSvc.prototype.setAnonymous = function () {
        var _this = this;
        this.loggedIn = false;
        intercom_1.default.setAnonymous();
        ['user', 'persist:auth', 'persist:user'].forEach(function (item) {
            return _this.LocalStorageSvc.remove(item);
        });
        return this.$timeout(function () { return _this.setUserGlobals(options.anonymous); });
    };
    AuthenticationSvc.prototype.getUser = function (update) {
        var userCookieIsPresent = this.ipCookie(this.animatronCookieName);
        var cachedUser = this.LocalStorageSvc.get('animatron:secure:user');
        if (userCookieIsPresent && cachedUser) {
            if (update) {
                this.updateUser();
            }
            return this.setUser(cachedUser, cachedUser.hash);
        }
        else {
            return this.updateUser();
        }
    };
    AuthenticationSvc.prototype.updateUser = function () {
        var _this = this;
        var deferred = this.$q.defer();
        var token = this.ipCookie(this.animatronCookieName);
        options.headers = { 'Animatron-Security-Token': token || '' };
        if (token) {
            this.HttpSvc('profile').secureGet().then(function (r) { return r.data; }).then(function (user) {
                _this.lastUpdated = _.now();
                if (underscore_extensions_1.Utils.isUser(user)) {
                    _this.setUser(user, token).then(deferred.resolve);
                }
                else {
                    _this.clearCookies();
                    deferred.resolve(_this.setAnonymous());
                }
            });
        }
        else {
            deferred.resolve(this.setAnonymous());
        }
        return deferred.promise;
    };
    AuthenticationSvc.prototype.login = function (secureUser, loginType) {
        var _this = this;
        if (loginType === void 0) { loginType = 'Email'; }
        try {
            this.ipCookie(this.animatronCookieName, secureUser.encryptedToken, CookieSettings_1.CookieSettings.get());
            this.ipCookie.remove('_animatron_activate_pending', CookieSettings_1.CookieSettings.get());
        }
        catch (e) {
            this.$log.error('Could not set cookie', e);
        }
        secureUser.userProfile.isNew = secureUser.isNew;
        secureUser.userProfile.social = loginType.toLowerCase() !== 'email';
        return this.setUser(secureUser.userProfile, secureUser.encryptedToken).then(function () {
            _this.closeModals();
            secureUser.isNew && _this.analyticSvc.signUpSocialComplete(loginType);
            _this.analyticSvc.login(secureUser.userProfile);
            _this.$rootScope.$emit('user:login');
            _this.redirectAfterLogin();
            return secureUser;
        });
    };
    AuthenticationSvc.prototype.loginFromCookie = function () {
        var _this = this;
        return this.updateUser().then(function () { return _this.redirectAfterLogin(); });
    };
    AuthenticationSvc.prototype.loginWithCookie = function (token) {
        this.ipCookie(this.animatronCookieName, token, CookieSettings_1.CookieSettings.get());
        return this.updateUser();
    };
    AuthenticationSvc.prototype.loginOAuth = function (authToken, oauthService, product) {
        var _this = this;
        var deferred = this.$q.defer();
        var productUpper = product ? product.toUpperCase() : underscore_extensions_1.Utils.getProduct();
        var animatronProduct = productUpper === 'ANY' ? 'STUDIO' : productUpper;
        var data = {
            '@class': 'oauth',
            entry: underscore_extensions_1.Utils.getEntry(),
            authToken: authToken,
            oauthService: oauthService,
            product: animatronProduct
        };
        var headers = tslib_1.__assign({}, this.analyticSvc.getGaHeader(), this.affiliateSvc.getAffiliateHeader(), options.user.hash ? options.headers : {});
        this.HttpSvc('authenticate')
            .post(data, { headers: headers })
            .then(function (r) { return r.data; })
            .then(function (response) {
            if (underscore_extensions_1.Utils.isApiError(response)) {
                _.notification.showError(response.message);
            }
            else {
                _this.loginRedirect = 'none';
                _this.login(response, oauthService).then(deferred.resolve);
            }
        });
        return deferred.promise;
    };
    AuthenticationSvc.prototype.logout = function () {
        this.loginRedirect = '';
        this.loginRedirectMessage = '';
        this.clearCookies();
        this.analyticSvc.logout();
        this.$cacheFactory.get('$http').removeAll();
        this.$rootScope.$emit(exports.USER_LOGOUT);
        return this.setAnonymous();
    };
    AuthenticationSvc.prototype.logoutAndGoRoot = function () {
        var _this = this;
        var product = underscore_extensions_1.Utils.getProduct();
        return this.logout().then(function () {
            var waveRootPath = "https://wave" + ( true ? '' : '-test') + ".video";
            var studioRootPath = "https://www.animatron" + ( true ? '' : '-test') + ".com/studio";
            var redirectPath =  false ? '' : product === 'STUDIO' ? studioRootPath : waveRootPath;
            _this.shouldRedirect() ? location.href = redirectPath : window.history.back();
        });
    };
    AuthenticationSvc.prototype.clearCookies = function () {
        this.ipCookie.remove(this.animatronCookieName, CookieSettings_1.CookieSettings.get());
    };
    AuthenticationSvc.prototype.notifyUserChange = function () {
        if (this.isCookieEnabled) {
            this.ipCookie('_animatronchanged', 'yes', CookieSettings_1.CookieSettings.get());
        }
    };
    AuthenticationSvc.prototype.toggleLoginModal = function (redirect, message) {
        if (message === void 0) { message = ''; }
        this.loginRedirect = redirect;
        this.loginRedirectMessage = message;
        this.loginModalShown = true;
    };
    AuthenticationSvc.prototype.openSignUpPage = function (redirectUrl, params) {
        if (params === void 0) { params = {}; }
        var paramsWithRedirectUrl = params;
        if (redirectUrl) {
            this.LocalStorageSvc.set(this.signupRedirectPropName, redirectUrl);
            paramsWithRedirectUrl = tslib_1.__assign({ redirectUrl: redirectUrl }, paramsWithRedirectUrl);
        }
        underscore_extensions_1.Utils.redirectToReact("signup", undefined, paramsWithRedirectUrl);
    };
    AuthenticationSvc.prototype.activateEmailRedirect = function () {
        var url = this.LocalStorageSvc.remove(this.signupRedirectPropName);
        url && this.redirect(url);
        return !!url;
    };
    AuthenticationSvc.prototype.openLogin = function () {
        var _this = this;
        if (options.handHeld) {
            this.$state.go('login').then(function () { return _this.$timeout(function () { return _this.loginRedirect = 'back'; }); });
        }
        else {
            this.toggleLoginModal();
        }
    };
    AuthenticationSvc.prototype.closeModals = function () {
        this.signupModalShown = false;
        this.loginModalShown = false;
    };
    AuthenticationSvc.prototype.setSubscription = function (user) {
        var wave;
        var studio;
        if (_.isArray(user.subscriptionDetails)) {
            user.subscriptionDetails.forEach(function (subscription) {
                if (subscription.product === 'WAVE') {
                    wave = subscription;
                }
                else {
                    studio = subscription;
                }
            });
            user.subscriptionDetails = Object.assign({}, { wave: wave, studio: studio });
        }
    };
    AuthenticationSvc.prototype.shouldRedirect = function () {
        return !this.$location.search().noRedirect && !this.LocalStorageSvc.get('noRedirect');
    };
    AuthenticationSvc.prototype.redirect = function (url) {
        underscore_extensions_1.Utils.redirect(url, this.$location);
    };
    AuthenticationSvc.prototype.getUrlByEntry = function (entry, baseUrl) {
        return ({
            CALENDAR: baseUrl + "calendar",
            TEMPLATE: baseUrl + "video-templates"
        }[entry]);
    };
    AuthenticationSvc.prototype.getUrlByProduct = function (product, baseUrl) {
        return ({
            WAVE: baseUrl + "my-projects",
            STUDIO: baseUrl + "home"
        }[product]);
    };
    AuthenticationSvc.prototype.getLoginRedirectUrl = function (entry, product, baseUrl) {
        return entry === 'LANDING'
            ? this.getUrlByProduct(product, baseUrl)
            : this.getUrlByEntry(entry, baseUrl);
    };
    AuthenticationSvc.prototype.redirectAfterLogin = function () {
        var entry = options.user.meta.entry;
        var product = underscore_extensions_1.Utils.getProduct();
        var url = this.getLoginRedirectUrl(entry, product, '/');
        var thirdPartyRedirect = this.LocalStorageSvc.remove('_animatron_redirect_onlogin');
        if (thirdPartyRedirect) {
            location.href = thirdPartyRedirect;
        }
        else if (this.loginRedirect === 'none') {
            // do nothing
        }
        else if (this.loginRedirect === 'back') {
            window.history.back();
        }
        else if (this.loginRedirect) {
            this.redirect(this.loginRedirect);
        }
        else if (this.shouldRedirect()) {
            this.$location.path(url);
        }
    };
    return AuthenticationSvc;
}());
exports.AuthenticationSvc = AuthenticationSvc;
module_1.default.service('AuthenticationSvc', AuthenticationSvc);


/***/ }),

/***/ "b+CF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/section-company-info_7e055cf7a2face6a911c2fcb333a9559.css";

/***/ }),

/***/ "b/cW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/newsWebsite_fe9b7f77e4da0de0bc55c6bd85b426a0.css";

/***/ }),

/***/ "b1d7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var underscore_extensions_1 = __webpack_require__("R0iF");
var ContentEditable = (function () {
    ContentEditable.$inject = ["$scope", "$element", "$filter"];
    function ContentEditable($scope, $element, $filter) {
        this.$scope = $scope;
        this.$element = $element;
        this.$filter = $filter;
    }
    ContentEditable.prototype.$onInit = function () {
        var _this = this;
        if (!this.ngModel)
            return;
        var read = function () {
            var text = _this.$filter('stripTags')(_this.$element.html()
                .replace(/<br>/g, '\n')
                .replace(/&nbsp;/g, ' ')
                .replace(/&amp;/g, '&')
                .trim());
            _this.ngModel.$setViewValue(text);
        };
        this.ngModel.$render = function () { return _this.$element.html((_this.ngModel.$viewValue || '')); };
        underscore_extensions_1.Utils.scopedEvent('paste', this.$scope, function (e) {
            e.preventDefault();
            document.execCommand('insertText', false, e.clipboardData.getData('text/plain'));
        }, this.$element[0]);
        underscore_extensions_1.Utils.scopedEvent('keypress', this.$scope, function (e) {
            if (e.which === 13 && (!e.shiftKey && !e.altKey && !e.ctrlKey && !e.metaKey)) {
                e.preventDefault();
                // (<HTMLElement>document.activeElement).blur();
            }
        }, this.$element[0]);
        this.$element.on('blur keyup change', function () { return _this.$scope.$evalAsync(read); });
    };
    return ContentEditable;
}());
module_1.default.directive('contenteditable', function () { return ({
    restrict: 'A',
    bindToController: true,
    require: { ngModel: '?ngModel' },
    controller: ContentEditable
}); });


/***/ }),

/***/ "b6Iv":
/***/ (function(module, exports) {

var path = 'https://assets.animatron.com/html/projects.html';
var html = "<div class=\"projects\" ng-hide=\"UserCtrl && UserCtrl.currentTab !== 'your'\" masonry infinite-scroll=\"animatron.nextPage()\" infinite-scroll-disabled=\"animatron.shownAll || (UserCtrl && UserCtrl.currentTab !== 'your')\" infinite-scroll-distance=\"0\"> <div class=\"projects-gutter\"></div> <div class=\"projects-column-width\"></div> <masonry-brick class=\"project-item\" id=\"brick-{{::wrapped.id}}\" ng-repeat=\"wrapped in AdSvc.results track by wrapped.id\" ng-style=\"::{height:wrapped.height + 'px'}\"> <project-item ng-if=\"::wrapped.project\" project=\"wrapped.project\" is-staff-picks=\"ExploreCtrl && ExploreCtrl.isStaffPicks\" show-visibility=\"animatron.owner || animatron.foreignAccess || SearchPageCtrl\"> </project-item> <ad-banner ng-if=\"::wrapped.ad\" ad=\"wrapped\"></ad-banner> </masonry-brick> </div> <loader-horizontal ng-hide=\"animatron.shownAll || !animatron.busy\"></loader-horizontal> ";
var angular = window.angular;
var injector = angular.element(document).injector();
if (injector) {
injector.get('$templateCache').put(path, html);
} else {
angular.module('templates').run(['$templateCache', function(c) { c.put(path, html) }]);
}
module.exports = path;

/***/ }),

/***/ "bPu8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/4.svg";

/***/ }),

/***/ "bUzP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getCss = function (file) { return __webpack_require__("zwf9")("./" + file + '.less'); };
// const html = (file: string) => require('../html/' + file + '.html');
// const any = html('pricing');
// console.log(any);
var queryParams = function () {
    return _.chain(location.search.slice(1).split('&'))
        .map(function (item) { return item.split('='); }).compact().object().value();
};
var getAngular = function (lib) { return "https://cdnjs.cloudflare.com/ajax/libs/angular.js/1.6.7/angular-" + lib + ".min.js"; };
exports.playerUrl = function () {
    var search = queryParams(), version = search.pVer || (location.host.indexOf('nightly') === 0 ? 'nightly' : 'latest'), min = true, dev = !true, salt = search.pSalt === 'on' ? new Date().getTime() : options.salt;
    if (search.pMin === 'off')
        min = false;
    if (search.pMin === 'on')
        min = true;
    if (search.pDev === 'off')
        dev = false;
    if (search.pDev === 'on')
        dev = true;
    var url = "https://player" + (dev ? '-dev' : '') + ".animatron.com/" + version + "/bundle/animatron" + (min ? '.min' : '') + ".js?" + salt;
    return search.pUrl || url;
};
exports.SimpleMDEUrl = 'https://cdn.jsdelivr.net/simplemde/latest/simplemde.min.js';
exports.jqueryPaymentLib = [
    'https://cdnjs.cloudflare.com/ajax/libs/jquery/2.2.1/jquery.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/jquery.payment/1.3.2/jquery.payment.min.js'
];
exports.masonryLib = 'https://cdnjs.cloudflare.com/ajax/libs/masonry/4.1.0/masonry.pkgd.min.js';
exports.flickityLib = 'https://cdnjs.cloudflare.com/ajax/libs/flickity/2.0.10/flickity.pkgd.min.js';
exports.twitterWidgetLib = 'https://platform.twitter.com/widgets.js';
exports.fbSDKlib = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.11&appId=" + options.social.facebookApiKey;
exports.linkedinLib = '//platform.linkedin.com/in.js';
exports.googleLib = 'https://apis.google.com/js/platform.js';
exports.tapfiliateLib = '//static.tapfiliate.com/tapfiliate.js';
exports.animatronProject = [
    getCss('projects'),
    getCss('user-popup'),
    getCss('comments')
];
var angularMessages = {
    name: 'ngMessages',
    files: [getAngular('messages')]
};
exports.datePicker = function () { return Promise.resolve({
    name: 'datePicker',
    files: ['https://cdn.rawgit.com/g00fy-/angular-datepicker/8c46855bed78ff7f0b523a794c7bdaabb558d081/dist/angular-datepicker.min.js',
        'https://cdn.rawgit.com/g00fy-/angular-datepicker/8c46855bed78ff7f0b523a794c7bdaabb558d081/dist/angular-datepicker.min.css']
}); };
// Drag & Drop
exports.animatronDragDropSvc = function () { return Promise.all([__webpack_require__.e/* require.ensure */(134).then((function () {
        __webpack_require__("EhqI");
        return {
            name: 'animatronApp.DragDropSvc',
            files: []
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronDropZone = function () { return Promise.all([__webpack_require__.e/* require.ensure */(20).then((function () {
        __webpack_require__("RZfb");
        return {
            name: 'animatronApp.DropZone',
            files: []
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronDragDropSvc()]); };
exports.animatronDragItem = function () { return Promise.all([__webpack_require__.e/* require.ensure */(21).then((function () {
        __webpack_require__("9sVo");
        return {
            name: 'animatronApp.DragItem',
            files: [getCss('drag-drop/drag-item')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronDragDropSvc()]); };
// Drag & Drop end
// subscription
exports.animatronSubscriptionCouponMessagesSvc = function () { return Promise.all([__webpack_require__.e/* require.ensure */(19).then((function () {
        __webpack_require__("1Pgo");
        return {
            name: 'animatronApp.SubscriptionCouponMessagesSvc',
            files: []
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronSubscriptionMessagesSvc = function () { return Promise.all([__webpack_require__.e/* require.ensure */(128).then((function () {
        __webpack_require__("Qd8D");
        return {
            name: 'animatronApp.SubscriptionMessagesSvc',
            files: []
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronSubscriptionMessages = function () { return Promise.all([__webpack_require__.e/* require.ensure */(62).then((function () {
        __webpack_require__("usqb");
        return {
            name: 'animatronApp.SubscriptionMessages',
            files: [getCss('settings/subscription/messages/subscription-messages')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronSubscriptionMessagesSvc()]); };
exports.animatronSubscriptionSvc = function () { return Promise.all([__webpack_require__.e/* require.ensure */(129).then((function () {
        __webpack_require__("VXOl");
        return {
            name: 'animatronApp.SubscriptionSvc',
            files: []
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronSubscriptionPredictPrice = function () { return Promise.all([__webpack_require__.e/* require.ensure */(16).then((function () {
        __webpack_require__("edCO");
        return {
            name: 'animatronApp.SubscriptionPredictPriceContainer',
            files: []
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe),
    exports.animatronSubscriptionSvc(),
    exports.animatronSubscriptionTotalPrice(),
    exports.animatronSubscriptionCreditInfo(),
    exports.animatronSubscriptionCouponMessagesSvc()
]); };
exports.animatronSubscriptionCreditInfo = function () { return Promise.all([__webpack_require__.e/* require.ensure */(57).then((function () {
        __webpack_require__("J3iv");
        return {
            name: 'animatronApp.SubscriptionCreditInfo',
            files: [getCss('settings/subscription/subscription-credit-info')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronSubscriptionTotalPrice = function () { return Promise.all([__webpack_require__.e/* require.ensure */(52).then((function () {
        __webpack_require__("ZKt+");
        return {
            name: 'animatronApp.SubscriptionTotalPrice',
            files: [getCss('settings/subscription/subscription-total-price')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronSubscriptionAlert = function () { return Promise.all([__webpack_require__.e/* require.ensure */(59).then((function () {
        __webpack_require__("urJj");
        return {
            name: 'animatronApp.SubscriptionAlert',
            files: [getCss('settings/subscription/subscription-alert')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronSubscriptionBillingInfoForm = function () { return Promise.all([__webpack_require__.e/* require.ensure */(58).then((function () {
        __webpack_require__("lZW1");
        return {
            name: 'animatronApp.SubscriptionBillingInfoForm',
            files: [getCss('settings/subscription/subscription-billing-info-form')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronSubscriptionCurrentPlan = function () { return Promise.all([__webpack_require__.e/* require.ensure */(56).then((function () {
        __webpack_require__("x7II");
        return {
            name: 'animatronApp.SubscriptionCurrentPlan',
            files: [getCss('settings/subscription/subscription-current-plan')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronSubscriptionInvoiceHistoryTable = function () { return Promise.all([__webpack_require__.e/* require.ensure */(55).then((function () {
        __webpack_require__("c6SK");
        return {
            name: 'animatronApp.SubscriptionInvoiceHistoryTable',
            files: [getCss('settings/subscription/subscription-invoice-history-table')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronSubscriptionTitle = function () { return Promise.all([__webpack_require__.e/* require.ensure */(53).then((function () {
        __webpack_require__("Rkgq");
        return {
            name: 'animatronApp.SubscriptionTitle',
            files: [getCss('settings/subscription/subscription-title')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronSubscriptionPaymentDetailsEnterCard = function () { return Promise.all([__webpack_require__.e/* require.ensure */(61).then((function () {
        __webpack_require__("z6GX");
        return {
            name: 'animatronApp.SubscriptionPaymentDetailsEnterCard',
            files: [getCss('settings/subscription/payment-details/subscription-payment-details-enter-card')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronSubscriptionPaymentDetailsWithCard = function () { return Promise.all([__webpack_require__.e/* require.ensure */(60).then((function () {
        __webpack_require__("mhCG");
        return {
            name: 'animatronApp.SubscriptionPaymentDetailsWithCard',
            files: [getCss('settings/subscription/payment-details/subscription-payment-details-with-card')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronSubscriptionRouterModalsContainer = function () { return Promise.all([__webpack_require__.e/* require.ensure */(63).then((function () {
        __webpack_require__("wg/K");
        return {
            name: 'animatronApp.SubscriptionRouterModalsContainer',
            files: [getCss('settings/subscription/containers/subscription-router-modals-container')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronSubscriptionCurrentPlanContainer = function () { return Promise.all([__webpack_require__.e/* require.ensure */(65).then((function () {
        __webpack_require__("4THJ");
        return {
            name: 'animatronApp.SubscriptionCurrentPlanContainer',
            files: [getCss('settings/subscription/containers/subscription-current-plan-container')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe),
    exports.animatronSubscriptionAlert(),
    exports.animatronSubscriptionTitle(),
    exports.animatronSubscriptionCurrentPlan(),
    exports.animatronSubscriptionPaymentDetailsContainer()
]); };
exports.animatronSubscriptionInvoiceHistoryContainer = function () { return Promise.all([__webpack_require__.e/* require.ensure */(64).then((function () {
        __webpack_require__("ErNr");
        return {
            name: 'animatronApp.SubscriptionInvoiceHistoryContainer',
            files: [getCss('settings/subscription/containers/subscription-invoice-history-container')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe),
    exports.animatronSubscriptionTitle(),
    exports.animatronSubscriptionInvoiceHistoryTable()
]); };
exports.animatronSubscriptionPaymentDetailsContainer = function () { return Promise.all([__webpack_require__.e/* require.ensure */(17).then((function () {
        __webpack_require__("t1Tz");
        return {
            name: 'animatronApp.SubscriptionPaymentDetailsContainer',
            files: [getCss('settings/subscription/containers/subscription-payment-details-container')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe),
    exports.animatronSubscriptionTitle(),
    exports.animatronSubscriptionPaymentDetailsEnterCard(),
    exports.animatronSubscriptionPaymentDetailsWithCard()
]); };
exports.animatronSubscriptionPage = function () { return Promise.all([__webpack_require__.e/* require.ensure */(54).then((function () {
        __webpack_require__("tGmZ");
        return {
            name: 'animatronApp.SubscriptionPage',
            files: [getCss('settings/subscription/subscription-page')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe),
    exports.animatronUpgrade(),
    exports.animatronSubscriptionMessages(),
    exports.animatronSubscriptionCurrentPlanContainer(),
    exports.animatronSubscriptionPredictPrice(),
    exports.animatronSubscriptionRouterModalsContainer(),
    exports.animatronSubscriptionInvoiceHistoryContainer()
]); };
// subscription end
// video folder
exports.animatronVideoFolderMasonrySvc = function () { return Promise.all([__webpack_require__.e/* require.ensure */(136).then((function () {
        __webpack_require__("O2Zt");
        return {
            name: 'animatronApp.VideoFolderMasonrySvc',
            files: []
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronVideoFolderMasonryItem = function () { return Promise.all([__webpack_require__.e/* require.ensure */(137).then((function () {
        __webpack_require__("f4EO");
        return {
            name: 'animatronApp.VideoFolderMasonryItem',
            files: []
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronVideoFolderMasonrySvc()]); };
exports.animatronVideoFolderMasonry = function () { return Promise.all([__webpack_require__.e/* require.ensure */(138).then((function () {
        __webpack_require__("vZ2w");
        return {
            name: 'animatronApp.VideoFolderMasonry',
            files: [getCss('wave/folder/masonry/video-folder-masonry')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronVideoFolderMasonryItem(), exports.animatronVideoFolderMasonrySvc()]); };
exports.animatronVideoFolderItem = function () { return Promise.all([__webpack_require__.e/* require.ensure */(40).then((function () {
        __webpack_require__("lUjf");
        return {
            name: 'animatronApp.VideoFolderItem',
            files: [getCss('wave/folder/video-folder-item')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronVideoFolderBottom()]); };
exports.animatronVideoFolderName = function () { return Promise.all([__webpack_require__.e/* require.ensure */(38).then((function () {
        __webpack_require__("r/wg");
        return {
            name: 'animatronApp.VideoFolderName',
            files: []
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronVideoFolderControls = function () { return Promise.all([__webpack_require__.e/* require.ensure */(42).then((function () {
        __webpack_require__("oq3L");
        return {
            name: 'animatronApp.VideoFolderControls',
            files: []
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronVideoFolderCreateNew()]); };
exports.animatronVideoFolderCreateNew = function () { return Promise.all([__webpack_require__.e/* require.ensure */(41).then((function () {
        __webpack_require__("7Wv9");
        return {
            name: 'animatronApp.VideoFolderCreateNew',
            files: []
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronVideoFolderBottom = function () { return Promise.all([__webpack_require__.e/* require.ensure */(43).then((function () {
        __webpack_require__("DZ4g");
        return {
            name: 'animatronApp.VideoFolderBottom',
            files: [getCss('wave/folder/video-folder-bottom')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronVideoFolderMoveModalSvc(), exports.animatronVideoFolderName()]); };
exports.animatronVideoFolderMoveModalSvc = function () { return Promise.all([__webpack_require__.e/* require.ensure */(139).then((function () {
        __webpack_require__("HgTl");
        return {
            name: 'animatronApp.VideoFolderMoveModalSvc',
            files: []
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronVideoFolderMoveModal = function () { return Promise.all([__webpack_require__.e/* require.ensure */(39).then((function () {
        __webpack_require__("zMdu");
        return {
            name: 'animatronApp.VideoFolderMoveModal',
            files: [getCss('wave/folder/video-folder-move-modal')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe),
    exports.animatronVideoFolderTreeItem(),
    exports.animatronVideoFolderCreateNew(),
    exports.animatronVideoFolderMoveModalSvc()
]); };
exports.animatronVideoFolderBreadcrumb = function () { return Promise.all([__webpack_require__.e/* require.ensure */(11).then((function () {
        __webpack_require__("XyZS");
        return {
            name: 'animatronApp.VideoFolderBreadcrumb',
            files: [getCss('wave/folder/video-folder-breadcrumb')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronVideoFolderTreeItem = function () { return Promise.all([__webpack_require__.e/* require.ensure */(37).then((function () {
        __webpack_require__("RPJj");
        return {
            name: 'animatronApp.VideoFolderTreeItem',
            files: [getCss('wave/folder/video-folder-tree-item')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronVideoFolderMoveModalSvc(), exports.animatronVideoFolderName()]); };
// video folder END
exports.animatronTitleBlock = function () { return __webpack_require__.e/* require.ensure */(75).then((function () {
    __webpack_require__("dhyF");
    return {
        name: 'animatronApp.titleBlock',
        files: [getCss('landing-template/components/title-block')]
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.animatronRelationList = function () { return __webpack_require__.e/* require.ensure */(97).then((function () {
    __webpack_require__("z2E9");
    return {
        name: 'animatronApp.relationList',
        files: [getCss('landing-template/components/relation-list')]
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.animatronButtonStart = function () { return __webpack_require__.e/* require.ensure */(132).then((function () {
    __webpack_require__("q6tK");
    return {
        name: 'animatronApp.buttonStart',
        files: []
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.animatronBackground = function () { return __webpack_require__.e/* require.ensure */(133).then((function () {
    __webpack_require__("zqBo");
    return {
        name: 'animatronApp.background',
        files: [getCss('landing-template/components/background')]
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.animatronIconTextList = function () { return __webpack_require__.e/* require.ensure */(98).then((function () {
    __webpack_require__("ORkG");
    return {
        name: 'animatronApp.iconTextList',
        files: [getCss('landing-template/components/icon-text-list')]
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
// contest landing
exports.animatronContestLandingSvc = function () { return __webpack_require__.e/* require.ensure */(151).then((function () {
    __webpack_require__("PKsc");
    return {
        name: 'animatronApp.contestLandingSvc',
        files: []
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.animatronChallengesList = function () { return Promise.all([__webpack_require__.e/* require.ensure */(122).then((function () {
        __webpack_require__("y4Cf");
        return {
            name: 'animatronApp.challengesList',
            files: [getCss('contest-landing/challenges-list')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.wistiaPlayer(), exports.animatronContestGoChallengeButton(), exports.animatronContestLandingSvc()]); };
exports.animatronJudgeItem = function () { return Promise.all([__webpack_require__.e/* require.ensure */(114).then((function () {
        __webpack_require__("wskZ");
        return {
            name: 'animatronApp.judgeItem',
            files: [getCss('contest-landing/judge-item')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronContestGoChallengeButton = function () { return __webpack_require__.e/* require.ensure */(152).then((function () {
    __webpack_require__("Zu7e");
    return {
        name: 'animatronApp.contestGoChallengeButton',
        files: []
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.animatronCountdown = function () { return Promise.all([__webpack_require__.e/* require.ensure */(115).then((function () {
        __webpack_require__("RGc2");
        return {
            name: 'animatronApp.countdown',
            files: [getCss('contest-landing/countdown')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronPreRegister = function () { return Promise.all([__webpack_require__.e/* require.ensure */(110).then((function () {
        __webpack_require__("sQxT");
        return {
            name: 'animatronApp.preRegister',
            files: [getCss('contest-landing/pre-register')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronSpreadInSocial = function () { return Promise.all([__webpack_require__.e/* require.ensure */(108).then((function () {
        __webpack_require__("fKtD");
        return {
            name: 'animatronApp.spreadInSocial',
            files: [getCss('contest-landing/spread-in')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe),
    exports.animatronTwitterShareButton(),
    exports.animatronFacebookShareButton(),
    exports.animatronLinkedinShareButton(),
    exports.animatronGoogleShareButton(),
]); };
exports.animatronSponsorContactUs = function () { return Promise.all([__webpack_require__.e/* require.ensure */(109).then((function () {
        __webpack_require__("dn18");
        return {
            name: 'animatronApp.sponsorContactUs',
            files: [getCss('contest-landing/sponsor-contact-us')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronTitleShadowBlock = function () { return Promise.all([__webpack_require__.e/* require.ensure */(107).then((function () {
        __webpack_require__("ZAlP");
        return {
            name: 'animatronApp.titleShadowBlock',
            files: [getCss('contest-landing/title-shadow-block')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronParticipateSteps = function () { return Promise.all([__webpack_require__.e/* require.ensure */(112).then((function () {
        __webpack_require__("fhpi");
        return {
            name: 'animatronApp.ParticipateSteps',
            files: [getCss('contest-landing/participate-steps')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronVideoImproveSteps = function () { return Promise.all([__webpack_require__.e/* require.ensure */(105).then((function () {
        __webpack_require__("OaVY");
        return {
            name: 'animatronApp.videoImproveSteps',
            files: [getCss('contest-landing/video-improve-steps')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronBackground()]); };
exports.animatronWinPrizesList = function () { return Promise.all([__webpack_require__.e/* require.ensure */(104).then((function () {
        __webpack_require__("6bK2");
        return {
            name: 'animatronApp.winPrizesList',
            files: [getCss('contest-landing/win-prizes-list')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronWinPrizesSection = function () { return Promise.all([__webpack_require__.e/* require.ensure */(103).then((function () {
        __webpack_require__("JOsm");
        return {
            name: 'animatronApp.winPrizesSection',
            files: [getCss('contest-landing/win-prizes-section')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTitleShadowBlock(), exports.animatronContestLandingSvc()]); };
exports.animatronCountdownSection = function () { return Promise.all([__webpack_require__.e/* require.ensure */(116).then((function () {
        __webpack_require__("kts8");
        return {
            name: 'animatronApp.countdownSection',
            files: [getCss('contest-landing/countdown-section')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronCountdown(), exports.animatronTitleBlock(), exports.animatronBackground()]); };
exports.animatronContestDaysTopSection = function () { return Promise.all([__webpack_require__.e/* require.ensure */(120).then((function () {
        __webpack_require__("KAAZ");
        return {
            name: 'animatronApp.contestDaysTopSection',
            files: [getCss('contest-landing/contest-days-top-section')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTitleBlock(), exports.animatronBackground(), exports.animatronContestGoChallengeButton()]); };
exports.animatronContactUsSection = function () { return Promise.all([__webpack_require__.e/* require.ensure */(121).then((function () {
        __webpack_require__("ooS/");
        return {
            name: 'animatronApp.contactUsSection',
            files: [getCss('contest-landing/contact-us-section')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe),
    exports.animatronBackground(),
    exports.animatronPreRegister(),
    exports.animatronSponsorContactUs(),
    exports.animatronSpreadInSocial()
]); };
exports.animatronPreRegisterSection = function () { return Promise.all([__webpack_require__.e/* require.ensure */(111).then((function () {
        __webpack_require__("WCe7");
        return {
            name: 'animatronApp.preRegisterSection',
            files: [getCss('contest-landing/pre-register-section')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronPreRegister(), exports.animatronBackground()]); };
exports.animatronMediaSponsorsSection = function () { return Promise.all([__webpack_require__.e/* require.ensure */(113).then((function () {
        __webpack_require__("4CKY");
        return {
            name: 'animatronApp.mediaSponsorsSection',
            files: [getCss('contest-landing/media-sponsors-section')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronChallengesListSection = function () { return Promise.all([__webpack_require__.e/* require.ensure */(123).then((function () {
        __webpack_require__("eI7p");
        return {
            name: 'animatronApp.challengesListSection',
            files: [getCss('contest-landing/challenges-list-section')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe),
    exports.animatronTitleShadowBlock(),
    exports.animatronChallengesList(),
    exports.wistiaPlayer(),
    exports.animatronTitleShadowBlock(),
    exports.animatronContestLandingSvc(),
    exports.animatronContestGoChallengeButton(),
]); };
exports.animatronContestTextVideoSection = function () { return Promise.all([__webpack_require__.e/* require.ensure */(117).then((function () {
        __webpack_require__("n7MZ");
        return {
            name: 'animatronApp.contestTextVideoSection',
            files: [getCss('contest-landing/contest-text-video-section')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.wistiaPlayer(), exports.animatronContestGoChallengeButton()]); };
exports.animatronVideoImproveStepsSection = function () { return Promise.all([__webpack_require__.e/* require.ensure */(106).then((function () {
        __webpack_require__("Eaz9");
        return {
            name: 'animatronApp.videoImproveStepsSection',
            files: [getCss('contest-landing/video-improve-steps-section')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronVideoImproveSteps(), exports.animatronTitleShadowBlock(), exports.animatronBackground(), exports.wistiaPlayer()]); };
exports.animatronContestLanding = function () { return Promise.all([__webpack_require__.e/* require.ensure */(118).then((function () {
        __webpack_require__("2hMW");
        return {
            name: 'animatronApp.contestLanding',
            files: [getCss('contest-landing/contest-landing')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe),
    exports.animatronWinPrizesSection(),
    exports.animatronCountdownSection(),
    exports.animatronContactUsSection(),
    exports.animatronContestLandingSvc(),
    exports.animatronPreRegisterSection(),
    exports.animatronMediaSponsorsSection(),
    exports.animatronChallengesListSection(),
    exports.animatronContestDaysTopSection(),
    exports.animatronContestTextVideoSection(),
    exports.animatronVideoImproveStepsSection()
]); };
exports.animatronContestDays = function () { return Promise.all([__webpack_require__.e/* require.ensure */(119).then((function () {
        __webpack_require__("NIBi");
        return {
            name: 'animatronApp.contestDays',
            files: [getCss('contest-landing/contest-days')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe),
    exports.animatronJudgeItem(),
    exports.animatronWinPrizesSection(),
    exports.animatronContactUsSection(),
    exports.animatronParticipateSteps(),
    exports.animatronPreRegisterSection(),
    exports.animatronMediaSponsorsSection(),
    exports.animatronContestDaysTopSection(),
    exports.animatronContestTextVideoSection(),
]); };
// END contest components
exports.animatronDifferentDevices = function () { return Promise.all([__webpack_require__.e/* require.ensure */(100).then((function () {
        __webpack_require__("4ON/");
        return {
            name: 'animatronApp.differentDevices',
            files: [getCss('landing-template/components/different-devices')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronTemplatePagesListItem = function () { return Promise.all([__webpack_require__.e/* require.ensure */(78).then((function () {
        __webpack_require__("b1je");
        return {
            name: 'animatronApp.templatePagesListItem',
            files: [getCss('landing-template/components/template-pages-list-item')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronBackground()]); };
exports.animatronTemplatePagesList = function () { return Promise.all([__webpack_require__.e/* require.ensure */(77).then((function () {
        __webpack_require__("TDxI");
        return {
            name: 'animatronApp.templatePagesList',
            files: [getCss('landing-template/components/template-pages-list')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTemplatePagesListItem()]); };
exports.animatronSectionTemplatePagesList = function () { return Promise.all([__webpack_require__.e/* require.ensure */(86).then((function () {
        __webpack_require__("lMON");
        return {
            name: 'animatronApp.sectionTemplatePagesList',
            files: [getCss('landing-template/components/sections/section-template-pages-list')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTemplatePagesList()]); };
exports.animatronSectionBackgroundText = function () { return Promise.all([__webpack_require__.e/* require.ensure */(96).then((function () {
        __webpack_require__("bep0");
        return {
            name: 'animatronApp.sectionBackgroundText',
            files: [getCss('landing-template/components/sections/section-background-text')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTitleBlock(), exports.animatronBackground()]); };
exports.animatronSectionBitmap = function () { return Promise.all([__webpack_require__.e/* require.ensure */(95).then((function () {
        __webpack_require__("YS9K");
        return {
            name: 'animatronApp.sectionBitmap',
            files: [getCss('landing-template/components/sections/section-bitmap')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTitleBlock()]); };
exports.animatronSectionFeedback = function () { return Promise.all([__webpack_require__.e/* require.ensure */(91).then((function () {
        __webpack_require__("rZo5");
        return {
            name: 'animatronApp.sectionFeedback',
            files: [getCss('landing-template/components/sections/section-feedback')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTitleBlock(), exports.animatronFeedback()]); };
exports.animatronSectionHorizontalTextVideo = function () { return Promise.all([__webpack_require__.e/* require.ensure */(89).then((function () {
        __webpack_require__("lsCU");
        return {
            name: 'animatronApp.sectionHorizontalTextVideo',
            files: [getCss('landing-template/components/sections/section-horizontal-text-video')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTitleBlock(), exports.animatronButtonStart(), exports.wistiaPlayer()]); };
exports.animatronSectionHorizontalImageText = function () { return Promise.all([__webpack_require__.e/* require.ensure */(90).then((function () {
        __webpack_require__("4iGy");
        return {
            name: 'animatronApp.sectionHorizontalImageText',
            files: [getCss('landing-template/components/sections/section-horizontal-image-text')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTextBlock(), exports.animatronButtonStart(), exports.animatronBackground()]); };
exports.animatronSectionVerticalTextVideo = function () { return Promise.all([__webpack_require__.e/* require.ensure */(84).then((function () {
        __webpack_require__("oprM");
        return {
            name: 'animatronApp.sectionVerticalTextVideo',
            files: [getCss('landing-template/components/sections/section-vertical-text-video')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTitleBlock(), exports.animatronBackground(), exports.animatronButtonStart(), exports.wistiaPlayer()]); };
exports.animatronSectionDifferentDevices = function () { return Promise.all([__webpack_require__.e/* require.ensure */(92).then((function () {
        __webpack_require__("6p0q");
        return {
            name: 'animatronApp.sectionDifferentDevices',
            files: [getCss('landing-template/components/sections/section-different-devices')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTitleBlock(), exports.animatronBackground(), exports.animatronDifferentDevices(), exports.animatronButtonStart()]); };
exports.animatronSectionCompanyInfo = function () { return Promise.all([__webpack_require__.e/* require.ensure */(94).then((function () {
        __webpack_require__("s9xa");
        return {
            name: 'animatronApp.sectionCompanyInfo',
            files: [getCss('landing-template/components/sections/section-company-info')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTitleBlock(), exports.animatronBackground(), exports.animatronIconTextList()]); };
exports.animatronSectionVideoStatistics = function () { return Promise.all([__webpack_require__.e/* require.ensure */(81).then((function () {
        __webpack_require__("QxZD");
        return {
            name: 'animatronApp.sectionVideoStatistics',
            files: [getCss('landing-template/components/sections/section-video-statistics')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTitleBlock(), exports.animatronDoubleCircleProgress()]); };
exports.animatronSectionCompanyQuote = function () { return Promise.all([__webpack_require__.e/* require.ensure */(93).then((function () {
        __webpack_require__("ukZq");
        return {
            name: 'animatronApp.sectionCompanyQuote',
            files: [getCss('landing-template/components/sections/section-company-quote')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronBackground()]); };
exports.animatronSectionTextAside = function () { return Promise.all([__webpack_require__.e/* require.ensure */(85).then((function () {
        __webpack_require__("AjAC");
        return {
            name: 'animatronApp.sectionTextAside',
            files: [getCss('landing-template/components/sections/section-text-aside')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTitleBlock(), exports.animatronRelationList()]); };
exports.animatronSectionSignUp = function () { return Promise.all([__webpack_require__.e/* require.ensure */(87).then((function () {
        __webpack_require__("Tzrl");
        return {
            name: 'animatronApp.sectionSignUp',
            files: [getCss('landing-template/components/sections/section-sign-up')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronBackground(), exports.animatronSignUpBlock(), exports.animatronTextBlock()]); };
exports.animatronSectionLogoVideoSignUp = function () { return Promise.all([__webpack_require__.e/* require.ensure */(88).then((function () {
        __webpack_require__("6vNO");
        return {
            name: 'animatronApp.sectionLogoVideoSignUp',
            files: [getCss('landing-template/components/sections/section-logo-video-sign-up')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTextBlock(), exports.animatronBackground(), exports.animatronSignUpBlock()]); };
exports.animatronSectionVideoSignUp = function () { return Promise.all([__webpack_require__.e/* require.ensure */(82).then((function () {
        __webpack_require__("ToFj");
        return {
            name: 'animatronApp.sectionVideoSignUp',
            files: [getCss('landing-template/components/sections/section-video-sign-up')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTitleBlock(), exports.animatronBackground(), exports.animatronSignUpBlock(), exports.scrollButton()]); };
exports.animatronSectionVideoTime = function () { return Promise.all([__webpack_require__.e/* require.ensure */(79).then((function () {
        __webpack_require__("4lUF");
        return {
            name: 'animatronApp.sectionVideoTime',
            files: [getCss('landing-template/components/sections/section-video-time')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTitleBlock(), exports.animatronBackground(), exports.animatronButtonStart(), exports.wistiaPlayer(), exports.scrollButton()]); };
exports.animatronSectionVideoGallery = function () { return Promise.all([__webpack_require__.e/* require.ensure */(83).then((function () {
        __webpack_require__("V7aM");
        return {
            name: 'animatronApp.sectionVideoGallery',
            files: [getCss('landing-template/components/sections/section-video-gallery')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTitleBlock(), exports.animatronVideoGallery(), exports.animatronButtonStart()]); };
exports.animatronSectionVideoSteps = function () { return Promise.all([__webpack_require__.e/* require.ensure */(80).then((function () {
        __webpack_require__("Th7s");
        return {
            name: 'animatronApp.sectionVideoSteps',
            files: [getCss('landing-template/components/sections/section-video-steps')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTitleBlock(), exports.videoSteps(), exports.animatronButtonStart()]); };
exports.animatronLandingTemplate = function () { return Promise.all([__webpack_require__.e/* require.ensure */(74).then((function () {
        __webpack_require__("/vY6");
        return {
            name: 'animatronApp.landingTemplate',
            files: [
                getCss('landing-template/landing-template')
            ]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe),
    exports.animatronSectionTemplatePagesList(),
    exports.animatronSectionBackgroundText(),
    exports.animatronSectionLogoVideoSignUp(),
    exports.animatronSectionVideoSignUp(),
    exports.animatronSectionVideoStatistics(),
    exports.animatronSectionVideoTime(),
    exports.animatronSectionBitmap(),
    exports.animatronSectionHorizontalTextVideo(),
    exports.animatronSectionCompanyInfo(),
    exports.animatronSectionHorizontalImageText(),
    exports.animatronSectionTextAside(),
    exports.animatronSectionCompanyQuote(),
    exports.animatronSectionDifferentDevices(),
    exports.animatronSectionVerticalTextVideo(),
    exports.animatronSectionVideoGallery(),
    exports.animatronSectionSignUp(),
    exports.animatronSectionFeedback(),
    exports.animatronSectionVideoSteps()
]); };
var userInfoForm = function () { return new Promise(function (resolve) {
    __webpack_require__.e/* require.ensure */(50).then((function () {
        __webpack_require__("bVBH");
        resolve([{
                name: 'animatronApp.userInfoForm',
                files: [
                    getCss('user-info-form'),
                    getCss('dropdown-menu'),
                    getCss('newsWebsite'),
                    getCss('_checkbox')
                ]
            }, angularMessages]);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}); };
exports.bgVideoSlider = function () { return Promise.all([__webpack_require__.e/* require.ensure */(126).then((function () {
        __webpack_require__("YCCM");
        return {
            name: 'animatronApp.bgVideoSlider',
            files: []
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.bgVideo()]); };
exports.modalVideoPlayer = function () { return Promise.all([__webpack_require__.e/* require.ensure */(72).then((function () {
        __webpack_require__("BvLB");
        return {
            name: 'animatronApp.modalVideoPlayer',
            files: [getCss('modal-video-player')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.videoPlayer()]); };
exports.mainLanding = function () { return Promise.all([__webpack_require__.e/* require.ensure */(73).then((function () {
        __webpack_require__("Q8Cs");
        return {
            name: 'animatronApp.mainLanding',
            files: [
                getCss('landing/any-landing'),
                options.handHeld ? getCss('mobile/m-any-landing') : ''
            ]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.tagsInput = function () { return new Promise(function (resolve) {
    __webpack_require__.e/* require.ensure */(127).then((function () {
        __webpack_require__("Z3Ae");
        resolve({ name: 'ngTagsInput', files: [getCss('ng-tags-input')] });
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}); };
exports.scrollFixedElement = function () { return new Promise(function (resolve) {
    __webpack_require__.e/* require.ensure */(143).then((function () {
        __webpack_require__("i7SO");
        resolve({ name: 'animatronApp.scrollFixedElement', files: [] });
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}); };
exports.waveUserPage = function () { return Promise.all([__webpack_require__.e/* require.ensure */(24).then((function () {
        __webpack_require__("JiMV");
        return {
            name: 'animatronApp.waveUserPage',
            files: [getCss('wave/wave-user-page')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.waveProjects(), exports.animatronVideoFolderBreadcrumb()]); };
exports.bgVideo = function () { return __webpack_require__.e/* require.ensure */(125).then((function () {
    __webpack_require__("B8SX");
    return {
        name: 'animatronApp.bgVideo',
        files: [getCss('bg-video')]
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.scrollButton = function () { return __webpack_require__.e/* require.ensure */(144).then((function () {
    __webpack_require__("FJil");
    return {
        name: 'animatronApp.scrollButton',
        files: [getCss('scroll-button')]
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.ytPlayer = function () { return __webpack_require__.e/* require.ensure */(135).then((function () {
    __webpack_require__("JOH8");
    return {
        name: 'animatronApp.ytPlayer',
        files: []
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.videoPlayer = function () { return __webpack_require__.e/* require.ensure */(47).then((function () {
    __webpack_require__("lOrt");
    return {
        name: 'animatronApp.videoPlayer',
        files: [getCss('video-player')]
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.wistiaPlayer = function () { return __webpack_require__.e/* require.ensure */(23).then((function () {
    __webpack_require__("CTLc");
    return {
        name: 'animatronApp.wistiaPlayer',
        files: [getCss('wistia-player')]
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.videoSlider = function () { return Promise.all([__webpack_require__.e/* require.ensure */(46).then((function () {
        __webpack_require__("zMz2");
        return {
            name: 'animatronApp.videoSlider',
            files: [getCss('video-slider')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.videoPlayer()]); };
var ticker = function () { return new Promise(function (resolve) {
    __webpack_require__.e/* require.ensure */(130).then((function () {
        __webpack_require__("dSeo");
        resolve({ name: 'animatronApp.ticker', files: [] });
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}); };
var animatronRandomNumber = function () { return new Promise(function (resolve) {
    __webpack_require__.e/* require.ensure */(48).then((function () {
        __webpack_require__("EgkG");
        resolve({
            name: 'animatronApp.randomFact',
            files: [getCss('settings/random-fact')]
        });
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}); };
exports.animatronUpgrade = function () { return Promise.all([new Promise(function (resolve) {
        try {
            angular.module('animatronApp.settings');
        }
        catch (e) {
            angular.module('animatronApp.settings', []);
        }
        __webpack_require__.e/* require.ensure */(3).then((function () {
            __webpack_require__("4X5L");
            __webpack_require__("Lb+m");
            __webpack_require__("ipbz");
            __webpack_require__("gojZ");
            __webpack_require__("rCIs");
            __webpack_require__("Pzqj");
            __webpack_require__("izVX");
            __webpack_require__("5T+r");
            __webpack_require__("BYam");
            __webpack_require__("WF19");
            __webpack_require__("YMs+");
            resolve([{
                    name: 'animatronApp.settings',
                    files: [getCss('settings')]
                }, { name: 'animatronApp.planAnimation', files: [] }]);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }), exports.animatronSubscriptionSvc()]); };
exports.animatronSettings = function () { return Promise.all([new Promise(function (resolve) {
        __webpack_require__.e/* require.ensure */(4).then((function () {
            try {
                angular.module('animatronApp.settings');
            }
            catch (e) {
                angular.module('animatronApp.settings', []);
            }
            __webpack_require__("ltG4");
            __webpack_require__("JDcb");
            __webpack_require__("po33");
            __webpack_require__("bG6I");
            __webpack_require__("a33m");
            __webpack_require__("jPbo");
            __webpack_require__("cs9A");
            resolve({
                name: 'animatronApp.settings',
                files: [
                    getCss('tabs'),
                    getCss('newsWebsite')
                ]
            });
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }), animatronRandomNumber(), exports.animatronUpgrade(), userInfoForm(), exports.animatronSubscriptionTitle(), exports.animatronUserNotification()]); };
exports.animatronTutorial = function () { return new Promise(function (resolve) {
    __webpack_require__.e/* require.ensure */(7).then((function () {
        angular.module('animatronApp.tutorial', []);
        __webpack_require__("plSH");
        __webpack_require__("zaE3");
        __webpack_require__("QEkP");
        __webpack_require__("f/MV");
        __webpack_require__("KtYt");
        __webpack_require__("Mc/u");
        __webpack_require__("BGMK");
        resolve({
            name: 'animatronApp.tutorial',
            files: [
                getCss('tutorial'),
                getCss('tabs'),
                getCss('search')
            ]
        });
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}); };
exports.animatronSpecialUpgrade = function () { return Promise.all([new Promise(function (resolve) {
        __webpack_require__.e/* require.ensure */(49).then((function () {
            try {
                angular.module('animatronApp.settings');
            }
            catch (e) {
                angular.module('animatronApp.settings', []);
            }
            __webpack_require__("i470");
            resolve({
                name: 'animatronApp.special-upgrade',
                files: [getCss('special-upgrade')]
            });
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }), exports.animatronSubscriptionPage(), exports.animatronSubscriptionPaymentDetailsContainer()]); };
exports.animatronFeedback = function () { return __webpack_require__.e/* require.ensure */(5).then((function () {
    try {
        angular.module('animatronApp.feedback');
    }
    catch (e) {
        angular.module('animatronApp.feedback', []);
    }
    __webpack_require__("HaCt");
    __webpack_require__("JKrW");
    __webpack_require__("euAE");
    __webpack_require__("/6Js");
    __webpack_require__("tsWW");
    return {
        name: 'animatronApp.feedback',
        files: [getCss('feedback-slider')]
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.animatronEdu = function () { return Promise.all([new Promise(function (resolve) {
        __webpack_require__.e/* require.ensure */(22).then((function () {
            angular.module('animatronApp.education', []);
            __webpack_require__("SI0D");
            __webpack_require__("Penj");
            __webpack_require__("gsWG");
            resolve({
                name: 'animatronApp.education',
                files: [
                    getCss('edu'),
                    getCss('signup')
                ]
            });
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }), exports.animatronTutorial()]); };
exports.animatronPrivacy = [getCss('tutorial')];
exports.animatronTermsServices = [getCss('tutorial')];
exports.pricingSubscription = function () { return __webpack_require__.e/* require.ensure */(9).then((function () {
    __webpack_require__("5721");
    return {
        name: 'animatronApp.pricingSubscription',
        files: []
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.animatronPricing = function () { return Promise.all([new Promise(function (resolve) {
        __webpack_require__.e/* require.ensure */(150).then((function () {
            angular.module('animatronApp.pricing', []);
            __webpack_require__("WF19");
            resolve([{
                    name: 'animatronApp.pricing',
                    files: [
                        getCss('pricing'),
                        options.handHeld ? getCss('mobile/m-landing-bottom') : ''
                    ]
                }, { name: 'animatronApp.planAnimation', files: [] }]);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }), exports.animatronFeedback(), exports.pricingSubscription(), exports.animatronSubscriptionPage(), exports.animatronSubscriptionPage()]); };
exports.wavePricing = function () { return Promise.all([__webpack_require__.e/* require.ensure */(28).then((function () {
        angular.module('animatronApp.wavePricing', []);
        __webpack_require__("+t0R");
        return {
            name: 'animatronApp.wavePricing',
            files: [
                getCss('wave/wave-pricing'),
                options.handHeld ? getCss('mobile/wave/m-wave-pricing') : ''
            ]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.pricingSubscription(), exports.animatronSubscriptionPage()]); };
var animatronCanvas = function () { return new Promise(function (resolve) {
    __webpack_require__.e/* require.ensure */(131).then((function () {
        __webpack_require__("65gs");
        resolve({ name: 'animatronApp.animatronCanvas', files: [] });
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}); };
exports.animatronVideoGallery = function () { return new Promise(function (resolve) {
    __webpack_require__.e/* require.ensure */(2).then((function () {
        __webpack_require__("Bqs3");
        resolve({
            name: 'animatronApp.videoGallery',
            files: [
                getCss('landing/video-gallery')
            ]
        });
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}); };
exports.animatronExplainerGallery = function () { return new Promise(function (resolve) {
    __webpack_require__.e/* require.ensure */(146).then((function () {
        __webpack_require__("z3nR");
        resolve({ name: 'animatronApp.explainerGallery', files: [getCss('landing/masonry-wrapper')] });
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}); };
exports.animatronSignup = function () { return new Promise(function (resolve) {
    __webpack_require__.e/* require.ensure */(142).then((function () {
        __webpack_require__("Vm6p");
        resolve([angularMessages, {
                name: 'animatronApp.signup',
                files: [
                    // getHtml('signup/sign-up'),
                    getCss('signup'),
                    getCss('sign-up-block')
                ]
            }]);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}); };
exports.introduceVideo = function () { return __webpack_require__.e/* require.ensure */(101).then((function () {
    __webpack_require__("t8a2");
    return {
        name: 'animatronApp.introduce-video',
        files: []
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.animatronBannerBottom = function () { return Promise.all([new Promise(function (resolve) {
        __webpack_require__.e/* require.ensure */(15).then((function () {
            angular.module('animatronApp.bannerBottom', []);
            __webpack_require__("EX7R");
            __webpack_require__("HMCk");
            __webpack_require__("urQF");
            resolve({
                name: 'animatronApp.bannerBottom',
                files: [
                    getCss('landing/banner-bottom'),
                    options.handHeld ? getCss('mobile/m-landing-banner') : ''
                ]
            });
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }), exports.animatronFeedback(), animatronCanvas(), exports.animatronVideoGallery()]); };
exports.animatronMediumLanding = function () { return Promise.all([new Promise(function (resolve) {
        __webpack_require__.e/* require.ensure */(1).then((function () {
            angular.module('animatronApp.mediumLanding', []);
            __webpack_require__("sz4O");
            resolve({
                name: 'animatronApp.mediumLanding',
                files: [
                    getCss('landing/medium-landing'),
                    options.handHeld && getCss('mobile/m-medium-landing')
                ]
            });
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }), animatronCanvas(), exports.animatronVideoGallery(), exports.bgVideo(), exports.videoSlider(), exports.animatronFeedback()]); };
exports.animatronComparisonBottom = function () { return Promise.all([new Promise(function (resolve) {
        new Promise(function(resolve) { resolve(); }).then((function () {
            angular.module('animatronApp.comparisonBottom', []);
            resolve({
                name: 'animatronApp.comparisonBottom',
                files: [
                    getCss('landing/comparison'),
                    options.handHeld ? getCss('mobile/m-landing-comparison') : '',
                    getCss('tabs')
                ]
            });
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }), exports.scrollFixedElement()]); };
exports.animatronLandingNewBottom = function () { return Promise.all([new Promise(function (resolve) {
        __webpack_require__.e/* require.ensure */(18).then((function () {
            angular.module('animatronApp.landingNewBottom', []);
            __webpack_require__("XOmU");
            __webpack_require__("AwXB");
            __webpack_require__("gkLk");
            __webpack_require__("ApdG");
            resolve({
                name: 'animatronApp.landingNewBottom',
                files: [
                    getCss('landing/masonry-wrapper'),
                    getCss('tabs'),
                    getCss('landing/landing-new-bottom')
                ]
            });
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }), exports.ytPlayer(), exports.animatronFeedback(), exports.wistiaPlayer()]); };
exports.animatronExplainerBottom = exports.animatronBannerBottom;
exports.animatronTwitterFollowButton = function () { return __webpack_require__.e/* require.ensure */(141).then((function () {
    __webpack_require__("ktV2");
    return {
        name: 'animatronApp.twitterFollowButton',
        files: []
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.animatronTwitterShareButton = function () { return __webpack_require__.e/* require.ensure */(140).then((function () {
    __webpack_require__("YP1l");
    return {
        name: 'animatronApp.twitterShareButton',
        files: []
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.animatronFacebookShareButton = function () { return __webpack_require__.e/* require.ensure */(148).then((function () {
    __webpack_require__("A869");
    return {
        name: 'animatronApp.facebookShareButton',
        files: [getCss('f_bsh-button')]
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.animatronLinkedinShareButton = function () { return __webpack_require__.e/* require.ensure */(145).then((function () {
    __webpack_require__("+sN8");
    return {
        name: 'animatronApp.linkedinShareButton',
        files: [getCss('le-share-button')]
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.animatronGoogleShareButton = function () { return __webpack_require__.e/* require.ensure */(147).then((function () {
    __webpack_require__("pVlO");
    return {
        name: 'animatronApp.googleShareButton',
        files: [getCss('go-share-button')]
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.animatronUserNotification = function () { return __webpack_require__.e/* require.ensure */(71).then((function () {
    __webpack_require__("tvuY");
    return {
        name: 'animatronApp.UserNotification',
        files: [getCss('notification/user-notification')]
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.animatronSignUpBlock = function () { return __webpack_require__.e/* require.ensure */(51).then((function () {
    __webpack_require__("Om7N");
    return [angularMessages, {
            name: 'animatronApp.signUpBlock',
            files: [getCss('sign-up-block')]
        }];
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.animatronDoubleCircleProgress = function () { return Promise.all([__webpack_require__.e/* require.ensure */(99).then((function () {
        __webpack_require__("bsPy");
        return {
            name: 'animatronApp.doubleCircleProgress',
            files: [getCss('landing-template/components/double-circle-progress')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.animatronTextBlock = function () { return Promise.all([__webpack_require__.e/* require.ensure */(76).then((function () {
        __webpack_require__("rOIc");
        return {
            name: 'animatronApp.textBlock',
            files: [getCss('landing-template/components/text-block')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTitleBlock(), exports.animatronButtonStart()]); };
exports.animatronCompany = function () { return Promise.all([__webpack_require__.e/* require.ensure */(124).then((function () {
        __webpack_require__("Ypo8");
        return {
            name: 'animatronApp.company',
            files: [
                getCss('company'),
                options.handHeld ? getCss('mobile/m-company') : ''
            ]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
//editor redirect page
exports.animatronEditorRedirect = function () { return Promise.all([__webpack_require__.e/* require.ensure */(44).then((function () {
        __webpack_require__("iI1I");
        return {
            name: 'animatronApp.editorRedirect',
            files: [
                getCss('editor-redirect')
            ]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTwitterFollowButton()]); };
//
exports.animatronContractors = function () { return new Promise(function (resolve) {
    __webpack_require__.e/* require.ensure */(102).then((function () {
        __webpack_require__("vxBE");
        resolve({
            name: 'animatronApp.contractors',
            files: [
                getCss('user-section'),
                getCss('contractors')
            ]
        });
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}); };
exports.waveMain = function () { return Promise.all([__webpack_require__.e/* require.ensure */(30).then((function () {
        __webpack_require__("sYxt");
        return {
            name: 'animatronApp.wave.landing',
            files: [
                getCss('wave/wave-landing'),
                options.handHeld ? getCss('mobile/wave/m-wave-landing') : ''
            ]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronVideoGallery(), exports.bgVideo(), exports.waveSectionHowWork()]); };
exports.waveLandingSMMW = function () { return Promise.all([__webpack_require__.e/* require.ensure */(31).then((function () {
        __webpack_require__("OzAF");
        return {
            name: 'animatronApp.wave.landingSMMW',
            files: [
                getCss('wave/wave-landing-smmw'),
                options.handHeld ? getCss('mobile/wave/m-wave-landing-smmw') : ''
            ]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.introduceVideo(), exports.waveSectionHowWork(), exports.scrollButton()]); };
exports.mariSmithTutorials = function () { return Promise.all([__webpack_require__.e/* require.ensure */(36).then((function () {
        __webpack_require__("m5ZQ");
        return {
            name: 'animatronApp.wave.mariSmithTutorials',
            files: [
                getCss('wave/wave-webinar'),
                options.handHeld ? getCss('mobile/wave/m-webinar') : ''
            ]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.salmaWebinars = function () { return Promise.all([__webpack_require__.e/* require.ensure */(35).then((function () {
        __webpack_require__("MnpC");
        return {
            name: 'animatronApp.wave.salmaWebinars',
            files: [
                getCss('wave/wave-webinar'),
                options.handHeld ? getCss('mobile/wave/m-webinar') : ''
            ]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe)]); };
exports.waveProject = function () { return Promise.all([__webpack_require__.e/* require.ensure */(27).then((function () {
        __webpack_require__("leUL");
        return {
            name: 'animatronApp.wave.project-item',
            files: [getCss('wave/wave-project-item')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronVideoFolderBottom(), exports.animatronVideoFolderMoveModalSvc()]); };
exports.waveTutorialWorkshops = function () { return __webpack_require__.e/* require.ensure */(0).then((function () {
    __webpack_require__("3xwt");
    return {
        name: 'animatronApp.wave.tutorialWorkshops',
        files: [getCss('wave/tutorial/wave-tutorial-workshops')]
    };
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe); };
exports.waveTutorialsItem = function () { return Promise.all([__webpack_require__.e/* require.ensure */(33).then((function () {
        __webpack_require__("NMZo");
        return {
            name: 'animatronApp.wave.tutorialsItem',
            files: [getCss('wave/tutorial/wave-tutorials-item')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronTutorial()]); };
exports.waveTutorialsList = function () { return Promise.all([__webpack_require__.e/* require.ensure */(32).then((function () {
        __webpack_require__("4HnX");
        return {
            name: 'animatronApp.wave.tutorialsList',
            files: [getCss('wave/tutorial/wave-tutorials-list')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.waveTutorialsItem()]); };
exports.waveTutorialPage = function () { return Promise.all([__webpack_require__.e/* require.ensure */(34).then((function () {
        __webpack_require__("H1pI");
        return {
            name: 'animatronApp.wave.tutorialPage',
            files: [getCss('wave/tutorial/wave-tutorial-page')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.waveTutorialsList(), exports.animatronSectionVerticalTextVideo(), exports.waveTutorialWorkshops(), exports.animatronSectionHorizontalImageText()]); };
exports.videoSteps = function () { return Promise.all([__webpack_require__.e/* require.ensure */(45).then((function () {
        __webpack_require__("L1PK");
        return {
            name: 'animatronApp.videoSteps',
            files: [getCss('video-steps')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.animatronButtonStart(), exports.wistiaPlayer()]); };
exports.waveSectionHowWork = function () { return Promise.all([__webpack_require__.e/* require.ensure */(26).then((function () {
        __webpack_require__("V2FM");
        return {
            name: 'animatronApp.wave.sectionHowWork',
            files: [getCss('wave/wave-section-how-work')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.videoSteps()]); };
exports.waveTemplate = function () { return Promise.all([__webpack_require__.e/* require.ensure */(25).then((function () {
        __webpack_require__("qWXa");
        return {
            name: 'animatronApp.wave.template-item',
            files: [getCss('wave/wave-template-item')]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe), exports.modalVideoPlayer()]); };
exports.waveProjects = function () { return Promise.all([__webpack_require__.e/* require.ensure */(10).then((function () {
        __webpack_require__("FrPD");
        return {
            name: 'animatronApp.wave.projects',
            files: [
                getCss('projects'),
                getCss('wave/wave-projects')
            ]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe),
    exports.waveProject(),
    exports.animatronDragItem(),
    exports.animatronDropZone(),
    exports.animatronVideoFolderItem(),
    exports.animatronVideoFolderCreateNew(),
    exports.animatronVideoFolderMoveModal(),
    exports.animatronVideoFolderMasonry()
]); };
exports.waveMyProjects = function () { return Promise.all([__webpack_require__.e/* require.ensure */(29).then((function () {
        __webpack_require__("M4Jw");
        return {
            name: 'animatronApp.wave.my-projects',
            files: [
                getCss('tabs'),
                getCss('wave/wave-my-projects')
            ]
        };
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe),
    exports.waveProjects(),
    exports.animatronVideoFolderBreadcrumb(),
    exports.animatronVideoFolderControls()
]); };
exports.animatronActivate = function () { return Promise.all([new Promise(function (resolve) {
        __webpack_require__.e/* require.ensure */(14).then((function () {
            __webpack_require__("tMOM");
            __webpack_require__("Gi7R");
            resolve([angularMessages, {
                    name: 'animatronApp.activate',
                    files: [
                        getCss('activate')
                    ]
                }]);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }), userInfoForm()]); };
exports.animatronRecovery = function () { return new Promise(function (resolve) {
    __webpack_require__.e/* require.ensure */(67).then((function () {
        __webpack_require__("Fsbj");
        resolve([angularMessages, {
                name: 'animatronApp.recovery',
                files: [getCss('activate')]
            }]);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}); };
exports.animatronRecoveryReset = function () { return new Promise(function (resolve) {
    __webpack_require__.e/* require.ensure */(66).then((function () {
        __webpack_require__("V703");
        resolve([angularMessages, {
                name: 'animatronApp.recoveryReset',
                files: [getCss('activate')]
            }]);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}); };
exports.animatronProjectAnalytics = function () { return new Promise(function (resolve) {
    __webpack_require__.e/* require.ensure */(13).then((function () {
        angular.module('animatronApp.projectAnalytics', []);
        __webpack_require__("ehZa");
        __webpack_require__("GI5z");
        __webpack_require__("xom6");
        __webpack_require__("Dbbe");
        resolve({
            name: 'animatronApp.projectAnalytics',
            files: [
                'https://cdnjs.cloudflare.com/ajax/libs/d3/3.5.16/d3.min.js',
                getCss('settings'),
                getCss('analytics'),
                getCss('projects'),
                getCss('tabs'),
                getCss('dropdown-menu')
            ]
        });
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}); };
exports.animatronThumbnailPicker = function () { return new Promise(function (resolve) {
    __webpack_require__.e/* require.ensure */(68).then((function () {
        angular.module('animatronApp.thumbnailPicker', []);
        __webpack_require__("GhNV");
        resolve({
            name: 'animatronApp.thumbnailPicker',
            files: [getCss('thumbnail-picker')]
        });
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}); };
exports.animatronPublish = function () { return Promise.all([new Promise(function (resolve) {
        __webpack_require__.e/* require.ensure */(12).then((function () {
            angular.module('animatronApp.publish', []);
            __webpack_require__("mx5K");
            __webpack_require__("CRMv");
            resolve({
                name: 'animatronApp.publish',
                files: [
                    getCss('publish'),
                    getCss('tabs'),
                    getCss('_checkbox')
                ]
            });
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }), ticker(), exports.animatronThumbnailPicker()]); };
exports.animatronProjectPreviewPicker = function () { return Promise.all([new Promise(function (resolve) {
        __webpack_require__.e/* require.ensure */(69).then((function () {
            angular.module('animatronApp.projectPreviewPicker', []);
            __webpack_require__("5KzC");
            resolve({
                name: 'animatronApp.projectPreviewPicker',
                files: [getCss('publish')]
            });
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }), exports.animatronThumbnailPicker()]); };
exports.animatronProjects = function () { return new Promise(function (resolve) {
    angular.module('animatronApp.projects', []);
    resolve({
        name: 'animatronApp.projects',
        files: [
            getCss('tabs'),
            getCss('newsWebsite'),
            getCss('search')
        ].concat(exports.animatronProject)
    });
}); };
exports.animatronUserPage = function () { return Promise.all([new Promise(function (resolve) {
        __webpack_require__.e/* require.ensure */(8).then((function () {
            angular.module('animatronApp.profileProject', []);
            __webpack_require__("vpuT");
            __webpack_require__("dMZG");
            __webpack_require__("+1JM");
            __webpack_require__("3Pz5");
            __webpack_require__("pD8l");
            resolve({
                name: 'animatronApp.profileProject',
                files: [getCss('user-section')]
            });
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }), exports.animatronProjects()]); };
exports.animatronHtml5Offline = function () { return Promise.all([new Promise(function (resolve) {
        __webpack_require__.e/* require.ensure */(70).then((function () {
            angular.module('animatronApp.html5Offline', []);
            __webpack_require__("X24d");
            resolve({
                name: 'animatronApp.html5Offline',
                files: [
                    getCss('publish'),
                    getCss('tabs'),
                    getCss('_checkbox')
                ]
            });
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }), exports.animatronThumbnailPicker()]); };
//export const animatronSearchPage = [animatronProjects(), getJs('controllers/SearchPageCtrl')];
exports.animatronSearchPage = function () { return Promise.all([new Promise(function (resolve) {
        __webpack_require__.e/* require.ensure */(149).then((function () {
            __webpack_require__("AUGb");
            resolve({
                name: 'animatronApp.searchPage',
                files: [
                    getCss('search-page'),
                    options.handHeld && getCss('mobile/m-search-page')
                ]
            });
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }), exports.animatronProjects()]); };
//FIXME might not work
exports.animatronContest = function () { return Promise.all([new Promise(function (resolve) {
        __webpack_require__.e/* require.ensure */(6).then((function () {
            angular.module('animatronApp.contest', []);
            __webpack_require__("5hF9");
            __webpack_require__("p7UG");
            __webpack_require__("Y0+c");
            __webpack_require__("GdTr");
            resolve({
                name: 'animatronApp.contest',
                files: [
                    getCss('contest/contest'),
                    getCss('_checkbox')
                ]
            });
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }), exports.animatronUserPage(), exports.datePicker()]); };


/***/ }),

/***/ "bXOc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var underscore_extensions_1 = __webpack_require__("R0iF");
var module_1 = __webpack_require__("jYQ6");
var Strings_1 = __webpack_require__("fxc3");
var OAuthCallbackSvc = (function () {
    OAuthCallbackSvc.$inject = ["$location", "$log", "$state", "$stateParams", "AuthenticationSvc", "LocalStorageSvc"];
    function OAuthCallbackSvc($location, $log, $state, $stateParams, AuthenticationSvc, LocalStorageSvc) {
        this.$location = $location;
        this.$log = $log;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.AuthenticationSvc = AuthenticationSvc;
        this.LocalStorageSvc = LocalStorageSvc;
    }
    OAuthCallbackSvc.prototype.doLogin = function (params, stateParams) {
        var _this = this;
        this.$log.debug('Callback activated', { params: params });
        var getToken = function () {
            var token = params.access_token || stateParams.code;
            return _.isArray(token) ? token[0] : token;
        };
        var oauthService = stateParams.provider.toUpperCase();
        var product = stateParams.product || underscore_extensions_1.Utils.getProduct().toLowerCase();
        var thirdPartyRedirect = this.LocalStorageSvc.get('_animatron_redirect_onlogin');
        switch (oauthService) {
            case 'GOOGLE':
            case 'FACEBOOK':
            case 'TWITTER':
            case 'DRIBBBLE':
            case 'WISTIA':
            case 'HUBSPOT':
            case 'VIMEO':
            case 'DROPBOX':
            case 'GDRIVE':
                if (!Strings_1.Strings.isBlank(getToken())) {
                    this.AuthenticationSvc.loginOAuth(getToken(), oauthService, product)
                        .then(function (secureUser) {
                        if (thirdPartyRedirect && !thirdPartyRedirect.includes(location.host)) {
                            document.querySelector('html').style['background-color'] = 'white';
                            document.querySelector('html').innerHTML = '<div style="font-size:25px">redirecting back...</div>';
                        }
                        else {
                            var homeUrl = product === 'wave' ? 'my-projects' : 'home';
                            _this.$location.hash('');
                            _this.$state.go(secureUser.isNew ? product + "-activate-oauth" : homeUrl, {}, { reload: true });
                        }
                    });
                }
                else {
                    this.$location.path('/404');
                }
                break;
            case 'TWITTER_EMOTIONS':
                this.LocalStorageSvc.set('_animatron_twitter', { token: getToken(), secret: params.secret_token });
                window.close();
                break;
            case 'FACEBOOK_EMOTIONS':
                this.LocalStorageSvc.set('_animatron_facebook', { token: getToken() });
                window.close();
                break;
            default:
                if (oauthService.endsWith('_SHARE')) {
                    window['share_updated'](getToken());
                    if (window.opener) {
                        window.opener['share_updated'](getToken());
                    }
                }
                else {
                    throw new Error('Unknown provider ' + oauthService);
                }
        }
    };
    OAuthCallbackSvc.prototype.onCallback = function ($stateParams, hash) {
        var params = hash.split('&').map(function (s) { return s.split('='); }).reduce(function (acc, arr) {
            acc[arr[0]] = arr[1];
            return acc;
        }, {});
        if (window.opener) {
            try {
                window.opener.angular.element(window.opener.document.body)
                    .injector()
                    .get('OAuthCallbackSvc')
                    .doLogin(params, $stateParams);
            }
            catch (e) {
                this.LocalStorageSvc.set('auth', { params: params, stateParams: $stateParams });
            }
            finally {
                window.close();
            }
        }
        else {
            this.doLogin(params, $stateParams);
        }
    };
    return OAuthCallbackSvc;
}());
exports.OAuthCallbackSvc = OAuthCallbackSvc;
module_1.default.service('OAuthCallbackSvc', OAuthCallbackSvc);


/***/ }),

/***/ "brzu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/4.png";

/***/ }),

/***/ "c5FE":
/***/ (function(module, exports) {

var path = 'https://assets.animatron.com/html/news.html';
var html = "<div class=\"news-container\" ng-if=\"NewsCtrl.newsList.length\"> <span class=\"icon\"></span> <div class=\"news-body\"> <div class=\"news-content\" ng-bind-html=\"NewsCtrl.currentNews\"></div> <button class=\"button button-close-message\" ng-click=\"NewsCtrl.deleteNews()\"></button> </div> </div>";
var angular = window.angular;
var injector = angular.element(document).injector();
if (injector) {
injector.get('$templateCache').put(path, html);
} else {
angular.module('templates').run(['$templateCache', function(c) { c.put(path, html) }]);
}
module.exports = path;

/***/ }),

/***/ "c5t7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AnalyticSvc_1 = __webpack_require__("44/O");
var timeoutClear_1 = __webpack_require__("yRab");
var detectUserActivity_1 = __webpack_require__("VLpl");
var timeout =  true ? 2 * 60 * 60 * 1000 : 3 * 60 * 1000;
var analyticTimeoutClear = function (clear) { return function () {
    return timeoutClear_1.default('analytic', timeout)(clear);
}; };
var runTimeout = _.compose(detectUserActivity_1.default, analyticTimeoutClear);
var clearAnalyticStorage = _.noop;
exports.default = function () {
    clearAnalyticStorage();
    clearAnalyticStorage = runTimeout(AnalyticSvc_1.clearVisitStore);
};


/***/ }),

/***/ "cZf6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/wave-tutorials-item_b4d39b022b1c3f5139fa5b385adcd80f.css";

/***/ }),

/***/ "cmQJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/sponsor-contact-us_bcb44e4933ea0e908cfd539298e6ef17.css";

/***/ }),

/***/ "cq6s":
/***/ (function(module, exports) {

var path = 'https://assets.animatron.com/html/user-popup.html';
var html = "<div ng-class=\"{'popup-opener': $ctrl.shown}\" ng-mouseenter=\"$ctrl.show($event)\" ng-mouseleave=\"$ctrl.hide()\"> <div class=\"popup {{$ctrl.position}}\" ng-if=\"$ctrl.loaded\"> <a ui-sref=\"studio-user({username: ($ctrl.user.username | encodeUsername), user: $ctrl.user})\" class=\"gag\"></a> <user-avatar user=\"$ctrl.user\" size=\"60\"></user-avatar> <div class=\"user-popup-info\"> <div class=\"user-popup-top\"> <a class=\"displayname\" ui-sref=\"studio-user({username: ($ctrl.user.username | encodeUsername), user: $ctrl.user})\" ng-bind=\"::$ctrl.user.displayName\"> </a> <i class=\"account-type {{::$ctrl.user.accountTypes.STUDIO.toLowerCase()}}\"></i> </div> <div class=\"user-popup-bottom\"> <div ng-if=\"::$ctrl.user.meta.location && $ctrl.user.meta.location != 'null'\" class=\"location\"> <span>{{::$ctrl.user.meta.location}}</span> </div> <div class=\"sites\"> <div class=\"social-links\"> <a ng-if=\"::$ctrl.user.meta.facebook\" ng-href=\"https://www.facebook.com/{{::$ctrl.user.meta.facebook}}\" target=\"_blank\" class=\"user-social-button fb\"></a> <a ng-if=\"::$ctrl.user.meta.twitter\" ng-href=\"https://twitter.com/{{::$ctrl.user.meta.twitter}}\" target=\"_blank\" class=\"user-social-button tw\"></a> <a ng-if=\"::$ctrl.user.meta.dribble\" ng-href=\"https://dribbble.com/{{::$ctrl.user.meta.dribble}}\" target=\"_blank\" class=\"user-social-button dr\"></a> </div> </div> </div> </div> <div class=\"project-previews\"> <loader-horizontal ng-if=\"$ctrl.loading\"></loader-horizontal> <a class=\"project-preview\" ng-repeat=\"project in $ctrl.user.projects\" ui-sref=\"studio-project({projectId:project.id, project:project})\" pick-preview-image=\"{width:320}\" preview-as-background title=\"{{::project.name}}\"> <i></i> </a> </div> <div class=\"user-popup-bottom\"> <div class=\"count-panel\"> <span><b ui-sref=\"studio-user({username:$ctrl.user.username, user:$ctrl.user.user})\">{{$ctrl.user.projectsCount || 0}}</b> {{::$root.t('user-info.animations')}}</span> <span><b ui-sref=\"studio-followers({username:$ctrl.user.username, user:$ctrl.user.user})\">{{$ctrl.user.followers || 0 }}</b> {{::$root.t('user-info.studio-followers')}}</span> <span><b ui-sref=\"studio-following({username:$ctrl.user.username, user:$ctrl.user.user})\">{{::$ctrl.user.followings || 0}}</b> {{::$root.t('user-info.studio-following')}}</span> </div> <div ng-if=\"::$root.user.username !== $ctrl.user.username && !$root.user.anonymous\"> <a class=\"button button-blue\" ng-if=\"!$ctrl.followersSvc.isFollowing($ctrl.user)\" ng-click=\"$ctrl.followersSvc.follow($ctrl.user)\">{{::$root.t('follow')}}</a> <a class=\"button button-blue\" ng-if=\"$ctrl.followersSvc.isFollowing($ctrl.user)\" ng-click=\"$ctrl.followersSvc.unfollow($ctrl.user)\">{{::$root.t('unfollow')}}</a> </div> </div> </div> <a class=\"username\" ui-sref=\"studio-user({username: ($ctrl.user.username | encodeUsername), user: $ctrl.user})\"> <user-avatar class=\"small pull-left\" user=\"$ctrl.user\" size=\"$ctrl.size\"></user-avatar> <b ng-hide=\"::$ctrl.avatarOnly\" ng-bind=\"::$ctrl.user.displayName\"></b> <i ng-hide=\"::$ctrl.avatarOnly\" class=\"account-type {{::$ctrl.user.accountTypes.STUDIO.toLowerCase()}}\"></i> </a> </div> ";
var angular = window.angular;
var injector = angular.element(document).injector();
if (injector) {
injector.get('$templateCache').put(path, html);
} else {
angular.module('templates').run(['$templateCache', function(c) { c.put(path, html) }]);
}
module.exports = path;

/***/ }),

/***/ "d1XY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/more-text_dea0b98cd309ef9255989e2c98ee8175.html";

/***/ }),

/***/ "dJ+1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/main-page_8329411c2916d406845483d22ea05fcb.css";

/***/ }),

/***/ "dLJ7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/comparison_51beb6bb385add5fe51d5a8118f106e5.css";

/***/ }),

/***/ "dQ5J":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/projects_b1da6a4e56c30b3014f8b9c777ff3d07.css";

/***/ }),

/***/ "dwQs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var underscore_extensions_1 = __webpack_require__("R0iF");
var LikeCtrl = (function () {
    LikeCtrl.$inject = ["$element", "$timeout", "HttpSvc", "MyFollowings"];
    function LikeCtrl($element, $timeout, HttpSvc, MyFollowings) {
        var _this = this;
        this.$element = $element;
        this.$timeout = $timeout;
        this.HttpSvc = HttpSvc;
        this.MyFollowings = MyFollowings;
        this.loaded = false;
        this.load = _.once(function () {
            if (options.handHeld)
                return;
            _this.loaded = true;
            _this.$timeout(function () { return underscore_extensions_1.Utils.rAF(function () {
                return _this.$element[0].firstChild.classList.add('popup-opener');
            }); });
        });
    }
    LikeCtrl.prototype.$onChanges = function (changes) {
        var _this = this;
        if (!changes.project.currentValue || !changes.project.currentValue.id)
            return;
        if (this.ProjectPageCtrl) {
            this.ProjectPageCtrl.projectPromise.then(this.init.bind(this));
        }
        else {
            this.init(this.project);
        }
        if (!options.handHeld) {
            this.MyFollowings.init().then(function (svc) { return _this.followersSvc = svc; });
        }
    };
    LikeCtrl.prototype.init = function (project) {
        this.project = project;
        this.project.likes && this.project.likes.sort(function (a, b) { return a.liked_at - b.liked_at; });
        this.http = this.HttpSvc('project', 'like', this.project.id);
    };
    LikeCtrl.prototype.changeLike = function () {
        if (options.user.anonymous)
            return;
        return this.isLiker() ? this.unlike() : this.like();
    };
    LikeCtrl.prototype.like = function () {
        this.project.likes.unshift({ user: options.user, liked_at: Date.now() });
        this.http.securePost();
    };
    LikeCtrl.prototype.unlike = function () {
        this.project.likes = this.project.likes.filter(function (l) { return l.user.username !== options.user.username; });
        this.http.secureDelete();
    };
    LikeCtrl.prototype.isLiker = function () {
        return !!_.find(this.project.likes, function (l) { return l.user.username === options.user.username; });
    };
    return LikeCtrl;
}());
exports.LikeCtrl = LikeCtrl;
module_1.default.component('like', {
    bindings: {
        project: '<'
    },
    controller: LikeCtrl,
    require: { ProjectPageCtrl: '^?projectPage' },
    templateUrl: __webpack_require__("f86U")
});


/***/ }),

/***/ "dy9G":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/landing-template_21f05f75ff1520c38fc96082892cca1e.css";

/***/ }),

/***/ "dz0q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/m-company_ce48d91b8ce6057c0085dfc1c92885cb.css";

/***/ }),

/***/ "e3be":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/subscription-current-plan_b005fbc4cd99d421929d384d38442a36.css";

/***/ }),

/***/ "eCEw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/text-block_d5532ed820a947a03bb7b029dc95162b.css";

/***/ }),

/***/ "eDeh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("G1du");
__webpack_require__("mADV");
__webpack_require__("P9JW");
__webpack_require__("8gLI");
__webpack_require__("f3NB");
__webpack_require__("mYqq");
__webpack_require__("RJzm");
__webpack_require__("K3aT");
__webpack_require__("tOiF");
__webpack_require__("awAO");
__webpack_require__("SFnc");
__webpack_require__("HAK0");
__webpack_require__("p5KT");
__webpack_require__("0ts5");
__webpack_require__("Zou0");
__webpack_require__("70FE");
__webpack_require__("lcdN");
__webpack_require__("bXOc");
// import './upgradeOneProjectSvc';
__webpack_require__("6cdR");
__webpack_require__("oJMd");
__webpack_require__("X7JN");
__webpack_require__("wFE4");
__webpack_require__("3Rv0");
__webpack_require__("44/O");
__webpack_require__("MT/e");
__webpack_require__("Lxjv");
__webpack_require__("i57k");
__webpack_require__("Q9ed");
__webpack_require__("ogFo");
__webpack_require__("2SCq");


/***/ }),

/***/ "eE93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getCommonLinks(product) {
    switch (product) {
        case 'WAVE':
            return {
                pricing: '/pricing',
                facebook: "//www.facebook.com/" + (options.user && !options.user.anonymous ? 'groups/' : '') + "wave.video",
                twitter: '//twitter.com/wave_video',
                instagram: '//www.instagram.com/wave.video/',
                youtube: 'https://www.youtube.com/wavevideo'
            };
        case 'STUDIO':
        default:
            return {
                pricing: '/studio/pricing',
                facebook: '//www.facebook.com/TheAnimatron',
                github: '//github.com/Animatron',
                twitter: '//twitter.com/animatron',
                youtube: '//www.youtube.com/c/AnimatronHero'
            };
    }
}
exports.default = getCommonLinks;


/***/ }),

/***/ "eWSb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/week8_2728306d4c0b45401e4c8d98c61931d8.html";

/***/ }),

/***/ "eXN9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/wave-header_d5a58d020145b7055b0833d707c47141.html";

/***/ }),

/***/ "egLR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/m-landing-comparison_f9c7df2b339b40d4c6d4f19bcbd766de.css";

/***/ }),

/***/ "ekLA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/wave-webinar_00da0d8e04a6b8e5c0a1f1d6fe2e6e44.css";

/***/ }),

/***/ "f+kA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/video-steps_7e119904b4afedeb391587e0b410a8f5.css";

/***/ }),

/***/ "f37r":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/2.png";

/***/ }),

/***/ "f3NB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("jYQ6");
var blackList = [
    'transition superseded',
    'Possibly unhandled rejection'
];
function isSpecialError(exception) {
    var message = _.isError(exception) ? exception.message : exception;
    return blackList.some(function (item) { return message.includes(item); });
}
module_1.default.factory('$exceptionHandler', ["$log", function ($log) {
    return (function (exception, cause) {
        if (isSpecialError(exception)) {
            console.info(exception, cause);
        }
        else {
            if (false) {
                _.notification.showError('Exception: ' + exception);
            }
            $log.error(exception, cause);
        }
    });
}]);


/***/ }),

/***/ "f86U":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/like_4ab86247caa54544bfe9c4638b2b352d.html";

/***/ }),

/***/ "fAML":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/footer_edb1b22db6f28420acd620f73ceccb2d.css";

/***/ }),

/***/ "fSNa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/5.png";

/***/ }),

/***/ "fUJ1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/medium-landing_fae2d51642858d7049e23264a36ddb90.css";

/***/ }),

/***/ "fUhQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/wave-pricing_6a3edac5115943a66ff9f861fde6d497.css";

/***/ }),

/***/ "fbuv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/font-ko_7d0d1bf91b94a34aa300d1e3bc2470e4.css";

/***/ }),

/***/ "fxc3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Strings = (function () {
    function Strings() {
    }
    Strings.isBlank = function (str) {
        if (str == null)
            str = '';
        return (/^\s*$/).test(str);
    };
    Strings.capitalize = function (str) {
        str = str == null ? '' : String(str);
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    Strings.titleCase = function (str) {
        return str.replace('-', ' ').replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    };
    Strings.toCamelCase = function (name) {
        return name.replace(/-(\w)/g, function (match) { return match[1].toUpperCase(); });
    };
    Strings.toParams = function (str) {
        return (str || '')
            .split('&')
            .map(function (s) { return s.split('='); })
            .reduce(function (acc, arr) {
            acc[arr[0]] = arr[1] || true;
            return acc;
        }, {});
    };
    Strings.endsWith = function (str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    };
    ;
    Strings.encodeUsername = function (username) {
        return (username || '').replace(Strings.UsernameRegex, function (c) { return encodeURIComponent(c); });
    };
    Strings.sameUser = function (username) {
        return Strings.encodeUsername(options.user.username) === username;
    };
    Strings.removeUrlProtocol = function (url) {
        return _.isString(url) ? url.replace(/(http:|https:)/, '') : '';
    };
    return Strings;
}());
Strings.map = ['#', '+', ' ', '/', '\\\\'].join('');
Strings.UsernameRegex = new RegExp("[" + Strings.map + "]", 'g');
Strings.Tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;
Strings.CommentTags = /<!--[\s\S]*?-->|<\?[\s\S]*?\?>/gi;
// static stripTags = (input: string | string[]): string => {
Strings.stripTags = function (input) {
    return input ?
        (_.isArray(input) ?
            input.map(function (i) { return _.isString(i) ? i.replace(Strings.CommentTags, '') : i; })
            : input.replace(Strings.CommentTags, '').replace(Strings.Tags, ''))
        : '';
};
exports.Strings = Strings;


/***/ }),

/***/ "g108":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/subscription_d905c829f79c19efc8f1956355a0f479.css";

/***/ }),

/***/ "ghOg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var underscore_extensions_1 = __webpack_require__("R0iF");
var LoginCtrl = (function () {
    LoginCtrl.$inject = ["$sce", "$stateParams", "AuthenticationSvc", "HttpSvc"];
    function LoginCtrl($sce, $stateParams, AuthenticationSvc, HttpSvc) {
        var _this = this;
        this.$sce = $sce;
        this.$stateParams = $stateParams;
        this.AuthenticationSvc = AuthenticationSvc;
        this.HttpSvc = HttpSvc;
        this.login = {
            '@class': 'basic',
            email: undefined,
            password: undefined
        };
        this.requiredFields = ['email', 'password'];
        this.redirectMsg = this.$sce.trustAsHtml(this.AuthenticationSvc.loginRedirectMessage);
        this.isRedirectMsgVisible = this.AuthenticationSvc.loginRedirect;
        this.loading = false;
        this.invalidLogin = false;
        this.unknownError = false;
        this.hideModal = function () { return _this.AuthenticationSvc.loginModalShown = false; };
    }
    LoginCtrl.prototype.loginSubmit = function () {
        var _this = this;
        this.invalidLogin = false;
        this.unknownError = false;
        if (!this.correctForm())
            return;
        this.loading = true;
        this.HttpSvc('authenticate')
            .post(this.login, { headers: options.user.hash ? options.headers : {} })
            .then(function (r) { return r.data; }).then(function (response) {
            if (underscore_extensions_1.Utils.isApiError(response)) {
                _this.invalidLogin = true;
                return null;
            }
            else {
                var redirectUrl = _this.$stateParams.redirectUrl;
                if (redirectUrl) {
                    _this.AuthenticationSvc.loginRedirect = redirectUrl;
                }
                return _this.AuthenticationSvc.login(response);
            }
        }).catch(function () { return _this.unknownError = true; }).finally(function () { return _this.loading = false; });
    };
    LoginCtrl.prototype.openSignUp = function () {
        this.hideModal();
        var email = this.login.email;
        var params = email ? { email: email } : {};
        this.AuthenticationSvc.openSignUpPage(null, params);
    };
    LoginCtrl.prototype.correctForm = function () {
        var _this = this;
        return _.every(this.requiredFields, function (field) {
            return _.isString(_this.login[field]) && _this.login[field].length > 0;
        });
    };
    return LoginCtrl;
}());
module_1.default.component('login', {
    controller: LoginCtrl,
    templateUrl: __webpack_require__("zyTD")
});


/***/ }),

/***/ "gkLk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/landing-new-bottom_80a6070e9da934b8bdf8eecbfbd1eb2c.html";

/***/ }),

/***/ "gsWG":
/***/ (function(module, exports) {

var path = 'https://assets.animatron.com/html/education/education.html';
var html = "<tutorial-modal></tutorial-modal> <div class=\"long-head-top\"> <h1>{{::$root.t('edu.h1')}}</h1> <h3>{{::$root.t('edu.h3')}}</h3> <div class=\"nav-wrapper\"> <nav> <a ui-sref-active=\"active\" ui-sref=\"studio-education.week({week: 'week' + p})\" ng-repeat=\"p in pages\"> <span><i></i></span>{{::$root.t('edu.week')}} {{p}} </a> </nav> </div> </div> <div class=\"week-curriculum anm-block\"> <div class=\"week-curriculum-header\"> <span class=\"week{{week.number}}\">{{::$root.t('edu.week')}} {{week.number}}. {{week.title}}</span> <a class=\"next\" ng-hide=\"week.number == 8\" ui-sref=\"studio-education.week({week: week.number + 1 < 9 ? ('week' + (week.number + 1)) : ('week' + (week.number)) })\"></a> <a class=\"prev\" ng-hide=\"week.number == 1\" ui-sref=\"studio-education.week({week: week.number - 1 !== 0 ? ('week' + (week.number - 1)) : ('week' + (week.number)) })\"></a> </div> <div class=\"week-curriculum-content ui-view-container\"> <div class=\"well\" ui-view></div> </div> </div> ";
var angular = window.angular;
var injector = angular.element(document).injector();
if (injector) {
injector.get('$templateCache').put(path, html);
} else {
angular.module('templates').run(['$templateCache', function(c) { c.put(path, html) }]);
}
module.exports = path;

/***/ }),

/***/ "h+vD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/light/card-maker.png";

/***/ }),

/***/ "hACO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/search_ff0ea78cc43e88252829952d32e6a8b8.css";

/***/ }),

/***/ "hB9q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/3.png";

/***/ }),

/***/ "hQA3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/wave-my-projects_ee94836323e5eeb45038db9c6c34030d.css";

/***/ }),

/***/ "hVBH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/relation-list_fcee6a674e1a392f24e12648730540c0.css";

/***/ }),

/***/ "hYS4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/m-wave-pricing_e30868328736353bba167fa6157dd5ac.css";

/***/ }),

/***/ "hflI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/7.png";

/***/ }),

/***/ "hfrq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = angular.module('animatronApp.directives', []);


/***/ }),

/***/ "hqAA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/subscription-title_c7335fccb65d26b5b79dcea7097a7231.css";

/***/ }),

/***/ "hqwK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/light-landing_18846e796a9001542a164c9d69693e92.css";

/***/ }),

/***/ "i57k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var module_1 = __webpack_require__("jYQ6");
var WistiaSvc = (function () {
    WistiaSvc.$inject = ["$q", "$http"];
    function WistiaSvc($q, $http) {
        this.$q = $q;
        this.$http = $http;
        this.baseUrl = 'https://api.wistia.com/v1/';
        this.baseParams = {
            api_password: options.wistiaApiKey,
        };
    }
    WistiaSvc.prototype.getWistiaPlayer = function (wistiaId, options) {
        if (options === void 0) { options = {}; }
        var deferred = this.$q.defer();
        var videoPlayer = window.Wistia && window.Wistia.api(wistiaId);
        if (videoPlayer) {
            var waitForPlayer_1 = function () { return setTimeout(function () {
                videoPlayer = window.Wistia.api(wistiaId);
                if (videoPlayer.ready()) {
                    deferred.resolve(videoPlayer);
                }
                else {
                    waitForPlayer_1();
                }
            }, 100); };
            waitForPlayer_1();
        }
        else {
            window._wq = window._wq || [];
            window._wq.push({
                id: wistiaId,
                options: tslib_1.__assign({ videoFoam: true }, options),
                onReady: function (videoPlayer) {
                    deferred.resolve(videoPlayer);
                }
            });
        }
        return deferred.promise;
    };
    WistiaSvc.prototype.getMedia = function (id) {
        var url = this.baseUrl + "medias/" + id + ".json";
        return this.$http
            .get(url, {
            params: this.baseParams
        })
            .then(function (r) { return r.data; });
    };
    return WistiaSvc;
}());
exports.WistiaSvc = WistiaSvc;
module_1.default.service('wistiaSvc', WistiaSvc);


/***/ }),

/***/ "iKnz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var underscore_extensions_1 = __webpack_require__("R0iF");
var AutoplayVideo = (function () {
    AutoplayVideo.$inject = ["$rootScope", "$scope", "$element", "$sce"];
    function AutoplayVideo($rootScope, $scope, $element, $sce) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$element = $element;
        this.$sce = $sce;
        this.videoUrl = this.$sce.trustAsResourceUrl(options.retina && this.withRetina ? this.url + '_2x' : this.url);
    }
    AutoplayVideo.prototype.$onInit = function () {
        var video = this.$element[0].querySelector('video');
        var safe = function (f) { return video && _.isFunction(video[f]) && video[f](); };
        this.$rootScope.$on("onScreen:" + this.url, function () { return safe('play'); });
        this.$rootScope.$on("notOnScreen:" + this.url, function () { return safe('pause'); });
        if (options.handHeld && !AutoplayVideo.iOS) {
            underscore_extensions_1.Utils.scopedEvent('touchstart', this.$scope, function videoStart() {
                safe('play');
                window.removeEventListener('touchstart', videoStart);
            });
        }
        else {
            safe('pause');
        }
    };
    AutoplayVideo.prototype.$onDestroy = function () {
        _.isFunction(window.stop) && window.stop();
    };
    return AutoplayVideo;
}());
AutoplayVideo.iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
module_1.default.component('autoplayVideo', {
    bindings: {
        url: '@',
        width: '@',
        height: '@',
        withWebm: '<',
        withRetina: '<'
    },
    controller: AutoplayVideo,
    template: "<div>\n                    <video width=\"{{::$ctrl.width}}\" height=\"{{::$ctrl.height}}\" \n                           preload autoplay muted loop playsinline webkit-playsinline>\n                        <source ng-src=\"{{::$ctrl.videoUrl + '.webm'}}\" type=\"video/webm\" ng-if=\"::$ctrl.withWebm\">\n                        <source ng-src=\"{{::$ctrl.videoUrl + '.mp4'}}\"  type=\"video/mp4\">\n                    </video>\n                    <div id=\"{{::$ctrl.url}}\" class=\"middle\" is-on-screen></div>\n               </div>"
});


/***/ }),

/***/ "iLwr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/video-folder-move-modal_f1e7d86a09ec89290c0d54e6be1bab49.css";

/***/ }),

/***/ "ifp+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/9.png";

/***/ }),

/***/ "isPM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/bg-video_a9e8a5e5ade4f0b25d9c6f10d6f1051c.css";

/***/ }),

/***/ "j+wj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/signup_168ff3b46745c6d73c4bbe0d08e129b2.css";

/***/ }),

/***/ "j1Q3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ObjectId = (function () {
    function ObjectId() {
    }
    ObjectId.get = function () {
        var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
        return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function () {
            return (Math.random() * 16 | 0).toString(16);
        }).toLowerCase();
    };
    return ObjectId;
}());
exports.ObjectId = ObjectId;


/***/ }),

/***/ "j8J/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/header_e202879252ab7cc5156f970814aa00cb.css";

/***/ }),

/***/ "jPQQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/publish_483057ae8959d32aff74ca15baec1892.css";

/***/ }),

/***/ "jYQ6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = angular.module('animatronApp.services', []);


/***/ }),

/***/ "jmbb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/wave-project-item_56f53bab56c029410e237c60b4abc39f.css";

/***/ }),

/***/ "juL4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/11.png";

/***/ }),

/***/ "jwTf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/challenges-list-section_d751ed7c29ac252c9b74129b3ba51204.css";

/***/ }),

/***/ "k4sW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/section-video-steps_0e6a96756b77a01989ab9ff54633f28c.css";

/***/ }),

/***/ "kaOu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/form-field-warning_d9493706a2e05669b292c8c006c2e145.css";

/***/ }),

/***/ "kfHS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/background_0b60b555c525afb02ce32c8952cb9fd8.css";

/***/ }),

/***/ "kglB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/m-webinar_57ddba7d621ab37bf7d5dc782cc3abdf.css";

/***/ }),

/***/ "kmnB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/related-pages_85529654099b8c050eae5a729cc7f445.html";

/***/ }),

/***/ "kvRk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/political-landing_32672f94e4f7484f88b70608ca525d8a.html";

/***/ }),

/***/ "kvam":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/ask-popup_1cec3e9559dc08a81db21ca84cb6bb43.css";

/***/ }),

/***/ "l0GU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/press-swipable_a272feb90bfb37cd949ed398c72235a4.html";

/***/ }),

/***/ "l8ep":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/1.png";

/***/ }),

/***/ "lGv7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/terms-of-service_08ceeb83c6f1e8a3c47371c489644c1c.html";

/***/ }),

/***/ "lSTx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/m-landing-bottom_44bdfffa674b547146a59cf718582e1c.css";

/***/ }),

/***/ "lcdN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("jYQ6");
var NewsSvc = (function () {
    NewsSvc.$inject = ["$interval", "$timeout", "HttpSvc", "LocalStorageSvc"];
    function NewsSvc($interval, $timeout, HttpSvc, LocalStorageSvc) {
        this.$interval = $interval;
        this.$timeout = $timeout;
        this.HttpSvc = HttpSvc;
        this.LocalStorageSvc = LocalStorageSvc;
        this.delayUpdateNews = 36e+5;
        this.currentIndex = 0;
        this.newsList = [];
        this.deferRun = true;
        this.deferRunTimer = 1000;
        this.httpNews = HttpSvc('news');
    }
    NewsSvc.prototype.isEqualUsers = function (user) {
        var copyUser = angular.copy(user);
        delete copyUser.auth;
        var isEqual = this.currentUser ? _.isEqual(this.currentUser, copyUser) : false;
        this.currentUser = copyUser;
        return isEqual;
    };
    NewsSvc.prototype.onUserChanged = function (user) {
        var _this = this;
        if (this.isEqualUsers(user))
            return;
        if (this.deferRun) {
            this.$timeout(function () {
                _this.getNews();
                _this.deferRun = false;
            }, this.deferRunTimer);
        }
        else {
            this.getNews();
        }
    };
    NewsSvc.prototype.getNews = function () {
        var _this = this;
        var httpNews = this.httpNews.chain(new Date().getTimezoneOffset());
        this.newsList = [];
        var request = options.user.anonymous ? httpNews.get() : httpNews.secureGet();
        request.then(function (r) { return r.data; }).then(function (res) { return _this.newsList = options.user.anonymous ? _this.getWhiteList(res) : res; });
        this.$interval.cancel(this.stopUpdateNews);
        this.stopUpdateNews = this.$interval(function () { return _this.getNews(); }, this.delayUpdateNews);
    };
    NewsSvc.prototype.getWhiteList = function (NewsList) {
        var deletedNewsList = this.LocalStorageSvc.get('deletedNewsList');
        if (deletedNewsList) {
            return NewsList.filter(function (newsItem) { return !_.contains(deletedNewsList, newsItem.id); });
        }
        return NewsList;
    };
    NewsSvc.prototype.addDeletedItemId = function (deleteId) {
        var deletedNewsList = this.LocalStorageSvc.get('deletedNewsList') || [];
        deletedNewsList.push(deleteId);
        this.LocalStorageSvc.set('deletedNewsList', deletedNewsList);
    };
    NewsSvc.prototype.deleteNews = function (id) {
        if (_.isEmpty(this.newsList))
            return;
        var deleteNews = _.findWhere(this.newsList, { id: id });
        this.newsList = _.without(this.newsList, deleteNews);
        if (options.user.anonymous) {
            this.addDeletedItemId(deleteNews.id);
        }
        else {
            this.httpNews.chain(deleteNews.id).secureDelete();
        }
    };
    return NewsSvc;
}());
exports.NewsSvc = NewsSvc;
module_1.default.service('NewsSvc', NewsSvc);


/***/ }),

/***/ "ldoD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/modal-video_304c67bd6f9c267b191bf2548b4da54e.html";

/***/ }),

/***/ "lu/X":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/animations_af7ac59f5208cc73b239c08da97d009a.css";

/***/ }),

/***/ "luA4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/15.svg";

/***/ }),

/***/ "lvE2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("3H1O");
__webpack_require__("5hi/");
__webpack_require__("KBdS");
__webpack_require__("4sGx");
__webpack_require__("CRNW");
__webpack_require__("a8RW");
__webpack_require__("aLLS");
__webpack_require__("FUIZ");
__webpack_require__("EXaJ");
__webpack_require__("B6ri");
__webpack_require__("q3WU");
__webpack_require__("/pFW");
__webpack_require__("C4lS");
__webpack_require__("FD1p");
__webpack_require__("oeVo");
__webpack_require__("UYjX");
__webpack_require__("4HmH");
__webpack_require__("AgC3");
__webpack_require__("5uTM");
__webpack_require__("Sct3");
__webpack_require__("xNor");
__webpack_require__("udNi");
__webpack_require__("+hc0");
__webpack_require__("9UtH");
__webpack_require__("G8ZG");
__webpack_require__("Om8q");
__webpack_require__("T1Il");
__webpack_require__("XaSg");
__webpack_require__("ghOg");
__webpack_require__("mqJy");
__webpack_require__("YAt/");
__webpack_require__("pVk+");
__webpack_require__("dwQs");
__webpack_require__("b1d7");
__webpack_require__("RIrZ");
__webpack_require__("IXUN");
__webpack_require__("FdTb");
__webpack_require__("oeUM");
__webpack_require__("GWJA");
__webpack_require__("T3B4");
__webpack_require__("XrJM");
__webpack_require__("sJU7");
__webpack_require__("FoMv");
__webpack_require__("PXh8");
__webpack_require__("a+yw");
__webpack_require__("w9R6");
__webpack_require__("iKnz");
__webpack_require__("Y8iI");
__webpack_require__("aOC8");
__webpack_require__("8dlX");
__webpack_require__("6M8O");
__webpack_require__("v1FL");
__webpack_require__("IGC9");
__webpack_require__("YeFr");
__webpack_require__("Dmwp");
__webpack_require__("4NXJ");


/***/ }),

/***/ "lwEL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/drag-item_d85de153a9841d04cb7a1dcd10d44e64.css";

/***/ }),

/***/ "mADV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("jYQ6");
var Strings_1 = __webpack_require__("fxc3");
var AnimatronPreviews = (function () {
    function AnimatronPreviews() {
    }
    AnimatronPreviews.prototype.computeHeight = function (height, width, computedWidth, maxHeight) {
        if (typeof maxHeight === 'undefined') {
            maxHeight = options.handHeld ? 1400 : 700;
        }
        var minHeight = 80;
        var computedHeight = (height || 450) / (width || 550) * computedWidth;
        return Math.min(maxHeight, Math.max(minHeight, computedHeight));
    };
    ;
    AnimatronPreviews.prototype.pickPreview = function (previews, width) {
        if (width === void 0) { width = 720; }
        var picked = _.find(previews, function (preview) {
            return /.*\/[a-z\d]*.(png|jpg)$/.test(preview) ||
                new RegExp('.*\/[a-z\\d\\_]*(-0)?_' + width + '.(png|jpg)$').test(preview);
        });
        if (angular.isUndefined(picked)) {
            if (angular.isArray(previews) && previews.length > 0) {
                return Strings_1.Strings.removeUrlProtocol(previews[0]);
            }
            else {
                return '';
            }
        }
        else {
            return Strings_1.Strings.removeUrlProtocol(picked);
        }
    };
    ;
    return AnimatronPreviews;
}());
exports.AnimatronPreviews = AnimatronPreviews;
module_1.default.service('AnimatronPreviews', AnimatronPreviews);


/***/ }),

/***/ "mIzu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/search-page_54d8c1c459485c5bfc9e9b16c5be2b36.css";

/***/ }),

/***/ "mQW2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/8.png";

/***/ }),

/***/ "mWZi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/404_bafb4a95032c40a7b1b9af718a95eb4e.html";

/***/ }),

/***/ "mYqq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var module_1 = __webpack_require__("jYQ6");
var Strings_1 = __webpack_require__("fxc3");
var lazy_modules_1 = __webpack_require__("bUzP");
var PlayerSvc = (function () {
    PlayerSvc.$inject = ["$location", "$log", "$http", "$filter", "$q", "BackendSvc", "$ocLazyLoad"];
    function PlayerSvc($location, $log, $http, $filter, $q, BackendSvc, $ocLazyLoad) {
        var _this = this;
        this.$location = $location;
        this.$log = $log;
        this.$http = $http;
        this.$filter = $filter;
        this.$q = $q;
        this.BackendSvc = BackendSvc;
        this.$ocLazyLoad = $ocLazyLoad;
        this.gwtPlayer = this.isGwt();
        this.fps = parseInt(this.$location.search().fps, 10);
        this.resetPlayer = function (playerPromise) { return _this.$q(function (resolve, reject) {
            var reset = function (player) {
                try {
                    _this.$log.debug('Reseting player', player);
                    if (player) {
                        if (player.invalidate) {
                            player.invalidate();
                            player.detach();
                        }
                        else if (player.release) {
                            player.release();
                        }
                        delete PlayerSvc.Cache[player.id];
                    }
                    resolve();
                }
                catch (e) {
                    // make it just resolve, since player throws a lot of errors during invalidation
                    resolve();
                    // this.$log.error(e);
                    // reject();
                }
            };
            _this.$q.resolve(playerPromise).then(reset);
        }); };
        this.getProjectId = function (project) { return project.id ? project.id : project; };
        this.getProjectBackendUrl = function (projectId) {
            return _this.BackendSvc.getProjectBackend(projectId).then(function (url) {
                return url + '/project/export/json/' + projectId + '?';
            });
        };
        this.getProjectUrl = _.memoize(function (project) { return _this.$q(function (resolve) {
            if (typeof project === 'string') {
                resolve(project);
            }
            else if (!Strings_1.Strings.isBlank(project.cdnContentUrl) && project.cdnVersion === project.version && !project.needsRepublish) {
                resolve(project.cdnContentUrl + '?');
            }
            else if (Strings_1.Strings.isBlank(project.serverUrl)) {
                return _this.getProjectBackendUrl(project.id);
            }
            else {
                if (_this.isCdnUrl(project.serverUrl)) {
                    resolve(project.serverUrl + '/' + project.id + '.json?');
                }
                else {
                    resolve('//' + project.serverUrl.replace(':80', '') + '/project/export/json/' + project.id + '?');
                }
            }
        }); }, this.getProjectId);
        if (this.gwtPlayer) {
            this.anmPromise = _.once(function () { return $ocLazyLoad.load(_this.$location.search().pUrl || 'https://player-dev.animatron.com/v2.0/player.js')
                .then(function () { return $q(function (resolve) {
                var check = function () {
                    if (!window.animatron) {
                        setTimeout(function () { return check(); }, 50);
                        return;
                    }
                    var player = window.animatron.Player.prototype;
                    player.isPaused = player.isPaused || player.isStopped;
                    player.pause = player.pause || player.stop;
                    resolve(window.animatron);
                };
                check();
            }); }); });
        }
        else {
            this.anmPromise = _.once(function () { return $ocLazyLoad.load(lazy_modules_1.playerUrl()).then(function () {
                var anm = window.anm;
                _this.decoratePlayer(anm);
                _this.animatronImporter = new anm.importers.animatron();
                return anm;
            }); });
        }
    }
    PlayerSvc.prototype.getAnm = function (func) {
        return this.anmPromise().then(function (anm) { return func(anm); });
    };
    PlayerSvc.prototype.resetPlayerById = function (canvasId) {
        this.resetPlayer(this.getPlayer(canvasId));
    };
    PlayerSvc.prototype.getPlayer = function (id) {
        return PlayerSvc.Cache[id];
    };
    PlayerSvc.prototype.instances = function () {
        return _.values(PlayerSvc.Cache);
    };
    PlayerSvc.prototype.getJson = function (project, params, forceAnonymous) {
        var _this = this;
        if (forceAnonymous === void 0) { forceAnonymous = false; }
        if (project.anim)
            return this.$q.resolve(project);
        return this.getProjectUrl(project).then(function (jsonUrl) {
            if (params.width && params.height) {
                if (jsonUrl.indexOf('?') === -1)
                    jsonUrl += '?';
                jsonUrl += '&w=' + params.width + '&h=' + params.height;
            }
            var needAuth = !forceAnonymous && !options.user.anonymous && !_this.isCdnUrl(jsonUrl)
                && (project.isOwner || !project.editorReadAccess);
            var httpOpts = {
                headers: needAuth ? options.headers : {}
            };
            var filteredUrl = _this.$filter('removeUrlProtocol')(jsonUrl);
            return _this.$http.get(filteredUrl, httpOpts).then(function (r) { return r.data; });
        });
    };
    PlayerSvc.prototype.createPlayer = function (project, divId, params, callback, callback2, forceAnonymous) {
        var _this = this;
        if (forceAnonymous === void 0) { forceAnonymous = false; }
        if (!project)
            throw new Error('Empty project was passed to createPlayer');
        var path = this.$location.path();
        params.width = params.width || project.width;
        params.height = params.height || project.height;
        if (this.fps) {
            params.fps = this.fps;
        }
        var promises = [this.anmPromise(), this.getJson(project, params, forceAnonymous)];
        return this.$q.all(promises)
            .then(function (_a) {
            var anm = _a[0], jsonObj = _a[1];
            if (_this.$location.path() !== path) {
                return _this.$q.reject('Location has changed since create request issued');
            }
            return _this.loadPlayer(jsonObj, divId, params, anm, callback, callback2);
        }).catch(function (e) {
            if (!/Location has changed/.test(e)) {
                _this.$log.error('Error creating player:', e);
            }
            return null;
        });
    };
    PlayerSvc.prototype.loadPlayer = function (jsonObj, divId, params, anm, callback, callback2) {
        if (jsonObj.anim.script && !this.gwtPlayer) {
            params = _.extend(params, {
                handleEvents: true, autoPlay: true, controlsEnabled: false, infiniteDuration: true
            });
        }
        var player = anm.createPlayer(divId, params);
        var wrappedCallback = function () { return callback && callback(player); };
        // if (PlayerSvc.Cache[divId]) throw new Error('Player is already attached to ' + divId);
        PlayerSvc.Cache[divId] = player;
        if (callback2)
            callback2();
        if (this.gwtPlayer) {
            player.load(jsonObj, wrappedCallback);
            player.setDebug(true);
        }
        else {
            player.load(jsonObj, this.animatronImporter, wrappedCallback);
        }
        this.checkAspectRatio(jsonObj.anim.dimension, params);
        return player;
    };
    PlayerSvc.prototype.isGwt = function () {
        return (this.$location.search().gwt || !true) && !this.$location.search().old;
    };
    PlayerSvc.prototype.checkAspectRatio = function (_a, _b) {
        var originalWidth = _a[0], originalHeight = _a[1];
        var width = _b.width, height = _b.height;
        var originalAspectRatio = originalWidth / originalHeight;
        var newAspectRatio = width / height;
        if (originalAspectRatio.toFixed(2) !== newAspectRatio.toFixed(2)) {
            this.$log.warn('Specified width & height is not correct', { originalAspectRatio: originalAspectRatio, newAspectRatio: newAspectRatio, originalHeight: originalHeight, originalWidth: originalWidth, width: width, height: height });
        }
    };
    PlayerSvc.prototype.isCdnUrl = function (url) {
        return url.indexOf('//clips.animatron') > -1 || url.indexOf('//publish.animatron') > -1;
    };
    // @formatter:off
    PlayerSvc.prototype.decoratePlayer = function (anm) {
        var player = anm.Player.prototype;
        var happens = function (p) { return p.happens || (p.state && p.state.happens) || anm.constants.STOPPED; };
        player.isPlaying = player.isPlaying || function () { return happens(this) === anm.constants.PLAYING; };
        player.isPaused = player.isPaused || function () { return happens(this) === anm.constants.PAUSED; };
        player.isStopped = player.isStopped || function () { return happens(this) === anm.constants.STOPPED; };
        player.getTime = player.getTime || function () { return this.state.time; };
        player.setSize = player.setSize || function (width, height) { return this._resize(width, height); };
    };
    return PlayerSvc;
}());
PlayerSvc.Cache = {};
exports.PlayerSvc = PlayerSvc;
var OldPlayer = (function (_super) {
    tslib_1.__extends(OldPlayer, _super);
    function OldPlayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OldPlayer.prototype.isGwt = function () {
        return false;
    };
    return OldPlayer;
}(PlayerSvc));
// FIXME rename to PlayerSvc
module_1.default.service('Player', PlayerSvc);
module_1.default.service('PlayerSvc', PlayerSvc);
module_1.default.service('OldPlayer', OldPlayer);


/***/ }),

/***/ "mqJy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var SpinnerSvc_1 = __webpack_require__("pPBV");
var AdSvc_1 = __webpack_require__("X7JN");
var ExploreCtrl = (function () {
    ExploreCtrl.$inject = ["$scope", "$state", "$rootScope", "$location", "AnimatronProjects", "TranslateSvc"];
    function ExploreCtrl($scope, $state, $rootScope, $location, AnimatronProjects, TranslateSvc) {
        var _this = this;
        this.$scope = $scope;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.AnimatronProjects = AnimatronProjects;
        this.TranslateSvc = TranslateSvc;
        this.contestType = 'USER';
        this.TabParams = {
            'most-plays': {
                sortBy: 'views',
                minViews: 1,
                minVersion: ExploreCtrl.DefMinVersion,
                noCount: true
            },
            'staff-picks': {
                sortBy: 'tag_creation_time',
                tag: 'Staff Picks',
                tag_type: 'SUPER',
                minVersion: ExploreCtrl.DefMinVersion,
                noCount: true
            },
            'contest-submissions': {
                sortBy: 'tag_creation_time',
                tag_type: 'CONTEST',
                minVersion: 0,
                contestType: this.contestType //TODO should be changed
            },
            'recently-added': {
                minVersion: ExploreCtrl.DefMinVersion,
                noCount: true
            },
            'my-projects': {}
        };
        this.tabsConfig = {
            'my-projects': options.user.anonymous,
            'contest-submissions': !options.enableContests
        };
        this.trackerFunction = angular.noop;
        $scope.$on('$destroy', function () {
            angular.element(window).unbind('scroll', _this.trackerFunction);
        });
        $scope.$watch(function () { return _this.contestType; }, function () { return _this.contestType && _this.onTabChange(_this.currentTab); });
        if ($location.search().confirmationSent) {
            _.notification.showSuccess(TranslateSvc.get('profile.confirmation-sent'));
            $location.url($location.path()).replace();
        }
        if ($location.search().login) {
            $location.url($location.path()).replace();
        }
    }
    ExploreCtrl.prototype.onTabChange = function (currentHash) {
        if (!currentHash)
            return;
        if (!this.tabs.includes(currentHash))
            currentHash = 'staff-picks';
        this.currentTab = currentHash;
        this.isStaffPicks = currentHash === 'staff-picks';
        this.$scope.animatron = this.getNewProjectService(currentHash);
        this.$scope.animatron.nextPage().then(function () { return SpinnerSvc_1.default.hide(); });
    };
    ;
    ExploreCtrl.prototype.getNewProjectService = function (currentTab) {
        var ownProjects = currentTab === 'my-projects';
        this.$scope.AdSvc = new AdSvc_1.AdSvc(!ownProjects, this.$rootScope);
        var tabParams = this.TabParams[currentTab];
        if (!tabParams) {
            throw new Error("cannot find svc params for tab - '" + currentTab + "'");
        }
        if (this.$state.params.product && options.user.staff) {
            tabParams.product = this.$state.params.product;
            tabParams.minVersion = 0;
        }
        return new this.AnimatronProjects(Object.assign({}, tabParams), ownProjects, this.cdnUrlCondition() ? ExploreCtrl.CdnUrl : '', this.$scope.AdSvc.adify.bind(this.$scope.AdSvc));
    };
    ExploreCtrl.prototype.cdnUrlCondition = function () {
        return true && this.isStaffPicks && !options.user.staff;
    };
    return ExploreCtrl;
}());
ExploreCtrl.DefMinVersion = 100;
ExploreCtrl.CdnUrl = 'https://d36bq5zmf7yjgb.cloudfront.net';
exports.ExploreCtrl = ExploreCtrl;
module_1.default.component('explorePage', {
    controllerAs: 'ExploreCtrl',
    controller: ExploreCtrl,
    templateUrl: __webpack_require__("6XG8")
});


/***/ }),

/***/ "n4af":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/subscription-payment-details-with-card_a52c683207544b8223e836314926ecb9.css";

/***/ }),

/***/ "nAeZ":
/***/ (function(module, exports, __webpack_require__) {

var path = 'https://assets.animatron.com/html/landing/landing-new.html';
var html = "<section class=\"landing-top\"> <div class=\"landing-top-content column\"> <h1>{{::$root.t('landing.title')}}</h1> <div class=\"flex-row\"> <div class=\"video-content\"> <div class=\"landing-video-preview\"> <wistia-player video=\"$ctrl.video\" options=\"$ctrl.videoOptions\"></wistia-player> </div> </div> <div class=\"text-content\"> <ul> <li class=\"explainer\"> <a href=\"/studio/explainer-video-maker\">{{::$root.t('landing.top.li1')}}</a> </li> <li class=\"whiteboard\"> <a href=\"/studio/whiteboard-animation-software\">{{::$root.t('landing.top.li2')}}</a> </li> <li class=\"banner\"> <a href=\"/studio/html5-banner-maker\">{{::$root.t('landing.top.li3')}}</a> </li> <li class=\"html5\">{{::$root.t('landing.top.li4')}}</li> <li class=\"stunning-presentation\"> <a href=\"/studio/presentation-maker\">{{::$root.t('landing.top.li5')}}</a> </li> </ul> </div> </div> </div> </section> <static-include src=\"" + __webpack_require__("gkLk") + "\"></static-include> ";
var angular = window.angular;
var injector = angular.element(document).injector();
if (injector) {
injector.get('$templateCache').put(path, html);
} else {
angular.module('templates').run(['$templateCache', function(c) { c.put(path, html) }]);
}
module.exports = path;

/***/ }),

/***/ "nCcs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/banner-bottom_e4b19823ba51c9f80d740385b9a69f3f.css";

/***/ }),

/***/ "nKgT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/buttons_ff85d545e2644efc077574acda118992.css";

/***/ }),

/***/ "nNID":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/light/pattern-light-landing-bottom.svg";

/***/ }),

/***/ "nSa/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/win-prizes-list_d41d8cd98f00b204e9800998ecf8427e.css";

/***/ }),

/***/ "o4OY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/subscription-total-price_4c34f4424121a82b06964267cd14a253.css";

/***/ }),

/***/ "oJMd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lazy_modules_1 = __webpack_require__("bUzP");
var module_1 = __webpack_require__("jYQ6");
/**
 * Singleton class to track current users followers globally
 * FIXME refresh on logout?
 */
var MyFollowings = (function () {
    MyFollowings.$inject = ["$rootScope", "$ocLazyLoad", "$q"];
    function MyFollowings($rootScope, $ocLazyLoad, $q) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$ocLazyLoad = $ocLazyLoad;
        this.$q = $q;
        this.init = _.once(function () { return _this.$q(function (resolve) {
            lazy_modules_1.animatronUserPage().then(function (a) { return _this.$ocLazyLoad.load(a); }).then(function () {
                var factory = angular.element(document).injector().get('FollowersSvc');
                _this.followersSvc = new factory(true, 'studio-following', false);
                resolve(_this.followersSvc);
                _this.$rootScope.$on('user:login', function () {
                    return _this.followersSvc = new factory(true, 'studio-following', false);
                });
            });
        }); });
    }
    return MyFollowings;
}());
exports.MyFollowings = MyFollowings;
module_1.default.service('MyFollowings', MyFollowings);


/***/ }),

/***/ "odw/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/subscription-current-plan-container_d41d8cd98f00b204e9800998ecf8427e.css";

/***/ }),

/***/ "oeUM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
module_1.default.component('projectItem', {
    bindings: {
        project: '<',
        showVisibility: '<',
        isStaffPicks: '<'
    },
    templateUrl: __webpack_require__("v/Ys")
});


/***/ }),

/***/ "oeVo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var underscore_extensions_1 = __webpack_require__("R0iF");
var UserPopup = (function () {
    UserPopup.$inject = ["$scope", "$filter", "$timeout", "$q", "HttpSvc", "AnimatronProjects", "MyFollowings"];
    function UserPopup($scope, $filter, $timeout, $q, HttpSvc, AnimatronProjects, MyFollowings) {
        var _this = this;
        this.$scope = $scope;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$q = $q;
        this.HttpSvc = HttpSvc;
        this.AnimatronProjects = AnimatronProjects;
        this.MyFollowings = MyFollowings;
        this.load = _.once(function () {
            _this.loaded = true;
            var username = _this.$filter('encodeUsername')(_this.user.username);
            if (UserPopup.userCache[_this.user.username]) {
                _this.user = UserPopup.userCache[_this.user.username];
            }
            else {
                _this.fetchAndCacheInfo(username);
            }
            _this.MyFollowings.init().then(function (svc) { return _this.followersSvc = svc; });
        });
        this.size = this.size || 20;
    }
    UserPopup.prototype.show = function (e) {
        var _this = this;
        this.load();
        if (this.shown) {
            this.$timeout.cancel(this.hideTimer); //the case when user hovers on popup-opener before animation ends(300ms)
        }
        else {
            this.pickPosition(e);
        }
        this.showTimer = this.$timeout(function () { return _this.shown = true; }, 500);
    };
    UserPopup.prototype.hide = function () {
        var _this = this;
        this.$timeout.cancel(this.showTimer);
        this.hideTimer = this.$timeout(function () { return _this.shown = false; }, 300); //transition duration
    };
    UserPopup.prototype.pickPosition = function (e) {
        var _this = this;
        underscore_extensions_1.Utils.rAF(function () {
            var scrollY = window.scrollY || document.documentElement.scrollTop;
            var topLeft = e.pageX + UserPopup.PopupWidth > window.innerWidth;
            var topRight = e.pageY + UserPopup.PopupHeight > (scrollY + window.innerHeight);
            if (topLeft && topRight) {
                _this.position = 'top-left';
            }
            else if (topRight || _this.disableBottom) {
                _this.position = 'top-right';
            }
            else if (!topLeft && !topRight) {
                _this.position = 'bottom-right';
            }
            else {
                _this.position = 'bottom-left';
            }
            _this.$scope.$apply();
        });
    };
    UserPopup.prototype.fetchAndCacheInfo = function (username) {
        var _this = this;
        this.loading = true;
        this.$q.all([
            new this.AnimatronProjects({ username: username, limit: 3, sortBy: 'views' }).nextPage(),
            this.HttpSvc(username, 'profile').get()
        ]).then(function (_a) {
            var prj = _a[0], usr = _a[1];
            _this.loading = false;
            _this.user = usr.data;
            _this.user.projects = prj.results;
            _this.user.projectsCount = prj.count;
            UserPopup.userCache[_this.user.username] = _this.user;
        });
    };
    return UserPopup;
}());
UserPopup.userCache = {};
UserPopup.PopupWidth = 400 + 50; //50 is offset
UserPopup.PopupHeight = 245 + 50; //50 is offset
module_1.default.component('userPopup', {
    bindings: {
        size: '<',
        user: '<',
        avatarOnly: '<',
        disableBottom: '<'
    },
    controller: UserPopup,
    templateUrl: __webpack_require__("cq6s")
});


/***/ }),

/***/ "ogFo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var module_1 = __webpack_require__("jYQ6");
var underscore_extensions_1 = __webpack_require__("R0iF");
var SpinnerSvc_1 = __webpack_require__("pPBV");
exports.FOLDER_DATA_CHANGED = 'wave/videoFolder/changeData';
exports.TREE_ITEM_SELECTED = 'wave/videoFolder/tree/itemSelected';
exports.FOLDER_TREE_DATA_CHANGED = 'wave/videoFolder/tree/changeData';
function isFolder(folder) {
    return folder.slug && folder.projects;
}
exports.isFolder = isFolder;
var VideoFolderSvc = (function () {
    VideoFolderSvc.$inject = ["$q", "$cacheFactory", "$rootScope", "TranslateSvc", "HttpSvc"];
    function VideoFolderSvc($q, $cacheFactory, $rootScope, TranslateSvc, HttpSvc) {
        var _this = this;
        this.$q = $q;
        this.$cacheFactory = $cacheFactory;
        this.$rootScope = $rootScope;
        this.TranslateSvc = TranslateSvc;
        this.HttpSvc = HttpSvc;
        this.currentUser = options.user;
        this.baseRequestParams = {
            product: 'WAVE'
        };
        this.httpCache = this.$cacheFactory('video-folder');
        this.newFolder = {};
        this.emitDataChanged = function () {
            _this.$rootScope.$emit(exports.FOLDER_DATA_CHANGED);
        };
        this.emitTreeItemSelected = function (folderId) {
            _this.$rootScope.$emit(exports.TREE_ITEM_SELECTED, folderId);
        };
        this.emitTreeDataChanged = function () {
            _this.$rootScope.$emit(exports.FOLDER_TREE_DATA_CHANGED);
        };
    }
    VideoFolderSvc.prototype.isChild = function (parent, child) {
        var check = function (f) {
            if (!f.folder) {
                return false;
            }
            else if (f.folder.id === parent.id) {
                return true;
            }
            else {
                return check(f.folder);
            }
        };
        return this.getTreeById(child.id).then(check);
    };
    VideoFolderSvc.prototype.sortByCreatedDate = function (folders) {
        return _.sortBy(folders, function (folder) { return -(new Date(folder.created).getTime()); });
    };
    VideoFolderSvc.prototype.isNewFolder = function (folder) {
        return folder.id === this.newFolder.id;
    };
    VideoFolderSvc.prototype.setNewCreatedFolder = function (newFolder) {
        this.newFolder = newFolder;
    };
    VideoFolderSvc.prototype.clearNewCreatedFolder = function (folder) {
        if (this.newFolder.id === folder.id) {
            this.newFolder = {};
        }
    };
    VideoFolderSvc.prototype.create = function (createParams) {
        var _this = this;
        var params = this.getParams(createParams);
        var url = "?" + params;
        this.onFolderUpdate();
        return this.makeRequest('securePost', url)
            .then(function (folder) {
            _this.setNewCreatedFolder(folder);
            return folder;
        });
    };
    VideoFolderSvc.prototype.get = function (folderId) {
        var params = this.getParams({ folderId: folderId });
        var url = "/fetch?" + params;
        return this.makeRequest('secureGet', url, { cache: this.httpCache });
    };
    VideoFolderSvc.prototype.getByPath = function (path) {
        var params = this.getParams({ path: "/" + (path || '') });
        var url = "/fetch?" + params;
        return this.makeRequest('secureGet', url, { cache: this.httpCache });
    };
    VideoFolderSvc.prototype.getRoot = function (username) {
        if (username === void 0) { username = this.currentUser.username; }
        var params = this.getParams();
        var url = "/users/" + encodeURIComponent(username) + "?" + params;
        return this.makeRequest('secureGet', url, { cache: this.httpCache });
    };
    VideoFolderSvc.prototype.getFolderTree = function (username) {
        var _this = this;
        if (username === void 0) { username = this.currentUser.username; }
        var params = this.getParams();
        var url = "/users/" + encodeURIComponent(username) + "/tree?" + params;
        return this.makeRequest('secureGet', url, { cache: this.httpCache })
            .then(function (rootFolder) {
            rootFolder.name = _this.TranslateSvc.get('wv.folder.breadcrumb.my-projects');
            return rootFolder;
        });
    };
    VideoFolderSvc.prototype.moveProject = function (moveParams) {
        this.onFolderUpdate();
        var params = this.getParams(moveParams);
        var url = "/project/move?" + params;
        var request = this.makeRequest('securePut', url);
        SpinnerSvc_1.default.withSpinner(request);
        request.then(this.emitDataChanged);
        return request;
    };
    VideoFolderSvc.prototype.moveFolder = function (moveParams) {
        var params = this.getParams(moveParams);
        var url = "/move?" + params;
        this.onFolderUpdate();
        var request = this.makeRequest('securePut', url);
        SpinnerSvc_1.default.withSpinner(request);
        request.then(this.emitDataChanged);
        return request;
    };
    VideoFolderSvc.prototype.deleteFolder = function (deleteParams) {
        var params = this.getParams(deleteParams);
        var url = "/delete?" + params;
        this.onFolderUpdate();
        return this.makeRequest('secureDelete', url).then(this.emitDataChanged);
    };
    VideoFolderSvc.prototype.renameFolder = function (renameFolderParams) {
        var params = this.getParams(renameFolderParams);
        var url = "/rename?" + params;
        this.onFolderUpdate();
        return this.makeRequest('securePut', url).then(this.emitDataChanged);
    };
    VideoFolderSvc.prototype.findInTree = function (folderId) {
        var find = function (parentFolder) {
            var result;
            if (parentFolder.id === folderId || !folderId)
                return parentFolder;
            parentFolder.folders.some(function (folder) {
                result = find(folder);
                return !!result;
            });
            return result;
        };
        return this.getFolderTree().then(function (parentFolder) { return find(parentFolder); });
    };
    VideoFolderSvc.prototype.getTreeById = function (folderId) {
        var find = function (parentFolder) {
            var result;
            if (parentFolder.id === folderId || !folderId)
                return parentFolder;
            parentFolder.folders.forEach(function (folder) {
                var childFolder = find(folder);
                if (childFolder) {
                    result = tslib_1.__assign({}, parentFolder, { folder: childFolder });
                }
            });
            return result;
        };
        return this.getFolderTree().then(function (parentFolder) { return find(parentFolder); });
    };
    VideoFolderSvc.prototype.getTreeByPath = function (folderPath) {
        if (!folderPath)
            return this.$q.resolve({});
        var slugs = folderPath.split('/');
        var find = function (parentFolder) {
            var currentSlug = slugs[0];
            currentSlug && parentFolder.folders.forEach(function (folder) {
                if (folder.slug === currentSlug) {
                    slugs = slugs.slice(1);
                    find(folder);
                    parentFolder.folder = folder;
                }
            });
            return parentFolder;
        };
        return this.getFolderTree().then(function (parentFolder) { return find(parentFolder); });
    };
    VideoFolderSvc.prototype.removeFolderFromTree = function (folderTree, excludeFolder) {
        var _this = this;
        if (folderTree.id === excludeFolder.parentId) {
            folderTree.folders = folderTree.folders.filter(function (folder) { return folder.id !== excludeFolder.id; });
        }
        else {
            folderTree.folders = folderTree.folders.map(function (folder) { return _this.removeFolderFromTree(folder, excludeFolder); });
        }
        return tslib_1.__assign({}, folderTree);
    };
    VideoFolderSvc.prototype.onFolderUpdate = function () {
        this.httpCache.removeAll();
    };
    VideoFolderSvc.prototype.makeRequest = function (method, url, config) {
        if (config === void 0) { config = {}; }
        var request = this.HttpSvc("folder" + url)["" + method](config)
            .then(function (r) { return r.data; });
        return this.requestErrorHandler(request);
    };
    VideoFolderSvc.prototype.requestErrorHandler = function (request) {
        var _this = this;
        return request.then(function (data) {
            var code = data.code;
            return !code || code < 300
                ? _this.$q.resolve(data)
                : _this.$q.reject(data);
        });
    };
    VideoFolderSvc.prototype.getParams = function (params) {
        if (params === void 0) { params = {}; }
        return underscore_extensions_1.Utils.toParams(tslib_1.__assign({}, this.baseRequestParams, params));
    };
    return VideoFolderSvc;
}());
exports.VideoFolderSvc = VideoFolderSvc;
module_1.default.service('videoFolderSvc', VideoFolderSvc);


/***/ }),

/***/ "omcN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/wave-trail_2384150959ed5017888c3f1008100d3b.css";

/***/ }),

/***/ "ovcP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/week5_35c5f9c4744070576482054f3f6ee6d8.html";

/***/ }),

/***/ "p5KT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("jYQ6");
var BackendSvc = (function () {
    BackendSvc.$inject = ["HttpSvc", "$q"];
    function BackendSvc(HttpSvc, $q) {
        var _this = this;
        this.HttpSvc = HttpSvc;
        this.$q = $q;
        this.getProjectBackend = _.memoize(function (projectId) {
            return _this.$q(function (resolve) {
                var method = options.user.anonymous ? 'get' : 'secureGet';
                return _this.HttpSvc('project-api', projectId)[method]()
                    .then(function (response) { return resolve(response.data.url); });
            });
        });
    }
    BackendSvc.prototype.getServerUrl = function (project) {
        var _this = this;
        var promise = project.serverUrl ? this.$q.resolve(project.serverUrl) : this.getProjectBackend(project.id);
        return promise.then(function (url) { return _this.formatUrl(url); });
    };
    BackendSvc.prototype.formatUrl = function (url) {
        if (url.indexOf('localhost') === -1) {
            url = url.replace(/(:\d{2,6})/, '');
        }
        var serverUrl = url.replace(/^https?:\/\//, '');
        return "//" + serverUrl;
    };
    return BackendSvc;
}());
exports.BackendSvc = BackendSvc;
module_1.default.service('BackendSvc', BackendSvc);


/***/ }),

/***/ "pLX0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/section-video-sign-up_febf5ff0da03514d93da5df64e509722.css";

/***/ }),

/***/ "pPBV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SpinnerSvc = (function () {
    function SpinnerSvc() {
    }
    SpinnerSvc.set = function (spinner) {
        SpinnerSvc.spinner = spinner;
    };
    SpinnerSvc.show = function () {
        SpinnerSvc.spinner.start();
    };
    SpinnerSvc.hide = function () {
        setTimeout(function () { return SpinnerSvc.spinner.complete(); }, 30);
    };
    SpinnerSvc.withSpinner = function (req) {
        SpinnerSvc.show();
        req.finally(function () { return SpinnerSvc.hide(); });
        return req;
    };
    return SpinnerSvc;
}());
SpinnerSvc.spinner = null;
exports.default = SpinnerSvc;


/***/ }),

/***/ "pVk+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
module_1.default.directive('blurMe', function () { return function (scope, element) {
    return element.on('click', function () {
        element[0].focus();
        element[0].blur();
    });
}; });


/***/ }),

/***/ "pbA1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/video-player_4059616200137a40bff5ecf396d8cdb9.css";

/***/ }),

/***/ "q3WU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
module_1.default.directive('formAutofillFix', function () {
    return function (scope, elem, attrs) {
        // Fixes Chrome bug: https://groups.google.com/forum/#!topic/angular/6NlucSskQjY
        elem.prop('method', 'POST');
        // Fix autofill issues where Angular doesn't know about autofilled inputs
        if (attrs.ngSubmit) {
            setTimeout(function () {
                elem.unbind('submit').bind('submit', function (e) {
                    e.preventDefault();
                    var arr = elem.find('input');
                    if (arr.length > 0) {
                        arr.triggerHandler('input').triggerHandler('change').triggerHandler('keydown');
                        scope.$apply(attrs.ngSubmit);
                    }
                });
            }, 0);
        }
    };
});


/***/ }),

/***/ "qffX":
/***/ (function(module, exports, __webpack_require__) {

var path = 'https://assets.animatron.com/html/search-page.html';
var html = "<div class=\"search-page-header-container projects-header clearfix\"> <div class=\"search-header\"> <tabs is-mobile-mode=\"false\" tabs=\"SearchPageCtrl.tabs\" current-tab=\"SearchPageCtrl.currentTab\" labels=\"{'search.works': animatron.count,\n                         'search.users': usersSvc.count}\"></tabs> <div class=\"search-result-container\"> <div class=\"search-result-count\"> <span class=\"result-count\">{{$root.t('search-page.result', usersSvc.count + animatron.count)}}</span> </div> <search></search> </div> </div> </div> <div class=\"search-users-container users\" ng-show=\"SearchPageCtrl.currentTab === 'search.users'\" infinite-scroll=\"usersSvc.nextPage()\" infinite-scroll-disabled=\"usersSvc.shownAll\" infinite-scroll-distance=\"0\"> <div class=\"user\" ng-repeat=\"user in usersSvc.results\"> <user-popup user=\"user\" size=\"40\"></user-popup> </div> </div> <div class=\"search-projects-container\" ng-show=\"SearchPageCtrl.currentTab === 'search.works'\"> <div class=\"result-title\" ng-show=\"animatron.count > 0 || SearchPageCtrl.SearchCtrl.myProjects\"> <div class=\"my-projects-checkbox\" ng-if=\"!$root.options.user.anonymous\"> <input id=\"my-projects\" type=\"checkbox\" ng-model=\"SearchPageCtrl.SearchCtrl.myProjects\" ng-change=\"SearchPageCtrl.SearchCtrl.startSearch()\"> <label for=\"my-projects\">my projects only</label> </div> </div> <static-include src=\"" + __webpack_require__("b6Iv") + "\"></static-include> </div> <div ng-if=\"animatron.loaded && !animatron.busy && animatron.count + usersSvc.count === 0 && !usersSvc.busy\" class=\"icon-status-msg-box\"> <div class=\"not-found-msg icon-status-msg icon-search-no-result\"> <span>{{::$root.t('search.notfound')}}</span> </div> </div> ";
var angular = window.angular;
var injector = angular.element(document).injector();
if (injector) {
injector.get('$templateCache').put(path, html);
} else {
angular.module('templates').run(['$templateCache', function(c) { c.put(path, html) }]);
}
module.exports = path;

/***/ }),

/***/ "rJ0m":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/light/banner-video-preview_x2.jpg";

/***/ }),

/***/ "rNCV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/project-access_331870c9e661da6fd360784c9678715c.html";

/***/ }),

/***/ "rU96":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/favicon.ico";

/***/ }),

/***/ "rd/d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/wave-landing_ee4a64af945948682188a79ede322761.css";

/***/ }),

/***/ "rkOV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/4.png";

/***/ }),

/***/ "rrSb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/10.svg";

/***/ }),

/***/ "sCFP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/spread-in_71835ddbb68149fe185964bc21f6c995.css";

/***/ }),

/***/ "sJU7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var ObjectId_1 = __webpack_require__("j1Q3");
/**
 * Add class to an element then add directive with value which contains words from previous class
 */
module_1.default.directive('appearAnimation', ["$rootScope", "ViewPortSvc", function ($rootScope, ViewPortSvc) {
    return function (scope, element, attrs) {
        if (!element[0].id)
            element[0].id = ObjectId_1.ObjectId.get();
        var id = element[0].id;
        var className = attrs.appearAnimation;
        var shouldDisponse = attrs.hasOwnProperty('andDisposeAnimation');
        if (/prerender/.test(navigator.userAgent)) {
            element[0].classList.add(className);
            return;
        }
        ViewPortSvc.subscribe(element[0]);
        setTimeout(function () { return ViewPortSvc.checker(); }, 0);
        var destroy = $rootScope.$on('onScreen:' + id, _.once(function () {
            if (shouldDisponse) {
                var initialName_1 = className.replace(/--.*$/, '');
                var dispose_1 = _.once(function () {
                    var toRemove = Array.apply(null, element[0].classList)
                        .filter(function (a) { return a.includes(initialName_1); })
                        .concat(className);
                    (_a = element[0].classList).remove.apply(_a, toRemove);
                    element[0].removeEventListener('transitionend', dispose_1);
                    var _a;
                });
                element[0].addEventListener('transitionend', dispose_1);
            }
            element[0].classList.add(className);
            ViewPortSvc.unsubscribe(element[0]);
            destroy();
            // scope.$destroy();
        }));
    };
}]);


/***/ }),

/***/ "sM/Y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/open-editor_1f61c246e670e77e170379f2e04c902b.css";

/***/ }),

/***/ "sNLF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/15.png";

/***/ }),

/***/ "svkI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/affiliate-popup_5627680adb7433cc7fed66a0a67255f1.html";

/***/ }),

/***/ "t/nL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/section-video-time_9bbd48ae9096f62db0ff0afa8945f17f.css";

/***/ }),

/***/ "tOiF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("jYQ6");
var jq = _.once(function () { return $.noConflict(); });
var PaymentHelpers = (function () {
    function PaymentHelpers() {
        this.cardExpiryVal = function (value) { return jq().payment.cardExpiryVal(value); };
        this.validateCardNumber = function (num) { return jq().payment.validateCardNumber(num); };
        this.validateCardCvc = function (cvc, type) { return jq().payment.validateCardCVC(cvc, type); };
        this.restrictNumeric = function (element) { return jq()(element).payment('restrictNumeric'); };
        this.formatCardCvc = function (element) { return jq()(element).payment('formatCardCVC'); };
        this.formatCardExpiry = function (element) { return jq()(element).payment('formatCardExpiry'); };
        this.formatCardNumber = function (element) { return jq()(element).payment('formatCardNumber'); };
    }
    PaymentHelpers.prototype.validateCardExpiry = function (value) {
        var exp = jq().payment.cardExpiryVal(value);
        return jq().payment.validateCardExpiry(exp.month.toString(), exp.year.toString());
    };
    ;
    return PaymentHelpers;
}());
module_1.default.factory('PaymentHelpers', function () { return new PaymentHelpers(); });


/***/ }),

/***/ "tV+N":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/banner/help-img-2.png";

/***/ }),

/***/ "tWLz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/fonts-basic_c8af4402ea50d0f0b62ceb5f5987b17f.css";

/***/ }),

/***/ "tjWj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/masonry-wrapper_542507cb57249376ee11881ebc7761ec.css";

/***/ }),

/***/ "tp6s":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/open-editor_cc8d6ab412bdf1def49150e25d65da97.html";

/***/ }),

/***/ "u8E4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/spinners_c054ba0e20568d4283df5ef9c5653ec0.css";

/***/ }),

/***/ "uaFb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/9.svg";

/***/ }),

/***/ "udNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var Strings_1 = __webpack_require__("fxc3");
var underscore_extensions_1 = __webpack_require__("R0iF");
var SearchCtrl = (function () {
    SearchCtrl.$inject = ["$state", "$q", "$stateParams"];
    function SearchCtrl($state, $q, $stateParams) {
        this.$state = $state;
        this.$q = $q;
        this.$stateParams = $stateParams;
        this.keyword = this.$stateParams.q;
        this.solr = !_.isUndefined(this.$stateParams.solr);
        this.myProjects = !_.isUndefined(this.$stateParams.myProjects);
    }
    SearchCtrl.prototype.startSearch = function (notify) {
        if (notify === void 0) { notify = true; }
        if (Strings_1.Strings.isBlank(this.keyword))
            return this.$q.resolve();
        if (_.isFunction(this.onStart))
            this.onStart();
        return this.$state.transitionTo('studio-search', {
            q: this.keyword,
            username: this.username,
            myProjects: this.myProjects || undefined,
            solr: this.solr || undefined
        }, { reload: true, notify: notify }).then(function () {
            return setTimeout(function () { return underscore_extensions_1.Utils.safe(function () { return document.querySelector('.project-search').focus(); }); }, 100);
        });
    };
    return SearchCtrl;
}());
exports.SearchCtrl = SearchCtrl;
module_1.default.component('search', {
    controller: SearchCtrl,
    controllerAs: 'Search',
    bindings: {
        username: '@',
        onStart: '&?'
    },
    templateUrl: __webpack_require__("HGeo")
});


/***/ }),

/***/ "ukZe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/banner/help-img-4.png";

/***/ }),

/***/ "v+R/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/pricing_dd224a00d491dfcb7fe023365807edb3.html";

/***/ }),

/***/ "v+uJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/8.png";

/***/ }),

/***/ "v/Ys":
/***/ (function(module, exports) {

var path = 'https://assets.animatron.com/html/project-item.html';
var html = "<div class=\"popup-opener\" ng-class=\"{'staff-picks': $ctrl.project.staffPicked && !$ctrl.isStaffPicks,\n                'hall-of-fame': $ctrl.project.hallOfFame,\n                'contest': $ctrl.project.contest}\"> <div class=\"popup top tool-tip\"> <span ng-show=\"::$ctrl.project.staffPicked\">{{::$root.t('projects.staff-picks')}}</span> <span ng-show=\"::$ctrl.project.hallOfFame\">{{::$root.t('projects.hall-of-fame')}}</span> <span ng-show=\"::$ctrl.project.contest\">{{::$root.t('projects.contest')}}</span> </div> </div> <div class=\"movie-buttons\" ng-if=\"::!$root.options.handHeld\"> <a ng-href=\"{{::$root.options.editorDomain}}#p={{::$ctrl.project.id}}\" class=\"control edit\" ng-if=\"::$ctrl.project.canEdit && !$root.options.user.anonymous\"> <span class=\"title\">{{::$root.t('project.button.edit')}}</span> </a> </div> <div class=\"project-border\"> <i></i> <a class=\"movie-body\" toggle-project-modal pick-preview-image=\"{img:false}\" ng-style=\"::{'height':$ctrl.project.computedHeight + 'px'}\"> </a> </div> <div class=\"project-info\"> <project-modal-link></project-modal-link> <div class=\"project-author p-info\"> <user-popup ng-if=\"::$ctrl.project.owner.username\" user=\"$ctrl.project.owner\" size=\"20\"></user-popup> <b ng-if=\"::!$ctrl.project.owner.username\">{{::$root.t('anonymous')}}</b> </div> <div class=\"project-basic-statistic\"> <like project=\"$ctrl.project\"></like> <span class=\"popup-opener project-basic-statistic-item views\"> <span class=\"popup tool-tip top\">{{::$root.t('projects.views')}}</span> {{::$ctrl.project.views || 0 | number}}</span> <span class=\"popup-opener project-basic-statistic-item comments\"> <span class=\"popup tool-tip top\">{{::$root.t('projects.comments')}}</span> {{$ctrl.project.comments.length || 0}}</span> <span ng-if=\"$ctrl.showVisibility\" class=\"popup-opener project-basic-statistic-item project-visibility {{::$ctrl.project.visibility.toLowerCase()}}\"> <span class=\"popup tool-tip top-left\">{{::$ctrl.project.visibility | visibilityExplanation}}</span> </span> </div> </div> ";
var angular = window.angular;
var injector = angular.element(document).injector();
if (injector) {
injector.get('$templateCache').put(path, html);
} else {
angular.module('templates').run(['$templateCache', function(c) { c.put(path, html) }]);
}
module.exports = path;

/***/ }),

/***/ "v09R":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/explainer_06a0bf06befe492b8cb4ea6685b82e99.html";

/***/ }),

/***/ "v1FL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var commonLinks_1 = __webpack_require__("eE93");
var underscore_extensions_1 = __webpack_require__("R0iF");
var CommonLink = (function () {
    CommonLink.$inject = ["$state"];
    function CommonLink($state) {
        this.$state = $state;
    }
    CommonLink.prototype.$onChanges = function () {
        this.product = this.product || underscore_extensions_1.Utils.getProduct();
        this.href = this.url ? this.getByUrl() : this.getByName();
    };
    CommonLink.prototype.getByName = function () {
        var links = commonLinks_1.default(this.product);
        return links[this.name];
    };
    CommonLink.prototype.getByUrl = function () {
        var productRootDirectory = this.product === 'STUDIO' ? '/studio' : '';
        return "" + productRootDirectory + this.url;
    };
    return CommonLink;
}());
module_1.default.component('commonLink', {
    bindings: {
        name: '@?',
        url: '@?',
        product: '@?',
        className: '@?'
    },
    transclude: true,
    controller: CommonLink,
    template: '<a ng-if="$ctrl.href" class="{{$ctrl.className}}" ng-href="{{$ctrl.href}}" ng-transclude></a> <ng-transclude ng-if="!$ctrl.href"></ng-transclude>'
});


/***/ }),

/***/ "vcaf":
/***/ (function(module, exports) {

//TODO remove `angular.element(document.body).ready(() => ...);` Must work without it.
var AnimatronNotification = (function () {
    function AnimatronNotification() {
        var _this = this;
        this.options = { timeout: 5000 };
        angular.element(document.body).ready(function () {
            _this.container = angular.element(document.querySelector('.animatron_notification_block'));
        });
    }
    AnimatronNotification.prototype.showError = function (message, timeout) {
        var _this = this;
        angular.element(document.body).ready(function () {
            _this.showMessage(message, timeout, 'error');
        });
    };
    AnimatronNotification.prototype.showSuccess = function (message, timeout) {
        var _this = this;
        angular.element(document.body).ready(function () {
            _this.showMessage(message, timeout, 'success');
        });
    };
    AnimatronNotification.prototype.showMessage = function (message, timeout, type) {
        var _this = this;
        this.hideInstantly();
        if (this.type !== type) {
            this.type = type;
            this.hide();
            this.showMessage(message, timeout, type);
            return;
        }
        if (timeout) {
            this.options.timeout = timeout;
        }
        document.querySelector('.animatron_notification_block').innerHTML = '';
        this.container.append(angular.element('<span/>').html(message));
        this.show();
        if (this.options.timeout > 0) {
            clearTimeout(this._timeout);
            this._timeout = setTimeout(function () { return _this.hide(); }, this.options.timeout);
        }
        var dismiss_btn = angular.element('<a href="#"/>')
            .addClass('close')
            .on('click', function (event) {
            event.preventDefault();
            _this.hide();
        });
        this.container.append(dismiss_btn);
    };
    AnimatronNotification.prototype.hide = function () {
        clearTimeout(this._timeout);
        if (this.container) {
            this.container.removeClass('show');
        }
    };
    AnimatronNotification.prototype.show = function () {
        this.container.addClass('show').removeClass('hide');
    };
    AnimatronNotification.prototype.hideInstantly = function () {
        if (this.container) {
            this.container.addClass('hide').removeClass('show');
        }
    };
    return AnimatronNotification;
}());
_.notification = new AnimatronNotification();


/***/ }),

/***/ "vhpm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/project-buttons_27d0ea0d9cdcb9d23b06b6ddf41311ac.html";

/***/ }),

/***/ "vjsU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/banner/help-img-1.png";

/***/ }),

/***/ "vkeZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/user-notification_bb8f6faa5a335ac0b9d577bd79c70b48.css";

/***/ }),

/***/ "vlSI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/2.svg";

/***/ }),

/***/ "vuk9":
/***/ (function(module, exports) {

var path = 'https://assets.animatron.com/html/header.html';
var html = "<header headroom=\"true\" ng-class=\"{active: $ctrl.openerActive}\" document-no-scroll=\"$root.options.handHeld && $ctrl.openerActive\"> <div class=\"header-content\"> <div class=\"content-left\"> <a class=\"animatron-logo-link\" ng-href=\"{{$root.options.animatronUrl}}\" ng-click=\"$ctrl.openerActive = false\"> <svg id=\"SvgjsSvg1015\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:svgjs=\"http://svgjs.com/svgjs\" width=\"142\" height=\"13\" viewBox=\"0 0 142 13\"><title>Fill 1</title><desc>Created with Avocode.</desc><defs id=\"SvgjsDefs1016\"></defs><path id=\"SvgjsPath1017\" d=\"M108.97 31.12H122.50999999999999V33.96H117.66999999999999V42.92H113.87999999999998V33.96H108.96999999999998ZM68.7 31.11H72.48V42.92H68.7ZM75.22 31.11H79V31.13C79.44 31.16 80.27 31.349999999999998 80.81 32.17L84.69 38.04L88.58 32.17C89.14999999999999 31.3 90.03999999999999 31.14 90.46 31.12H90.47C90.61 31.11 90.7 31.12 90.7 31.12H94.24000000000001V42.92H90.46000000000001V35.13L85.44000000000001 42.92H83.95000000000002L79.00000000000001 35.24V42.92H75.22000000000001ZM62.51 31.11H66.28999999999999V42.92H62.65999999999999V42.93C62.65999999999999 42.93 61.77999999999999 43.03 60.249999999999986 41.73C59.079999999999984 40.72 54.999999999999986 36.14 53.899999999999984 34.9V42.93H50.11999999999998V31.119999999999997H53.899999999999984V31.13C54.329999999999984 31.16 55.58999999999998 31.34 56.359999999999985 32.32L62.509999999999984 39.11ZM123.96 31.11H127.74V31.12H135.84C136.86 31.07 139.14000000000001 32 138.82 33.6C138.73 34.1 138.45999999999998 34.26 138.23 34.63L135.25 37.86L139.9 42.92H135.25L130.57 37.86L134.15 33.96H127.74000000000001V42.92H123.96000000000001ZM171 31.11H174.79V42.92H171.15V42.93C171.15 42.93 170.27 43.03 168.75 41.73C167.57 40.72 163.49 36.14 162.39 34.9V42.93H158.60999999999999V31.119999999999997H162.39V31.13C162.82999999999998 31.16 164.07999999999998 31.34 164.85 32.32L171 39.11ZM39.35 31.15L39.32 31.09H43.38L49.7 42.9L45.690000000000005 43L41.36000000000001 34.92L37.010000000000005 43.06L33.00000000000001 42.96L39.32000000000001 31.15ZM100.93 31.12L100.9 31.060000000000002H104.96000000000001L111.28 42.88L107.26 42.970000000000006L102.94 34.89000000000001L98.59 43.03000000000001L94.58 42.93000000000001L100.9 31.120000000000005ZM143.97 34.93C143.97 34.339999999999996 144.48 33.87 145.1 33.87H151.25C151.87 33.87 152.38 34.339999999999996 152.38 34.93V39.1C152.38 39.690000000000005 151.87 40.160000000000004 151.25 40.160000000000004H145.1C144.48 40.160000000000004 143.97 39.690000000000005 143.97 39.1ZM140.27 34.12V39.91C140.27 41.629999999999995 141.83 43.029999999999994 143.74 43.029999999999994H152.61C154.52 43.029999999999994 156.08 41.629999999999995 156.08 39.91V34.12C156.08 32.4 154.52 30.999999999999996 152.61 30.999999999999996H143.74C141.83 30.999999999999996 140.27 32.4 140.27 34.12Z \" fill=\"#000000\" fill-opacity=\"1\" transform=\"matrix(1,0,0,1,-33,-31)\"></path></svg> </a> <div class=\"main-menu\"> <div class=\"menu-opener button button-blue button-medium\" ng-class=\"{active: $ctrl.openerActive}\" ng-click=\"$ctrl.openerActive = !$ctrl.openerActive\"> {{::$root.t('header.nav.menu')}} </div> <div class=\"menu-overlay\" ng-click=\"$ctrl.openerActive = !$ctrl.openerActive\" ng-class=\"{active: $ctrl.openerActive}\"></div> <nav class=\"mobile\"> <div ng-if=\"$root.options.handHeld\" class=\"search-box explore-page\" ng-hide=\"true\"> <search on-start=\"$ctrl.openerActive = false\"></search> </div> <div class=\"close-button\" ng-click=\"$ctrl.openerActive = !$ctrl.openerActive\"></div> <div class=\"links-wrapper\"> <div class=\"logo-block\"> <a class=\"animatron-logo-link\" href=\"/\" ng-click=\"$ctrl.openerActive = false\"> <svg id=\"SvgjsSvg1015\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:svgjs=\"http://svgjs.com/svgjs\" width=\"142\" height=\"13\" viewBox=\"0 0 142 13\"><title>Fill 1</title><desc>Created with Avocode.</desc><defs id=\"SvgjsDefs1016\"></defs><path id=\"SvgjsPath1017\" d=\"M108.97 31.12H122.50999999999999V33.96H117.66999999999999V42.92H113.87999999999998V33.96H108.96999999999998ZM68.7 31.11H72.48V42.92H68.7ZM75.22 31.11H79V31.13C79.44 31.16 80.27 31.349999999999998 80.81 32.17L84.69 38.04L88.58 32.17C89.14999999999999 31.3 90.03999999999999 31.14 90.46 31.12H90.47C90.61 31.11 90.7 31.12 90.7 31.12H94.24000000000001V42.92H90.46000000000001V35.13L85.44000000000001 42.92H83.95000000000002L79.00000000000001 35.24V42.92H75.22000000000001ZM62.51 31.11H66.28999999999999V42.92H62.65999999999999V42.93C62.65999999999999 42.93 61.77999999999999 43.03 60.249999999999986 41.73C59.079999999999984 40.72 54.999999999999986 36.14 53.899999999999984 34.9V42.93H50.11999999999998V31.119999999999997H53.899999999999984V31.13C54.329999999999984 31.16 55.58999999999998 31.34 56.359999999999985 32.32L62.509999999999984 39.11ZM123.96 31.11H127.74V31.12H135.84C136.86 31.07 139.14000000000001 32 138.82 33.6C138.73 34.1 138.45999999999998 34.26 138.23 34.63L135.25 37.86L139.9 42.92H135.25L130.57 37.86L134.15 33.96H127.74000000000001V42.92H123.96000000000001ZM171 31.11H174.79V42.92H171.15V42.93C171.15 42.93 170.27 43.03 168.75 41.73C167.57 40.72 163.49 36.14 162.39 34.9V42.93H158.60999999999999V31.119999999999997H162.39V31.13C162.82999999999998 31.16 164.07999999999998 31.34 164.85 32.32L171 39.11ZM39.35 31.15L39.32 31.09H43.38L49.7 42.9L45.690000000000005 43L41.36000000000001 34.92L37.010000000000005 43.06L33.00000000000001 42.96L39.32000000000001 31.15ZM100.93 31.12L100.9 31.060000000000002H104.96000000000001L111.28 42.88L107.26 42.970000000000006L102.94 34.89000000000001L98.59 43.03000000000001L94.58 42.93000000000001L100.9 31.120000000000005ZM143.97 34.93C143.97 34.339999999999996 144.48 33.87 145.1 33.87H151.25C151.87 33.87 152.38 34.339999999999996 152.38 34.93V39.1C152.38 39.690000000000005 151.87 40.160000000000004 151.25 40.160000000000004H145.1C144.48 40.160000000000004 143.97 39.690000000000005 143.97 39.1ZM140.27 34.12V39.91C140.27 41.629999999999995 141.83 43.029999999999994 143.74 43.029999999999994H152.61C154.52 43.029999999999994 156.08 41.629999999999995 156.08 39.91V34.12C156.08 32.4 154.52 30.999999999999996 152.61 30.999999999999996H143.74C141.83 30.999999999999996 140.27 32.4 140.27 34.12Z \" fill=\"#000000\" fill-opacity=\"1\" transform=\"matrix(1,0,0,1,-33,-31)\"></path></svg> </a> </div> <div class=\"navigation-links\"> <a class=\"wave-landing\" ng-href=\"{{ $root.options.waveUrl}}\">{{::$root.t('landing.wave')}}</a> <a class=\"studio-landing\" href=\"/studio\">{{::$root.t('landing.studio')}}</a> <div tabindex=\"1\" class=\"header-dropdown-block header-more-block\"> <a href=\"#\" class=\"header-dropdown-link header-more-link\">{{::$root.t('header.more.link')}}</a> <div class=\"header-dropdown header-more-dropdown\" ng-click=\"$ctrl.openerActive = false\"> <a class=\"blog\" href=\"https://wave.video/blog\">{{::$root.t('header.nav.blog')}}</a> <a class=\"about\" href=\"{{ $root.options.animatronUrl + '/company/about' }}\">{{::$root.t('company.title')}}</a> </div> </div> <div class=\"closer\" tabindex=\"1\"></div> </div> </div> </nav> </div> </div> </div> </header>";
var angular = window.angular;
var injector = angular.element(document).injector();
if (injector) {
injector.get('$templateCache').put(path, html);
} else {
angular.module('templates').run(['$templateCache', function(c) { c.put(path, html) }]);
}
module.exports = path;

/***/ }),

/***/ "vzSK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/both-landings-common_c3504c735980b363429fcf1bc623fe7a.css";

/***/ }),

/***/ "w2og":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/9.png";

/***/ }),

/***/ "w9R6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var module_1 = __webpack_require__("hfrq");
var lazy_modules_1 = __webpack_require__("bUzP");
var PressSwipable = (function () {
    PressSwipable.$inject = ["$element", "$q"];
    function PressSwipable($element, $q) {
        this.$element = $element;
        this.$q = $q;
        this.flicktyPromise = $q(function (resolve) { return loadScripts([lazy_modules_1.flickityLib], resolve); });
    }
    PressSwipable.prototype.$postLink = function () {
        this.initFlickty('.slide', false, true);
    };
    PressSwipable.prototype.initFlickty = function (cellSelector, prevNextButtons, pageDots) {
        var _this = this;
        this.flicktyPromise.then(function () {
            var Flickity = window.Flickity;
            new Flickity(_this.$element[0].firstChild, {
                cellSelector: cellSelector,
                prevNextButtons: prevNextButtons,
                pageDots: pageDots,
                wrapAround: true,
                resize: false,
                cellAlign: 'center',
                adaptiveHeight: true,
                setGallerySize: false
            });
        });
    };
    return PressSwipable;
}());
var PressSwipableTwitter = (function (_super) {
    PressSwipableTwitter.$inject = ["$element", "$q"];
    tslib_1.__extends(PressSwipableTwitter, _super);
    function PressSwipableTwitter($element, $q) {
        var _this = _super.call(this, $element, $q) || this;
        _this.$element = $element;
        _this.$q = $q;
        _this.twitterPromise = $q(function (resolve) { return loadScripts([lazy_modules_1.twitterWidgetLib], resolve); });
        return _this;
    }
    PressSwipableTwitter.prototype.$postLink = function () {
        var _this = this;
        var children = this.$element[0].firstElementChild.childElementCount;
        var rendered = 0;
        this.twitterPromise.then(function () { return window.twttr.events.bind('rendered', function () {
            if (++rendered === children) {
                _this.initFlickty('.twitter-tweet', true, true);
            }
        }); });
    };
    return PressSwipableTwitter;
}(PressSwipable));
module_1.default.component('pressSwipable', {
    controller: PressSwipable,
    templateUrl: __webpack_require__("l0GU")
});
module_1.default.component('pressTwitterGallery', {
    controller: PressSwipableTwitter,
    templateUrl: __webpack_require__("SzCq")
});


/***/ }),

/***/ "wCd9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/logo_b25a417656b629e0999b721c87034413.css";

/***/ }),

/***/ "wFE4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

ViewPortSvc.$inject = ["$rootScope"];
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var module_1 = __webpack_require__("jYQ6");
var underscore_extensions_1 = __webpack_require__("R0iF");
exports.IntersectionObserver = window.IntersectionObserver;
var Observer = (function () {
    function Observer(emmiter) {
        this.emmiter = emmiter;
        this.onInit();
    }
    Observer.prototype.onInit = function () { };
    Observer.prototype.whenOnScreen = function (element) {
        this.emmiter('onScreen:' + element.id);
        element.classList.add('on-screen');
        element.classList.remove('not-on-screen');
    };
    Observer.prototype.whenNotOnScreen = function (element) {
        this.emmiter('notOnScreen:' + element.id);
        element.classList.add('not-on-screen');
        element.classList.remove('on-screen');
    };
    return Observer;
}());
exports.Observer = Observer;
var ScrollObserver = (function (_super) {
    tslib_1.__extends(ScrollObserver, _super);
    function ScrollObserver() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.observables = [];
        return _this;
    }
    ScrollObserver.prototype.onInit = function () {
        var _this = this;
        window.addEventListener('scroll', _.throttle(function () { return _this.checker(); }, 100), false);
    };
    ScrollObserver.prototype.checker = function () {
        var _this = this;
        return underscore_extensions_1.Utils.rAF(function () {
            var windowHeight = _this.staticWindowHeight ? +_this.staticWindowHeight : window.innerHeight;
            _this.observables.forEach(function (o) {
                var dimension = o.element.getBoundingClientRect(), top = dimension.top, bottom = dimension.bottom, height = dimension.height, topVisible = top + height >= 0, botVisible = bottom - height <= windowHeight;
                var onScreen = topVisible && botVisible;
                if (o.centredOn) {
                    var windowPlace = windowHeight * (o.centredOn / 100);
                    onScreen = top <= windowPlace && bottom >= windowPlace;
                }
                if (onScreen && !o.wasOnScreen && o.wasOutOfScreen) {
                    o.wasOnScreen = true;
                    o.wasOutOfScreen = false;
                    _this.whenOnScreen(o.element);
                }
                else if (!onScreen && o.wasOnScreen && !o.wasOutOfScreen) {
                    o.wasOnScreen = false;
                    o.wasOutOfScreen = true;
                    _this.whenNotOnScreen(o.element);
                }
            });
        });
    };
    ScrollObserver.prototype.subscribe = function (element, centredOn) {
        this.observables.push({
            element: element,
            centredOn: centredOn,
            wasOnScreen: false,
            wasOutOfScreen: true
        });
    };
    ScrollObserver.prototype.unsubscribe = function (element) {
        this.observables = this.observables.filter(function (o) { return o.element !== element; });
    };
    return ScrollObserver;
}(Observer));
exports.ScrollObserver = ScrollObserver;
var IntersctObserver = (function (_super) {
    tslib_1.__extends(IntersctObserver, _super);
    function IntersctObserver() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.observer = new exports.IntersectionObserver(_this.checker.bind(_this));
        return _this;
    }
    IntersctObserver.prototype.checker = function (changes) {
        var _this = this;
        changes && underscore_extensions_1.Utils.rAF(function () { return changes.forEach(function (change) {
            var onScreen = change.intersectionRatio !== 0;
            if (onScreen) {
                _this.whenOnScreen(change.target);
            }
            else if (!onScreen) {
                _this.whenNotOnScreen(change.target);
            }
        }); });
    };
    IntersctObserver.prototype.subscribe = function (element) {
        this.observer.observe(element);
    };
    IntersctObserver.prototype.unsubscribe = function (element) {
        this.observer.unobserve(element);
    };
    return IntersctObserver;
}(Observer));
exports.IntersctObserver = IntersctObserver;
//IE 11 fix for .middle
HTMLElement.prototype.getBoundingClientRect = (function () {
    var oldGetBoundingClientRect = HTMLElement.prototype.getBoundingClientRect;
    return function () {
        try {
            return oldGetBoundingClientRect.apply(this, arguments);
        }
        catch (e) {
            return {
                left: '',
                right: '',
                top: '',
                bottom: ''
            };
        }
    };
})();
function ViewPortSvc($rootScope) {
    var emmiter = $rootScope.$emit.bind($rootScope);
    // const observer: Observer = IntersectionObserver ? new IntersctObserver(emmiter) : new ScrollObserver(emmiter);
    return new ScrollObserver(emmiter);
}
module_1.default.service('ViewPortSvc', ViewPortSvc);


/***/ }),

/***/ "wJnc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/_typography_7d99e03223012e618de7f8151c51f31b.css";

/***/ }),

/***/ "wTNS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/comments_a9973519437284a57f50a0a9647fdc78.html";

/***/ }),

/***/ "wWYA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/banner/help-img-5.png";

/***/ }),

/***/ "wX/j":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/12.png";

/***/ }),

/***/ "we/J":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/address_cfba6c317055aab935dab0c59d072d29.css";

/***/ }),

/***/ "whPB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/banner/help-img-3.png";

/***/ }),

/***/ "wmF7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/contractors_fddb01d200c641bed030b17dd4679504.css";

/***/ }),

/***/ "wpGM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/3.png";

/***/ }),

/***/ "wuZI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/20.png";

/***/ }),

/***/ "wwNa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/section-horizontal-text-video_ef732b3debfb0a7bb32b5714b9f47a64.css";

/***/ }),

/***/ "wz+r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CookieSettings = (function () {
    function CookieSettings() {
    }
    CookieSettings.get = function () {
        var cookieSettings = {
            path: '/',
            expires: 365,
            domain: undefined
        };
        if (location.hostname !== 'localhost' && location.hostname.indexOf('192.168') !== 0) {
            cookieSettings.domain = location.host.replace('www', '');
        }
        return cookieSettings;
    };
    return CookieSettings;
}());
exports.CookieSettings = CookieSettings;


/***/ }),

/***/ "x+OW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/notifications_8f662b348103d33c454947b13aebf8b3.css";

/***/ }),

/***/ "x0FM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/12.png";

/***/ }),

/***/ "x7Q4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/global_87fe54a5c0107b4fc172744c115dfe83.css";

/***/ }),

/***/ "xD0M":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/1.svg";

/***/ }),

/***/ "xNor":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = __webpack_require__("hfrq");
var underscore_extensions_1 = __webpack_require__("R0iF");
var ProjectAccessCtrl = (function () {
    ProjectAccessCtrl.$inject = ["$state", "$http", "HttpSvc", "BackendSvc"];
    function ProjectAccessCtrl($state, $http, HttpSvc, BackendSvc) {
        var _this = this;
        this.$state = $state;
        this.$http = $http;
        this.HttpSvc = HttpSvc;
        this.BackendSvc = BackendSvc;
        this.access = {
            PUBLIC: 'PUBLIC',
            PRIVATE: 'PRIVATE',
            UNLISTED: 'UNLISTED'
        };
        this.product = underscore_extensions_1.Utils.getProduct();
        this.userFeatures = options.user.subscriptionDetails.studio.features;
        this.isAdmin = !!this.userFeatures.Admin;
        this.canOnlyRead = !this.project.isOwner && this.isAdmin;
        this.isShowAccess = this.project.isOwner;
        this.canChangePermissions = !options.user.anonymous && this.userFeatures.ProjectPermissions.canChangePermissions;
        this.canWrite = this.canChangePermissions;
        if (this.canChangePermissions) {
            this.countPrivateUnlistedProjects = this.userFeatures.PrivateUnlistedProjects.numProjects;
            this.HttpSvc("projects/stats?product=" + this.product).secureGet().then(function (r) { return r.data; }).then(function (res) {
                var countProjectCreated = res.privateProjects + res.unlistedProjects;
                _this.canWrite = countProjectCreated < _this.countPrivateUnlistedProjects
                    || _this.project.visibility !== _this.access.PUBLIC;
            });
        }
    }
    Object.defineProperty(ProjectAccessCtrl.prototype, "url", {
        get: function () {
            var _this = this;
            return this.BackendSvc.getServerUrl(this.project)
                .then(function (url) { return url + "/project/update/permission/" + _this.project.id; });
        },
        enumerable: true,
        configurable: true
    });
    ProjectAccessCtrl.prototype.changeVisibility = function (accessType) {
        this.project.visibility = accessType;
    };
    ProjectAccessCtrl.prototype.changeAccess = function (accessType) {
        var _this = this;
        if (this.project.visibility !== accessType) {
            var data_1 = this.project.product === 'WAVE' && accessType === 'PUBLIC' ?
                {
                    'visibility': accessType,
                    'writeAccess': [],
                    'readAccess': ['PUBLIC']
                } :
                {
                    'visibility': accessType,
                    'writeAccess': [],
                    'readAccess': []
                }, oldVisibility_1 = this.project.visibility;
            this.changeVisibility(accessType);
            this.url.then(function (url) {
                _this.$http.put(url, data_1, { headers: options.headers })
                    .then(function (res) {
                    if (res && res.data.code) {
                        _this.changeVisibility(oldVisibility_1);
                        _.notification.showError(res.data.message || 'Error changing project access');
                    }
                });
            });
        }
    };
    ProjectAccessCtrl.prototype.openSubscription = function () {
        this.$state.go(this.product.toLowerCase() + "-settings.subscription");
    };
    return ProjectAccessCtrl;
}());
module_1.default.directive('projectAccess', function () { return ({
    restrict: 'E',
    controller: ProjectAccessCtrl,
    controllerAs: 'ProjectAccess',
    bindToController: {
        project: '='
    },
    scope: true,
    templateUrl: __webpack_require__("rNCV")
}); });


/***/ }),

/***/ "xU9L":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/wave-section-how-work_a12bd1ee9c0aa74bfff55c70f3d4cb95.css";

/***/ }),

/***/ "xXoS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/tutorial_c83b72ab283c97823f4402e4a8fc3224.css";

/***/ }),

/***/ "xlID":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/login-modal_8836c1f37893871024b990b9980cad54.css";

/***/ }),

/***/ "xpHJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/sign-up-block_cd1259f34ae798a49d07b42525726ed4.css";

/***/ }),

/***/ "y+GP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/section-background-text_673293687f30a269467d630759287cc7.css";

/***/ }),

/***/ "yCid":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/14.svg";

/***/ }),

/***/ "yQlI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/info-app-sumo_49becd49a6a3cb7e4d370c3f05200f26.css";

/***/ }),

/***/ "yRMd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/user-popup_85d1763092283aabbea98d2ee40cfcb1.css";

/***/ }),

/***/ "yRab":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var storageName = 'timeout_clear';
var setPrevTime = function (name, time) {
    return localStorage.setItem(storageName + ":" + name, "" + time);
};
var getPrevTime = function (name) {
    return localStorage.getItem(storageName + ":" + name);
};
exports.default = function (name, timeout) { return function (clear) {
    var prevTime = getPrevTime(name);
    var prevTimeOrDefault = prevTime
        ? new Date(JSON.parse(prevTime))
        : new Date();
    var prevTimeWithTimeout = prevTimeOrDefault.getTime() + timeout;
    var currentTime = new Date().getTime();
    if (!prevTime) {
        setPrevTime(name, currentTime);
    }
    if (prevTimeWithTimeout <= currentTime) {
        clear();
        setPrevTime(name, currentTime);
    }
}; };


/***/ }),

/***/ "yiF7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/modal-video-player_e8a174ea1dc3214a30fe6dc6854cc7ba.css";

/***/ }),

/***/ "z7A8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/14.png";

/***/ }),

/***/ "zH1h":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/video-improve-steps-section_a5c173079725d56c98c9f76579e7903e.css";

/***/ }),

/***/ "zJEW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/male/7.svg";

/***/ }),

/***/ "zdW0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stylesheets/section-sign-up_e771c8691117b44eac411c93cdfc5e75.css";

/***/ }),

/***/ "zpKr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/avatars/female/18.svg";

/***/ }),

/***/ "zwf9":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./404-page.less": "QQt/",
	"./_checkbox-tab.less": "Bkei",
	"./_checkbox.less": "7c9p",
	"./_fonts.less": "/Rep",
	"./_lang.less": "N3N4",
	"./_mixins.less": "NItV",
	"./_slider.less": "7JoK",
	"./activate.less": "PZhr",
	"./aff-modal.less": "LUYn",
	"./analytics.less": "8Acd",
	"./animations.less": "lu/X",
	"./ask-popup.less": "kvam",
	"./auth.less": "Skyp",
	"./bg-video.less": "isPM",
	"./buttons.less": "nKgT",
	"./comments.less": "+goU",
	"./company.less": "6bdG",
	"./contest-landing/challenges-list-section.less": "jwTf",
	"./contest-landing/challenges-list.less": "4Y92",
	"./contest-landing/contact-us-section.less": "QqRC",
	"./contest-landing/contest-days-top-section.less": "5MIU",
	"./contest-landing/contest-days.less": "PpkO",
	"./contest-landing/contest-landing.less": "R8gk",
	"./contest-landing/contest-text-video-section.less": "RySD",
	"./contest-landing/countdown-section.less": "67wm",
	"./contest-landing/countdown.less": "Du2S",
	"./contest-landing/judge-item.less": "Ao4C",
	"./contest-landing/media-sponsors-section.less": "Jrnx",
	"./contest-landing/participate-steps.less": "03GZ",
	"./contest-landing/pre-register-section.less": "EepZ",
	"./contest-landing/pre-register.less": "DMU6",
	"./contest-landing/sponsor-contact-us.less": "cmQJ",
	"./contest-landing/spread-in.less": "sCFP",
	"./contest-landing/title-shadow-block.less": "L2qt",
	"./contest-landing/video-improve-steps-section.less": "zH1h",
	"./contest-landing/video-improve-steps.less": "+G96",
	"./contest-landing/win-prizes-list.less": "nSa/",
	"./contest-landing/win-prizes-section.less": "SW67",
	"./contest/contest.less": "Otff",
	"./contractors.less": "wmF7",
	"./delete-account.less": "/78k",
	"./discount-dialog.less": "TnCe",
	"./drag-drop/drag-item.less": "lwEL",
	"./dropdown-menu.less": "Bdsd",
	"./editor-redirect.less": "6gbB",
	"./edu.less": "TBjL",
	"./f_bsh-button.less": "5TC1",
	"./feedback-slider.less": "5j0l",
	"./fonts/font-ko.less": "fbuv",
	"./fonts/fonts-basic.less": "tWLz",
	"./footer.less": "fAML",
	"./global.less": "x7Q4",
	"./go-share-button.less": "HmW0",
	"./header.less": "j8J/",
	"./landing-template/components/background.less": "kfHS",
	"./landing-template/components/different-devices.less": "Ir05",
	"./landing-template/components/double-circle-progress.less": "WgFx",
	"./landing-template/components/icon-text-list.less": "5G1g",
	"./landing-template/components/relation-list.less": "hVBH",
	"./landing-template/components/sections/section-background-text.less": "y+GP",
	"./landing-template/components/sections/section-bitmap.less": "7s+J",
	"./landing-template/components/sections/section-company-info.less": "b+CF",
	"./landing-template/components/sections/section-company-quote.less": "7f+t",
	"./landing-template/components/sections/section-different-devices.less": "LxjB",
	"./landing-template/components/sections/section-feedback.less": "QAC1",
	"./landing-template/components/sections/section-horizontal-image-text.less": "JAU9",
	"./landing-template/components/sections/section-horizontal-text-video.less": "wwNa",
	"./landing-template/components/sections/section-logo-video-sign-up.less": "3PSy",
	"./landing-template/components/sections/section-sign-up.less": "zdW0",
	"./landing-template/components/sections/section-template-pages-list.less": "F6N9",
	"./landing-template/components/sections/section-text-aside.less": "OmPd",
	"./landing-template/components/sections/section-vertical-text-video.less": "MJwn",
	"./landing-template/components/sections/section-video-gallery.less": "NZ2j",
	"./landing-template/components/sections/section-video-sign-up.less": "pLX0",
	"./landing-template/components/sections/section-video-statistics.less": "57HE",
	"./landing-template/components/sections/section-video-steps.less": "k4sW",
	"./landing-template/components/sections/section-video-time.less": "t/nL",
	"./landing-template/components/template-pages-list-item.less": "ZSj8",
	"./landing-template/components/template-pages-list.less": "R8wy",
	"./landing-template/components/text-block.less": "eCEw",
	"./landing-template/components/title-block.less": "5W2z",
	"./landing-template/landing-template.less": "dy9G",
	"./landing-video-preview.less": "MLEj",
	"./landing/any-landing.less": "BjM0",
	"./landing/banner-bottom.less": "nCcs",
	"./landing/both-landings-common.less": "vzSK",
	"./landing/comparison.less": "dLJ7",
	"./landing/landing-new-bottom.less": "LT3T",
	"./landing/landing-new.less": "3Sex",
	"./landing/landing-top-common.less": "9VVx",
	"./landing/light-landing.less": "hqwK",
	"./landing/masonry-wrapper.less": "tjWj",
	"./landing/medium-landing.less": "fUJ1",
	"./landing/political-landing.less": "Rpkd",
	"./landing/video-gallery.less": "KvyJ",
	"./le-share-button.less": "8gmB",
	"./library.less": "UVgn",
	"./login-modal.less": "xlID",
	"./logo.less": "wCd9",
	"./main-page.less": "dJ+1",
	"./main.less": "3ksy",
	"./mobile/m-any-landing.less": "aiHC",
	"./mobile/m-company.less": "dz0q",
	"./mobile/m-header.less": "S6Z6",
	"./mobile/m-landing-banner.less": "SDKh",
	"./mobile/m-landing-bottom.less": "lSTx",
	"./mobile/m-landing-common.less": "DhCa",
	"./mobile/m-landing-comparison.less": "egLR",
	"./mobile/m-medium-landing.less": "BGDY",
	"./mobile/m-search-page.less": "JE8O",
	"./mobile/mobile.less": "0nYI",
	"./mobile/wave/m-wave-landing-smmw.less": "QHsv",
	"./mobile/wave/m-wave-landing.less": "+m0I",
	"./mobile/wave/m-wave-pricing.less": "hYS4",
	"./mobile/wave/m-wave-typography.less": "BTge",
	"./mobile/wave/m-webinar.less": "kglB",
	"./modal-video-player.less": "yiF7",
	"./modal.less": "0wzA",
	"./newsWebsite.less": "b/cW",
	"./ng-tags-input.less": "Argd",
	"./notification/user-notification.less": "vkeZ",
	"./notifications.less": "x+OW",
	"./open-editor.less": "sM/Y",
	"./pagination.less": "Xy+x",
	"./popup.less": "9uvP",
	"./pricing.less": "BH+f",
	"./project-upgrade.less": "acIy",
	"./projects.less": "dQ5J",
	"./publish.less": "jPQQ",
	"./scroll-button.less": "J0yb",
	"./search-page.less": "mIzu",
	"./search.less": "hACO",
	"./settings.less": "NGqW",
	"./settings/address.less": "we/J",
	"./settings/form-field-warning.less": "kaOu",
	"./settings/info-app-sumo.less": "yQlI",
	"./settings/random-fact.less": "Dg8K",
	"./settings/subscription/containers/subscription-current-plan-container.less": "odw/",
	"./settings/subscription/containers/subscription-invoice-history-container.less": "BCWO",
	"./settings/subscription/containers/subscription-payment-details-container.less": "9IMG",
	"./settings/subscription/containers/subscription-router-modals-container.less": "BJa0",
	"./settings/subscription/messages/subscription-messages.less": "UAPN",
	"./settings/subscription/payment-details/subscription-payment-details-enter-card.less": "CxL4",
	"./settings/subscription/payment-details/subscription-payment-details-with-card.less": "n4af",
	"./settings/subscription/subscription-alert.less": "J6t3",
	"./settings/subscription/subscription-billing-info-form.less": "4uz1",
	"./settings/subscription/subscription-credit-info.less": "Xo4n",
	"./settings/subscription/subscription-current-plan.less": "e3be",
	"./settings/subscription/subscription-invoice-history-table.less": "JDnY",
	"./settings/subscription/subscription-page.less": "Hh+C",
	"./settings/subscription/subscription-title.less": "hqAA",
	"./settings/subscription/subscription-total-price.less": "o4OY",
	"./sign-up-block.less": "xpHJ",
	"./signup.less": "j+wj",
	"./special-upgrade.less": "+K6/",
	"./spinners.less": "u8E4",
	"./studio-responsiveness.less": "1uG8",
	"./subscription.less": "g108",
	"./tabs.less": "4eYb",
	"./thumbnail-picker.less": "07M5",
	"./tutorial.less": "xXoS",
	"./user-info-form.less": "IFnZ",
	"./user-popup.less": "yRMd",
	"./user-section.less": "HCXh",
	"./video-player.less": "pbA1",
	"./video-slider.less": "KApX",
	"./video-steps.less": "f+kA",
	"./wave/_typography.less": "wJnc",
	"./wave/folder/masonry/video-folder-masonry.less": "Nlhm",
	"./wave/folder/video-folder-bottom.less": "Cw72",
	"./wave/folder/video-folder-breadcrumb.less": "OjHm",
	"./wave/folder/video-folder-item.less": "Vc67",
	"./wave/folder/video-folder-move-modal.less": "iLwr",
	"./wave/folder/video-folder-tree-item.less": "OAh3",
	"./wave/tutorial/wave-tutorial-page.less": "CDOh",
	"./wave/tutorial/wave-tutorial-workshops.less": "KLH/",
	"./wave/tutorial/wave-tutorials-item.less": "cZf6",
	"./wave/tutorial/wave-tutorials-list.less": "74nn",
	"./wave/wave-landing-smmw.less": "/r0m",
	"./wave/wave-landing.less": "rd/d",
	"./wave/wave-my-projects.less": "hQA3",
	"./wave/wave-pricing.less": "fUhQ",
	"./wave/wave-project-item.less": "jmbb",
	"./wave/wave-projects.less": "15vf",
	"./wave/wave-section-how-work.less": "xU9L",
	"./wave/wave-template-item.less": "aTCW",
	"./wave/wave-trail.less": "omcN",
	"./wave/wave-user-page.less": "GIoJ",
	"./wave/wave-webinar.less": "ekLA",
	"./wistia-player.less": "NTYq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zwf9";

/***/ }),

/***/ "zyTD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/login_dc9a4b4bae2186310e521d2ad1a54085.html";

/***/ })

/******/ });


// WEBPACK FOOTER //
// javascripts/main-d07a2eed5a1912ce9525.min.js